// Spain
export const locale = {
	lang: 'es',
	data: {
		WHAT_IF: {
			SIMULATION: { ACTUAL_VALUE: 'Valor real' },
			GRAPH: {
				BASELINE_TIMESTAMP: 'Marca de tiempo de referencia',
				NO_DATA: '¡No se encontraron datos!',
				RUN_SIMULATION_TITLE: 'Ejecuta una simulación para ver los resultados del gráfico',
				RUN_SIMULATION_HINT: 'Haz clic en «Ejecutar» después de configurar los parámetros de simulación.',
				RAW_TAG_DEPENDENCY: 'Dependencia de tags sin procesar',
				BASELINE: 'Referencia',
				SIMULATION: 'Simulación',
				SIMULATED: 'Simulado',
			},
			SEARCH: {
				PLACEHOLDER: 'Buscar instalación, sistema, unidad o tag',
				SEARCHING: 'Buscando…',
				NO_RESULTS: 'No se encontraron coincidencias',
				ERROR: 'La búsqueda falló. Inténtalo de nuevo.',
			},
			TABLE: {
				DELTA_TOOLTIP: 'Cambio absoluto (Simulado − Base)',
				DELTA_PERCENT_TOOLTIP: 'Cambio porcentual respecto a la base',
				IMPACT_PROGRESS: 'Progreso de impacto',
				IMPACT: 'Impacto',
			},
			IMPACTED_KPI: {
				TITLE: 'KPI calculados afectados ({{count}})',
				NO_IMPACTED_KPIS: 'Aún no hay KPIs afectados',
				EMPTY_HINT: 'Seleccione etiquetas sin procesar a la izquierda para ver el impacto en los KPI posteriores.',
				LOADING: 'Cargando etiquetas calculadas...',
				SELECTION_HINT: '{{checked}} de {{total}} KPIs seleccionados en el sistema principal — desmarque para excluir de la simulación. Los chips "Driven by" muestran qué etiquetas sin procesar afectan a cada KPI. Los sistemas hermanos que comparten la misma firma de etiqueta se enumeran a continuación como impactos entre sistemas de solo lectura.',
				CROSS_SYSTEM_IMPACT: 'Impacto entre sistemas',
				KPI_COUNT: '{{count}} KPIs',
				TAG_PARAMETER: 'Etiqueta / Parámetro',
				CALCULATED_TAG: 'Etiqueta Calculada',
				DRIVEN_BY: 'Impulsado por:',
			},
			PAGE: {
				TITLE: 'What-If',
				SELECT_RAW_TAGS_TITLE: 'Seleccionar etiquetas sin procesar para simular',
				SELECT_RAW_TAGS_SUBTITLE: 'Elija etiquetas de la jerarquía a continuación',
				SIMULATION_SETUP_TITLE: 'Configuración de la simulación',
				SIMULATION_SETUP_SUBTITLE: 'Seleccione etiquetas arriba para comenzar',
				RUN: 'Ejecutar',
				RESET: 'Restablecer',
				NO_TAGS_SELECTED: 'No hay etiquetas seleccionadas',
				NO_TAGS_SELECTED_DESC: 'Elija etiquetas sin procesar arriba para definir cambios.',
				CLICK_TIMESTAMP_HINT: 'Haga clic en cualquier parte del gráfico para seleccionar una marca de tiempo del estado operativo.',
				CLICK_RANGE_HINT: 'Haga clic dos veces en el gráfico para seleccionar el rango del estado operativo.',
				SELECTED_OPERATING_STATE: 'Estado operativo seleccionado:',
				SELECTED_OPERATING_RANGE: 'Rango operativo seleccionado:',
				FIRST_POINT_PREFIX: 'Primer punto:',
				FIRST_POINT_SUFFIX: '— haga clic de nuevo para establecer el final del rango.',
				SIMULATION_RESULTS: 'Resultados de la simulación',
				TABLE_VIEW: 'Vista de tabla',
				RUN_SIMULATION_TABLE_TITLE: 'Ejecute una simulación para ver los resultados de la tabla',
				TABLE_UNAVAILABLE_PERIOD: 'La vista de tabla no está disponible para simulaciones de período',
				SWITCH_TO_SINGLE_POINT: 'Cambie al modo "Punto único" o use la pestaña Vista de gráfico.',
				NO_KPI_ROWS: 'No hay filas de KPI para mostrar',
				NO_KPI_ROWS_DESC: 'Todos los KPI afectados están desmarcados. Seleccione KPIs en la pestaña KPIs afectados para verlos aquí.',
				GRAPH_VIEW: 'Vista de gráfico',
				SIMULATION_TYPE_PERCENT: '% de cambio',
				SIMULATION_TYPE_ABSOLUTE: 'Valor absoluto',
				TIME_CONTEXT_SINGLE: 'Punto único',
				TIME_CONTEXT_PERIOD: 'Período',
			},
			IMPACTED_KPIS_TAB_LABEL: 'KPIs afectados',
			IMPACTED_KPIS_TAB_LABEL_COUNT: 'KPIs afectados ({{count}})',
			HIERARCHY_TOOLTIP: {
				TAG_NAME: 'Nombre de etiqueta',
				TAG_ID: 'ID de etiqueta',
				TAG_DESCRIPTION: 'Descripción',
				ASSET_NAME: 'Nombre del activo',
				SYSTEM_NAME: 'Nombre del sistema',
			},
		},
		TRANSLATOR: {
			SELECT: 'Elige tu idioma',
		},
		VALIDATION: {
			REQUIRED: 'Este campo es obligatorio',
			PATTERN: 'Formato no válido',
			MIN: 'El valor es demasiado pequeño',
			MAX: 'El valor es demasiado grande',
			MIN_LENGTH: 'El valor es demasiado corto',
			MAX_LENGTH: 'El valor es demasiado largo',
			SELECT_AT_LEAST_ONE: 'Seleccione al menos una opción',
			INVALID: 'Valor no válido',
			FIELD_REQUIRED: '{{field}} es obligatorio',
		},
		COMMON: {
			NO_MATCHES: 'No se encontraron resultados para "{{keyword}}"',
			TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Pruebe con una palabra clave diferente o borre la búsqueda',
			SELECT_A_SYSTEM: 'Seleccione un sistema.',
			SELECT_DIFF_UNIT: 'Seleccione una unidad o planta diferente',
			SELECT_DIFF: 'Seleccione una planta, unidad o sistema diferente',
			NO_TAGS_FOUND: 'No se encontraron etiquetas',
			SELECT_FACILITY: 'Seleccione una planta diferente',
			ADDED_FROM_ROOTY: 'Añadido desde {{name}}',
		},
		COMMENT_POPUP: {
			TITLE: 'Dejar Comentario',
			ENTER_MESSAGE: 'Ingrese su mensaje',
			COMMENT_PLACEHOLDER: 'Agregue un comentario, use @ para etiquetar miembros del equipo',
			FILE_SIZE_LIMIT_ERROR: '{{fileName}} no se pudo cargar debido al límite de tamaño de archivo.',
			UPLOAD_FAILED_ERROR: 'No se pudo cargar {{fileName}}.',
			INVALID_FILES_ERROR: 'No se seleccionaron archivos válidos. Solo se permiten archivos con las extensiones {{extensions}}',
		},
		REGENERATE_HYPOTHESES_POPUP: {
			TITLE: 'Regenerar hipótesis',
			DESCRIPTION: 'Todas las hipótesis se regenerarán utilizando los comentarios proporcionados sobre la cadena causal, las recomendaciones y la evidencia propuesta. La versión actual se guardará en el historial.',
			REGENERATION_CONTEXT: 'Contexto de regeneración',
			TOTAL_FEEDBACKS: 'Comentarios totales',
			ADDED_AS_EVIDENCE: 'Añadido como evidencia',
			APPROVED: 'Aprobado',
			RELEARNED: 'Reaprendido',
			SETTINGS: 'Configuración',
			DOCUMENT_INSIGHTS: 'Información de documentos',
			SAP_INSIGHTS: 'Información de SAP',
			CONNECTED_SYSTEMS_REVIEW: 'Revisión de sistemas conectados',
			ALERT_REVIEW_WINDOW: 'Ventana de revisión de alertas',
			DAYS: 'Días',
			RESET_AND_RERUN: 'Restablecer y volver a ejecutar',
			RESET_AND_RERUN_INFO: 'Se ignorarán las hipótesis, comentarios, recomendaciones y evidencia propuesta anteriores. El RCA se generará desde cero utilizando solo los datos más recientes disponibles.',
			VERSION_HISTORY_NOTE: 'Las hipótesis actuales se guardarán en el historial de versiones. Puede restaurar versiones anteriores en cualquier momento.',
			USER_CONSENT: 'Entiendo que el contexto de RCA anterior no se utilizará para esta ejecución.',
			CANCEL: 'Cancelar',
			REGENERATE_ALL: 'Regenerar todo',
			REGENERATE_ALL_TOOLTIP: 'Mejorar el RCA actual utilizando el contexto existente',
			RESET_AND_RERUN_BTN: 'Restablecer y volver a ejecutar',
			RESET_AND_RERUN_TOOLTIP: 'Generar un nuevo RCA desde cero',
		},
		SHARE_REPORT_POPUP: {
			TITLE: 'Compartir informe',
			ADD_PEOPLE: 'Añadir personas',
			MESSAGE: 'Mensaje',
			MESSAGE_PLACEHOLDER: 'Escriba su mensaje (opcional)',
			COPY_LINK: 'Copiar enlace',
			CANCEL: 'Cancelar',
			SEND: 'Enviar',
		},
		FEEDBACK_POPUP: {
			PREVIOUSLY_APPROVED: 'Aprobado anteriormente',
			PREVIOUSLY_RELEARNED: 'Reaprendido anteriormente',
			SEE_LESS: 'Ver menos',
			SEE_MORE: 'Ver más...',
			FEEDBACK_LABEL: 'Comentarios',
			FEEDBACK_TOOLTIP: 'Este comentario se usará durante la reejecución del RCA.',
			CANCEL: 'Cancelar',
			CONFIRM: 'Confirmar',
			RELEARNED_BY: 'Reaprendido por:',
			NO_REASON_ADDED: 'No se agregó ningún motivo',
		},
		ASK_ROOTY_POPUP: {
			ENTER_MESSAGE_TO_START: 'Ingrese su mensaje para iniciar un chat',
			MESSAGE_PLACEHOLDER: 'Ingrese su mensaje...',
		},
		ROOTY_CHAT: {
			FOLLOW_UP_SUGGESTIONS: 'Sugerencias de seguimiento',
			ASK_TITLE: 'Preguntar a {{name}}',
			UPLOAD_TOOLTIP: 'Suba archivos PDF, Word, Excel, PNG, JPG y JPEG para que {{name}} los analice.',
			DISCLAIMER: '{{name}} proporciona respuestas asistidas por IA y puede no ser siempre precisa. Verifique antes de actuar.',
			FEEDBACK_SUBTITLE: 'Seleccione el problema principal para que podamos mejorar las futuras respuestas de {{name}}.',
			POPUP_TITLE: 'Preguntar a {{name}}',
			NOT_ENABLED: '{{name}} no está habilitado para el usuario actual.',
			SHARE: 'Compartir',
			RENAME: 'Renombrar',
			DELETE: 'Eliminar',
			HISTORY: 'Historial',
			CLOSE: 'Cerrar',
			SEARCH: 'Buscar...',
			UNSAVED: 'Sin guardar',
			NO_HISTORY_HEADING: 'No hay historial disponible.',
			NO_HISTORY_DESC: 'No pudimos encontrar datos históricos.',
			START_NEW_CHAT: 'Iniciar nuevo chat',
			AGENT_CONTEXT_TOOLTIP: 'Contexto del Agente',
			CHAT_HISTORY_TOOLTIP: 'Historial de chat',
			UNPIN: 'Desanclar',
			PIN: 'Anclar',
			FULL_SCREEN: 'Pantalla completa',
			EXIT_FULL_SCREEN: 'Salir de pantalla completa',
			EXPAND: 'Expandir',
			COLLAPSE: 'Contraer',
			INTRO_TITLE: '¡Hola! ¿Necesita ayuda con lo que está viendo?',
			INTRO_DESC: 'Pregúnteme lo que sea o puedo resumir esta pantalla, explicar tendencias, comparar elementos y sugerir próximos pasos.',
			SUGGESTIONS: 'Sugerencias',
			SUGGESTION_1: 'Resuma este RCA en 30 segundos (qué pasó y por qué).',
			SUGGESTION_2: '¿Qué hipótesis está más respaldada por la evidencia mostrada aquí?',
			SUGGESTION_3: 'Compare las hipótesis: ¿cuál es la evidencia más sólida para cada una?',
			CP_INTRO_TITLE: '¡Hola! ¿Necesita ayuda con la optimización de capacidad y la planificación de escenarios?',
			CP_INTRO_DESC: 'Puedo ayudarle a crear modelos de planificación, probar contingencias de disparo de unidades, simular el crecimiento de la demanda pico y analizar la viabilidad de energía y agua.',
			CP_SUGGESTION_1: 'Resuma el costo total de generación, el consumo de combustible y el desglose por planta para esta ejecución.',
			CP_SUGGESTION_2: '¿Cuál es nuestro margen de reserva rotante y hay horas de déficit?',
			CP_SUGGESTION_3: '¿Qué pasaría si H5_GT se desconecta durante la demanda pico?',
			CP_SUGGESTION_4: 'Simule un crecimiento del +5% en la demanda pico de energía para este escenario.',
			LOADING_EARLIER: 'Cargando conversación anterior…',
			SHOW_EARLIER: 'Mostrar conversación anterior',
			RESPONSE_STOPPED: 'Generación de respuesta detenida',
			LOADING_ALT: 'Cargando',
			THINKING: 'Pensando',
			THOUGHT_FOR: 'Pensó durante {{seconds}}s',
			DOWNLOAD_CSV: 'Descargar CSV',
			COPY_CSV: 'Copiar CSV',
			DOWNLOAD_IMAGE: 'Descargar imagen',
			COPY_IMAGE: 'Copiar imagen',
			WHAT_IF_SCENARIO_CREATED: 'Escenario What-If creado',
			CHANGE_APPLIED: 'Cambio aplicado:',
			NEW_SCENARIO: 'Nuevo escenario:',
			VIEW_CONFIGURATION: 'Ver configuración',
			RUN_OPTIMIZATION: 'Ejecutar optimización',
			RESULTS_COMPARISON: 'Comparación de resultados',
			ALL_IMPROVED: 'Todo mejoró',
			KPI: 'KPI',
			BASE: 'Base',
			WHAT_IF: 'What-If',
			YES: 'Sí',
			NO: 'No',
			CHANGED: 'cambiado',
			WHATIF_KPI_POWER_FEASIBLE: 'Potencia viable',
			WHATIF_KPI_WATER_FEASIBLE: 'Agua viable',
			WHATIF_KPI_EST_COST: 'Costo estimado',
			WHATIF_KPI_POWER_SHORTFALL: 'Déficit de potencia',
			WHATIF_KPI_WATER_SHORTFALL: 'Déficit de agua',
			WHATIF_KPI_AVG_GENERATION: 'Generación media',
			WHATIF_KPI_AVG_HEADROOM: 'Margen medio',
			WHATIF_KPI_TOTAL_STARTS: 'Arranques totales',
			WHATIF_KPI_AVG_WATER_OUTPUT: 'Producción media de agua',
			WHATIF_KPI_GAP_PERCENT: 'Brecha %',
			WHATIF_POWER_BALANCE: 'Balance de potencia (MW)',
			WHATIF_TIME_AXIS: 'Tiempo',
			WHATIF_POWER_AXIS: 'Potencia (MW)',
			WHATIF_WATER_OUTPUT: 'Producción de agua (MIGD)',
			WHATIF_WATER_AXIS: 'Agua (MIGD)',
			WHATIF_TRACE_DEMAND: 'Demanda',
			WHATIF_TRACE_GEN: 'Gen.',
			WHATIF_TRACE_WATER: 'Agua',
			NO_MAJOR_DIFF: 'Ningún KPI cambió más del 5% entre los dos escenarios.',
			VIEW_FULL_RESULTS: 'Ver resultados completos',
			APPLY_AS_EVIDENCE: 'Aplicar como evidencia',
			ADDED_AS_EVIDENCE: 'Agregado como evidencia',
			ALREADY_ADDED_AS_EVIDENCE: 'Ya agregado como evidencia',
			ADD_AS_EVIDENCE: 'Agregar como evidencia',
			BRANCH_VISIBILITY_NOTICE: 'Los mensajes nuevos solo son visibles para usted.',
			CONTINUE: 'Continuar',
			SEARCH_SCENARIOS: 'Buscar escenarios...',
			FILTER_SCENARIOS: 'Filtrar escenarios',
			SOURCE: 'Fuente',
			ALL_SOURCES: 'Todas las fuentes',
			HUMAN_MANUAL: 'Manual (Humano)',
			AI_GENERATED: 'Generado por IA',
			STRATEGY_AUTO: 'Estrategia (Automático)',
			DATE_MODIFIED: 'Fecha de modificación',
			ALL_TIME: 'Todo el tiempo',
			TODAY: 'Hoy',
			LAST_7_DAYS: 'Últimos 7 días',
			RECENT: 'Reciente',
			OFFICIAL: 'Oficial',
			ALL_SCENARIOS: 'Todos los escenarios',
			NO_SCENARIOS_MATCH: 'Ningún escenario coincide con "{{query}}"',
			DRAFT: 'Borrador',
			DISMISS: 'Descartar',
			CONTEXT_PREFIX: 'Contexto:',
			REMOVE_CONTEXT: 'Eliminar contexto',
			SELECT_A_SCENARIO: 'Seleccionar un escenario',
			CLEAR_SCENARIO: 'Borrar escenario',
			LATEST_RUN_DEFAULT: 'Última ejecución (Predeterminado)',
			DROP_FILES_HERE: 'Suelte los archivos aquí',
			COMPOSER_PLACEHOLDER: 'Haga una pregunta o solicitud...',
			ADD_FILES_OR_IMAGES: 'Agregar archivos o imágenes',
			LANGUAGE: 'Idioma',
			MIC_BLOCKED: 'El acceso al micrófono está bloqueado. Permita el permiso del micrófono',
			USE_VOICE_INPUT: 'Usar entrada de voz',
			VOICE_INPUT_ALT: 'Entrada de voz',
			STOP_RECORDING: 'Detener grabación',
			STOP_RECORDING_ALT: 'Detener grabación',
			STOP_GENERATION: 'Detener generación',
			SEND_ALT: 'Enviar',
			FEEDBACK_WHAT_WENT_WRONG: '¿Qué salió mal con esta respuesta?',
			FEEDBACK_CATEGORY: 'Categoría de comentarios',
			SELECT_AN_ISSUE: 'Seleccione un problema',
			SELECT_CATEGORY_TO_CONTINUE: 'Seleccione una categoría para continuar',
			ADDITIONAL_DETAILS_OPTIONAL: 'Detalles adicionales (Opcional)',
			FEEDBACK_COMMENT_PLACEHOLDER: 'Cuéntenos más sobre lo que estuvo mal.',
			CANCEL: 'Cancelar',
			SUBMIT_FEEDBACK: 'Enviar comentarios',
			ERROR: 'Error',
			FEEDBACK_SUBMIT_ERROR: 'No se pudo enviar el comentario. Inténtelo de nuevo.',
			TRY_AGAIN: 'Intentar de nuevo',
			OPEN_LINK: 'Abrir enlace',
			OPEN_DOCUMENT: 'Abrir documento',
			PAGE_PREFIX: 'Página-{{page}}',
			FEEDBACK_CATEGORY_INCORRECT_ANSWER: 'Respuesta incorrecta',
			FEEDBACK_CATEGORY_DID_NOT_ANSWER: 'No respondió mi pregunta',
			FEEDBACK_CATEGORY_MISSING_DATA: 'Faltan datos relevantes',
			FEEDBACK_CATEGORY_INCORRECT_REASONING: 'Análisis o razonamiento incorrecto',
			FEEDBACK_CATEGORY_POOR_CHART: 'Gráfico o visualización deficiente',
			FEEDBACK_CATEGORY_POOR_DOCUMENT: 'Respuesta de documento deficiente',
			FEEDBACK_CATEGORY_TOO_SLOW: 'La consulta fue demasiado lenta',
			FEEDBACK_CATEGORY_INCOMPLETE: 'La respuesta estuvo incompleta',
			FEEDBACK_CATEGORY_OTHER: 'Otro',
			CHATBOT_PRIVATE: 'Privado',
			CHATBOT_INHOUSE_GPT: 'Inhouse GPT',
			LANGUAGE_ENGLISH_US: 'Inglés (EE. UU.)',
			LANGUAGE_ARABIC: 'Árabe',
			MODE_AUTO: 'Automático',
			MODE_GENERAL: 'General',
			MODE_DOCS: 'Documentos',
			MODE_OPTIMIZER: 'Optimizador',
			DATE_TODAY: 'Hoy',
			DATE_YESTERDAY: 'Ayer',
			DATE_THIS_WEEK: 'Esta semana',
			DATE_LAST_WEEK: 'La semana pasada',
			DATE_THIS_MONTH: 'Este mes',
			DATE_LAST_MONTH: 'El mes pasado',
			DATE_OLDER: 'Más antiguo',
			CONTEXT: {
				FROM: 'Contexto de {{source}}',
				LAUNCHED_FROM: 'Rooty iniciado desde {{source}}',
				UPDATED: 'Contexto actualizado',
				REMOVED: 'Contexto eliminado',
				APPLIED: 'Contexto aplicado',
				GENERAL: 'ahora usando el contexto general del chat',
				MORE: 'Más',
				SEE_LESS: 'Ver menos',
				LABEL: {
					ALERT: 'Alerta',
					RCA: 'RCA',
					SCOPE: 'Alcance',
					SYSTEM: 'Sistema',
					SCENARIO: 'Escenario',
					SIMULATION_TYPE: 'Tipo de simulación',
					PREVIOUS: 'Anterior',
					NEW: 'Nuevo',
					SOURCE: 'Origen',
				},
				SOURCE: {
					ALERT: 'Detalles de la alerta',
					RCA: 'RCA',
					SYSTEM: 'Vista del sistema',
					WHAT_IF: 'Análisis hipotético',
				},
				SUMMARY: {
					ALERT: 'Alerta {{value}}',
					RCA: 'RCA de la alerta {{value}}',
					SYSTEM: 'Sistema {{value}}',
					WHAT_IF: 'Hipotético: {{value}}',
				},
			},
			TOAST_FEEDBACK_THANKS: 'Gracias. Lo usaremos para mejorar Rooty.',
			TOAST_FEEDBACK_POSITIVE_THANKS: 'Gracias por sus comentarios.',
			TOAST_COPIED_MESSAGE: 'Mensaje copiado.',
			TOAST_LINK_COPIED: 'Copiado',
			TOAST_CHAT_DELETED: 'Chat eliminado',
			TOAST_CHAT_DELETE_FAILED: 'No se pudo eliminar el chat.',
			TOAST_NEW_CHAT_STARTED: 'Nuevo chat iniciado',
		},
		AGENT_CONTEXT: {
			CONSIDERED: 'Contexto del agente considerado',
			ITEMS: 'elementos',
			ADD: 'Agregar contexto del agente',
			UPDATED: 'Actualizado',
			DIALOG_DESC: 'Capture orientación operativa reutilizable para {{name}} y RCA.',
			DIALOG_DISCLAIMER: 'Este contexto puede influir en futuras respuestas de {{name}} y RCA para análisis coincidentes. No afecta la detección de anomalías ni los modelos predictivos.',
			SIDEPANEL_DESC: 'Conocimiento operativo reutilizable disponible para {{name}} y RCA.',
			SIDEPANEL_EMPTY: 'Capture conocimiento operativo reutilizable para {{name}} y RCA, como pautas de razonamiento, guías de investigación y terminología.',
			REMOVE_CONFIRM: '"<strong>{{title}}</strong>" se eliminará y {{name}} o RCA ya no lo tendrán en cuenta.<br>Esta acción no se puede deshacer.',
			TITLE: 'Contexto del Agente',
			READ_ONLY: 'Solo lectura',
			ADD_SHORT: 'Agregar',
			CLOSE: 'Cerrar',
			SEARCH_PLACEHOLDER: 'Buscar por título o alcance...',
			EDIT: 'Editar',
			DELETE: 'Eliminar',
			EMPTY_HEADING: 'Aún no hay Contexto de Agente',
			LAST_UPDATED_PREFIX: 'Última actualización',
			BY_PREFIX: 'Por',
			SECTION_CONTEXT_TYPE: '1. TIPO DE CONTEXTO',
			SECTION_SCOPE: '2. ALCANCE',
			SECTION_CONTEXT: '3. CONTEXTO',
			SELECT_SCOPE: 'Seleccionar alcance',
			CONTEXT_TITLE_LABEL: 'Título',
			CONTEXT_TITLE_PLACEHOLDER: 'Ingrese el título del contexto',
			GUIDANCE_LABEL: 'Descripción de la orientación',
			GUIDANCE_PLACEHOLDER: 'Ingrese la descripción de la orientación',
			PLAYBOOK_NAME_LABEL: 'Nombre del manual',
			PLAYBOOK_NAME_PLACEHOLDER: 'Ingrese el nombre del manual',
			INVESTIGATION_STEPS_LABEL: 'Pasos de investigación',
			STEP_PLACEHOLDER: 'Ingrese la descripción del paso',
			ADD_STEP: '+ Agregar Paso',
			TERM_HEADER: 'Término',
			MEANING_HEADER: 'Significado',
			TERM_PLACEHOLDER: 'Agregar término',
			MEANING_PLACEHOLDER: 'Ingrese el significado',
			CANCEL: 'Cancelar',
			CARD_REASONING_GUIDANCE_TITLE: 'Guía de Razonamiento',
			CARD_REASONING_GUIDANCE_DESC: 'Reglas de interpretación específicas de la planta que ayudan a los agentes de IA a razonar sobre el comportamiento.',
			CARD_INVESTIGATION_PLAYBOOK_TITLE: 'Manual de Investigación',
			CARD_INVESTIGATION_PLAYBOOK_DESC: 'Flujo de trabajo estructurado de resolución de problemas para un problema operativo recurrente.',
			CARD_TERMINOLOGY_TITLE: 'Terminología',
			CARD_TERMINOLOGY_DESC: 'Alias, abreviaturas y convenciones de nomenclatura específicas de la planta.',
			SAVE_IN_PROGRESS: 'Guardado en curso. Espere.',
			SCOPE_REQUIRED: 'Se requiere una selección de alcance antes de guardar.',
			TITLE_REQUIRED: 'Se requiere un título antes de guardar.',
			GUIDANCE_DESC_REQUIRED: 'Se requiere una descripción de la guía antes de guardar.',
			PLAYBOOK_NAME_REQUIRED: 'Se requiere un nombre de manual antes de guardar.',
			STEPS_REQUIRED: 'Todos los pasos de investigación deben completarse antes de guardar.',
			TERMINOLOGY_REQUIRED: 'Todas las entradas de terminología deben tener un término y un significado antes de guardar.',
			SOME_ERROR_OCCURRED: 'Ocurrió un error',
			EDIT_TITLE: 'Editar Contexto del Agente',
			SAVE_CHANGES: 'Guardar Cambios',
			DELETE_CONTEXT_TITLE: '¿Eliminar este contexto?',
			DELETED_SUCCESSFULLY: 'Eliminado con éxito.',
		SECTION_GUIDANCE: 'Orientación',
		TERMS_LABEL: 'Términos',
		REASONING_LABEL: 'Razonamiento',
		PLAYBOOK_LABEL: 'Manual',
		},
		MENU: {
			NEW: 'nuevo',
			ACTIONS: 'Comportamiento',
			CREATE_POST: 'Crear nueva publicación',
			PAGES: 'Pages',
			FEATURES: 'Caracteristicas',
			APPS: 'Aplicaciones',
			HOME: 'Inicio',
			SYSTEM: 'Sistema',
			ANALYSIS: 'Análisis',
			CONFIGURATION: 'Configuración',
			ALERTS: 'Alertas',
			ALERT_TRIAGE: 'Triaje de Alertas',
			KNOWLEDGE_GRAPH: 'Grafo de Conocimiento',
			ASSET_EXPLORER: 'Explorador de Activos',
			LIBRARY: 'Biblioteca',
			USER_MANAGEMENT: 'Gestión de usuarios',
			MODEL_WIZARD: 'Asistente de modelo',
			DASHBOARD_WIZARD: 'Asistente de tablero',
			IOW: 'IOW',
			PROCESS: 'Proceso',
			GENAI: 'GenAI',
			MAINTENANCE_OPTIMIZATION: 'Optimización de mantenimiento',
			RCM: 'RCM',
			SETTINGS: 'Configuración',
			HAZOP: 'Hazop',
			CASES: 'Casos',
			CAPACITY_OPTIMIZATION: 'Optimización de capacidad',
			WHAT_IF: 'What-if',
			HEALTH_METRICS: 'Métricas de salud',
			PLATFORM_CONFIGURATION: 'Configuración de la plataforma',
			DATA_MANAGEMENT: 'Gestión de datos',
			PLATFORM_POLICIES: 'Políticas de plataforma',
			CONNECTIONS_APIS: 'Conexiones y APIs',
			MODULE_CONFIGURATION: 'Configuración del módulo',
			AI_MANAGEMENT: 'Gestión de IA',
			ROOTY: '{{name}}',
			NOTIFICATION: 'Notificación',
			HELP: 'Ayuda',
			PROFILE: 'Mi perfil',
			LOGOUT: 'Cerrar sesión',
			LANGUAGE: 'Idioma',
			BASIC_USER_GUIDE: 'Guía básica',
			ADVANCED_USER_GUIDE: 'Guía avanzada'
		},
		AUTH: {
			PASSWORD_REQUIREMENTS: {
				TITLE: 'Su contraseña debe incluir:',
				MIN_CHARACTERS: 'Mínimo 8 caracteres',
				UPPERCASE_LETTER: 'Al menos 1 letra mayúscula',
				NUMBER: 'Al menos 1 número',
				SPECIAL_CHARACTER: 'Al menos 1 carácter especial',
			},
			GENERAL: {
				OR: 'O',
				SUBMIT_BUTTON: 'Enviar',
				NO_ACCOUNT: 'No tienes una cuenta?',
				SIGNUP_BUTTON: 'Regístrate',
				FORGOT_BUTTON: 'Se te olvidó tu contraseña',
				BACK_BUTTON: 'Espalda',
				PRIVACY: 'Intimidad',
				LEGAL: 'Legal',
				CONTACT: 'Contacto',
				VERIFY_BUTTON: 'Verificar',
				ENTER_OTP: 'Introducir OTP',
				HAVE_ACCOUNT: 'Ya tengo una cuenta',
			},
			LOGIN: {
				TITLE: 'Crear una cuenta',
				BUTTON: 'Registrarse',
				SIGN_IN_MICROSOFT: 'Iniciar sesión con Microsoft',
				SIGN_IN_SAML: 'Iniciar sesión con SAML',
				REMEMBER_ME: 'Recordarme',
				SIGNING_IN: 'Iniciando sesión. Por favor espere...',
				BPCL_WELCOME: '¡Bienvenido a la solución de rendimiento de activos basada en IA de BPCL!',
			},
			RESET: {
				TITLE: 'Restablecer contraseña',
				SUCCESS: 'Contraseña cambiada con éxito.',
				NEWPASSWORD: 'Nueva contraseña',
				REENTERNEWPASSWORD: 'Verificar contraseña',
				VERIFICATION_CODE_SENT: 'Introduzca el código de verificación enviado a',
				NO_CODE_RECEIVED: '¿No recibiste el código?',
				RESEND: 'Reenviar',
				RESEND_IN: 'en',
			},
			FORGOT: {
				TITLE: 'Contraseña olvidada?',
				DESC: 'Ingrese su correo electrónico para restablecer su contraseña',
				SUCCESS: 'Check your email for OTP.',
				REQUEST_RESET_BUTTON: 'Solicitar restablecimiento de contraseña',
				BACK_TO_SIGNIN: 'Volver a iniciar sesión',
			},
			REGISTER: {
				TITLE: 'Sign Up',
				DESC: 'Enter your details to create your account',
				SUCCESS: 'Your account has been successfuly registered.',
				ORGANIZATION_NAME: 'Nombre de la organización',
				NAME: 'Nombre',
				AGREE_PREFIX: 'Acepto los',
				TERMS_CONDITIONS: 'términos y condiciones',
				EMAIL_ALREADY_REGISTERED: 'Este correo electrónico ya está registrado.',
			},
			INPUT: {
				EMAIL: 'Correo electrónico',
				EMAIL_ADDRESS: 'Dirección de correo electrónico',
				FULLNAME: 'Nombre completo',
				PASSWORD: 'Contraseña',
				CONFIRM_PASSWORD: 'Confirmar contraseña',
				USERNAME: 'Usuario'
			},
			PLACEHOLDER:{
				EMAIL: 'Introducir correo electrónico',
				PASSWORD: 'Introducir contraseña'
			},
			VERIFY:{
				VERIFY_EMAIL: 'Verificación de correo electrónico',
				BACK_TO_SIGNIN: 'Volver a iniciar sesión',
			},
			SUBSCRIPTION: {
				EXPIRED: 'Su suscripción ha caducado.',
				RENEW: 'Renueve ahora o contacte con soporte para obtener ayuda.',
			},
			VALIDATION: {
				INVALID: '{{name}} no es válido',
				INVALID_EMAIL: 'Ingrese una dirección de correo electrónico válida',
				REQUIRED: '{{name}} es obligatorio',
				MIN_LENGTH: 'La longitud mínima de {{name}} es {{min}}',
				AGREEMENT_REQUIRED: 'Es necesario aceptar los términos y condiciones',
				NOT_FOUND: 'El {{name}} solicitado no se encuentra',
				INVALID_LOGIN: 'Los datos de inicio de sesión son incorrectos',
				INVALID_RESET: 'La OTP introducida es incorrecta o ha caducado. Por favor, inténtelo de nuevo.',
				REQUIRED_FIELD: 'Campo obligatorio',
				MIN_LENGTH_FIELD: 'Longitud mínima del campo:',
				MAX_LENGTH_FIELD: 'Longitud máxima del campo:',
				INVALID_FIELD: 'El campo no es válido',
				OTP_REQUIRED: 'Ingrese el código de verificación enviado a su correo electrónico.'
			}
		},
		ECOMMERCE: {
			COMMON: {
				SELECTED_RECORDS_COUNT: 'Selected records count: ',
				ALL: 'All',
				SUSPENDED: 'Suspended',
				ACTIVE: 'Active',
				FILTER: 'Filter',
				BY_STATUS: 'by Status',
				BY_TYPE: 'by Type',
				BUSINESS: 'Business',
				INDIVIDUAL: 'Individual',
				SEARCH: 'Search',
				IN_ALL_FIELDS: 'in all fields'
			},
			ECOMMERCE: 'eCommerce',
			CUSTOMERS: {
				CUSTOMERS: 'Customers',
				CUSTOMERS_LIST: 'Customers list',
				NEW_CUSTOMER: 'New Customer',
				DELETE_CUSTOMER_SIMPLE: {
					TITLE: 'Customer Delete',
					DESCRIPTION: 'Are you sure to permanently delete this customer?',
					WAIT_DESCRIPTION: 'Customer is deleting...',
					MESSAGE: 'Customer has been deleted'
				},
				DELETE_CUSTOMER_MULTY: {
					TITLE: 'Customers Delete',
					DESCRIPTION: 'Are you sure to permanently delete selected customers?',
					WAIT_DESCRIPTION: 'Customers are deleting...',
					MESSAGE: 'Selected customers have been deleted'
				},
				UPDATE_STATUS: {
					TITLE: 'Status has been updated for selected customers',
					MESSAGE: 'Selected customers status have successfully been updated'
				},
				EDIT: {
					UPDATE_MESSAGE: 'Customer has been updated',
					ADD_MESSAGE: 'Customer has been created'
				}
			}
		},
		HEALTH_METRICS: {
			TITLE: 'Métricas de Salud',
			SYSTEM_MODEL_METRICS: 'Métricas de Salud del Sistema y Modelo',
			DATA_FEED_HEALTH: 'Salud del Feed de Datos',
			QC_CHECK: 'Verificación QC',
			QC: {
				RAW_TAG_QC: 'QC de Etiqueta Bruta',
				CALCULATED_TAG_QC: 'QC de Etiqueta Calculada',
				MODEL_QC: 'QC de Modelo',
				COMING_SOON: 'Próximamente',
				CONFIGURATION: 'Configuración de Verificación QC',
				ALL_TAGS: 'Todas las Etiquetas',
				PROBLEM_TAGS: 'Etiquetas con Problemas',
				SEARCH: 'Buscar...',
				COLUMN_CONFIG: 'Configuración de Columnas',
				ADD_TAG: 'Agregar Etiqueta',
				EXPORT: 'Exportar',
				UPLOAD: 'Subir Etiquetas (Excel)',
				DOWNLOAD: 'Descargar Etiquetas (Excel)',
				VIEW: 'Ver',
				EDIT: 'Editar',
				NO_TAGS_FOUND: 'No se encontraron etiquetas',
				ADD_DESCRIPTION: 'Agregar Descripción',
				ADD_UOM: 'Agregar UdM',
				COL_INDEX: '#',
				COL_SYSTEM_NAME: 'Nombre del Sistema',
				COL_TAG_NAME: 'Nombre de Etiqueta',
				COL_TAG_ID: 'ID de Etiqueta',
				COL_TAG_DESCRIPTION: 'Descripción de Etiqueta',
				COL_UOM: 'Unidad',
				COL_IR_UPPER: 'IR Superior',
				COL_TRIP_UPPER: 'Disparo Superior',
				COL_ALARM_UPPER: 'Alarma Superior',
				COL_THRES_UPPER: 'Umbral Superior',
				COL_OPS_UPPER: 'Operación Superior',
				COL_OPS_LOWER: 'Operación Inferior',
				COL_THRES_LOWER: 'Umbral Inferior',
				COL_ALARM_LOWER: 'Alarma Inferior',
				COL_TRIP_LOWER: 'Disparo Inferior',
				COL_IR_LOWER: 'IR Inferior',
				COL_FLATLINE: 'Detección de Línea Plana',
				COL_OUTLIER: 'Detección de Atípicos',
				COL_RANGE: 'Detección de Fuera de Rango',
				COL_MISSING_DATA: 'Detección de Datos Faltantes',
				COL_FLATLINE_ALERT: 'Gen. Alerta de Línea Plana',
				COL_OUTLIER_ALERT: 'Gen. Alerta de Atípicos',
				COL_RANGE_ALERT: 'Gen. Alerta de Fuera de Rango',
				COL_MISSING_DATA_ALERT: 'Gen. Alerta de Datos Faltantes',
				COL_ATTENTION: 'Atención',
				COL_THRES_NOT: 'Not. Umbral',
				COL_KPI: 'KPI',
				COL_DIRECTIONALITY: 'Direccionalidad',
				COL_IOW_LOWER: 'IOW Inferior',
				COL_IOW_UPPER: 'IOW Superior',
				COL_ACTIONS: 'Acciones',
				COL_DESCRIPTION: 'Descripción',
				EDIT_TAG: 'Editar Etiqueta',
				LOWER: 'Inferior',
				UPPER: 'Superior',
				INSTRUMENT_RANGE: 'Rango de Instrumento',
				TRIP_LIMITS: 'Límites de Disparo',
				ALARM_LIMITS: 'Límites de Alarma',
				THRESHOLD_LIMITS: 'Límites de Umbral',
				DIRECTIONALITY: 'Direccionalidad',
				IOW_CRITICALITY: 'Criticidad IOW',
				FLATLINE_DETECTION: 'Detección de Línea Plana',
				THRESHOLD_NOTIFICATION: 'Notificación de Umbral',
				ASSET: 'Activo',
				CALCULATED_FLAG: 'Indicador Calculado',
				REMARK: 'Observación',
				REMARK_PLACEHOLDER: 'Ingrese Observación para Editar',
				CANCEL: 'Cancelar',
				SAVE: 'Guardar',
			},
			DATA_FEED: {
				TITLE: 'Salud del Feed de Datos (Monitoreo)',
				ALL_TAGS: 'Todas las etiquetas',
				GOOD_TAGS: 'Etiquetas buenas',
				BAD_TAGS: 'Etiquetas malas',
				GROUP_BY: 'Agrupar por',
				DOWNLOAD: 'Descargar',
				NO_TAGS_FOUND_TITLE: 'No se encontraron etiquetas',
				NO_TAGS_FOUND_DESC: 'Verifique filtros y rango de fechas',
				TAGS: 'Etiquetas',
				SHOW: 'Mostrar',
				MORE_TAGS: 'más etiquetas',
				NO_TAGS: 'No se encontraron etiquetas.',
				SYSTEM_NAME: 'Nombre del Sistema',
				VALUE: 'Valor',
				QUALITY: 'Calidad',
				TIMESTAMP: 'Marca de tiempo',
				TAG_NAME: 'Nombre de la Etiqueta',
				TAG_ID: 'ID de Etiqueta'
			},
			MODEL_HEALTH: {
				TITLE: 'Métricas de Salud del Sistema y Modelo',
				ALL_SYSTEMS: 'Todos los sistemas',
				PROBLEM_SYSTEMS: 'Sistemas con problemas',
				NO_PROBLEM_SYSTEMS: 'No se encontraron sistemas con problemas',
				SEARCH: 'Buscar...',
				REFRESH: 'Actualizar datos',
				DOWNLOAD: 'Descargar',
				SYSTEM_NAME: 'Nombre del Sistema',
				STATUS: 'ESTADO',
				DEPLOYED_VERSION: 'Versión implementada',
				LAST_DATA_PULL: 'Última extracción',
				DATA_HEALTH: 'Salud de datos',
				MODEL_HEALTH: 'Salud del modelo',
				PREDICTION_TIME: 'Tiempo de predicción',
				LAST_PREDICTION: 'Última predicción',
				PREDICTIONS_OLDER_THAN_2_HOURS: 'Predicciones > 2 hrs son Sistemas con Problemas',
				LAST_DATA_WRITTEN: 'Últimos datos escritos',
				LAST_ANOMALY_WRITTEN: 'Última anomalía',
				FETCH_STATUS: 'Estado de extracción',
				FETCH_RATE: 'Tasa de extracción',
				FETCH_SAMPLING_RATE: 'Tasa de muestreo',
				PREDICTION_STATUS: 'Estado de predicción',
				PREDICTION_RATE: 'Tasa de predicción',
				SAMPLING_RATE: 'Tasa de muestreo',
				ACTIONS: 'Acciones',
				CUSTOMIZE_COLUMNS: 'Personalizar columnas',
				NO_DATA_MATCHING: 'No hay datos disponibles para el activo seleccionado',
				DEPLOYED_DATE: 'Fecha de implementación',
				DEPLOYED_BY: 'Implementado por',
				DEPLOYMENT_NOTE: 'Nota de implementación',
				ACTIVE_ALERTS: 'Alertas activas',
				RETRAINING_RECOMMENDED: {
					TITLE: 'Reentrenamiento recomendado',
					DESCRIPTION: 'La evaluación reciente sugiere que el modelo puede ya no reflejar el comportamiento operativo actual. Las siguientes etiquetas contribuyen más a esta recomendación.',
					CONTRIBUTING_TAGS: 'Etiquetas contribuyentes (hasta 5)',
					TAG_NAME_AND_ID: 'Nombre e ID de etiqueta',
					TAG_TOOLTIP: 'Nombre: {{tagName}}\nTagID: {{tagId}}',
					CONTRIBUTION_SCORE: 'Puntuación de contribución',
					LAST_EVALUATED: 'Última evaluación',
					MODEL_VERSION: 'Modelo',
					COPY_TAGS: 'Copiar etiquetas',
					COPY_FULL_DETAILS: 'Copiar detalles completos',
					RETRAIN_MODEL: 'Reentrenar modelo',
					RETRAIN: 'Reentrenar',
					TIP_PREFIX: 'Consejo: Haga clic en el chip',
					TIP_SUFFIX: 'de la columna Salud del modelo para ver por qué se recomienda el reentrenamiento.',
					NO_TAGS: 'No se encontraron etiquetas contribuyentes.',
					TAGS_COPIED: 'Etiquetas copiadas.\nDisponibles en el portapapeles.',
					DETAILS_COPIED: 'Detalles copiados.\nDisponibles en el portapapeles.',
					RECOMMENDED_DATE_RANGE: 'Rango de fechas recomendado para reentrenar',
					RECOMMENDED_DATE_RANGE_HINT: 'Use este rango de fechas para revisar y reentrenar el modelo con los datos más relevantes.',
					NO_DATE_RANGE: 'No hay rango de fechas disponible para reentrenar el modelo',
					ADD_COMMENT: 'Agregar comentario',
					ADD_COMMENT_PLACEHOLDER: 'Agregar un motivo',
					START_RETRAINING: 'Iniciar reentrenamiento',
					BACK: 'Atrás',
					FORCE_INCLUDE_BANNER: 'Las regiones recomendadas se han añadido automáticamente como rangos Force Include.',
					TRAINING_PERIOD: 'Período de entrenamiento',
					EXISTING_TRAINING_REGION: 'Región de entrenamiento existente',
					CURRENT_MODEL_VERSION: 'Versión actual del modelo',
					RECOMMENDED_REGION: 'Región recomendada',
					FROM_MODEL_HEALTH_EVALUATION: 'De la evaluación de salud del modelo',
					NO_TRAINING_RANGES: 'No hay regiones de entrenamiento disponibles.',
					LOADING_RANGES: 'Cargando regiones de entrenamiento...',
				}
			}
		},
		SHARED_MODULE: {
			COLUMN_CONFIG: {
				TITLE: 'Mostrar columnas',
				SEARCH: 'Buscar...',
				SELECT_ALL: 'Seleccionar todo',
				RESET_TO_DEFAULT: 'Restablecer'
			},
			CALCULATED_TAG_POPUP: {
				EXPRESSION: 'Expresión',
				EXPRESSION_DESCRIPTION: 'Descripción de la expresión'
			}
		},
		DATA_MANAGEMENT: {
			QC: {
				RUN_QC: 'Ejecutar QC',
				RUN_QC_SELECTED: 'Ejecutar QC en seleccionados',
				RUN_QC_TOOLTIP: 'Ejecutar el agente de calidad de datos sobre los registros actuales',
				RUNNING: 'Ejecutando QC',
				DETAIL_TITLE: 'Registro de mantenimiento',
				TAB_DETAILS: 'Detalles',
				TAB_REVIEW: 'Revisión',
				NO_DETAILS: 'No hay detalles disponibles.',
				VIEW_DETAILS: 'Ver detalles',
				FIELDS: {
					NOTIFICATION_NO: 'N.º de aviso',
					ORDER: 'Orden',
					TYPE: 'Tipo',
					EQUIPMENT: 'Equipo',
					EQUIPMENT_DESC: 'Descripción del equipo',
					FUNCTIONAL_LOC: 'Ubicación funcional',
					PLAN_GROUP: 'Grupo planificador',
					PLAN_GROUP_DESC: 'Descripción del grupo planificador',
					MAINTENANCE_PLANT: 'Planta de mantenimiento',
					MAINTENANCE_PLANT_DESC: 'Descripción de la planta de mantenimiento',
					PLANT_SECTION: 'Sección de planta',
					PRIORITY: 'Prioridad',
					DAMAGE: 'Daño',
					DESCRIPTION: 'Descripción',
					STATUS: 'Estado',
					USER_STATUS: 'Estado de usuario',
					CREATED_ON: 'Creado el',
					COMPLETED_ON: 'Completado el',
					BREAKDOWN_DURATION: 'Duración de la avería',
					INTERNAL_LABOUR: 'Costo de mano de obra interna',
					EXTERNAL_LABOUR: 'Costo de mano de obra externa',
					EXTERNAL_SERVICE: 'Costo de servicio externo'
				},
				LAST_RUN: 'Última ejecución de QC',
				VIEW_FINDINGS: 'Ver hallazgos',
				FINDINGS_TITLE: 'Hallazgos de calidad de datos',
				NO_FINDINGS: 'No se encontraron problemas para este registro.',
				BLOCKERS: 'Bloqueantes',
				WARNINGS: 'Advertencias',
				RULE: 'Regla',
				FIELD: 'Campo',
				EVIDENCE: 'Evidencia',
				RECOMMENDATION: 'Recomendación',
				CONFIG_TITLE: 'Reglas de calidad de datos',
				SCOPE_GLOBAL: 'Global',
				SCOPE_SYSTEM: 'Este sistema',
				RULE_MANDATORY_FIELDS: 'Campos obligatorios',
				MANDATORY_FIELDS_LABEL: 'Campos requeridos',
				SEVERITY: 'Severidad',
				RULE_DESCRIPTION: 'Longitud de la descripción',
				MIN_LENGTH: 'Longitud mínima (caracteres)',
				RULE_DATES: 'Consistencia de fechas',
				ALLOW_COMPLETION_BEFORE_CREATION: 'Permitir fecha de finalización anterior a la de creación',
				RULE_DUPLICATES: 'Detección de duplicados',
				WINDOW_DAYS: 'Ventana de duplicados (días)',
				RULE_PLANNING: 'Planificación',
				REQUIRE_LABOR: 'Requerir mano de obra en órdenes de trabajo',
				RULE_COMPLETION: 'Finalización',
				REQUIRE_ROOT_CAUSE: 'Requerir causa raíz en registros finalizados',
				RULE_TEXT_QUALITY: 'Calidad del texto (AI)',
				TEXT_QUALITY_HINT: 'Usa el modelo de lenguaje para revisar ortografía y calidad de la descripción',
				CHECK_SPELLING: 'Revisar ortografía',
				CHECK_DESCRIPTION_MEANING: 'Revisar que la descripción sea significativa',
				CHECK_ROOT_CAUSE: 'Revisar idoneidad de la causa raíz',
				RULE_WORK_ORDER: 'Orden de trabajo requerida',
				WORK_ORDER_HINT: 'Marca una orden de trabajo faltante solo cuando la notificación está completada y pertenece a los tipos de notificación seleccionados abajo.',
				WORK_ORDER_TYPES_LABEL: 'Tipos de notificación que requieren una orden de trabajo',
				RULE_SLA: 'SLA / Fecha requerida',
				SLA_CHECK_OVERDUE: 'Marcar notificaciones vencidas respecto a su fecha de finalización requerida',
				SLA_CHECK_LATE: 'Marcar notificaciones completadas después de su fecha de finalización requerida',
				RULE_BREAKDOWN_CONSISTENCY: 'Consistencia del indicador de avería',
				BREAKDOWN_CONSISTENCY_HINT: 'Verifica el indicador de avería (Effect) contra el tiempo de inactividad registrado. Seleccione los valores de Effect que indican una avería en este sitio.',
				BREAKDOWN_EFFECT_VALUES_LABEL: 'Valores de Effect que indican una avería',
				RULE_AGING: 'Antigüedad / Atraso acumulado',
				MAX_OPEN_DAYS: 'Días máximos que una notificación puede permanecer abierta',
				RULE_STATUS_CONSISTENCY: 'Consistencia de cierre de estado',
				STATUS_CONSISTENCY_HINT: 'Verifica la fecha de finalización contra el estado de cierre del flujo de trabajo. Seleccione los códigos de estado que significan \'cerrado\' en este sitio.',
				CLOSED_KEYWORDS_LABEL: 'Códigos de estado que significan cerrado',
				RULE_COST_SANITY: 'Sanidad de costos',
			},
			TABS: {
				DOCUMENTS: 'Documentos',
				TAGS: 'Etiquetas',
				MAINTENANCE: 'Mantenimiento',
				PIDS: 'P&IDs',
				RELIABILITY: 'Fiabilidad'
			},
			COMMON: {
				PROCESSING: 'Procesando',
				READY: 'Listo',
				REVIEW: 'Revisar',
				BLOCKED: 'Bloqueado',
				PENDING: 'Pendiente',
				SEARCH: 'Buscar...',
				SEARCH_RECORDS: 'Buscar registros...',
				ADD_DOCUMENT: 'Añadir Documento',
				NO_MATCHING: 'No se encontraron documentos.',
				LOADING: 'Cargando datos...',
				LOADING_MORE: 'Cargando más...',
				LOADING_MORE_RECORDS: 'Cargando más registros...',
				CANCEL: 'Cancelar',
				EDIT: 'Editar',
				SAVE: 'Guardar',
				SAVING: 'Guardando...',
				ASK_ROOTY: 'Preguntar a Rooty',
				DOWNLOAD: 'Descargar',
				IMPORT_DATA: 'Importar datos',
				REPLACE_FILE: 'Reemplazar archivo',
				UPLOAD: 'Subir'
			},
			FILTERS: {
				ALL_ISSUES: 'Todos los problemas',
				CHOOSE_ISSUES: 'Elegir problemas a mostrar',
				ALL_CLASSES: 'Todas las clases',
				CHOOSE_CLASSES: 'Elegir clases a mostrar',
				GROUP_BY: 'Agrupar por',
				ALL_TYPES: 'Todos los tipos',
				EVENT_TYPES: 'Tipos de eventos',
				FILTER_ISSUE_TYPE: 'Tipo de Problema'
			},
			IMPORT_BANNER: {
				IMPORTING: 'Importando {{ count }} documentos',
				IMPORTING_AUTO: 'Importando {{ uploaded }} documentos, {{ remaining }} restantes (Total: {{ total }})',
				INITIALIZING_AUTO: 'Inicializando la sincronización de documentos...',
				AUTO_TAKE_MINS: 'Por favor espere mientras sincronizamos sus documentos en segundo plano...',
				TAKE_30_MINS: 'Esto puede tardar hasta 30 minutos.',
				IMPORTED_SUCCESS: '{{ count }} documentos importados',
				SUMMARY: 'Resumen de importación:',
				NEEDS_REVIEW: 'Necesita revisión',
				ALREADY_PRESENT: 'Ya presente',
				REMOVED_AT_SOURCE: 'Eliminado en el origen',
				SYNC_FAILED: 'Error de sincronización'
			},
			TABLE_COLUMNS: {
				DOCUMENT: 'Documento',
				CLASS: 'Clase',
				DOC_TYPE: 'Tipo',
				STATUS: 'Estado',
				SOURCE: 'Fuente',
				ISSUES: 'Problemas',
				LAST_UPDATED: 'Última actualización',
				ACTIONS: 'Acciones',
				NOTIFICATION: 'Notificación',
				EQUIPMENT: 'Equipo',
				DESCRIPTION: 'Descripción',
				TYPE: 'Tipo',
				MAINTENANCE_PLANT: 'Planta de Mant.',
				FAILURE_MODE: 'Modo de falla',
				SECTION: 'Sección',
				DATES: 'Fechas',
				CONTEXT: 'Contexto',
				TIME_HRS: 'Tiempo (en hrs)',
				RCA: 'RCA',
				SOURCE_NAME: 'Nombre de Fuente',
				PATH: 'Ruta',
				SYNC_FREQUENCY: 'Frecuencia de Sincronización',
				LAST_SYNCED: 'Última Sincronización',
			},
			EMPTY_STATE: {
				NO_DOCS_TITLE: 'No hay documentos importados',
				NO_DOCS_SUBTITLE: 'Añada documentos manualmente o use la herramienta de IA.',
				NO_MAINT_TITLE: 'No hay datos de mantenimiento',
				NO_MAINT_SUBTITLE: "Seleccione 'Importar datos' para comenzar a agregar datos de mantenimiento."
			},
			ADD_DOC_DIALOG: {
				FILE_UPLOAD: 'Subir archivo',
				UPLOAD_MANUALLY: 'Subir archivos manualmente',
				BULK_UPLOAD_TITLE: 'Carga masiva con plantilla',
				BULK_UPLOAD_DESC: 'Descargue la estructura, coloque los documentos y suba la carpeta entera.',
				DOWNLOAD_TEMPLATE: 'Descargar plantilla',
				DRAG_DROP: 'Arrastra tu archivo aquí o',
				BROWSE: 'navegar',
				SUPPORTS: 'Soporta PDF, Word, Excel, imágenes o un ZIP para carga masiva.',
				SELECTED_FILES: 'Archivos seleccionados',
				APPLY_TO_ALL: 'Aplicar a todos:',
				CLASS: 'Clase',
				DOC_TYPE: 'Tipo de Doc',
				LINKED_TO: 'Vinculado a',
				SELECT_CLASS: 'Seleccionar clase',
				SELECT_DOC_TYPE: 'Seleccionar Tipo Doc',
				CHOOSE_LINK: 'Elegir dónde vincular',
				FILE_SELECTED: 'Archivo seleccionado',
				FILES_SELECTED: 'Archivos seleccionados',
				CONFIRM_IMPORT: 'Confirmar/Importar',
				REPLACE_HINT: 'Por favor, suba el archivo de reemplazo correcto para este documento. Idealmente, debería ser el mismo archivo que se pretendía originalmente.',
				DUPLICATE_BADGE: 'Duplicado',
				DUPLICATES_SKIPPED_BANNER: 'Se detectaron {{count}} archivo(s) duplicado(s). Se excluyen y no se subirán.',
				DUPLICATES_SKIPPED_INLINE: '({{count}} duplicado omitido)',
				REMOVE_DUPLICATES: 'Eliminar duplicados'
			},
			DOC_VIEWER: {
				DOC_DETAILS: 'Detalles del documento',
				PREVIEW: 'Vista previa',
				FULL_SCREEN: 'Pantalla completa',
				NO_PREVIEW: 'Sin vista previa',
				NO_PREVIEW_DESC: 'Este archivo no se puede previsualizar.',
				METADATA: 'Metadatos',
				DOC_IDENTIFICATION: 'Identificación',
				DOC_NAME: 'Nombre',
				DOC_ID: 'ID de documento',
				DOC_CLASS: 'Clase',
				DOC_TYPE: 'Tipo de documento',
				MISSING: 'Falta',
				DOC_SOURCE: 'Origen',
				FILE_SIZE: 'Tamaño del archivo',
				FILE_UPLOAD_SOURCE: 'Carga de archivo',
				EXTERNAL_SOURCE: 'Externo (Drive, etc)',
				VERSIONING: 'Versiones',
				UPLOADED_ON: 'Subido el',
				LAST_MODIFIED: 'Modificado por última vez',
				EFFECTIVE_DATE: 'Día efectivo',
				EXPIRY_DATE: 'Fecha de caducidad',
				REVISION: 'Revisión',
				VERSION_1: 'Versión 1',
				VERSION_2: 'Versión 2',
				STATUS: 'Estado',
				STATUS_UPLOADING: 'Subiendo',
				STATUS_QUEUED: 'En cola',
				STATUS_PROCESSING: 'Procesando',
				STATUS_READY: 'Listo',
				STATUS_PENDING: 'Pendiente',
				LINKED_TO: 'Vinculado a',
				FACILITIES: 'Instalaciones',
				UNITS: 'Unidades',
				SYSTEMS: 'Sistemas',
				CHOOSE_LINK_DESC: 'Elija dónde vincular',
				EXTRACTED_DATA: 'Datos extraídos',
				NO_EXTRACTED_DATA: 'No hay datos extraídos.'
			},
			TOOLTIPS: {
				ISSUE_FILTER: 'Filtro de problemas',
				CLASS_FILTER: 'Filtro de clase',
				CUSTOMIZE_COLUMNS: 'Personalizar columnas',
				VIEW_DETAILS: 'Ver detalles',
				DELETE_FILE: 'Eliminar archivo',
				STATUS_QUEUED_PROCESSING: 'Su documento está en cola y se procesará en breve.',
				STATUS_READY: 'Su documento ha sido procesado y está listo para usar.'
			},
			DEDUP_MENU: {
				TRIGGER_LABEL: 'Duplicados',
				TITLE: 'Duplicados resueltos',
				SUMMARY: '{{dupes}} de {{total}} archivo(s) seleccionado(s) tienen duplicados',
				DESCRIPTION: 'Los originales se conservan. Los otros {{unaffected}} archivo(s) no se modifican.',
				MERGE_TAGS: 'Eliminar duplicados, fusionar etiquetas ({{count}})',
				NO_MERGE_TAGS: 'Eliminar duplicados, NO fusionar etiquetas ({{count}})',
				FAILURE: 'No se pudieron eliminar algunos duplicados',
				TOAST_MERGED: 'Se eliminaron {{count}} archivo(s) duplicado(s). Las etiquetas se fusionaron con los archivos originales.',
				TOAST_NOT_MERGED: 'Se eliminaron {{count}} archivo(s) duplicado(s). Las etiquetas del archivo original no se modificaron.'
			},
			CONNECTED_SOURCES: {
				CLOSE: 'Cerrar',
				DISCONNECT_MSG: 'Desconectar {{provider}} detendrá la sincronización de documentos e impedirá que UptimeAI acceda a los archivos de la cuenta de {{provider}} conectada.<br/>Los documentos ya importados en UptimeAI permanecerán disponibles, pero ya no recibirán actualizaciones de {{provider}}.',
				DISCONNECT_TITLE: '¿Desconectar la integración de {{provider}}?',
				DISCONNECT_OK: 'Desconectar {{provider}}',
				FETCH_SOURCES_FAILED: 'Error al obtener las fuentes conectadas.',
				SOURCE_UPDATED_SUCCESS: 'Fuente actualizada con éxito.',
				SOURCE_CONNECTED_SUCCESS: 'Fuente conectada con éxito.',
				TRIGGERING_SYNC: 'Iniciando sincronización...',
				SYNC_STARTED_SUCCESS: 'Sincronización iniciada con éxito.',
				FAILED_TRIGGER_SYNC: 'Error al iniciar la sincronización.',
				INACTIVE_REASON_COVERED: 'Cubierto por la fuente principal activa \'{{name}}\' ({{path}})',
				REAL_TIME: 'Tiempo real',
				ONE_TIME: 'Una vez',
				DAILY: 'Diario',
				HOURLY: 'Cada hora',
				WEEKLY: 'Semanal',
				MONTHLY: 'Mensual',
				NA: 'N/A',
				PAUSED: 'Pausado',
				INACTIVE: 'Inactivo',
				UNKNOWN: 'Desconocido',
				TITLE: 'Fuentes Conectadas',
				ACTIVE: 'Activo',
				CONNECT_SOURCE: 'Conectar Fuente',
				NO_SOURCES_HEADING: 'Aún no hay fuentes conectadas.',
				NO_SOURCES_CONTENT: 'Conecta una fuente para importar archivos.',
				NEVER: 'Nunca',
				SYNC_NOW: 'Sincronizar ahora',
				MONITOR: 'Monitorear',
				SETTINGS: 'Configuración',
				DISCONNECT: 'Desconectar',
				SYNC_ACTIVITY: 'Actividad de sincronización',
				NO_RECENT_ACTIVITY: 'No se encontró actividad de sincronización reciente.',
				STATUS_SUCCESS: 'Éxito',
				STATUS_PARTIAL: 'Parcial',
				STATUS_FAILED: 'Fallido',
				STATUS_RUNNING: 'Corriendo',
				SYNC_FAILED_ERROR: 'La sincronización falló debido a un error.',
				SYNC_STATS: '+ {{new}} nuevos · {{updated}} actualizados · {{skipped}} sin cambios',
				SYNC_STATS_PARTIAL: '+ {{new}} nuevos · {{updated}} actualizados · {{skipped}} sin cambios · {{failed}} fallidos',
			},
			CONNECT_SOURCE: {
				PROVIDERS: {
					DOCUMENT_LOCATOR: {
						NAME: 'Document Locator',
						DESC: 'Conéctese a una base de datos de Document Locator para sincronizar documentos de forma continua.'
					}
				},
				PROVIDER_FIELDS: {
					DOCUMENT_LOCATOR: {
						DIALECT: 'Tipo de base de datos',
						HOST: 'Host del servidor',
						PORT: 'Puerto',
						DATABASE: 'Nombre de la base de datos',
						USER: 'Nombre de usuario',
						PASSWORD: 'Contraseña',
						ENCRYPT: 'Cifrar la conexión',
						TRUST_CERT: 'Confiar en el certificado del servidor',
						SP_FILE_INFO: 'Procedimiento de información de archivos',
						SP_FILE_CONTENT: 'Procedimiento de contenido de archivos',
						SP_PLACEHOLDER: 'Introduzca el nombre del procedimiento almacenado'
					}
				},
				TITLE: 'Conectar Fuente',
				STEP_1: 'Conectar a Fuente',
				STEP_2: 'Autenticar Fuente',
				STEP_3: 'Detalles de la Fuente',
				SHAREPOINT: 'SharePoint',
				SHAREPOINT_DESC: 'Conéctese a las bibliotecas de SharePoint para sincronizar documentos continuamente.',
				CONNECT_TO_SHAREPOINT: 'Conectar a SharePoint',
				CONNECT_TO_PROVIDER: 'Conectar a {{provider}}',
				CONNECTION_VERIFIED: 'Conexión verificada.',
				DESCRIPTOR_LOAD_FAILED: 'No se pudo cargar la configuración de esta fuente.',
				TEST_CONNECTION_REQUIRED: 'Pruebe la conexión con éxito antes de conectarse.',
				API_INTEGRATION: 'Integración API',
				API_DESC: 'Conéctese a las APIs de gestión de documentos para sincronizar archivos automáticamente.',
				CMMS: 'CMMS',
				CMMS_DESC: 'Conéctese a su CMMS (SAP PM, Maximo, etc.) para la sincronización continua de documentos.',
				COMING_SOON: 'Próximamente',
				OAUTH_TAB: 'Iniciar sesión con Microsoft (OAuth)',
				TOKEN_TAB: 'Token de acceso (manual)',
				SIGN_IN_MICROSOFT: 'Iniciar sesión con Microsoft',
				OAUTH_DESC: 'Conecte su cuenta de Microsoft para explorar las bibliotecas de SharePoint e importar documentos.',
				SECURE_AUTH: 'Autenticación segura',
				SECURE_AUTH_DESC: 'Utiliza Microsoft OAuth. Sus credenciales nunca se almacenan en esta aplicación.',
				READ_ONLY: 'Acceso de solo lectura',
				READ_ONLY_DESC: 'La aplicación solo lee documentos. No se modificarán ni eliminarán archivos en SharePoint.',
				TOKEN_PLACEHOLDER: 'Pegue su token de acceso de SharePoint',
				TOKEN_WARNING: 'Los tokens de acceso caducan. Considere OAuth para una sincronización ininterrumpida.',
				MANUAL_AUTH_DESC: 'Ingrese sus credenciales de Registro de Aplicación de Azure. Se almacenan de forma segura en el servidor.',
				TENANT_ID_LABEL: 'ID de Inquilino',
				TENANT_ID_PLACEHOLDER: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
				CLIENT_ID_LABEL: 'ID de Cliente (ID de Aplicación)',
				CLIENT_ID_PLACEHOLDER: 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
				CLIENT_SECRET_LABEL: 'Secreto del Cliente',
				CLIENT_SECRET_PLACEHOLDER: 'Pegue el valor de su secreto de cliente',
				SAVE_CREDENTIALS: 'Guardar y Continuar',
				STEP_CONNECTION_CONFIG: 'Configuración de conexión',
				APP_CONNECTION_CONFIG: 'Configuración de conexión de la aplicación',
				NEW_CONNECTION: 'Nueva conexión',
				ACTIVE_CONNECTION_CONFIG: 'Configuración de conexión activa',
				PROVIDER: 'Proveedor',
				MICROSOFT_SHAREPOINT: 'Microsoft SharePoint',
				APP_ID: 'ID de la aplicación (ID del cliente)',
				REGISTER_CONFIG_DESC: 'Ingrese los detalles para registrar una nueva configuración de credenciales de cliente/registro de aplicación.',
				CONFIG_NAME_LABEL: 'Nombre de la configuración',
				CONFIG_NAME_PLACEHOLDER: 'p. ej. SharePoint Production',
				BACK_TO_SELECTION: 'Volver a la selección',
				SAVE_CONNECTION_BTN: 'Guardar conexión',
				PLEASE_SELECT_CONNECTION: 'Seleccione o registre una configuración de conexión primero.',
				RESTORED_SESSION_FOR: 'Sesión autenticada restaurada para: {{user}}',
				PLEASE_COMPLETE_SIGNIN: 'Por favor, complete primero el inicio de sesión de Microsoft.',
				SELECT_APP_REGISTRATION: 'Seleccione o registre primero una conexión de registro de aplicaciones.',
				FAILED_AUTH_URL: 'Error al obtener la URL de autorización de Microsoft.',
				ERROR_REQ_AUTH_LINK: 'Error al solicitar el enlace de autorización.',
				FILL_ALL_FIELDS: 'Complete todos los campos de configuración de conexión.',
				APP_REG_SAVED: 'Configuración de registro de aplicación guardada correctamente.',
				FAILED_SAVE_CONFIG: 'Error al guardar la configuración.',
				SITE_URL_LABEL: 'URL del sitio de SharePoint (La URL completa de su colección de sitios de SharePoint)',
				SITE_URL_PLACEHOLDER: 'https://company.sharepoint.com/sites/engineering',
				LIBRARY_PATH_LABEL: 'Ruta de la biblioteca',
				LIBRARY_PATH_DESC: '(Ruta a la biblioteca de documentos, ej. /Shared Documents/Equipment)',
				LIBRARY_PATH_PLACEHOLDER: '/Shared Documents/Equipment',
				FILE_TYPE_LABEL: 'Filtro de tipo de archivo (Solo importar archivos que coincidan con estos tipos; dejar vacío para todos)',
				SYNC_FREQUENCY: 'Frecuencia de sincronización',
				SYNC_AUTO: 'Auto (Tiempo real)',
				SYNC_HOURLY: 'Cada hora',
				SYNC_DAILY: 'Diaria',
				SYNC_DAILY_DESC: 'Sincronizar cada 24 horas a una hora programada',
				SYNC_WEEKLY: 'Semanal',
				SYNC_BIWEEKLY: 'Quincenal',
				SYNC_MONTHLY: 'Mensual',
				CONFLICT_LABEL: 'Resolución de conflictos (Cómo manejar documentos que ya existen en el sistema)',
				CONFLICT_KEEP_NEWEST: 'Mantener la versión más reciente',
				TEST_CONNECTION: 'Probar conexión',
				TEST_SUCCESS: 'Conexión exitosa - se encontraron {{count}} archivos de documentos coincidentes',
				CANCEL: 'Cancelar',
				CONNECT_AND_SYNC: 'Conectar e iniciar sincronización',
				AUTH_SUCCESS: 'Se ha autenticado correctamente. Haga clic en Siguiente a continuación para configurar los detalles de la fuente.',
				APP_ONLY_SYNC_DESC: 'La sincronización solo de aplicación se ejecuta en segundo plano utilizando la configuración de registro de la aplicación seleccionada. No se requiere inicio de sesión de usuario individual.',
				FILE_TYPE_FILTER_DESC: 'Solo importe archivos que coincidan con estos tipos; déjelo sin seleccionar para importar todos los archivos.',
				NEXT: 'Siguiente',
				AUTHENTICATED_PROFILE: 'Perfil de Microsoft Autenticado',
				USER_NAME: 'Nombre de Usuario',
				EMAIL_ADDRESS: 'Dirección de correo electrónico',
				SIGN_IN_DIFFERENT_ACCOUNT: 'Iniciar sesión con una cuenta diferente'
			}
		},
		MODULE_CONFIGURATION: {
			TABS: {
				TRIAGE: 'Alert Triage', MAINTENANCE: 'Mantenimiento', COMING_SOON: 'Próximamente' },
			COMMON: { CANCEL: 'Cancelar', SAVE: 'Guardar', EDIT: 'Editar', DOWNLOAD: 'Descargar', UPLOAD: 'Subir', DELETE: 'Eliminar', SELECT_ALL: 'Seleccionar todo', SEARCH: 'Buscar actividad...', EDIT_CONFIGURATION: 'Editar configuración', SAVE_CONFIGURATION: 'Guardar configuración', APPLY_TEMPLATE: 'Aplicar plantilla', TEMPLATE_MANAGER: 'Gestor de plantillas', SAVED_CONFIGURATION: 'Configuración guardada', CONFIGURE: 'Configurar', BETA_ANALYTICS: 'Análisis β', UPDATE_TEMPLATE: 'Actualizar plantilla', SAVE_TEMPLATE: 'Guardar plantilla', FINISH_SAVE_PACKAGE: 'Finalizar y guardar paquete', DONE: 'Hecho', RE_GENERATE: 'Regenerar', YES: 'Sí', NO: 'No', LOADING: 'Loading...', COPY: 'Copiar', APPLYING_TEMPLATE: 'Aplicando plantilla', LOADING_TEMPLATE: 'Cargando plantilla', TO: 'a' },
			HEADER: { CONFIG_FOR: 'Configurar PM, FMEA, CM para:', SELECT_EQUIPMENT: 'Por favor seleccione un equipo' },
			EQUIPMENT_EMPTY: { TITLE: 'Seleccionar Equipo', DESC: 'Seleccione un equipo del panel de jerarquía para configurar', ACTIVITIES: 'actividades PM, FMEA, CM.', NO_TEMPLATE_TITLE: 'Ninguna Plantilla Aplicada', NO_TEMPLATE_DESC: 'Aplique una plantilla para configurar las actividades PM, FMEA y CM para este equipo.' },
			COMING_SOON: { TITLE: 'Próximamente', DESC: 'Esta función se encuentra actualmente en desarrollo y estará disponible en una futura actualización.' },
			MANAGER: { TITLE: 'Gestor de plantillas', EDIT_TEMPLATE: 'Editar plantilla', LINKED_ASSETS: 'activos vinculados', SUB_HEADER: 'Gestionar plantillas reutilizables de PM, CM y Modos de Falla', COL_NAME: 'Nombre de la plantilla', COL_DESC: 'Descripción', COL_TYPE: 'Tipo', COL_ASSETS: 'Activos vinculados', COL_ASSET: 'Activos', COL_CREATOR: 'Creado por', COL_DATE: 'Última modificación', EMPTY_TITLE: 'No se encontraron plantillas', EMPTY_DESC: 'Las plantillas guardadas de PM, CM y Modos de falla aparecerán aquí.', SELECT_DESC: 'Seleccione una plantilla prediseñada para aplicarla a su equipo.', SEARCH_TEMPLATE: 'Buscar plantilla...', EQ_TEMPLATE_LIBRARY: 'Biblioteca de plantillas de equipos', COL_STATUS: 'Estado', STATUS_IN_PROGRESS: 'En progreso', STATUS_READY: 'Lista para usar', STATUS_DEPRECATED: 'Obsoleta', LIFECYCLE: 'Más acciones', LOCK: 'Bloquear y marcar como lista', LOCK_HINT: 'Complete la plantilla al 100 % para poder bloquearla.', UNLOCK: 'Desbloquear', DEPRECATE: 'Marcar como obsoleta', REACTIVATE: 'Reactivar', DUPLICATING: 'Creando plantilla duplicada de {{name}}...' },
			UPLOAD: { TITLE_PM: 'Subir plantilla PM', TITLE_CM: 'Subir plantilla CM', TITLE_FM: 'Subir plantilla de Modos de falla', TEMPLATE_NAME: 'Nombre de la plantilla', ENTER_TEMPLATE: 'Ingrese el nombre de la plantilla', DRAG_DROP: 'Arrastre y suelte su archivo aquí o', BROWSE: 'examinar', REMOVE_FILE: 'Eliminar archivo' },
			PM: { TITLE: 'Configuración PM', CONFIG_FOR: 'Configurando Lista de Verificación PM para:', SELECT_HOW: 'Seleccione cómo desea configurar las actividades PM', APPLY_TEMPLATE: 'Aplicar plantilla', IMPORT_SAP: 'Importar desde SAP', UPLOAD_TEMPLATE: 'Subir Plantilla', DOWNLOAD_TEMPLATE: 'Descargar Plantilla', CHECKLIST_TEMPLATE: 'Plantilla de Lista de Verificación PM', SAVE_TEMPLATE: 'Guardar Plantilla', EDIT_TEMPLATE: 'Editar Plantilla', OVERALL_VARS: 'Variables generales de nivel PM', OVERALL_TIME: 'Tiempo total (en horas)', MUST_BE_POSITIVE: 'Ingrese un número mayor que 0', OVERALL_MANNING: 'Dotación general', TECH_COUNT: 'Técnico (en cantidad)', HELPER_COUNT: 'Ayudante (en cantidad)', COST_PARTS: 'Costo de repuestos (si los hay) (en USD)', COST_CONS: 'Costo de consumibles (en USD)', PM_INTERVAL: 'Intervalo actual del PM (en días)', PROD_LOSS: 'Pérdida de producción (en USD)', TAB_CHECKLIST: 'Lista de verificación PM', ACTIVITIES_CHECKLIST: 'Lista de verificación de actividades PM', ACTIVITIES_CHECKLIST_DESC: 'Lista de todas las actividades PM definidas en esta plantilla de lista de verificación', ENRICH_ROOTY: 'Enriquecer lista de verificación con Rooty', ROOTY_LOADING: 'Rooty está analizando sus actividades PM...', ROOTY_BUNDLE_TITLE: 'Sugerencias de paquetes de actividades', ROOTY_BUNDLE_DESC: 'Revise los paquetes sugeridos a continuación. Confirme para continuar y generar los indicadores de construcción.', ROOTY_CONFIRM_BUNDLES: 'Todo bien — Generar indicadores de construcción', ROOTY_CONFIRM_FLAGS: 'Todo bien — Generar tiempo por actividad', ROOTY_FLAGS_READY: 'Indicadores de construcción generados. Revise las pestañas a continuación.', ROOTY_FLAGS_OUTPUT: 'Análisis de indicadores de construcción', ROOTY_NO_SYSTEM: 'Guarde la Actividad PM para habilitar el enriquecimiento', TAB_BUNDLES: 'Paquetes de Actividades', BUN_TITLE: 'Paquetes de Actividades PM', BUN_DESC: 'Agrupar actividades de PM en paquetes lógicos para una programación eficiente', TAB_FLAGS: 'Indicadores de construcción', FLAG_TITLE: 'Indicadores de construcción', FLAG_DESC: 'Clasificar las actividades como regulatorias, procedimentales u operativas', TAB_TIME: 'Tiempo por Actividad', TIME_TITLE: 'Tiempo por Actividad', TIME_DESC: 'Estimar el tiempo requerido para cada actividad PM', TAB_BETA: 'Definir β', BETA_TITLE: 'Definir β', BETA_DESC: 'Establecer la sensibilidad de CM/fallas sobre la frecuencia de PM para cada actividad', RE_GENERATE: 'Re-generar', CHECKLIST_CONFIG: 'Configuración de lista de verificación PM', CONFIG_CHECKLIST_FOR: 'Configurando lista de verificación para:', ROOTY_CANNED_1: 'Leyendo la lista de verificación...', ROOTY_CANNED_2: 'Analizando actividades de PM...', ROOTY_CANNED_3: 'Preparando sugerencias...' },
			PM_APPLY: { TITLE: 'Biblioteca de plantillas de listas de verificación de PM', STEP_1: 'Seleccionar Plantilla', STEP_2: 'Seleccionar Equipo', STEP_1_DESC: 'Seleccione una plantilla de lista de verificación PM preconstruida para aplicar a su equipo. Las plantillas contienen secuencias configuradas de actividades de pm de las mejores prácticas.', EMPTY: 'No se encontraron plantillas.', CONFIG_FOR: 'Plantilla PM configurada para', EXEC_SUCCESS: 'ejecutándose a lo largo de los límites del intervalo con éxito.', PM_ACTIVITIES: 'Actividades PM', INTERVAL: 'Intervalo:', APPLIES_TO: 'Aplica a:', EQ_TITLE: 'Seleccionar equipo para aplicar plantilla', EQ_SELECTED: 'Equipos Seleccionados', SELECT_TEMPLATE: 'Seleccionar Plantilla', APPLY_TEMPLATE: 'Aplicar Plantilla' },
			CM: { TITLE: 'Configuración CM', CONFIG_FOR: 'Configurando actividades CM para:', SELECT_HOW: 'Seleccione cómo desea configurar las actividades CM', APPLY_TEMPLATE: 'Aplicar plantilla', UPLOAD_TEMPLATE: 'Cargar plantilla', DOWNLOAD_TEMPLATE: 'Descargar plantilla', CM_VARS: 'Variables de Nivel CM', EQ_REDUNDANCY: 'Redundancia del equipo', PROD_LOSS: 'Pérdida de Producción', TECH_COUNT: '# de Técnicos Necesarios', HELP_COUNT: '# de Ayudantes Necesarios', COST_CONS: 'Costo de Consumibles (si aplica)', SPARES_COST: 'Considerar Costo de Repuestos', YES: 'Sí', NO: 'No', LABOUR_VARS: 'Variables de mano de obra', WRENCH_TIME_VARS: 'Variables de tiempo de llave', WRENCH_WARNING: 'Las duraciones de avería pueden incluir tiempo de espera — se prefieren estimaciones de tiempo de llave sobre valores basados en duración', COL_FAILURE_MODE: 'Modo de falla', COL_ACTIVITY: 'Actividad', COL_CM_COUNT: 'Conteo CM', COL_WRENCH_TIME: 'Tiempo llave est. (hrs)', COL_CONFIDENCE: 'Confianza', COL_OVERRIDE: 'Anulación (hrs)' },
			FM: { TITLE: 'Configuración de Modos de Falla', CONFIG_FOR: 'Configurando Modos de Falla para:', SELECT_HOW: 'Seleccione cómo desea configurar los Modos de Falla', SAVED_CONF: 'Configuración Guardada', RCM_ANALYSIS: 'Análisis RCM', APPLY_LIB: 'Aplicar de la Biblioteca de Plantillas', APPLY_LIB_DESC: 'Utilice plantillas de modo de falla preconstruidas para su clase de equipo', APPLY_LIB_AVAIL: 'Plantilla disponible: Plantilla de Bomba ACW', UPLOAD_RCM: 'Subir análisis RCM previo', UPLOAD_RCM_DESC: 'Importar modos de falla desde un archivo de estudio RCM existente (Excel/CSV)', NEW_STUDY: 'Crear Nuevo Estudio FMEA', NEW_STUDY_DESC: 'Comenzar un nuevo FMEA usando el asistente guiado de estudios', APPLY_TEMPLATE: 'Aplicar plantilla', CREATE_ROOTY: 'Crear vía ROOTY', UPLOAD_EXCEL: 'Subir desde Excel', DOWNLOAD_TEMPLATE: 'Descargar plantilla', COL_FM_ID: 'ID FM', COL_SUBSYSTEM: 'Subsistema', COL_COMPONENT: 'Componente', COL_FUNCTION: 'Función', COL_FUNC_FAIL: 'Falla funcional', COL_FAILURE_MODE: 'Modo de falla', COL_CONSEQUENCE_CAT: 'Categoría de consecuencia', COL_FAILURE_BEHAVIOR: 'Comportamiento de falla', COL_PDM_APPLICABILITY: 'Aplicabilidad PdM', COL_LIKELY_CAUSES: 'Causas probables', COL_SYMPTOMS: 'Síntomas / Indicadores', COL_LOCAL_EFFECTS: 'Efectos locales', COL_SYSTEM_EFFECTS: 'Efectos del sistema', COL_PLANT_EFFECTS: 'Efectos en la planta', COL_EFFECTS: 'Efectos', COL_IMPACTS: 'Impactos', COL_EFFECT: 'Efecto', COL_TYPE: 'Tipo', COL_STATUS: 'Estado', COL_EVIDENCES: 'Evidencias', COL_TOTAL_COST: 'Costo total', COL_CATEGORY: 'Categoría', COF_RATING: 'Calificación CoF', COF_CATEGORY: 'Categoría CoF', COST_SUMMARY: 'Resumen de costos', REPAIR_COST: 'Costo de reparación (en USD)', SAFETY_RISK_COST: 'Costo de riesgo de seguridad (en USD)', PROD_LOSS: 'Pérdida de producción (en USD)', OUTAGE_DURATION: 'Duración de la interrupción (en horas)', TOTAL_COST_USD: 'Costo total (en USD)', CONSEQUENCE_RATING: 'Calificación de consecuencia', SAFETY: 'Seguridad', OPERATIONAL: 'Operacional', ENVIRONMENTAL: 'Ambiental', REPUTATIONAL: 'Reputacional', CLASSIFICATION_HIDDEN: 'Clasificación: Falla oculta', SUPPORTING_EVIDENCE: 'Evidencia de soporte', VIEW_EVIDENCE: 'Ver panel de evidencia completo', NO_FM_FOUND: 'No se encontró configuración de modos de falla...', EXPAND_ADDITIONAL_INFO: 'Información adicional', PERF_STANDARD: 'Estándar de rendimiento', FM_ANCHOR_LEVEL: 'Nivel de anclaje FM', FM_TYPE: 'Tipo FM', SYMPTOM_CHILDREN: 'Síntomas secundarios', CURRENT_CONTROLS: 'Controles actuales', EVIDENCE_SOURCE: 'Fuente de evidencia', WO_EVIDENCE_REFS: 'Referencias de evidencia WO', VALIDATION_OUTCOME: 'Resultado de validación', UNVALIDATED_JUSTIFICATION: 'Justificación no validada', CONFIDENCE: 'Confianza', PF_INTERVAL: 'Estimación intervalo P-F' },
			EDITOR: {
				SAVING: 'Guardando...',
				SAVE_TEMPLATE: 'Guardar plantilla',
				SAVE_ACTIVITY: 'Guardar actividad',
				SAVE_PACKAGE: 'Guardar paquete de equipo',
				CREATE_TEMPLATE: 'Crear plantilla',
				EMPTY_TEMPLATE: 'Plantilla vacía',
				CREATE_VIA_ROOTY: 'Crear con Rooty',
				SAVE_CONTINUE: 'Guardar y continuar',
				SAVE_TO_CONFIGURE: 'Guarde la plantilla para comenzar a configurar PM, FMEA y CM.',
				DOWNLOAD: 'Descargar plantilla',
				UPLOAD: 'Subir plantilla',
				PM_CHECKLIST: 'Lista de verificación PM',
				FMEA_CONFIG: 'Configuración de modos de falla',
				CM_CHECKLIST: 'Lista de verificación CM (Pronto)',
				DESC: 'Descripción',
				TEMPLATE_NAME: 'Nombre de la plantilla',
				OVERALL_PM_VARS: 'Variables generales de nivel PM',
				SAVE_PM_ACTIVITY: 'Guardar actividad PM',
				SAVE_FMEA_CONFIG: 'Guardar configuración FMEA',
				SAVE_CM_CONFIG: 'Guardar configuración CM',
					RE_GENERATE: 'Regenerar',
				SAVED_INTERNALLY: 'guardado internamente con éxito:',
				DEFINE_PM: 'Definir lista de verificación PM',
				DEFINE_FM: 'Definir configuración FMEA',
				DEFINE_CM: 'Definir configuración CM',
				DEFINE_WRENCH_TIME: 'Definir variables de tiempo de llave',
				DEFINE_DESC: 'Descargue un ejemplo o suba una plantilla completa para generar.',
				NO_PM_ATTACHED: 'Sin configuración PM adjunta',
				NO_FM_ATTACHED: 'Sin configuración de modos de falla adjunta',
				NO_CM_ATTACHED: 'Sin configuración CM adjunta',
				PM_CONFIG_TAB: 'Configuración PM',
				FM_CONFIG_TAB: 'Configuración FMEA',
				CM_CONFIG_TAB: 'Configuración CM',
				PM_FM_MAPPING_TAB: 'Mapeo PM -> FM',
				DEFINE_PM_FM: 'Definir mapeo PM-FM',
				DEFINE_PM_FM_DESC: 'Configure qué actividades PM mitigan los modos de falla para este equipo.',
				PM_FM_MAPPING_MATRIX: 'Matriz de mapeo PM-FM',
				PM_FM_MAPPING_SUBHEADER: 'Configure qué actividades PM mitigan modos de falla para {{equipment}}',
				PM_FM_SEARCH_PM: 'Buscar actividad PM...',
				PM_FM_SHOW_ALL: 'Mostrar todo',
				PM_FM_SHOW_MAPPED: 'Mapeado',
				PM_FM_SHOW_UNMAPPED: 'Sin mapear',
				PM_FM_SHOW_ZERO_COVERAGE: 'Sin cobertura',
				PM_FM_LEGEND_FULL: '1 = Totalmente mapeado',
				PM_FM_LEGEND_PARTIAL: '0,1-0,9 = Relación parcial',
				PM_FM_LEGEND_EMPTY: 'Vacío = Sin mapear',
				PM_FM_CONFIRM_ALL: 'Confirmar restantes',
				PM_FM_CONFIRM_ROW: 'Confirmar mapeo',
				PM_FM_UNMAP: 'Desasignar',
				PM_FM_NO_PM_ATTACHED: 'Sin actividades PM configuradas',
				PM_FM_NO_FM_ATTACHED: 'Sin modos de falla configurados',
				PM_FM_STALE_BANNER: 'PM o FMEA cambió desde que se generó este mapeo. Las actividades nuevas o modificadas aparecen sin asignar abajo — asígnelas directamente, o use Regenerar para que Rooty vuelva a analizar todo desde cero (esto sobrescribirá sus mapeos revisados).',
				PM_FM_REGENERATE: 'Regenerar',
				PM_FM_UNMAPPED_COUNT: '{{count}} sin asignar',
				PM_FM_ZERO_COVERAGE_HEADING: 'Modos de falla sin cobertura',
				PM_FM_NEW_PM_PROPOSALS: 'Nuevas propuestas de PM',
				PM_FM_ACCEPT_PROPOSAL: 'Aceptar propuesta'
			}
		},
		CONFIGURATION: {
			CASES: {
				TITLE: 'Configuración de casos',
				LAST_UPDATED_BY: 'Última actualización por {{name}} - {{date}}',
				MATRIX_TITLE: 'Matriz de probabilidad e impacto',
				MATRIX_SUBTITLE: '(constante M1 — utilizable en cálculos)',
				VALUE_INPUT_TITLE: 'Entrada de valores',
				VALUE_INPUT_SUBTITLE: '(valores que los usuarios pueden introducir en los campos de valor para un caso)',
				CALCULATIONS_TITLE: 'Cálculos',
				CALCULATIONS_SUBTITLE: '(cálculos de valor configurados por el usuario dentro de un caso)',
				OPTIONAL_TITLE: 'Opcional',
				OPTIONAL_SUBTITLE: '(campos adicionales que se pueden agregar a un caso con fines de seguimiento)',
				COL_CONSTANT: 'Constante',
				COL_UNIT_FIELD: 'Campo de unidad',
				COL_FIELD_UOM: 'UoM del campo',
				COL_DEFAULT_VALUE: 'Valor por defecto',
				COL_ACTIONS: 'Acciones',
				COL_CALCULATION: 'Cálculo',
				COL_UOM: 'UoM',
				COL_FORMULA: 'Fórmula',
				COL_FIELD: 'Campo',
				COL_VALUE: 'Valor',
				COL_UNIT_OF_MEASURE: 'Unidad de medida',
				ADD: 'Añadir',
				ADD_ROW: 'Añadir fila',
				CANCEL: 'Cancelar',
				SAVE: 'Guardar',
				SAVE_SUCCESS: 'Configuración de casos guardada con éxito',
				IMPACT: 'IMPACTO',
				LIKELIHOOD: 'PROBABILIDAD',
				DELETE_ROW: 'Eliminar fila',
				PLACEHOLDER_UNIT_FIELD: 'Introducir campo de unidad',
				PLACEHOLDER_FIELD_UOM: 'Introducir UoM del campo',
				PLACEHOLDER_DEFAULT_VALUE: 'Introducir valor por defecto',
				PLACEHOLDER_CALCULATION: 'Introducir nombre de cálculo',
				PLACEHOLDER_UOM: 'Introducir UoM',
				PLACEHOLDER_FORMULA: 'Introducir fórmula',
				PLACEHOLDER_FIELD_NAME: 'Introducir nombre del campo',
				DUPLICATE_FIELD_NAME: 'El nombre del campo debe ser único',
				PLACEHOLDER_VALUE: 'Introducir valor',
				PLACEHOLDER_UNIT_OF_MEASURE: 'Introducir unidad de medida',
				RESET_TO_DEFAULTS: 'Restablecer valores predeterminados',
				RESET_MATRIX_CONFIRM_TITLE: '¿Restablecer valores predeterminados?',
				RESET_MATRIX_CONFIRM_DESC: 'Esto restablecerá la <strong>Matriz de Probabilidad e Impacto</strong> a sus valores predeterminados originales. Se perderá cualquier cambio personalizado que haya realizado.',
				RESET_MATRIX_CONFIRM_OK: 'Confirmar',
				LOAD_ERROR: 'Error al cargar la configuración de casos',
				SAVE_ERROR: 'Error al guardar la configuración de casos',
				RESET_ERROR: 'Error al restablecer la configuración de casos',
				CONSTANT_USED_IN_FORMULA: 'Esta constante se ha utilizado en una fórmula',
				FORMULA: {
					UNDEFINED_CONSTANT: 'La constante "{{constant}}" no está definida',
					INVALID_CHARACTER: 'La fórmula contiene un carácter u operador no admitido',
					UNBALANCED_PARENTHESES: 'La fórmula tiene paréntesis no balanceados',
					EMPTY_PARENTHESES: 'La fórmula tiene paréntesis vacíos',
					MISSING_OPERATOR: 'A la fórmula le falta un operador entre valores',
					INVALID_OPERATOR_POSITION: 'La fórmula tiene un operador en una posición no válida',
					TRAILING_OPERATOR: 'La fórmula no puede terminar con un operador'
				}
			},
			FILTER: {
				TITLE: 'Filtros',
				SEARCH: 'Buscar'
			},
			ASSET_TEMPLATE: {
				TITLE: 'Lista de plantillas de activos',
				SEARCH: 'Buscar',
				TOOLTIP_ADD: 'Agregar nuevo activo',
				TOOLTIP_DELETE: 'Eliminar activo',
				TOOLTIP_SYNC: 'Sincronizar',
				TOOLTIP_SYNC_PROGRESS: 'Sincronización en curso',
				SYNC_STARTED_TOAST: 'Sincronización de la plantilla de activo iniciada.',
				SYNC_COMPLETED_TOAST: 'Sincronización de la plantilla de activo completada.',
				SYNC_FAILED_TOAST: 'Sincronización de la plantilla de activo fallida{{errorSuffix}}.',
				COL_INDEX: 'N.º',
				COL_TEMPLATE_NAME: 'Nombre de plantilla',
				COL_APPLICATION: 'Aplicación',
				COL_CREATED_ON: 'Creado el',
				COL_ACTIONS: 'Acciones',
				NO_RECORDS: 'No se encontraron registros',
				NO_MATCHES: 'No se encontraron resultados para "{{keyword}}"',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Pruebe con una palabra clave diferente o borre la búsqueda',
				LOADING: 'Cargando...'
			},
			TAGS: {
				TOOLTIP_UPLOAD_SCADA: 'Subir mapeo SCADA de etiquetas',
				TITLE: 'Lista de etiquetas',
				SEARCH: 'Buscar',
				TOOLTIP_ADD: 'Agregar nueva etiqueta',
				TOOLTIP_UPLOAD: 'Cargar etiquetas',
				TOOLTIP_DOWNLOAD: 'Descargar lista de etiquetas',
				TOOLTIP_TAG_MAPPING: 'Ir a mapeo de etiquetas',
				TOOLTIP_DELETE: 'Eliminar etiqueta',
				TOOLTIP_NO_FAILURE_MODES: 'Sin modos de fallo asociados',
				TOOLTIP_VIEW_CHANGES: 'Ver cambios',
				COL_INDEX: 'N.º',
				COL_NAME: 'Nombre',
				COL_TAG_ID: 'ID de etiqueta',
				COL_SHARED: 'Compartido',
				COL_UNIT: 'Unidad',
				COL_FAILURE_MODES: 'Modo(s) de fallo',
				COL_MODELLING: 'Usado para modelado',
				COL_CALCULATED: 'Calculado',
				COL_DESCRIPTION: 'Descripción',
				COL_ASSET: 'Activo',
				COL_ACTIONS: 'Acciones',
				NO_TAGS: 'No hay etiquetas disponibles para el activo seleccionado',
				NO_MATCHES: 'No se encontraron resultados para "{{keyword}}"',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Pruebe con una palabra clave diferente o borre la búsqueda'
			},
			FAILURE_MODE: {
				TITLE: 'Lista de modos de fallo',
				SEARCH: 'Buscar',
				TOOLTIP_UPLOAD: 'Cargar modos de fallo',
				TOOLTIP_ADD: 'Agregar nuevo modo de fallo',
				TOOLTIP_EDIT: 'Editar modo de fallo',
				TOOLTIP_FILTER: 'Filtrar',
				TOOLTIP_DELETE: 'Eliminar',
				TOOLTIP_EDIT_DIRECTIONALITY: 'Editar direccionalidad de etiqueta',
				COL_INDEX: 'N.º',
				COL_NAME: 'Nombre',
				COL_DESCRIPTION: 'Descripción',
				COL_TAG: 'Etiqueta',
				COL_ASSET: 'Activo',
				COL_RECOMMENDATIONS: 'Recomendaciones',
				COL_ACTIONS: 'Acciones',
				NO_RECORDS: 'No se encontraron registros'
			},
			DIGITIZATION: {
				TITLE: 'Lista de digitalización',
				SEARCH: 'Buscar',
				TOOLTIP_ADD: 'Agregar nueva digitalización',
				TOOLTIP_DELETE: 'Eliminar digitalización',
				COL_INDEX: 'N.º',
				COL_MANUFACTURER: 'Fabricante',
				COL_MODEL: 'Modelo',
				COL_INDUSTRY_TYPE: 'Tipo de industria',
				COL_MODIFIED_ON: 'Modificado el',
				COL_CREATED_ON: 'Creado el',
				NO_RECORDS: 'No se encontraron registros',
				NO_MATCHES: 'No se encontraron resultados para "{{keyword}}"',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Pruebe con una palabra clave diferente o borre la búsqueda'
			},
			TABS: {
				ASSET_TEMPLATE: 'Plantilla de activo',
				ASSETS: 'Activos',
				DIGITIZATION: 'Digitalización',
				SETTINGS: 'Configuración',
				CASES: 'Casos'
			},
			SETTINGS: {
				TITLE: 'Actualizar configuración',
				COL_INDEX: '#',
				COL_PAGE_NAME: 'Nombre de página',
				COL_LAST_UPDATED: 'Última actualización',
				COL_UPDATED_BY: 'Actualizado por',
				TOOLTIP_SETTINGS: 'Configuración',
				LOADING: 'Cargando configuración...',
				NO_SETTINGS: 'No se encontró configuración'
			},
			ASSETS: {
				TITLE: 'Lista de activos',
				SEARCH: 'Buscar',
				TOOLTIP_FILTER: 'Filtrar activo',
				TOOLTIP_DELETE: 'Eliminar activo',
				TOOLTIP_VIEW_CHANGES: 'Ver cambios',
				COL_INDEX: 'Nro.',
				COL_NAME: 'Nombre del activo',
				COL_TYPE: 'Tipo de activo',
				COL_UNIT: 'Unidad',
				COL_SYSTEM: 'Sistema',
				COL_APPLICATION: 'Aplicación',
				COL_CONFIGURATION: 'Configuración',
				COL_INDUSTRY: 'Industria',
				COL_AUTHOR: 'Autor',
				COL_MAKE_MODEL: 'Marca y modelo',
				COL_MAINTENANCE: 'Datos de mantenimiento',
				NO_RECORDS: 'No se encontraron registros',
				NO_MATCHES: 'No se encontraron resultados para "{{keyword}}"',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Pruebe con una palabra clave diferente o borre la búsqueda',
			},
			FM_MAPPING_MENU: {
				HIGH: 'Alto',
				LOW: 'Bajo',
				STABLE: 'Estable',
				REFERENCE: 'Referencia',
				UNMAPPED: 'Sin mapear',
				TOOLTIP_HIGH_PRIMARY: 'Alto - Modo de fallo primario',
				TOOLTIP_HIGH_SECONDARY: 'Alto - Modo de fallo secundario',
				TOOLTIP_LOW_PRIMARY: 'Bajo - Modo de fallo primario',
				TOOLTIP_LOW_SECONDARY: 'Bajo - Modo de fallo secundario',
				TOOLTIP_STABLE_PRIMARY: 'Estable - Modo de fallo primario',
				TOOLTIP_STABLE_SECONDARY: 'Estable - Modo de fallo secundario',
				TOOLTIP_REFERENCE: 'Modo de fallo de referencia',
				FM_LOGIC: 'Lógica FM',
				HIGH_INCREASING: 'Alto/Creciente',
				LOW_DECREASING: 'Bajo/Decreciente',
				RULE_BASED: 'Basado en reglas',
				UNMAP: 'Desasignar',
				RULE_BASED_CONDITION: 'Condición basada en reglas',
				OPERATOR: 'Operador',
				COMPARE_TO: 'Comparar con',
				ENTER_VALUE: 'Ingresar valor',
				NUMERIC_INPUT_ONLY: 'Solo entrada numérica',
				PREFERENCE: 'Preferencia',
				APPLY: 'Aplicar'
			},
			QUICK_FILTER: {
				NO_MATCHES: 'No se encontraron resultados para "{{keyword}}"',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Pruebe con una palabra clave diferente o borre la búsqueda',
				CLOSE: 'Cerrar',
			},
			DIGITIZATION_POPUP: {
				FORM_ERROR: 'Oh vaya! El fabricante y el nombre del modelo ya están en uso. Cambia algunas cosas e intenta enviar de nuevo.',
				MANUFACTURER: 'Fabricante',
				MANUFACTURER_NAME: 'Nombre del fabricante',
				MODEL: 'Modelo',
				MODEL_NAME: 'Nombre del modelo',
				INDUSTRY_TYPE: 'Tipo de industria',
				ENTER: 'Ingresar',
				SELECT: 'Seleccionar',
				IS: 'es',
				CUT_IN_SPEED: 'Velocidad de corte de entrada(m/s)',
				CUT_IN_SPEED_LABEL: 'Velocidad de corte de entrada',
				CUT_OFF_SPEED: 'Velocidad de corte de salida(m/s)',
				CUT_OFF_SPEED_LABEL: 'Velocidad de corte de salida',
				CAPACITY_KWH: 'Ingrese el valor en KWH',
				CAPACITY: 'Capacidad',
				IS_REQUIRED: 'es requerido',
				SMALLER_THAN_CUTOFF: 'debe ser menor que el corte',
				GREATER_THAN_CUTIN: 'debe ser mayor que el corte de entrada',
				GREATER_THAN_ZERO: 'debe ser mayor que 0',
				POWER_CURVE: 'Curva de potencia',
				REQUIRED: 'requerido',
				UPLOAD_POWER_CURVE: 'Subir curva de potencia',
				DOWNLOAD_SAMPLE: 'Descargar muestra/archivo previamente cargado',
				VIEW_POWER_CURVE: 'Ver datos de curva de potencia cargada',
				ERROR_CODE_MAP: 'Mapa de códigos de error',
				UPLOAD_SCADA: 'Subir código de evento SCADA',
				VIEW_SCADA: 'Ver datos de código de evento SCADA cargado',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancelar cambios',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Guardar cambios'
			},
			FAILURE_MODE_POPUP: {
				FORM_ERROR: 'Oh vaya! Cambia algunas cosas e intenta enviar de nuevo.',
				NAME: 'Nombre',
				IS: 'es',
				PRIORITY: 'Prioridad',
				REQUIRED: 'requerido',
				START_TIME: 'Hora de inicio (en horas)',
				START_TIME_LABEL: 'Hora de inicio',
				END_TIME: 'Hora de fin (en horas)',
				END_TIME_LABEL: 'Hora de fin',
				IS_REQUIRED: 'es requerido',
				TIME_RANGE: 'el rango debe estar entre 0.1 y 48 horas',
				DESCRIPTION: 'Descripción',
				RELIABILITY_SAVINGS: 'Ahorros de confiabilidad (potencial)',
				MAINTENANCE_SAVINGS: 'Ahorros de mantenimiento (potencial)',
				PERFORMANCE_SAVINGS: 'Ahorros de rendimiento (potencial)',
				REMARK: 'Observación',
				REMARK_TO_EDIT: 'Observación para editar',
				ENTER: 'Ingresar',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancelar cambios',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Guardar cambios'
			},
			TAG_DIRECTIONALITY_POPUP: {
				FORM_ERROR: 'Oh vaya! Cambia algunas cosas e intenta enviar de nuevo.',
				TAG_NAME: 'Nombre de etiqueta',
				DIRECTIONALITY: 'Direccionalidad',
				SELECT: 'Seleccionar',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancelar cambios',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Guardar cambios'
			},
			FM_RECOMMENDATION_POPUP: {
				FORM_ERROR: 'Oh vaya! Cambia algunas cosas e intenta enviar de nuevo.',
				RECOMMENDATION: 'Recomendación',
				IS: 'es',
				CATEGORY: 'Categoría',
				SELECT: 'Seleccionar',
				SELECT_FAILURE: 'Seleccionar fallo',
				FAILURE: 'Fallo',
				REMARK: 'Observación',
				REMARK_TO_EDIT: 'Observación para editar',
				ENTER: 'Ingresar',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancelar cambios',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Guardar cambios'
			},
			TAGS_POPUP: {
				FORECASTING: 'Pronóstico',
				PERFORMANCE_DEGRADATION: 'Degradación del rendimiento',
				PERFORMANCE_DEGRADATION_HINT: '(Habilitar el pronóstico de tiempo hasta la intervención para esta etiqueta)',
				DYNAMIC_DEVIATION_THRESHOLD: 'Umbral de desviación dinámica',
				DEVIATION_LOW: 'Bajo',
				DEVIATION_MEDIUM: 'Medio',
				DEVIATION_HIGH: 'Alto',
				ERRATIC_DETECTION: 'Detección errática',
				ERRATIC_ALERT: 'Alerta errática',
				MISSING_DATA_DETECTION: 'Detección de datos faltantes',
				OUTLIER_DETECTION: 'Detección de valores atípicos',
				OUT_OF_RANGE_DETECTION: 'Detección de fuera de rango',
				DATA_QUALITY_ALERT_GENERATION: 'GENERACIÓN DE ALERTAS DE CALIDAD DE DATOS',
				DATA_QUALITY_ALERT_DESC: 'Elija qué problemas de DQ detectados deben generar alertas. Desactivar la generación de alertas no detiene el cálculo de DQ. Los valores seguirán apareciendo en las tablas de DQ.',
				FLATLINE_ALERT: 'Alerta de línea plana',
				MISSING_DATA_ALERT: 'Alerta de datos faltantes',
				OUTLIER_ALERT: 'Alerta de valor atípico',
				OUT_OF_RANGE_ALERT: 'Alerta de fuera de rango',
				ALERTS_NOTIFICATIONS_KPI: 'Alertas, notificaciones y KPI',
				OPERATIONAL_LIMITS: 'Límites operativos',
				ADDITIONAL_SETTINGS: 'Ajustes Adicionales',
				NO_TAGS_WITH_TAGID_MAPPED: 'No se encontraron Tags mapeados.',
				FUNCTION_NAME: 'Nombre de la función',
				DATA_QUALITY_DETECTION: 'Detección de calidad de datos',
				SELECT_TAG_TO_ADD_MORE: 'Seleccione la primera etiqueta para habilitar la adición de más etiquetas',
				ENTER_FORMULA: 'Ingresar fórmula*',
				LOWER: 'Inferior',
				UPPER: 'Superior',
				START: 'Inicio',
				END: 'Fin',
				DEADLINE: 'Fecha límite',
				FORMULA_PLACEHOLDER: 'Escriba la fórmula. Ej. (t1+t2)*t3',
				SELECT_TAG: 'Seleccionar etiqueta',
				SELECT_KEY: 'Seleccionar clave',
				VALUE: 'Valor',
				FORM_ERROR: 'Oh vaya! Cambia algunas cosas e intenta enviar de nuevo.',
				TAG_NAME: 'Nombre de etiqueta',
				DESCRIPTION: 'Descripción',
				TAG_ID: 'ID de etiqueta',
				UNIT: 'Unidad',
				INSTRUMENT_RANGE: 'Rango de instrumento',
				TRIP_LIMITS: 'Límites de disparo',
				THRESHOLD_ALERT: 'Alerta de umbral',
				THRESHOLD_ALERT_DELAY: 'Retraso de alerta de umbral',
				IOW_CRITICALITY: 'Criticidad IOW',
				DIRECTIONALITY: 'Direccionalidad',
				DIRECTION: 'Dirección',
				FLATLINE_DETECTION: 'Detección de línea plana',
				ATTENTION: 'Atención',
				THRESHOLD_NOTIFICATION: 'Notificación de umbral',
				KPI: 'KPI',
				STRING_CURRENT: 'Corriente de cadena',
				STRING_CAPACITY: 'Capacidad de cadena',
				SCADA_ERROR_CODES: 'Códigos de error SCADA',
				COMMA_SEPARATED_ERROR_CODES: 'Agregar códigos de error separados por comas',
				ASSET: 'Activo',
				CALCULATED_FLAG: 'Indicador calculado',
				REMARK: 'Observación',
				REMARK_TO_EDIT: 'Observación para editar',
				FUNCTION_TABLE: 'Tabla de funciones',
				PARAMETERS: 'Parámetros',
				CONSTANTS: 'Constantes',
				PLOT_CONTINUOUS: 'Trazar como tendencia de línea continua (ignorar valores faltantes)',
				ENTER: 'Ingresar',
				SELECT: 'Seleccionar',
				WRITE_CUSTOM_CODE: 'Escribir código personalizado',
				UPLOAD_TAGS: 'Subir etiquetas',
				DOWNLOAD_CORRELATION_CSV: 'Descargar formato CSV de correlación',
				UPLOAD_CORRELATION_CSV: 'Subir CSV de correlación',
				DELETE: 'Eliminar',
				ADD: 'Agregar',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancelar cambios',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Guardar cambios',
				ALARM_LIMITS: 'Límites de alarma',
				THRESHOLD_LIMITS: 'Límites de umbral',
				CORRELATION_CSV_UPLOAD_LABEL: 'Subir CSV de correlación',
				TRIAL_RUN: 'Ejecución de prueba',
				SELECT_PYTHON_FUNCTION: 'Seleccionar función Python',
				SEARCH_FUNCTIONS_PLACEHOLDER: 'Buscar funciones...',
				NO_MATCHING_FUNCTION_FOUND: 'No se encontró ninguna función coincidente',
				SELECT_FUNCTION_ERROR: 'Seleccione una función Python',
				DEPRECATED: 'Obsoleta',
				DEPRECATED_FORMULA_TOOLTIP: 'Esta fórmula está obsoleta. Seleccione la fórmula actualizada.',
				DEPRECATED_FORMULA_ERROR: 'Esta fórmula está obsoleta. Seleccione la fórmula actualizada.',
				CUSTOM_FORMULA_INVALID_VARS: 'Variable(s) inválida(s) utilizada(s)',
				CUSTOM_FORMULA_INVALID_SYNTAX: 'Variable(s)/expresión matemática inválida',
				CUSTOM_FORMULA_REQUIRED: 'La fórmula es obligatoria',
				SEARCH_ASSETS_PLACEHOLDER: 'Buscar activos...',
				NO_MATCHING_ASSET_FOUND: 'No se encontró ningún activo coincidente',
				SEARCH_DOTS: 'Buscar...',
				NO_MATCHING_TAG_FOUND: 'No se encontró ninguna etiqueta coincidente',
				NO_TAGS_FOUND_WITH_TAGID_MAPPED: 'No se encontraron etiquetas con TagId asignado.',
				SEARCH_PLAIN: 'Buscar',
				NO_MATCHING_KEY_FOUND: 'No se encontró ninguna clave coincidente',
				PARAMETER_NAME_HINT: 'Nombre del parámetro',
				CONSTANT_NAME_HINT: 'Nombre de la constante',
				DISPLAY_EXPRESSION: 'Expresión de visualización',
				DISPLAY_EXPRESSION_PLACEHOLDER: 'Ingrese la expresión',
				EXPRESSION_DESCRIPTION: 'Descripción de la expresión',
				EXPRESSION_DESCRIPTION_PLACEHOLDER: 'Ingrese la descripción de la expresión'
			},
			ASSET_TEMPLATE_DELETE: {
				TITLE: 'Confirmación de eliminación de activo',
				CONFIRM_MSG: '¿Está seguro de que desea eliminar el activo?',
				ASSOCIATED_ITEMS_MSG: '¿También desea eliminar los siguientes elementos asociados al activo?',
				DELETE_TAGS: 'Eliminar etiquetas asociadas',
				DELETE_FAILURE_MODES: 'Eliminar modos de fallo asociados',
				DELETING: 'Eliminando...',
				CANCEL: 'Cancelar',
				DELETE: 'Eliminar'
			},
			FM_INFO: {
				TITLE: 'Información de modo de fallo',
				TOOLTIP_ADD: 'Agregar',
				TOOLTIP_EDIT: 'Editar',
				TOOLTIP_UPLOAD: 'Subir',
				TOOLTIP_DOWNLOAD: 'Descargar',
				TOOLTIP_EDIT_MAPPING: 'Editar mapeo',
				TOOLTIP_DELETE: 'Eliminar',
				TOOLTIP_VIEW_CHANGES: 'Ver cambios',
				UPLOAD_FAILURE_MODES: 'Subir modos de fallo',
				UPLOAD_FM_TAG_MAPPINGS: 'Subir asignaciones de fallo a etiqueta',
				DOWNLOAD_FAILURE_MODES: 'Descargar modos de fallo',
				DOWNLOAD_FM_TAG_MAPPINGS: 'Descargar asignaciones de fallo a etiqueta',
				COL_FAILURE_MODE: 'Modo de fallo',
				COL_START_TIME: 'Hora de inicio',
				COL_END_TIME: 'Hora de fin',
				COL_PRIORITY: 'Prioridad',
				COL_ACTIONS: 'Acciones',
				PRIORITY_DESCRIPTION: 'Descripción de la prioridad de impacto',
				NO_RECORDS: 'No hay modos de fallo disponibles para el activo seleccionado'
			},
			RECOMMENDATIONS: {
				TITLE: 'Recomendaciones',
				TOOLTIP_ADD: 'Agregar',
				TOOLTIP_EDIT: 'Editar',
				TOOLTIP_UPLOAD: 'Subir',
				TOOLTIP_DOWNLOAD: 'Descargar',
				TOOLTIP_EDIT_MAPPING: 'Editar mapeo de mecanismos a recomendaciones',
				TOOLTIP_DELETE: 'Eliminar',
				TOOLTIP_VIEW_CHANGES: 'Ver cambios',
				UPLOAD_RECOMMENDATIONS: 'Subir recomendaciones',
				UPLOAD_REC_FM_MAPPINGS: 'Subir asignaciones de recomendación a FM',
				DOWNLOAD_RECOMMENDATIONS: 'Descargar recomendaciones',
				DOWNLOAD_REC_FM_MAPPINGS: 'Descargar asignaciones de recomendación a FM',
				COL_RECOMMENDATIONS: 'Recomendaciones',
				COL_CATEGORY: 'Categoría',
				NO_RECORDS: 'No hay recomendaciones disponibles para el activo seleccionado'
			},
			ASSET_TEMPLATE_SYNC: {
				SYNC_MSG: 'Se han realizado los siguientes cambios en la plantilla de activo. Verifique y decida si deben sincronizarse con los activos creados usando esta plantilla.',
				ASSETS: 'Activos',
				SELECT_ALL: 'Seleccionar todo',
				TAGS: 'Etiquetas',
				FAILURES: 'Fallos',
				RECOMMENDATIONS: 'Recomendaciones',
				CLOSE_TOOLTIP: 'Cerrar ventana',
				CANCEL: 'Cerrar',
				DONT_SYNC: 'No sincronizar',
				DONT_SYNC_TOOLTIP: 'No sincronizar cambios',
				SYNC: 'Sincronizar',
				SYNC_TOOLTIP: 'Sincronizar cambios'
			},
			TAG_TEMPLATE_LIST: {
				TITLE: 'Lista de etiquetas',
				SEARCH: 'Buscar',
				TOOLTIP_SEARCH: 'Buscar',
				TOOLTIP_ADD: 'Agregar nueva etiqueta',
				TOOLTIP_UPLOAD: 'Subir etiquetas',
				TOOLTIP_DOWNLOAD: 'Descargar lista de etiquetas',
				TOOLTIP_CLONE: 'Clonar etiqueta',
				TOOLTIP_DELETE: 'Eliminar etiqueta',
				TOOLTIP_VIEW_CHANGES: 'Ver cambios',
				COL_INDEX: 'Nro.',
				COL_TAG_TYPE: 'Tipo de etiqueta',
				COL_NAME: 'Nombre',
				COL_DESCRIPTION: 'Descripción de etiqueta',
				COL_UNIT: 'Unidad',
				COL_FAILURE_MODES: 'Modo(s) de fallo',
				COL_DIRECTIONALITY: 'Direccionalidad',
				COL_CALCULATED: 'Calculado',
				COL_ACTIONS: 'Acciones',
				NO_RECORDS: 'No hay etiquetas disponibles para el activo seleccionado',
				TOOLTIP_NO_FM: 'Sin modos de fallo asociados',
				NO_MATCHES: 'No se encontraron resultados para "{{keyword}}"',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Pruebe con una palabra clave diferente o borre la búsqueda',
				LOADING: 'Cargando...'
			},
			SUBSYSTEMS: {
				TITLE: 'Subsistemas',
				SEARCH: 'Buscar'
			},
			ASSET_TEMPLATE_POPUP: {
				FORM_ERROR: 'Oh vaya! Cambia algunas cosas e intenta enviar de nuevo.',
				NAME: 'Nombre',
				IS: 'es',
				ALREADY_TAKEN: 'Ya en uso',
				TEMPLATE_NAME: 'Nombre de plantilla',
				APPLICATION: 'Aplicación',
				TEMPLATE_APPLICATION: 'Aplicación de plantilla',
				PLEASE_ENTER: 'Por favor ingrese',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancelar cambios',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Guardar cambios'
			},
			ASSETS_FM_INFO: {
				TITLE: 'Información de modo de fallo',
				TOOLTIP_ADD: 'Agregar',
				TOOLTIP_EDIT: 'Editar',
				TOOLTIP_UPLOAD: 'Subir',
				TOOLTIP_DOWNLOAD: 'Descargar',
				TOOLTIP_EDIT_MAPPING: 'Editar etiqueta a mecanismos',
				TOOLTIP_DELETE: 'Eliminar',
				TOOLTIP_VIEW_CHANGES: 'Ver cambios',
				UPLOAD_FAILURE_MODES: 'Subir modos de fallo',
				UPLOAD_FM_TAG_MAPPINGS: 'Subir asignaciones de fallo a etiqueta',
				DOWNLOAD_FAILURE_MODES: 'Descargar modos de fallo',
				DOWNLOAD_FM_TAG_MAPPINGS: 'Descargar asignaciones de fallo a etiqueta',
				COL_STATUS: 'Estado',
				COL_FAILURE_MODE: 'Modo de fallo',
				COL_PRIORITY: 'Prioridad',
				COL_START_TIME: 'Hora de inicio',
				COL_END_TIME: 'Hora de fin',
				COL_ACTIONS: 'Acciones',
				PRIORITY_DESCRIPTION: 'Descripción de la prioridad de impacto',
				NO_RECORDS: 'No hay modos de fallo disponibles para el activo seleccionado'
			},
			TAG_FM_POPUP: {
				TITLE: 'Etiqueta a mecanismos',
				TAG_NAME: 'Nombre de etiqueta',
				SEARCH_TAG: 'Buscar etiqueta',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancelar cambios',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Guardar cambios',
				NO_RECORDS: "No se encontraron etiquetas ni modos de fallo",
				NO_MATCHES: 'No se encontraron resultados para "{{keyword}}"',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Pruebe con una palabra clave diferente o borre la búsqueda',
			},
			ASSETS_RECOMMENDATIONS: {
				TITLE: 'Recomendaciones',
				TOOLTIP_ADD: 'Agregar',
				TOOLTIP_EDIT: 'Editar',
				TOOLTIP_UPLOAD: 'Subir',
				TOOLTIP_DOWNLOAD: 'Descargar',
				TOOLTIP_EDIT_MAPPING: 'Editar mapeo de mecanismos a recomendaciones',
				TOOLTIP_DELETE: 'Eliminar',
				TOOLTIP_VIEW_CHANGES: 'Ver cambios',
				UPLOAD_RECOMMENDATIONS: 'Subir recomendaciones',
				UPLOAD_REC_FM_MAPPINGS: 'Subir asignaciones de recomendación a FM',
				DOWNLOAD_RECOMMENDATIONS: 'Descargar recomendaciones',
				DOWNLOAD_REC_FM_MAPPINGS: 'Descargar asignaciones de recomendación a FM',
				COL_RECOMMENDATIONS: 'Recomendaciones',
				COL_CATEGORY: 'Categoría',
				COL_ACTIONS: 'Acciones',
				NO_RECORDS: 'No hay recomendaciones disponibles para el activo seleccionado'
			},
			REC_FM_POPUP: {
				TITLE: 'Mecanismos a recomendaciones',
				RECOMMENDATION: 'Recomendación',
				CATEGORY: 'Categoría',
				OFFLINE: 'Fuera de línea',
				ONLINE: 'En línea',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancelar cambios',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Guardar cambios'
			},
			ASSET_DELETE: {
				TITLE: 'Confirmación de eliminación de activo',
				CONFIRM_MSG: '¿Está seguro de que desea eliminar el activo?',
				ASSOCIATED_ITEMS_MSG: '¿También desea eliminar los siguientes elementos asociados al activo?',
				DELETE_TAGS: 'Eliminar etiquetas asociadas',
				DELETE_FAILURE_MODES: 'Eliminar modos de fallo asociados',
				DELETING: 'Eliminando...',
				CANCEL: 'Cancelar',
				DELETE: 'Eliminar'
			},
			ASSET_POPUP: {
				FORM_ERROR: 'Oh vaya! Cambia algunas cosas e intenta enviar de nuevo.',
				ASSET_NAME: 'Nombre del activo',
				ASSET_MODEL: 'Modelo del activo',
				ASSET_ID: 'ID de activo',
				DEPLOYED_DATE: 'Fecha de despliegue',
				SYSTEM: 'Sistema',
				MAINTENANCE_DATA: 'Datos de mantenimiento',
				PROVIDER_DATA: 'Datos del proveedor',
				ENTER: 'Ingresar',
				SELECT: 'Seleccionar',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancelar cambios',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Guardar cambios'
			},
			NAME_MAPPING: {
				TITLE_TAG_FM: 'Carga de etiqueta a mecanismos',
				TITLE_REC_FM: 'Carga de recomendación a mecanismos',
				TAG_NAME_MAPPING: 'Mapeo de nombre de etiqueta',
				REC_NAME_MAPPING: 'Mapeo de nombre de recomendación',
				TAG_NAME: 'Nombre de etiqueta',
				RECOMMENDATION_NAME: 'Nombre de recomendación',
				TAG_NAME_OPTIONS: 'Opciones de nombre de etiqueta',
				REC_NAME_OPTIONS: 'Opciones de nombre de recomendación',
				OPTIONS_PLACEHOLDER: 'Opciones',
				NO_TAG_SUGGESTIONS: 'No se encontraron sugerencias. Esta etiqueta no se usará en el mapeo final.',
				TAG_DELETED_FROM_MAPPING: 'Etiqueta eliminada del mapeo',
				NO_REC_SUGGESTIONS: 'No se encontraron sugerencias. Esta recomendación no se usará en el mapeo final.',
				REC_DELETED_FROM_MAPPING: 'Recomendación eliminada del mapeo',
				FM_DELETED_FROM_MAPPING: 'Modo de fallo eliminado del mapeo',
				ACTIONS: 'Acciones',
				FM_MAPPING: 'Mapeo de modo de fallo',
				FM_NAME: 'Nombre de modo de fallo',
				FM_OPTIONS: 'Opciones de modo de fallo',
				TOOLTIP_CLEAR: 'Limpiar selección',
				TOOLTIP_DELETE_TAG: 'Eliminar etiqueta',
				TOOLTIP_UNDO_TAG: 'Deshacer eliminación de etiqueta',
				TOOLTIP_DELETE_FM: 'Eliminar modo de fallo',
				TOOLTIP_UNDO_FM: 'Deshacer eliminación de modo de fallo',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancelar cambios',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Guardar cambios'
			},
			TAG_TEMPLATE_POPUP: {
				ERRATIC_DETECTION: 'Detección errática',
				ERRATIC_ALERT: 'Alerta errática',
				MISSING_DATA_DETECTION: 'Detección de datos faltantes',
				OUTLIER_DETECTION: 'Detección de valores atípicos',
				OUT_OF_RANGE_DETECTION: 'Detección de fuera de rango',
				DATA_QUALITY_ALERT_GENERATION: 'GENERACIÓN DE ALERTAS DE CALIDAD DE DATOS',
				DATA_QUALITY_ALERT_DESC: 'Elija qué problemas de DQ detectados deben generar alertas. Desactivar la generación de alertas no detiene el cálculo de DQ. Los valores seguirán apareciendo en las tablas de DQ.',
				FLATLINE_ALERT: 'Alerta de línea plana',
				MISSING_DATA_ALERT: 'Alerta de datos faltantes',
				OUTLIER_ALERT: 'Alerta de valor atípico',
				OUT_OF_RANGE_ALERT: 'Alerta de fuera de rango',
				ALERTS_AND_NOTIFICATIONS: 'Alertas y notificaciones',
				OPERATIONAL_LIMITS: 'Límites operativos',
				DATA_QUALITY_DETECTION: 'Detección de calidad de datos',
				SELECT_TAG_TO_ADD_MORE: 'Seleccione la primera etiqueta para habilitar la adición de más etiquetas',
				LOWER_RANGE: 'Rango inferior',
				UPPER_RANGE: 'Rango superior',
				LOWER: 'Inferior',
				UPPER: 'Superior',
				ALARM_LIMITS: 'Límites de alarma',
				THRESHOLD_LIMITS: 'Límites de umbral',
				START: 'Inicio',
				END: 'Fin',
				FORMULA_PLACEHOLDER: 'Escriba la fórmula. Ej. (t1+t2)*t3',
				SELECT_TAG: 'Seleccionar etiqueta',
				VALUE: 'Valor',
				DELETE: 'Eliminar',
				ADD: 'Agregar',
				FORM_ERROR: 'Oh vaya! Cambia algunas cosas e intenta enviar de nuevo.',
				TAG_TYPE: 'Tipo de etiqueta',
				TAG_NAME: 'Nombre de etiqueta',
				TAG_DESCRIPTION: 'Descripción de etiqueta',
				DESCRIPTION: 'Descripción',
				UNIT: 'Unidad',
				INSTRUMENT_RANGE: 'Rango de instrumento',
				TRIP_LIMITS: 'Límites de disparo',
				THRESHOLD_ALERT: 'Alerta de umbral',
				THRESHOLD_ALERT_DELAY: 'Retraso de alerta de umbral',
				DESIGN_VALUE: 'Valor de diseño',
				DIRECTIONALITY: 'Direccionalidad',
				DIRECTION: 'Dirección',
				IOW_CRITICALITY: 'Criticidad IOW',
				FLATLINE_DETECTION: 'Detección de línea plana',
				ATTENTION: 'Atención',
				THRESHOLD_NOTIFICATION: 'Notificación de umbral',
				CALCULATED_FLAG: 'Indicador calculado',
				PARAMETERS: 'Parámetros',
				CONSTANTS: 'Constantes',
				UPLOAD_TAGS: 'Subir etiquetas',
				ENTER: 'Ingresar',
				SELECT: 'Seleccionar',
				SELECT_PYTHON_FUNCTION: 'Seleccionar función Python',
				SEARCH_FUNCTIONS_PLACEHOLDER: 'Buscar funciones...',
				NO_MATCHING_FUNCTION_FOUND: 'No se encontró ninguna función coincidente',
				SELECT_FUNCTION_ERROR: 'Seleccione una función Python',
				SEARCH_TAG_TYPE_PLACEHOLDER: 'Buscar tipo de etiqueta...',
				NO_MATCHING_TAG_TYPE_FOUND: 'No se encontró ningún tipo de etiqueta coincidente',
				SEARCH_DOTS: 'Buscar...',
				NO_MATCHING_TAG_FOUND: 'No se encontró ninguna etiqueta coincidente',
				PARAMETER_NAME_HINT: 'Nombre del parámetro',
				CONSTANT_NAME_HINT: 'Nombre de la constante',
				DISPLAY_EXPRESSION: 'Expresión de visualización',
				DISPLAY_EXPRESSION_PLACEHOLDER: 'Ingrese la expresión',
				EXPRESSION_DESCRIPTION: 'Descripción de la expresión',
				EXPRESSION_DESCRIPTION_PLACEHOLDER: 'Ingrese la descripción de la expresión',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancelar cambios',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Guardar cambios'
			},
			TEMPLATE_NAME_MAPPING: {
				TITLE: 'Etiqueta a mecanismos',
				TAG_NAME_MAPPING: 'Mapeo de nombre de etiqueta',
				TAG_NAME: 'Nombre de etiqueta',
				TAG_NAME_OPTIONS: 'Opciones de nombre de etiqueta',
				OPTIONS_PLACEHOLDER: 'Opciones',
				NO_TAG_SUGGESTIONS: 'No se encontraron sugerencias. Esta etiqueta no se usará en el mapeo final.',
				TAG_DELETED_FROM_MAPPING: 'Etiqueta eliminada del mapeo',
				FM_DELETED_FROM_MAPPING: 'Modo de fallo eliminado del mapeo',
				ACTIONS: 'Acciones',
				FM_MAPPING: 'Mapeo de modo de fallo',
				FM_NAME: 'Nombre de modo de fallo',
				FM_OPTIONS: 'Opciones de modo de fallo',
				TOOLTIP_CLEAR: 'Limpiar selección',
				TOOLTIP_DELETE_TAG: 'Eliminar etiqueta',
				TOOLTIP_UNDO_TAG: 'Deshacer eliminación de etiqueta',
				TOOLTIP_DELETE_FM: 'Eliminar modo de fallo',
				TOOLTIP_UNDO_FM: 'Deshacer eliminación de modo de fallo',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancelar cambios',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Guardar cambios'
			},
			FM_INFO_POPUP: {
				FORM_ERROR: 'Oh vaya! Cambia algunas cosas e intenta enviar de nuevo.',
				NAME: 'Nombre',
				PRIORITY: 'Prioridad',
				START_TIME: 'Hora de inicio (en horas)',
				START_TIME_LABEL: 'Hora de inicio',
				END_TIME: 'Hora de fin (en horas)',
				END_TIME_LABEL: 'Hora de fin',
				IS: 'es',
				REQUIRED: 'requerido',
				DESCRIPTION: 'Descripción',
				RELIABILITY_SAVINGS: 'Ahorros de confiabilidad (potencial)',
				MAINTENANCE_SAVINGS: 'Ahorros de mantenimiento (potencial)',
				PERFORMANCE_SAVINGS: 'Ahorros de rendimiento (potencial)',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancelar cambios',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Guardar cambios'
			},
			TAG_FM_INFO_POPUP: {
				TITLE: "Asignador de modos de falla de plantilla de etiquetas",
				TAG_NAME: "Nombre de etiqueta",
				SEARCH_TAG: "Buscar etiqueta",
				NAME: "Nombre",
				TAG_ID: "ID de etiqueta",
				CANCEL: "Cancelar",
				CANCEL_TOOLTIP: "Cancelar cambios",
				SAVE: "Guardar",
				SAVE_TOOLTIP: "Guardar cambios",
				NO_RECORDS: "No se encontraron etiquetas ni modos de fallo",
				NO_MATCHES: 'No se encontraron resultados para "{{keyword}}"',
				TRY_DIFFERENT_KEYWORD_CLEAR_SEARCH: 'Pruebe con una palabra clave diferente o borre la búsqueda',
			},
			RECOMMENDATIONS_POPUP: {
				FORM_ERROR: 'Oh vaya! Cambia algunas cosas e intenta enviar de nuevo.',
				RECOMMENDATION: 'Recomendación',
				IS: 'es',
				CATEGORY: 'Categoría',
				SELECT: 'Seleccionar',
				SELECT_FAILURE: 'Seleccionar fallo',
				FAILURE: 'Fallo',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancelar cambios',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Guardar cambios'
			},
			REC_TEMPLATE_FM_POPUP: {
				TITLE: 'Mecanismos a recomendaciones',
				RECOMMENDATION: 'Recomendación',
				CATEGORY: 'Categoría',
				OFFLINE: 'Fuera de línea',
				ONLINE: 'En línea',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancelar cambios',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Guardar cambios'
			},
			SUBSYSTEM_TEMPLATE: {
				TITLE: 'Lista de plantillas de subsistema',
				SEARCH: 'Buscar',
				TOOLTIP_ADD: 'Agregar nueva plantilla de subsistema',
				TOOLTIP_EDIT: 'Editar plantilla de subsistema',
				TOOLTIP_DELETE: 'Eliminar plantilla de subsistema',
				COL_INDEX: 'Nro.',
				COL_NAME: 'Nombre',
				COL_DESCRIPTION: 'Descripción',
				COL_CREATED_ON: 'Creado el'
			},
			SUBSYSTEM_TEMPLATE_DELETE: {
				TITLE: 'Confirmación de eliminación de plantilla de subsistema',
				CONFIRM_MSG: '¿Está seguro de que desea eliminar la plantilla de subsistema?',
				DELETING: 'Eliminando...',
				CANCEL: 'Cancelar',
				DELETE: 'Eliminar'
			},
			SUBSYSTEM_TEMPLATE_POPUP: {
				ADD_TITLE: 'Agregar plantilla de subsistema',
				EDIT_TITLE_PREFIX: 'Editar plantilla de subsistema',
				NAME: 'Nombre',
				DESCRIPTION: 'Descripción',
				NAME_TAKEN_ERROR: 'El nombre ya está en uso',
				NAME_REQUIRED_ERROR: 'El nombre es obligatorio',
				FORM_ERROR: 'Oh vaya! Cambia algunas cosas e intenta enviar de nuevo.',
				CANCEL: 'Cancelar',
				CANCEL_TOOLTIP: 'Cancelar cambios',
				SAVE: 'Guardar',
				SAVE_TOOLTIP: 'Guardar cambios'
			}

		},
		ADVANCED_ANALYSIS: {
			TABS: {
				ADVANCED_ANALYSIS: 'Análisis avanzado',
				RENEWABLES: 'Energías renovables',
				SUMMARY: 'Resumen',
				DOWNTIME: 'Tiempo de inactividad',
				UNDERPERFORMANCE: 'Bajo rendimiento',
				CURTAILMENT: 'Reducción',
				SOILING_LOSS: 'Pérdida por ensuciamiento',
				LOSS_BUCKETING: 'Clasificación de pérdidas',
				MAINTENANCE: 'Mantenimiento'
			},
			TOOLBAR: {
				SELECT_ANALYSIS: 'Seleccionar análisis',
				SEARCH_ANALYSIS: 'Buscar análisis...',
				NO_MATCHING_ANALYSIS: 'No se encontró ningún análisis coincidente',
				PUBLIC: 'Público',
				SAVE_ALL: 'Guardar todo',
				TOOLTIP_SAVE_ALL: 'Guardar todos los cambios',
				TOOLTIP_DOWNLOAD: 'Descargar estadísticas de todos los análisis',
				ANALYSIS_TYPE: 'Tipo de análisis'
			},
			HEADER: {
				CREATED_BY: 'por',
				CREATED_ON: 'Creado el:'
			},
			EMPTY_STATE: {
				HEADING: 'Seleccione una análisis existente o cree una nueva',
				CONTENT: 'Por favor seleccione o agregue un análisis.'
			},
			DESCRIPTION_LABEL: 'Descripción:',
			POPUP: {
				FORM_ERROR: '¡Vaya! Cambia algunos campos e intenta enviar de nuevo.',
				NAME_PLACEHOLDER: 'Nombre',
				NAME_ERROR_TAKEN: 'Ya está en uso',
				NAME_HINT: 'Por favor ingrese',
				NAME_HINT_STRONG: 'Nombre del análisis',
				DESC_PLACEHOLDER: 'Descripción',
				DESC_ERROR_PREFIX: 'La descripción es',
				DESC_HINT: 'Por favor ingrese',
				DESC_HINT_STRONG: 'Descripción del análisis',
				SELECT_FACILITY: 'Seleccionar instalación',
				SEARCH_FACILITY: 'Buscar',
				NO_MATCHING_FACILITY: 'No se encontró ninguna instalación coincidente',
				TOOLTIP_CANCEL: 'Cancelar cambios',
				TOOLTIP_SAVE: 'Guardar cambios',
				BTN_CANCEL: 'Cancelar',
				BTN_SAVE: 'Guardar'
			},
			SAVE_CONFIRMATION: {
				TITLE: 'Cambios sin guardar',
				MESSAGE: 'Hay cambios sin guardar. ¿Desea continuar?',
				BTN_CANCEL: 'Cancelar',
				BTN_SAVE_CONTINUE: 'Guardar y continuar',
				BTN_DISCARD: 'Descartar cambios y continuar'
			},
			COMMON: {
				BTN_OK: 'Aceptar',
				BTN_CANCEL: 'Cancelar',
				BTN_CLOSE: 'Cerrar',
				BTN_RESET: 'Restablecer',
				BTN_SAVE: 'Guardar',
				LOADING: 'Cargando...',
				NO_RECORDS: 'No se encontraron registros',
				SEARCH: 'Buscar',
				SEARCH_PLACEHOLDER: 'Buscar...',
				TOOLTIP_DELETE: 'Eliminar',
				TOOLTIP_ADD: 'Agregar',
				TOOLTIP_DOWNLOAD: 'Descargar',
				TOOLTIP_CANCEL: 'Cancelar cambios',
				TOOLTIP_SAVE: 'Guardar cambios',
				TOOLTIP_REMOVE_CARD: 'Eliminar tarjeta',
				DATE_RANGE: 'Rango de fechas'
			},
			FILTER: {
				TITLE: 'Filtro',
				UNIT: 'Unidad',
				SYSTEM: 'Sistema',
				SEARCH_SYSTEM: 'Buscar sistema...',
				NO_MATCHING_SYSTEM: 'No se encontró ningún sistema coincidente'
			},
			BUCKETING_FILTER: {
				FACILITY_TYPE: 'Tipo de instalación',
				SELECT_FACILITY: 'Seleccionar instalación',
				TOOLTIP_CARD_VIEW: 'Vista de tarjetas',
				TOOLTIP_TABLE_VIEW: 'Vista de tabla',
				SEARCH_SYSTEM: 'Buscar sistema...',
				NO_SYSTEM_FOUND: 'No se encontró ningún sistema',
				GROUP_BY: 'Agrupar por:',
				ENABLE_CLUSTERING: 'Activar agrupación',
				SELECT_CLUSTER: 'Seleccionar clúster',
				WIND_DIRECTION: 'Dirección del viento',
				SELECTED_DATE_RANGE: 'Rango de fechas seleccionado',
				START_DATE: 'Fecha de inicio',
				END_DATE: 'Fecha de fin',
				CONFIGURE_LOSS: 'Configurar pérdida',
				SAP_FILTER_TITLE: 'Filtro de campo(s) SAP:'
			},
			BUCKETING_TABLE: {
				SEARCH: 'Buscar',
				SORT_BY: 'Ordenar por',
				SORT_NONE: 'Ninguno',
				SORT_ASC: 'Ascendente',
				SORT_DESC: 'Descendente',
				COL_NAME: 'Nombre',
				COL_GENERATION: 'Generación (en MWh)',
				COL_EFFICIENCY: 'Eficiencia de rendimiento (%)',
				COL_BREAKDOWN_COUNT: 'Conteo de averías',
				COL_NOTIFICATION_COUNT: 'Conteo de notificaciones',
				COL_CLOSED: 'Cerrado',
				COL_OPEN: 'Abierto',
				COL_BLOCK: 'Bloque',
				COL_EFF_LOSS: 'Pérdida de eficiencia',
				COL_INV: 'Inversor',
				COL_TIME: 'Tiempo (hh:mm)',
				COL_CURTAILMENT_LOSS: 'Pérdida por reducción (MWh)',
				COL_GEN_LOSS: 'Pérdida de generación (MWh)',
				COL_GEN_LOSS_NET: 'Pérdida de generación (MWh)',
				COL_GEN_LOSS_MWH: 'PÉRDIDA GEN. (MWh)',
				COL_AVAILABILITY: 'Disponibilidad',
				COL_REV_LOSS: 'Pérdida de ingresos',
				COL_MAINTENANCE_COST: 'Costo de mantenimiento',
				COL_DOWNTIME: 'Tiempo de inactividad',
				COL_DURATION_PCT: 'Duración %',
				COL_MTTR: 'MTTR (hh:mm)',
				COL_ASSET: 'Activo',
				COL_MTBF: 'MTBF (hh:mm)',
				COL_IDEAL_GEN: 'Generación ideal (KWh)',
				COL_SOILING_LOSS: 'Pérdida por ensuciamiento (KWh)',
				COL_SOILING_LOSS_PCT: 'Pérdida por ensuciamiento (% de gen. ideal)',
				COL_SCHEDULED_DATE: 'Fecha programada de limpieza',
				COL_LAST_CLEANED: 'Última limpieza',
				COL_LAST_CLEANED_DAYS: '(Días atrás)',
				COL_NOTIFICATION_NO: 'N° de notificación',
				COL_EQUIPMENT_ID: 'ID de equipo',
				COL_FUNCTIONAL_LOC: 'Ubicación funcional',
				COL_EQUIPMENT: 'Equipo',
				COL_DESCRIPTION: 'Descripción',
				COL_CREATED_BY: 'Creado por',
				COL_CREATED_ON: 'CREADO EL',
				COL_MAINTENANCE_PLANT: 'Planta de mantenimiento',
				COL_PLAN_GROUP: 'Grupo de planificación',
				COL_COMPLETED_ON: 'Completado el',
				COL_COMPLETED_BY: 'Completado por',
				COL_COMPONENT: 'Componente'
			},
			POWER_CURVE: {
				TITLE_PREFIX: 'Configuración de curva de potencia para',
				OEM: 'Curva de potencia OEM',
				CALCULATED: 'Curva de potencia calculada',
				START_DATE: 'Fecha de inicio',
				STOP_DATE: 'Fecha de fin',
				DATE_RANGE_ERROR: 'La fecha de inicio debe ser anterior a la fecha de fin.',
				ADD_COMMENT: 'Agregar comentario',
				COMMENT_ERROR: 'Por favor ingrese un comentario válido.'
			},
			FILTER_MIN_MAX: {
				TOOLTIP: 'Filtro Min-Max',
				GREATER_THAN: 'Mayor que',
				LESS_THAN: 'Menor que'
			},
			TAG_FILTER: {
				SELECT_TAG: 'Seleccionar tag',
				NO_MATCHING_TAG: 'No se encontró ningún tag coincidente'
			},
			LIST_CARD: {
				NO_MATCHING_TAG: 'No se encontró ningún tag coincidente'
			},
			LIST_XY_CARD: {
				X_AXIS: 'Eje X',
				Y_AXIS: 'Eje Y',
				SEARCH_X: 'Buscar X...',
				SEARCH_Y: 'Buscar Y...',
				NO_MATCHING_X: 'No se encontró ningún X coincidente',
				NO_MATCHING_Y: 'No se encontró ningún Y coincidente'
			},
			CHART: {
				TOOLTIP_DOWNLOAD_TAG: 'Descargar datos de etiqueta',
				TOOLTIP_NO_ACCESS: 'No tiene acceso a las unidades y sistemas utilizados en este elemento de análisis. Por lo tanto, ha sido desactivado.',
				TOOLTIP_REMOVE_FILTER: 'Eliminar filtro',
				LOCK_X_AXIS: 'Bloquear eje X (Fecha)',
				MULTI_AXIS: 'Múltiples ejes',
				TRIP_LIMIT: 'Límite de disparo',
				ALARM_LIMIT: 'Límite de alarma',
				THRESHOLD_LIMIT: 'Límite de umbral',
				INSTRUMENT_RANGE: 'Rango del instrumento',
				LOCK_X_AXIS_ALERT_TOOLTIP: 'No puede desbloquear en la comparación de alertas',
				TYPE_SIGNAL_VS_TIME: 'Señal vs Tiempo @ diferentes momentos',
				TYPE_SIGNAL_VS_SIGNAL: 'Señal vs Señal @ diferentes momentos',
				TYPE_STATE_SIGNAL: 'Análisis de señal para estados operativos',
				TYPE_STATE_SIGNAL_VS_SIGNAL: 'Señal vs Señal en estados operativos',
				TYPE_MULTISIGNAL: 'Análisis multi-señal en estados operativos',
				TYPE_MULTISIGNAL_VS_SIGNAL: 'Multi-señal vs Señal en estados operativos',
				TYPE_FULL_SYSTEM: 'Comparación de sistema/equipo',
				TYPE_ALERT_COMPARISON: 'Comparación de alertas'
			},
			TAG_DIALOG: {
				TITLE_PLACEHOLDER: 'Título',
				DESC_PLACEHOLDER: 'Descripción',
				PLOT_TYPE_LABEL: 'Tipo de gráfico',
				QUICK_PLOT: 'Gráfico rápido',
				AXIS_TYPE_LABEL: 'Tipo de eje',
				AXIS_MULTI: 'Múltiple',
				AXIS_SINGLE: 'Único'
			},
			SUMMARY: {
				LOADING: '¡Procesando datos, por favor espere!',
				NO_DATA: 'Sin datos disponibles.',
				NO_RENEWABLE_ASSETS: 'No se encontraron activos renovables',
				NO_RENEWABLE_ASSETS_SUBTITLE: 'Ningún activo coincide con los filtros seleccionados',
				NO_SYSTEMS: 'No se encontraron sistemas',
				NO_SYSTEMS_SUBTITLE: 'Ningún sistema coincide con los filtros y el rango de fechas seleccionados.',
				NO_DOWNTIME_DATA: 'No hay datos de tiempo de inactividad disponibles',
				NO_DOWNTIME_DATA_SUBTITLE: 'Los datos de tiempo de inactividad no están disponibles para los filtros y el rango de fechas seleccionados.',
				NO_PERFORMANCE_DATA: 'No hay datos de rendimiento disponibles',
				NO_PERFORMANCE_DATA_SUBTITLE: 'Los datos de rendimiento no están disponibles para los filtros y el rango de fechas seleccionados.',
				NO_CURTAILMENT_DATA: 'No hay datos de reducción disponibles',
				NO_CURTAILMENT_DATA_SUBTITLE: 'Los datos de reducción no están disponibles para los filtros y el rango de fechas seleccionados.',
				NO_LOSS_DATA: 'No hay datos de pérdidas disponibles',
				NO_LOSS_DATA_SUBTITLE: 'Los datos de pérdidas no están disponibles para los filtros y el rango de fechas seleccionados.',
				NO_MAINTENANCE_DATA: 'No hay datos de tiempo de mantenimiento disponibles',
				NO_MAINTENANCE_DATA_SUBTITLE: 'Los datos de tiempo de mantenimiento no están disponibles para los filtros y el rango de fechas seleccionados.',
				NO_SOILING_LOSS_DATA: 'No hay datos de pérdida por ensuciamiento disponibles',
				NO_SOILING_LOSS_DATA_SUBTITLE: 'Los datos de pérdida por ensuciamiento no están disponibles para los filtros y el rango de fechas seleccionados.',
			},
			AVAILABILITY: {
				TIME_BASED: 'Disponibilidad basada en tiempo',
				ENERGY_BASED: 'Disponibilidad basada en energía',
				TARGET_SUFFIX: 'Objetivo',
				TOTAL_LOSS_TITLE: 'Pérdida total (MWh)',
				ROW_DOWNTIME: 'Tiempo de inactividad (HH:MM)',
				ROW_LOST_PRODUCTION: 'Producción perdida (MWh)',
				ROW_LOST_REVENUE: 'Ingresos perdidos',
				ROW_MTBF: 'MTBF (Tiempo medio entre fallas - HH:MM)',
				ROW_MTTR: 'MTTR (Tiempo medio de reparación - HH:MM)',
				COL_NAME: 'Nombre',
				COL_VALUE: 'Valor'
			},
			PERFORMANCE: {
				LOST_GENERATION: 'Generación perdida (MWh)',
				LOST_REVENUE: 'Ingresos perdidos',
				BEST_PERFORMING: 'Mejor rendimiento',
				WORST_PERFORMING: 'Peor rendimiento',
				SHOW_TOP: 'Mostrar top:',
				TOTAL_LOSS_TITLE: 'Pérdida total (MWh)',
				PERF_CURVE_TITLE: 'Curva de rendimiento',
				WIND_ROSE_TITLE: 'Rosa de los vientos'
			},
			CURTAILMENT: {
				LOST_GENERATION: 'Generación perdida (MWh)',
				LOST_REVENUE: 'Ingresos perdidos',
				SHOW_TOP: 'Mostrar top:',
				TOTAL_LOSS_TITLE: 'Pérdida total (MWh)'
			},
			SOILING: {
				TOTAL_LOSS_TITLE: 'Pérdida total (MWh)',
				SOILING_CURVE_SUFFIX: 'Curva de pérdida por ensuciamiento',
				TOOLTIP_SAVE: 'Guardar',
				TOOLTIP_CANCEL: 'Cancelar',
				SECTION_SOILING: 'Ensuciamiento',
				SECTION_TEMPERATURE: 'Temperatura',
				SECTION_OTHERS: 'Otros',
				REF_SETTING: 'Configuración de referencia',
				CRS: 'CRS',
				SRS: 'SRS',
				SELECT_UNIT: 'Seleccionar unidad',
				SELECT_SYSTEM: 'Seleccionar sistema',
				SELECT_ASSET: 'Seleccionar activo',
				SELECT_TAG: 'Seleccionar etiqueta',
				SEARCH: 'Buscar',
				SEARCH_SYSTEM: 'Buscar sistema...',
				NO_MATCHING_UNIT: 'No se encontró ninguna unidad coincidente',
				NO_MATCHING_SYSTEM: 'No se encontró ningún sistema coincidente',
				NO_MATCHING_ASSET: 'No se encontró ningún activo coincidente',
				NO_MATCHING_TAG: 'No se encontró ninguna etiqueta coincidente',
				APPLY_ON: 'Aplicar en',
				CLEANING_CYCLE: 'Ciclo de limpieza',
				CLEANING_CYCLE_HINT: '(en días)',
				BTN_START_EXPERIMENT: 'Iniciar experimento',
				TOOLTIP_FORCE_STOP: 'Forzar detención del experimento en curso',
				TOOLTIP_UPLOAD_SOILING: 'Subir ratio de ensuciamiento',
				CLEANING_UPDATE: 'Actualización de limpieza',
				TOOLTIP_UPLOAD_CLEANING: 'Subir programa de limpieza',
				TOOLTIP_DOWNLOAD_CLEANING: 'Descargar informe de actualización de limpieza',
				CHOOSE_DATE: 'Elegir una fecha',
				DATE_HINT: 'MM/DD/AAAA',
				BTN_UPDATE: 'Actualizar'
			},
			LOSS: {
				LOST_GENERATION: 'Generación perdida (MWh)',
				LOST_REVENUE: 'Ingresos perdidos',
				EFFECTIVE_PR: 'PR efectivo',
				HIGHEST_LOSS_BUCKET: 'Mayor categoría de pérdida',
				LOSS_BUCKETING_TITLE: 'Clasificación de pérdidas (MWh)'
			},
			MAINTENANCE: {
				CHART_TITLE: 'Tiempo de mantenimiento (HH:MM)',
				BAD_ACTORS_TITLE: 'Principales actores problemáticos',
				NOTIFICATION_STATUS: 'Estado de notificaciones',
				SHDJ_DISTRIBUTION: 'Distribución SHDJ por unidad',
				PENDING_DEFECTS_TITLE: 'Defectos pendientes e informes de antigüedad',
				COL_GROUP_SECTION: 'Grupo/Sección',
				COL_0_30: '0 - 30 Días',
				COL_31_90: '31 - 90 Días',
				COL_91_180: '91 - 180 Días',
				COL_181_365: '181 - 365 Días',
				COL_365_500: '365 - 500 Días',
				COL_GRAND_TOTAL: 'Total general',
				MONTHLY_DEFECTS_PREFIX: 'Estado mensual de defectos -',
				TOTAL_MTD: 'Total de defectos MTD',
				YEARLY_DEFECTS_PREFIX: 'Estado anual de defectos - EF',
				TOTAL_YTD: 'Total de defectos YTD',
				PM_COMPLIANCE_PREFIX: 'Informe de cumplimiento PM -',
				COL_EQUIPMENT: 'Equipo',
				COL_SCHEDULED: 'Programado',
				COL_PENDING: 'Pendiente',
				COL_COMPLETED: 'Completado',
				COL_COMPLIANCE: 'Cumplimiento (%)'
			},
			MESSAGES: {
				SERVER_ERROR: 'Error interno del servidor',
				SAVE_SUCCESS: 'El análisis se ha guardado correctamente.',
				UPDATE_SUCCESS: 'El análisis ha sido actualizado.',
				ADD_SUCCESS: 'El análisis ha sido añadido.',
				COPY_SUCCESS: 'El análisis ha sido copiado.',
				CARD_GENERATED: 'Se ha generado correctamente una nueva tarjeta de análisis',
				POWER_CURVE_STARTED: 'Cálculo de la curva de potencia iniciado para',
				POWER_CURVE_FAILED: 'El cálculo de la curva de potencia falló para'
			}
		},
		NOTIFICATION_WIZARD: {
			HEADER_TITLE: 'Notificaciones',
			MARK_ALL_READ: 'Marcar todo como leído',
			SETTINGS: 'Configuración',
			TAB_ALL: 'Todas',
			TAB_UNREAD: 'Nuevas no leídas',
			TAB_ASSIGNED: 'Asignadas a mí',
			NOTIFICATIONS_SUFFIX: 'notificaciones',
			TOOLTIP_MARK_READ: 'Marcar como leído',
			TOOLTIP_MARK_UNREAD: 'Marcar como no leído',
			TOOLBAR_ITEM: 'elemento',
			TOOLBAR_ITEMS: 'elementos',
			TOOLBAR_SELECTED: 'seleccionado(s)',
			TOOLBAR_MARK_READ: 'Marcar como leído',
			TOOLBAR_MARK_UNREAD: 'Marcar como no leído',
			TOOLBAR_CLEAR: 'Eliminar mensajes',
			ERROR_TITLE: 'No se pudieron cargar las notificaciones',
			ERROR_DESC: 'Algo salió mal al obtener las notificaciones. Por favor, inténtelo de nuevo.',
			NOTIF_OFF_TITLE: 'Las notificaciones están desactivadas',
			NOTIF_OFF_DESC: 'Active las notificaciones para recibir actualizaciones aquí.',
			EMPTY_DEFAULT_TITLE: 'Sin notificaciones',
			EMPTY_DEFAULT_DESC: 'Aún no tiene notificaciones. Una vez que las reciba, aparecerán aquí.',
			EMPTY_CAUGHT_UP_TITLE: 'Está al día.',
			EMPTY_UNREAD_DESC: 'Las nuevas notificaciones de alertas y actualizaciones aparecerán aquí.',
			EMPTY_ASSIGNED_DESC: 'Las notificaciones asignadas a usted aparecerán aquí.',
			EMPTY_ALL_TITLE: 'Aún no hay notificaciones',
			EMPTY_ALL_DESC: 'Las actualizaciones aparecerán aquí',
			GROUP_TODAY: 'Hoy',
			GROUP_YESTERDAY: 'Ayer',
			GROUP_THIS_WEEK: 'Antes esta semana',
			GROUP_THIS_MONTH: 'Antes este mes',
			GROUP_LAST_MONTH: 'El mes pasado',
			GROUP_OLDER: 'Mes anterior',
			SETTINGS_HEADER: 'Configuración de preferencias del usuario',
			SETTINGS_TAB_NOTIFICATIONS: 'Notificaciones',
			SETTINGS_TAB_AUDIBLE: 'Alarmas audibles',
			SETTINGS_COL_TYPE: 'Tipo',
			SETTINGS_COL_EMAIL: 'Correo electrónico',
			SETTINGS_COL_PLATFORM: 'Plataforma',
			SETTINGS_COL_AUDIBLE: 'Audible',
			SETTINGS_ALERTS_HEADER: 'Alertas',
			SETTINGS_ALERTS_DESC: 'Notificaciones activadas cuando se genera una nueva alerta.',
			SETTINGS_AUDIBLE_ALERTS_DESC: 'Reproducir una alarma audible cuando se creen estas alertas.',
			SETTINGS_NEW_ANOMALY: 'Nuevas alertas de anomalías',
			SETTINGS_NEW_HIGH_ANOMALY: 'Nuevas alertas de anomalía alta',
			SETTINGS_NEW_LOW_ANOMALY: 'Nuevas alertas de anomalía baja',
			SETTINGS_NEW_THRESHOLD: 'Nuevas alertas de umbral',
			SETTINGS_OWNERSHIP_HEADER: 'Propiedad y asignación de alertas',
			SETTINGS_OWNERSHIP_DESC: 'Notificaciones relacionadas con la responsabilidad de alertas.',
			SETTINGS_ALERT_OWNER: 'Asignado como propietario de alerta',
			SETTINGS_ALERT_WATCHER: 'Asignado como observador de alerta',
			SETTINGS_ACTIVITY_HEADER: 'Actividad de alertas',
			SETTINGS_ACTIVITY_DESC: 'Controla si los usuarios reciben actualizaciones continuas tras la asignación.',
			SETTINGS_OWNED_ALERTS: 'Actualizaciones en alertas propias',
			SETTINGS_WATCHED_ALERTS: 'Actualizaciones en alertas observadas',
			SETTINGS_SYSTEM_HEADER: 'Actualizaciones del sistema',
			SETTINGS_SYSTEM_DESC: 'Notificaciones relacionadas con operaciones de IA / sistema.',
			SETTINGS_MODEL_RETRAINING: 'Reentrenamiento de modelo completado',
			SETTINGS_AUDIBLE_FOOTER_NOTE: 'La alarma audible sonará una vez o seguirá notificando a la frecuencia seleccionada hasta que haga clic en la alerta para ver sus detalles.',
			PDF_HEADER: 'Gestión de casos - PDF generado',
			PDF_GENERATED_BEFORE: 'El PDF de gestión de casos se ha generado correctamente.',
			PDF_DOWNLOAD_LINK: 'Descargar PDF',
			PDF_GENERATED_AFTER: 'o acceda mediante el enlace enviado a su correo electrónico. El enlace de descarga caduca el {{expiry}}.',
			PDF_LINK_EXPIRED_TOOLTIP: 'Este enlace de descarga ha caducado. Genere el PDF de nuevo para descargarlo.',
			ASSET_TEMPLATE_SYNC_STARTED_TITLE: 'Sincronización de plantilla de activo iniciada – {{templateName}}',
			ASSET_TEMPLATE_SYNC_COMPLETED_TITLE: 'Sincronización de plantilla de activo completada – {{templateName}}',
			ASSET_TEMPLATE_SYNC_FAILED_TITLE: 'Sincronización de plantilla de activo fallida – {{templateName}}'
		},
		MAINTENANCE_OPTIMIZATION: {
			// Main component
			HEADER_TITLE: 'Optimización de Mantenimiento',
			TAB_RESULTS: 'Resultados y Valor',
			TAB_SCHEDULES: 'Planes PM',
			TAB_RUN_HISTORY: 'Historial de Ejecuciones',

			// Run History
			RH_COL_SL_NO: 'N.º',
			RH_COL_RUN_DATE: 'Fecha de Ejecución',
			RH_COL_NAME: 'Nombre',
			RH_COL_CREATOR: 'Creador',
			RH_COL_SCOPE: 'Alcance',
			RH_COL_STATUS: 'Estado',
			RH_COL_TOTAL_VALUE: 'Valor Total',
			RH_COL_APPROVED: 'Aprobado',
			RH_COL_ACTIONS: 'Acciones',
			RH_VIEW: 'Ver',
			RH_EQUIPMENTS: 'equipos',
			RH_SEARCH_PLACEHOLDER: 'Buscar ejecuciones...',
			RH_EMPTY: 'No se encontraron ejecuciones de optimización para la selección actual.',
			RH_STATUS_PENDING: 'Pendiente',
			RH_STATUS_RUNNING: 'En ejecución',
			RH_STATUS_PROCESSING: 'Procesando',
			RH_STATUS_COMPLETED: 'Completado',
			RH_STATUS_FAILED: 'Fallido',
			BTN_RUN_OPTIMIZATION: 'Ejecutar Optimización',
			LAST_RUN_PREFIX: 'Última optimización ejecutada:',

			// PM Schedules
			PM_DOWNLOAD_TITLE: 'Opciones de descarga',
			PM_DOWNLOAD_SUBTITLE: 'Use los botones a continuación para exportar planes PM en un formato que se puede cargar en SAP o su CMMS:',
			PM_DOWNLOAD_ALL_TITLE: 'Descargar TODO (CSV)',
			PM_DOWNLOAD_ALL_DESC: 'Lista consolidada de todas las actividades PM',
			PM_DOWNLOAD_PER_EQ_TITLE: 'Informes por Equipo',
			PM_DOWNLOAD_PER_EQ_DESC: 'Filtrado al activo seleccionado en la jerarquía',
			PM_DOWNLOAD_CONSOLIDATED_TITLE: 'Planes Consolidados',
			PM_DOWNLOAD_CONSOLIDATED_DESC: 'Agrupado por nuevo intervalo',
			PM_SEARCH_PLACEHOLDER: 'Buscar...',
			PM_GROUP_BY_INTERVAL: 'Agrupar por: Intervalo',
			PM_FILTER: 'Filtrar',
			PM_COL_ID: 'ID',
			PM_COL_NAME: 'Nombre del Plan PM',
			PM_COL_ACCESS_CLASS: 'Clase de Acceso',
			PM_COL_BUNDLE_NAME: 'Nombre del Paquete',
			PM_COL_BUNDLE_ID: 'ID del Paquete',
			PM_COL_PREV_INTERVAL: 'Intervalo PM Anterior',
			PM_COL_CURR_INTERVAL: 'Intervalo PM Actual',
			PM_EACH: 'Cada',
			PM_DAYS: 'días',

			// Results & Values
			RV_TOTAL: 'Total',
			RV_POTENTIAL_VALUE: 'Valor potencial',
			RV_PM_SCHEDULING: 'Programación PM',
			RV_CM_REDUCTION: 'Reducción CM',
			RV_FAILURE_REDUCTION: 'Reducción de Fallos / Averías',
			RV_BY_REC_TYPE: 'Por Tipo de Recomendación',
			RV_TOTAL_ACTIVITIES: 'Total de Actividades Inspeccionadas',
			RV_INCREASES: 'Aumentos',
			RV_DECREASES: 'Disminuciones',
			RV_NO_CHANGES: 'Sin Cambios',
			RV_REMOVE: 'Eliminar',
			RV_ADD: 'Agregar',
			RV_WHERE_VALUE: 'Dónde Está el Valor',
			RV_BY_STATUS: 'Por Estado',
			RV_TOTAL_SCHEDULES: 'Total de Planes',
			RV_PENDING: 'Pendiente',
			RV_APPROVED: 'Aprobado',
			RV_REJECTED: 'Rechazado',
			RV_SEARCH_PLACEHOLDER: 'Buscar...',
			RV_GROUP_BY_SYSTEM: 'Agrupar por: Sistema',
			RV_FILTER: 'Filtrar',
			RV_COL_FREQ_REC: 'Recomendación de Frecuencia',
			RV_COL_HIERARCHY: 'Jerarquía / Nombres PM',
			RV_COL_REC_INTERVAL: 'Intervalo Recomendado (días)',
			RV_COL_SAVINGS: 'Ahorros Totales ($/año)',
			RV_COL_PM: 'PM ($/año)',
			RV_COL_CM: 'CM ($/año)',
			RV_COL_FAILURE_RISK: 'Riesgo de Fallo ($/año)',
			RV_COL_APPROVE: 'Aprobar / Rechazar',
			RV_COL_PM_ID: 'PM ID',
			RV_COL_ACTIVITY: 'Actividad',
			RV_COL_ROLE: 'Rol',
			RV_COL_STANDALONE: 'Independiente',
			RV_COL_EFFECTIVE: 'Efectivo',
			RV_COL_EVIDENCE: 'Evidencia',
			RV_COL_VALUE: 'Valor',
			RV_COL_STATUS: 'Estado',
			RV_BH_CURRENT: 'Actual',
			RV_BH_EFFECTIVE: 'Efectivo',
			RV_BH_OUTCOME: 'Resultado',
			RV_BH_DRIVER: 'Impulsor(es)',
			RV_BH_VALUE: 'Valor',
			RV_BH_CONFIDENCE: 'Confianza',
			RV_BH_STATUS: 'Estado',
			RV_BH_ACTIVITIES: 'actividades',
			RV_BH_DRIVERS: 'impulsores',
			RV_BH_OVERRIDES: 'anulaciones',
			RV_BH_UNCHANGED: 'sin cambios',
			RV_BH_NONE: 'Ninguno',
			RV_BH_NO_CHANGE: 'Sin cambios',
			RV_BH_NA: 'n/a',
			RV_DEEP_DIVE: 'Análisis detallado',
			RV_BUNDLE_SUMMARY: 'Resumen del paquete',
			RV_LAST_RUN: 'Última ejecución',
			RV_NO_RESULTS: 'No hay resultados de optimización para esta selección.',
			RV_SELECT_NODE: 'Seleccione una instalación, unidad o sistema para ver los resultados.',
			RV_LOADING: 'Cargando resultados...',

			// MC Recommendation panel
			MC_PANEL_TITLE: 'Panel Detallado — Recomendación',
			MC_ASK_ROOTY: 'Preguntar a Rooty',
			MC_APPROVE: 'Aprobar',
			MC_REJECT: 'Rechazar',
			MC_CURRENT_FREQ: 'Frecuencia Actual',
			MC_REC_FREQ: 'Frecuencia Recomendada',
			MC_SHOW: 'Mostrar',
			MC_COMPACT: 'Compacto',
			MC_ADVANCED: 'Avanzado',
			MC_TAB_DECISION: 'Decisión',
			MC_TAB_OBSERVATIONS: 'Observaciones',
			MC_TAB_FAILURE_MODES: 'Modos de Fallo',
			MC_DECISION_TITLE: 'Decisión',
			MC_WHY_NOW: 'POR QUÉ AHORA',
			MC_EXPECTED_VALUE: 'VALOR ESPERADO',
			MC_SECONDARY_ACTION: 'ACCIÓN SECUNDARIA',
			MC_REC_CONFIDENCE: 'Confianza en la Recomendación',
			MC_SAVINGS_BREAKDOWN: 'Desglose de Ahorros',
			MC_TOTAL_ANNUAL_SAVINGS: 'Ahorros anuales totales',
			MC_PREDICTIONS: 'Predicciones',
			MC_EXPECTED_OUTCOME: 'Resultado esperado si se acepta la recomendación',
			MC_INTERVAL_SENSITIVITY: 'Sensibilidad del Intervalo (β / η)',
			MC_ANNUAL_CM_COUNT: 'Conteo Anual de CM',
			MC_CURRENT_CM_COUNT: 'Conteo actual de CM:',
			MC_PREDICTED_CM_COUNT: 'Nuevo conteo previsto de CM:',
			MC_ANNUAL_BD_COUNT: 'Conteo Anual de Averías',
			MC_CURRENT_BD_COUNT: 'Conteo actual de averías:',
			MC_PREDICTED_BD_COUNT: 'Nuevo conteo previsto de averías:',
			MC_PM_FREQUENCY: 'Frecuencia PM',
			MC_CURRENT: 'Actual:',
			MC_RECOMMENDED: 'Recomendado:',
			MC_FM_LINK: 'pestaña Modos de Fallo',
			MC_OBS_REACTIVE_VS_PREVENTIVE: 'Ratio Coste Reactivo vs Preventivo',
			MC_OBS_CM_TIMING: 'Análisis de Temporización de Eventos CM',
			MC_OBS_EARLY: 'Temprano',
			MC_OBS_MID: 'Medio',
			MC_OBS_LATE: 'Tardío',
			MC_OBS_POST_PM: 'Recurrencia Post-PM',
			MC_OBS_EVIDENCE_LOG: 'Abrir Registro de Evidencias completo →',
			MC_FM_SERVED_BY: 'atendido por este PM',
			MC_FM_SORT: 'Ordenar',
			MC_FM_BY_ROLE: 'Por Rol',
			MC_FM_EXPAND_ALL: 'Expandir Todo',
			MC_FM_PRIMARY: 'Primario',
			MC_FM_SUPPORTING: 'De apoyo',
			MC_FM_INCIDENTAL: 'Incidental',
			MC_FM_AGG_B: 'Agregado B',
			MC_FM_CM_COUNT: 'Conteo CM /AÑO',
			MC_FM_BREAKDOWNS: 'Averías / AÑO',
			MC_FM_DIAGNOSIS: 'Diagnóstico',
			MC_FM_TIMING: 'Temporización',
			MC_FM_SENSITIVITY: 'Sensibilidad (β)',
			MC_FM_IMPACT: 'Impacto',
			MC_FM_EVENTS: 'Eventos',
			MC_FM_DATE_COL: 'Fecha',
			MC_FM_EVENT_COL: 'Evento',
			MC_FM_COST_COL: 'Coste',
			MC_FM_CLASS_COL: 'Clase',
			MC_TAG_INCREASE_FREQ: 'Aumentar frecuencia',
			MC_TAG_TIMING: 'basado en tiempo',
			MC_TAG_CASE2: 'Caso 2',
			MC_TAG_CBM: '+ red de seguridad CBM',
			MCB_OPEN_EVIDENCE_LOG: 'Abrir registro de evidencia',
			MCB_DECISION_STANDALONE: 'Recomendación independiente',
			MCB_DECISION_EFFECTIVE: 'Recomendación efectiva del paquete',
			MCB_EFFECTIVE_IS_STANDALONE: 'El resultado independiente también es el resultado efectivo',
			MCB_EXPECTED_IMPACT: 'Impacto esperado',
			MCB_EFFECTIVE_BUNDLE_RESULT: 'Resultado efectivo del paquete',
			MCB_PM_COST: 'Costo de PM',
			MCB_PM_COST_SUB: 'Gasto anual adicional de PM',
			MCB_CM_SAVINGS: 'Ahorro de CM',
			MCB_CM_SAVINGS_SUB: 'Reducción anual esperada',
			MCB_BD_SAVINGS: 'Ahorro por averías',
			MCB_BD_SAVINGS_SUB: 'Reducción anual esperada',
			MCB_NET_VALUE: 'Valor anual neto',
			MCB_NET_VALUE_SUB: 'Después de la propagación del paquete',
			MCB_CONFIDENCE: 'Confianza',
			MCB_DRIVER_BASED: 'Basado en el impulsor',
			MCB_WHY: 'Por qué esta recomendación',
			MCB_ADVANCED_PENDING: 'Los detalles avanzados llegarán pronto.',
			MCB_OBS_WHAT: 'Lo que observó el motor',
			MCB_OBS_ECONOMIC: 'Cribado económico',
			MCB_OBS_TIMING: 'Momento',
			MCB_OBS_POSTPM: 'Recurrencia posterior al PM',
			MCB_TIMING_DISTRIBUTION: 'Distribución temporal',
			MCB_EARLY: 'Temprano',
			MCB_MIDDLE: 'Medio',
			MCB_LATE: 'Tardío',
			MCB_FM_BUILDUP: 'Acumulación de modos de fallo',
			MCB_FM_BUILDUP_SUB: 'La vista compacta muestra la conclusión. La avanzada expone el diagnóstico, la predicción, la confianza y el rastro de evidencia de cada FM.',
			MCB_DETAILS: 'Detalles',
			MCB_FM_DIAGNOSIS: 'Diagnóstico',
			MCB_FM_EVIDENCE: 'Evidencia',
			MCB_FM_TIMING: 'Momento',
			MCB_FM_CONTRIBUTION: 'Contribución',
			MCB_FM_STANDALONE: 'Independiente',
			MCB_FM_EFFECTIVE: 'Efectivo',
			MCB_FM_ROUTE: 'Ruta',
			MCB_FM_INTERVAL_CONTRIB: 'Contribución al intervalo',
			MCB_FM_VALUE: 'Valor',
			MCB_FM_STATUS: 'Estado',
			MCB_FM_ADMIN_INTERPRETATION: 'Interpretación del administrador',
			MCB_FM_INTERVAL_DRIVER: 'Impulsor del intervalo',
			MCB_FM_OVERRIDDEN: 'FM anulado',
			MCB_FM_NON_INTERVAL: 'No relativo al intervalo',
			MCB_STANDALONE_NOT_REALIZED: 'El ahorro independiente de {{code}} no se realiza y no debe sumarse a los totales del equipo o de la cartera.',
			MCB_CONF_DATA_SUFFICIENCY: 'Suficiencia de datos',
			MCB_CONF_TIMING_QUALITY: 'Calidad temporal',
			MCB_CONF_MAPPING_QUALITY: 'Calidad de mapeo',
			MCB_CONF_PRIOR_CONFIRMATION: 'Confirmación previa',
			MCB_OBS_ACTIONABILITY: 'Accionabilidad',
			MCB_OBS_CONDITION_MODIFIER: 'Modificador de condición',
			MCB_OBS_DATA_GATE: 'Puerta de datos',
			MCB_PRED_DETAILS: 'Detalles de predicción',
			MCB_PRED_B_BASE: 'Base B',
			MCB_PRED_ASSET_MODIFIER: 'Modificador de activo',
			MCB_PRED_B_OPTIMIZATION: 'Optimización B',
			MCB_PRED_CM: 'Predicción CM',
			MCB_PRED_BD: 'Predicción BD',
			MCB_D_SEC_A: 'A. Puerta de datos y clasificación',
			MCB_D_SEC_B: 'B. Patrón temporal',
			MCB_D_SEC_C: 'C. Carga, condición y accionabilidad',
			MCB_D_SEC_D: 'D. Cribado económico y diagnóstico',
			MCB_D_SEC_E: 'E. Construcción de B',
			MCB_D_SEC_F: 'F. Predicción y valor',
			MCB_D_SEC_G: 'G. Evidencia de eventos',
			MCB_D_ROUTE: 'Ruta',
			MCB_D_PM_CYCLES: 'Ciclos de PM',
			MCB_D_QUALIFYING_EVENTS: 'Eventos calificados',
			MCB_D_MAPPING_CONFIDENCE: 'Confianza de mapeo',
			MCB_D_MEAN_MX: 'Media Mx',
			MCB_D_SPREAD: 'Dispersión Σx',
			MCB_D_EML: 'E/M/L',
			MCB_D_POSTPM: 'PostPM',
			MCB_D_RWCM_RAW: 'RWCM bruto',
			MCB_D_EFF_CM_BURDEN: 'Carga CM efectiva',
			MCB_D_HM: 'Hm',
			MCB_D_GM: 'Gm',
			MCB_D_PM_BURDEN: 'Carga de PM',
			MCB_D_CM_BD_BURDEN: 'Carga CM + BD',
			MCB_D_RA_COST: 'Costo Ra',
			MCB_D_DIAGNOSIS: 'Diagnóstico',
			MCB_D_B_BASE: 'Base B',
			MCB_D_DIRECTION: 'Dirección',
			MCB_D_CONCENTRATION: 'Concentración',
			MCB_D_B_OPT: 'B Opt',
			MCB_D_INTERVAL: 'Intervalo',
			MCB_D_CM_PREDICTION: 'Predicción CM',
			MCB_D_STANDALONE_NET: 'Neto independiente',
			MCB_D_EFF_BUNDLE_NET: 'Neto efectivo del paquete',
			MCB_D_COL_EVENT: 'Evento',
			MCB_D_COL_DATE: 'Fecha',
			MCB_D_COL_CLASS: 'Clase',
			MCB_D_COL_BD: 'BD',
			MCB_D_COL_XE: 'x<sub>e</sub>',
			MCB_D_COL_COST: 'Costo',

			// Run Configuration Dialog
			RC_TITLE: 'Configuración de Ejecución',
			RC_TAB_SCOPE: 'Alcance',
			RC_TAB_CONFIGURE: 'Configurar',
			RC_TAB_IMPORT: 'Importar Datos',
			RC_TAB_DATA_QC: 'QC de Datos',
			RC_TAB_MAPPING: 'Asignación',
			RC_SAVE: 'Guardar',
			RC_CANCEL: 'Cancelar',
			RC_PREVIOUS: 'Anterior',
			RC_NEXT: 'Siguiente',
			RC_RUN: 'Ejecutar',
			RC_CONFIGURE_TITLE: 'Configurar Análisis',
			RC_CONFIGURE_DESC: 'Establezca el perfil de análisis, umbrales y parámetros de ajuste. La mayoría de los usuarios deben elegir un perfil y ajustar solo los parámetros principales. Los parámetros avanzados controlan el comportamiento interno del algoritmo.',
			RC_ASSET_CLASS_TITLE: 'Anulaciones de Clase de Activo',
			RC_ASSET_CLASS_DESC: 'Entradas A/B/C por clase para parámetros de tolerancia al riesgo',
			RC_ANALYSIS_WINDOW_TITLE: 'Ventana de Análisis',
			RC_ANALYSIS_WINDOW_DESC: 'Defina el período de tiempo para el análisis de datos CMMS',
			RC_DURATION: 'Duración',
			RC_INITIAL_DATE: 'Fecha Inicial',
			RC_END_DATE: 'Fecha Final',
			RC_ANALYSIS_PERIOD_PREFIX: 'Período de Análisis:',
			RC_MONTHS: 'meses',
			RC_SAP_NOTIFICATIONS: 'Notificaciones SAP:',
			RC_FETCHING: 'Obteniendo...',
			RC_RECORDS: 'registros',
			RC_ANALYSIS_PROFILE_TITLE: 'Perfil de Análisis',
			RC_ANALYSIS_PROFILE_DESC: 'Establece todos los parámetros con valores predeterminados precalibrados. Puede anular valores individuales a continuación.',
			RC_DATA_SUFFICIENCY_TITLE: 'Requisitos de Suficiencia de Datos',
			RC_DATA_SUFFICIENCY_DESC: 'Cuánta evidencia se necesita antes de que el algoritmo actúe',
			RC_MIN_PM_CYCLES: 'Ciclos PM Mínimos',
			RC_MIN_FM_EVENTS: 'Eventos FM Mínimos',
			RC_RECENCY_HALF_LIFE: 'Vida Media de Actualidad (h)',
			RC_POST_PM_WINDOW: 'Ventana Post-PM (d)',
			RC_CYCLES: 'ciclos',
			RC_RESET_TO_BASE: 'Restablecer a base',
			RC_PM_CM_RATIO_TITLE: 'Umbrales de Ratio PM/CM (Ra)',
			RC_PM_CM_RATIO_DESC: '¿Cuándo es el gasto en PM demasiado alto o demasiado bajo en relación con la carga de fallos? Ambos ratios siempre se calculan y se informan.',
			RC_PRIMARY_RATIO_LABEL: 'Ratio principal para la lógica de diagnóstico',
			RC_OVER_MAINTAINED: 'Sobremantenido (Caso 1)',
			RC_UNDER_MAINTAINED: 'Submantenido (Caso 2)',
			RC_INTERVAL_ADJ_TITLE: 'Límites de Ajuste de Intervalo',
			RC_INTERVAL_ADJ_DESC: 'Cambio máximo de intervalo por ciclo de recomendación. Límites separados para extensión vs reducción.',
			RC_INTERVAL_ROUNDING: 'Redondeo de Intervalo',
			RC_ROUND_TO: 'Redondear a',
			RC_DIRECTION: 'Dirección',
			RC_ADJ_MODE: 'Modo de Ajuste: Porcentaje',
			RC_ADVANCED_PARAMS_TITLE: 'Parámetros Avanzados',
			RC_ADVANCED_PARAMS_DESC: 'Ajuste interno del algoritmo — análisis de temporización, enrutamiento, sensibilidad, niveles de confianza',
			RC_ADVANCED_WARNING: 'Estos parámetros controlan el procesamiento interno de señales. Cambiarlos sin comprender las fórmulas puede producir resultados engañosos. El selector de perfil anterior establece valores predeterminados razonables para cada uno. Solo anule si tiene una razón específica.',
			RC_PARAM_COL_PARAM: 'Parámetro',
			RC_PARAM_COL_DESC: 'Descripción',
			RC_PARAM_COL_EFFECT: 'EFECTO',
			RC_PARAM_COL_VALUE: 'Valor',
			RC_GOAL_SEEKER_TITLE: 'Modo de Búsqueda de Objetivos',
			RC_GOAL_SEEKER_DESC: 'Optimizar para lograr un objetivo específico de reducción de presupuesto',
			RC_GOAL_SEEKER_CURRENT: 'Actual',
			RC_GOAL_SEEKER_TARGET: 'Reducción Objetivo:',
			RC_CONSTRAINTS: 'Restricciones',
			RC_EXCLUDE_CRITICALITY: 'Excluir Criticidades de Activos',
			RC_EXCLUDE_EQ_TYPES: 'Excluir Tipos de Equipos',
			RC_SCOPE_TITLE: 'Alcance',
			RC_SCOPE_DESC: 'Defina el alcance de la ejecución de optimización.',
			RC_IMPORT_TITLE: 'Importar Datos',
			RC_IMPORT_DESC: 'Notificaciones SAP para el sistema seleccionado durante la ventana de análisis configurada.',
			RC_PM_EVENTS: 'Eventos PM',
			RC_CM_EVENTS: 'Eventos CM',
			RC_FAILURE_EVENTS: 'Eventos de Fallo',
			RC_NO_RECORDS: 'No se encontraron registros para este tipo de evento en la ventana seleccionada',
			RC_COL_NOTIFICATION: 'Notificación',
			RC_COL_EQUIPMENT: 'Equipo',
			RC_COL_DESCRIPTION: 'Descripción',
			RC_COL_TYPE: 'Tipo',
			RC_COL_CREATED_ON: 'Creado el',
			RC_COL_COMPLETED_ON: 'Completado el',
			RC_COL_PLAN_GROUP: 'Grupo de Plan',
			RC_DATA_QC_TITLE: 'QC de Datos',
			RC_DATA_QC_DESC: 'Revisar comprobaciones de calidad de datos.',
			RC_MAPPING_TITLE: 'Asignación',
			RC_MAPPING_DESC: 'Configurar la asignación CM-FM.',
			RC_MAPPING_GROUP_BY: 'Agrupar por',
			RC_MAPPING_GROUP_FM: 'Modo de Falla',
			RC_MAPPING_GROUP_PREVENTABILITY: 'Prevenibilidad',
			RC_MAPPING_SEARCH_PLACEHOLDER: 'Buscar notificación, orden, equipo, descripción',
			RC_MAPPING_LOW_CONFIDENCE: 'Baja confianza',
			RC_MAPPING_EDITED: 'Editado',
			RC_MAPPING_REGENERATE: 'Regenerar',
			RC_MAPPING_DOWNLOAD: 'Descargar',
			RC_MAPPING_UPLOAD: 'Subir',
			RC_MAPPING_RESET_ALL: 'Restablecer todo',
			RC_MAPPING_COL_ORDER: 'Orden #',
			RC_MAPPING_COL_EQUIPMENT_ID: 'ID de Equipo',
			RC_MAPPING_COL_WO_DESC: 'Descripción de OT',
			RC_MAPPING_COL_WO_TYPE: 'Tipo de OT',
			RC_MAPPING_COL_MAPPED_FM: 'Modo de Falla Asignado',
			RC_MAPPING_COL_PREVENTABILITY: 'Prevenibilidad',
			RC_MAPPING_EVENT: 'evento',
			RC_MAPPING_EVENTS: 'eventos',
			RC_MAPPING_AVG_FM_CONF: 'Conf. FM prom.',
			RC_MAPPING_AVG_PREV_CONF: 'Conf. Prev. prom.',
			RC_MAPPING_NO_RECORDS: 'No hay notificaciones CM/BD disponibles para la asignación',
			RC_MAPPING_NO_FILTERED_RESULTS: 'Ninguna asignación coincide con los filtros actuales',
			RC_MAPPING_GENERATING: 'Asignando eventos CM/Avería a modos de falla...',
			RC_MAPPING_GENERATION_ERROR: 'No se pudo generar la asignación CM/BD → modo de falla.',
			RC_MAPPING_UNMAPPED: 'Sin asignar',
			RC_MAPPING_SYMPTOM_ONLY: 'Solo síntoma',
			RC_MAPPING_SYMPTOM_ONLY_TOOLTIP: 'No se pudo reasignar a un modo de falla de causa raíz — excluido de los cálculos de optimización.',
			RC_MAPPING_UNMAPPED_CONF_TOOLTIP: 'Confianza en la determinación de "sin coincidencia" en sí, no en un modo de falla específico.',
			RC_MAPPING_NO_RATIONALE: 'No se proporcionó justificación.',
			RC_MAPPING_DETAIL_IDENTITY_SOURCE: 'Identidad y Origen',
			RC_MAPPING_DETAIL_WO_CONTENT: 'Contenido de la OT',
			RC_MAPPING_DETAIL_DURATION: 'Duración',
			RC_MAPPING_DETAIL_FM_MAPPING: 'Asignación de MF',
			RC_MAPPING_DETAIL_PREVENTABILITY: 'Prevenibilidad',
			RC_MAPPING_DETAIL_AUDIT: 'Auditoría',
			RC_MAPPING_DETAIL_EVENT_CLASS: 'Tipo de Orden / Clase de Evento',
			RC_MAPPING_DETAIL_SCHED_START: 'Inicio Programado',
			RC_MAPPING_DETAIL_SCHED_FINISH: 'Fin Programado',
			RC_MAPPING_DETAIL_ACTIVITY_CODE: 'Código de Actividad',
			RC_MAPPING_DETAIL_DAMAGE_CODE: 'Código de Daño',
			RC_MAPPING_DETAIL_CAUSE_CODE: 'Código de Causa',
			RC_MAPPING_DETAIL_MATERIAL_COST: 'Costo de Material',
			RC_MAPPING_DETAIL_PERMIT_ISSUED: 'Permiso Emitido',
			RC_MAPPING_DETAIL_PERMIT_CLOSED: 'Permiso Cerrado',
			RC_MAPPING_DETAIL_CM_DURATION: 'Duración CM (h)',
			RC_MAPPING_DETAIL_DURATION_SOURCE: 'Fuente de Duración',
			RC_MAPPING_DETAIL_FM_ID_NAME: 'ID / Nombre de MF',
			RC_MAPPING_DETAIL_FM_TYPE: 'Tipo de MF',
			RC_MAPPING_DETAIL_FAILURE_MODE_TYPE: 'Tipo de Modo de Falla',
			RC_MAPPING_DETAIL_CONFIDENCE: 'Confianza',
			RC_MAPPING_DETAIL_SOURCE: 'Fuente',
			RC_MAPPING_DETAIL_RE_ATTRIBUTED_FROM: 'Reasignado desde',
			RC_MAPPING_DETAIL_SYMPTOM_ONLY: 'Solo Síntoma',
			RC_MAPPING_DETAIL_RATIONALE: 'Justificación',
			RC_MAPPING_DETAIL_CLASS: 'Clase',
			RC_MAPPING_DETAIL_KEY_SIGNALS: 'Señales Clave',
			RC_MAPPING_DETAIL_EDITED_BY: 'Editado por',
			RC_MAPPING_DETAIL_EDITED_AT: 'Editado el',
			RC_MAPPING_DETAIL_FM_AGENT_RUN: 'Ejecución del Agente MF',
			RC_MAPPING_DETAIL_PREVENTABILITY_AGENT_RUN: 'Ejecución del Agente de Prevenibilidad',
			RC_MAPPING_DETAIL_EXISTING: 'Existente',
			RC_MAPPING_DETAIL_NOT_AVAILABLE: 'No disponible',
			RC_MAPPING_REGEN_CONFIRM_TITLE: '¿Regenerar asignación?',
			RC_MAPPING_REGEN_CONFIRM_MESSAGE: 'Se regenerarán {{count}} fila(s) editadas manualmente, usando sus correcciones como guía para la nueva ejecución.',

			// Select option labels
			OPT_6_MONTHS: '6 Meses',
			OPT_12_MONTHS: '12 Meses',
			OPT_15_MONTHS: '15 Meses',
			OPT_24_MONTHS: '24 Meses',
			OPT_36_MONTHS: '36 Meses',
			OPT_1_CYCLE: '1 Ciclo (Agresivo)',
			OPT_2_CYCLES: '2 Ciclos (Base)',
			OPT_3_CYCLES: '3 Ciclos (Conservador)',
			OPT_WEEKLY: 'Semanal (7 Días)',
			OPT_BIWEEKLY: 'Quincenal (14 Días)',
			OPT_MONTHLY: 'Mensual (30 Días)',
			OPT_NEAREST: 'Más cercano',
			OPT_UP: 'Arriba',
			OPT_DOWN: 'Abajo',
			OPT_CRIT_A: 'A (Crítico)',
			OPT_CRIT_B: 'B (Importante)',
			OPT_CRIT_C: 'C (Estándar)',
			OPT_CRIT_D: 'D (Bajo)',
			OPT_PROFILE_BASE_NAME: 'Base',
			OPT_PROFILE_BASE_SUBTITLE: 'Equilibrado, predeterminado',
			OPT_PROFILE_CONSERVATIVE_NAME: 'Conservador',
			OPT_PROFILE_CONSERVATIVE_SUBTITLE: 'Menos recomendaciones, mayor confianza',
			OPT_PROFILE_AGGRESSIVE_NAME: 'Agresivo',
			OPT_PROFILE_AGGRESSIVE_SUBTITLE: 'Más recomendaciones, mayor ahorro potencial',
			OPT_PCT_SHORTER_10: '10% más corto',
			OPT_PCT_SHORTER_20: '20% más corto',
			OPT_PCT_SHORTER_25: '25% más corto',
			OPT_PCT_SHORTER_50: '50% más corto',
			OPT_PCT_LONGER_10: '10% más largo',
			OPT_PCT_LONGER_20: '20% más largo',
			OPT_PCT_LONGER_25: '25% más largo',
			OPT_PCT_LONGER_50: '50% más largo'
		},
		USER_MANAGEMENT: {
			FORM_ERROR: '¡Vaya! Modifica algunos campos e inténtalo de nuevo.',
			CANCEL: 'Cancelar',
			SAVE: 'Guardar',
			CANCEL_CHANGES: 'Cancelar cambios',
			SAVE_CHANGES: 'Guardar cambios',
			NO_RECORDS: 'No se encontraron registros',
			PLEASE_WAIT: 'Por favor espere....',
			SEARCH: 'Buscar',
			ACTIONS: 'Acciones',
			NAME: 'Nombre',
			EMAIL: 'Correo electrónico',
			PHONE: 'Teléfono',
			FACILITY: 'Instalación',
			UNITS: 'Unidades',
			SYSTEMS: 'Sistemas',
			SYSTEM: 'Sistema',
			UNIT: 'Unidad',
			USER: 'Usuario',
			SELECT_FACILITY: 'Seleccionar instalación',
			SELECT_FACILITIES: 'Seleccionar instalaciones',
			SELECT_UNITS: 'Seleccionar unidades',
			SELECT_SYSTEMS: 'Seleccionar sistemas',
			SELECT_SYSTEM: 'Seleccionar sistema',
			SELECT_UNIT: 'Seleccionar unidad',
			SELECT_USER: 'Seleccionar usuario',
			SEARCH_UNIT: 'Buscar unidad...',
			NO_MATCHING_UNIT: 'No se encontró unidad coincidente',
			SEARCH_SYSTEM: 'Buscar sistema...',
			NO_MATCHING_SYSTEM: 'No se encontró sistema coincidente',
			ROLES: {
				LIST_TITLE: 'Lista de roles',
				NEW_ROLE: 'Nuevo rol',
				CREATE_ROLE_TOOLTIP: 'Crear nuevo rol',
				SEARCH_USER: 'Buscar usuario',
				FETCH_SELECTED: 'Obtener seleccionados',
				FETCH_SELECTED_TOOLTIP: 'Obtener roles seleccionados',
				COL_TITLE: 'Título',
				VIEW_ROLE: 'Ver',
				EDIT_ROLE: 'Editar',
				ROLE_SUFFIX: 'rol',
				DELETE_ROLE: 'Eliminar rol',
				PERMISSIONS_HEADING: 'Permisos:',
				ENTER_TITLE: 'Introducir título',
				TITLE_REQUIRED: 'El título es',
				TITLE_REQUIRED_STRONG: 'obligatorio',
				TITLE_HINT: 'Por favor introduzca',
				TITLE_HINT_STRONG: 'Título',
			},
			USERS: {
				TAB_USERS: 'Usuarios',
				TAB_USER_GROUPS: 'Grupos de usuarios',
				USER_LIST: 'Lista de usuarios',
				FILTERED_USER_LIST: 'Lista de usuarios filtrada',
				SHOW_DEACTIVATED: 'Mostrar desactivados',
				DOWNLOAD_TOOLTIP: 'Descargar lista de usuarios',
				DOWNLOAD: 'Descargar',
				NEW_USER: 'Nuevo usuario',
				NEW_USER_TOOLTIP: 'Crear nuevo usuario',
				UPLOAD_USER: 'Cargar usuario',
				UPLOAD_USER_TOOLTIP: 'Crear múltiples usuarios',
				SEARCH_USER: 'Buscar usuario',
				COL_SL_NO: 'N.º',
				COL_USERNAME: 'Nombre de usuario',
				COL_EMAIL: 'Correo electrónico',
				COL_NAME: 'Nombre',
				COL_ROLES: 'Roles',
				COL_ADMIN: 'Admin',
				COL_ENTERPRISE_ADMIN: 'Admin empresarial',
				COL_PHONE: 'Teléfono',
				COL_LAST_ACTIVE: 'Último acceso',
				COL_STATUS: 'Estado',
				STATUS_ACTIVE: 'Activo',
				STATUS_DEACTIVATED: 'Desactivado',
				EDIT_USER: 'Editar usuario',
				DELETE_USER: 'Eliminar usuario',
			},
			USER_GROUPS: {
				TITLE: 'Grupos de usuarios',
				ADD_TOOLTIP: 'Añadir grupo de usuarios',
				NEW_GROUP: 'Nuevo grupo de usuarios',
				COL_SL_NO: 'N.º',
				EDIT_TOOLTIP: 'Editar usuario',
				DELETE_TOOLTIP: 'Eliminar usuario',
				NAME_REQUIRED: 'El nombre es',
				NAME_REQUIRED_STRONG: 'obligatorio',
				NAME_HINT: 'Por favor introduzca',
				NAME_HINT_STRONG: 'nombre',
				NO_USER_GROUPS: 'No se han creado grupos de usuarios todavía',
				CREATE_GROUP_GET_STARTED: 'Cree un nuevo grupo de usuarios para comenzar',
			},
			USER_EDIT: {
				USER_INFO_HEADING: 'Información del usuario',
				SYSTEM_ACCESS_HEADING: 'Acceso al sistema',
				FACILITY_ADMIN_HEADING: 'Acceso de administrador de instalación',
				MODULE_ACCESS_HEADING: 'Acceso a módulos',
				EMAIL_LABEL: 'Correo electrónico',
				EMAIL_HINT: 'Introducir correo electrónico',
				PASSWORD_LABEL: 'Contraseña',
				PASSWORD_HINT: '(Mín. 8 caracteres, al menos un carácter especial, una mayúscula y un número)',
				PASSWORD_REQUIRED: 'La contraseña es',
				PASSWORD_REQUIRED_STRONG: 'obligatoria',
				NAME_LABEL: 'Nombre',
				NAME_HINT: 'Introducir nombre',
				PHONE_LABEL: 'Teléfono',
				PHONE_HINT: 'Introducir teléfono',
				PHONE_REQUIRED: 'El teléfono es',
				PHONE_REQUIRED_STRONG: 'obligatorio',
				ENTERPRISE_ADMIN: 'Admin empresarial',
				OPT_WHATSAPP: 'Activar WhatsApp',
				INTERNAL: 'Interno',
				MODEL_RETRAINING: 'Reentrenamiento de modelo',
				FACILITIES_LABEL: 'Instalaciones',
				SELECT_ALL: 'Seleccionar todo',
				MODULE_LABEL: 'Módulo',
				SELECT_MODULES_HINT: 'Seleccionar módulos',
				SEARCH_MODULES: 'Buscar módulos...',
				NO_MATCHING_MODULE: 'No se encontró módulo coincidente',
				MODULE_REQUIRED: 'Se debe seleccionar al menos un módulo.',
				SAVE_TOOLTIP: 'Guardar',
				CANCEL_TOOLTIP: 'Cancelar',
			},
			UPLOAD_USERS: {
				TITLE: 'Cargar lista de usuarios',
				SELECT_CSV: 'Seleccionar archivo CSV',
				CSV_REQUIRED: 'El archivo CSV es',
				CSV_REQUIRED_STRONG: 'obligatorio',
				SELECT_FILE: 'Seleccionar archivo',
				DOWNLOAD_FORMAT_TOOLTIP: 'Descargar formato CSV',
				SUBMIT: 'Enviar',
			},
			USER_POPUP: {
				EMAIL_REQUIRED: 'El correo es',
				EMAIL_REQUIRED_STRONG: 'obligatorio',
				EMAIL_HINT: 'Por favor introduzca',
				EMAIL_HINT_STRONG: 'Correo electrónico',
				PASSWORD_REQUIRED: 'La contraseña es',
				PASSWORD_REQUIRED_STRONG: 'obligatoria',
				PASSWORD_HINT: 'Introducir',
				PASSWORD_HINT_STRONG: 'Contraseña',
				NAME_REQUIRED: 'El nombre es',
				NAME_REQUIRED_STRONG: 'obligatorio',
				NAME_HINT: 'Introducir',
				NAME_HINT_STRONG: 'Nombre',
				PHONE_REQUIRED: 'El teléfono es',
				PHONE_REQUIRED_STRONG: 'obligatorio',
				PHONE_HINT: 'Por favor introduzca',
				PHONE_HINT_STRONG: 'Teléfono',
				FACILITY_HINT: 'Seleccionar',
				SYSTEM_HINT: 'Seleccionar',
				SYSTEMS_PLACEHOLDER: 'Sistemas',
				SYSTEM_HINT_STRONG: 'Sistema',
				FACILITY_HINT_STRONG: 'Instalación',
			},
			CONFIRMATION: {
				REASON_REQUIRED: 'El motivo es obligatorio.',
			},
			USER_ROLES: {
				SELECT_ROLE: 'Seleccionar rol',
				ASSIGN_TOOLTIP: 'Asignar rol',
				ASSIGN: 'Asignar',
				ASSIGNED_ROLES: 'Roles asignados:',
				REMOVE_TOOLTIP: 'Eliminar rol',
			},
			ADDRESS: {
				FORM_ERROR: '¡Vaya! Modifica algunos campos e inténtalo de nuevo.',
				ADDRESS_LINE: 'Introducir línea de dirección',
				ADDRESS_LINE_REQUIRED: 'La línea de dirección es',
				ADDRESS_LINE_REQUIRED_STRONG: 'obligatoria',
				ADDRESS_LINE_HINT: 'Por favor introduzca',
				ADDRESS_LINE_HINT_STRONG: 'Línea de dirección',
				CITY: 'Ciudad',
				CITY_REQUIRED: 'La ciudad es',
				CITY_REQUIRED_STRONG: 'obligatoria',
				CITY_HINT: 'Por favor introduzca',
				CITY_HINT_STRONG: 'Ciudad',
				STATE: 'Introducir estado/provincia',
				STATE_REQUIRED: 'El estado es',
				STATE_REQUIRED_STRONG: 'obligatorio',
				STATE_HINT: 'Por favor introduzca',
				STATE_HINT_STRONG: 'Estado',
				POSTCODE: 'Introducir código postal',
				POSTCODE_REQUIRED: 'El código postal es',
				POSTCODE_REQUIRED_STRONG: 'obligatorio',
				POSTCODE_HINT: 'Por favor introduzca',
				POSTCODE_HINT_STRONG: 'Código postal',
			},
			SOCIAL: {
				FORM_ERROR: '¡Vaya! Modifica algunos campos e inténtalo de nuevo.',
				LINKEDIN: 'Introducir dirección de LinkedIn',
				LINKEDIN_HINT: 'Por favor introduzca',
				LINKEDIN_HINT_STRONG: 'LinkedIn',
				FACEBOOK: 'Introducir dirección de Facebook',
				FACEBOOK_HINT: 'Por favor introduzca',
				FACEBOOK_HINT_STRONG: 'Facebook',
				TWITTER: 'Introducir dirección de Twitter',
				TWITTER_HINT: 'Por favor introduzca',
				TWITTER_HINT_STRONG: 'Twitter',
				INSTAGRAM: 'Introducir dirección de Instagram',
				INSTAGRAM_HINT: 'Por favor introduzca',
				INSTAGRAM_HINT_STRONG: 'Instagram',
				ADDRESS_SUFFIX: 'dirección',
			},
			CHANGE_PASSWORD: {
				FORM_ERROR: '¡Vaya! Las contraseñas no coinciden.',
				PASSWORD: 'Introducir contraseña',
				PASSWORD_REQUIRED: 'La contraseña es',
				PASSWORD_REQUIRED_STRONG: 'obligatoria',
				PASSWORD_HINT: 'Por favor introduzca',
				PASSWORD_HINT_STRONG: 'Contraseña',
				CONFIRM_PASSWORD: 'Confirmar contraseña',
				CONFIRM_REQUIRED: 'La confirmación es',
				CONFIRM_REQUIRED_STRONG: 'obligatoria',
				CONFIRM_HINT: 'Por favor confirme',
				CONFIRM_HINT_STRONG: 'Contraseña',
				CHANGE_BUTTON: 'Cambiar contraseña',
				SAVE_CHANGES: 'Guardar cambios',
			},
		},
		SYSTEM_VIEW: {
			PARTS: 'PARTES',
			ACTIVE: 'ACTIVO',
			SYSTEM: 'Sistema',
			SEARCH_SYSTEM: 'Buscar sistema...',
			NO_MATCHING_SYSTEM: 'No se encontró ningún sistema coincidente',
			OPEN_ALERTS: 'ALERTAS ABIERTAS',
			ACTIVE_ALERTS: 'ALERTAS ACTIVAS',
			UNACK_ALERTS: 'ALERTAS NO CONF.',
			RELIABILITY: 'CONFIABILIDAD',
			MEAN_TIME_BETWEEN_ALERTS: 'TIEMPO MEDIO ENTRE ALERTAS',
			UPTIME: 'DISPONIBILIDAD',
			DAYS: 'días',
			PERFORMANCE_CURVES: 'CURVAS DE RENDIMIENTO',
			OPEN_IN_NEW_TAB: 'Abrir en nueva pestaña',
			TAB_ANOMALY: 'Anomalía',
			TAB_SYSTEM_DETAILS: 'Detalles del sistema',
			TAB_DATA_QUALITY: 'Calidad de datos',
			TAB_PERFORMANCE: 'Rendimiento',
			CLEAR_SIMULATION: 'Borrar simulación',
			SIMULATION: 'Simulación',
			CLICK_TO_START_PREDICTION: 'Clic para iniciar predicción',
			PREDICTION_RUNNING: 'Predicción en curso',
			NO_OF_DAYS: 'Nº de días',
			OK: 'Aceptar',
			RESET: 'Restablecer',
			RETRAINING: 'Reentrenamiento',
			MORE: 'Más',
			TAGS: 'Etiquetas',
			SEARCH_TAG: 'Buscar etiqueta...',
			NO_MATCHING_TAG: 'No se encontró etiqueta coincidente',
			ASSET_LABEL: 'Activo:',
			NAME_LABEL: 'Nombre:',
			TAG_ID_LABEL: 'ID de etiqueta:',
			CANCEL: 'Cancelar',
			ASSETS: 'ACTIVOS',
			SEARCH_ASSET: 'Buscar activo...',
			NO_MATCHING_ASSET: 'No se encontró activo coincidente',
			RESET_ASSET_SELECTION: 'Restablecer selección de activo',
			DATA_QUALITY: {
				SEARCH_TAG: 'Buscar etiqueta',
				DOWNLOAD_TOOLTIP: 'Descargar informe de calidad de datos de etiquetas',
				DOWNLOAD: 'Descargar',
				COL_TAG_NAME: 'Nombre de etiqueta',
				COL_MISSING_DATA: 'Datos faltantes',
				COL_FLAT_LINE: 'Línea plana',
				COL_OUTLIER: 'Valor atípico',
				COL_OUT_OF_RANGE: 'Fuera de rango',
				COL_TOTAL_INVALID_DATA: 'Total datos inválidos',
				COL_ACTIONS: 'Acciones',
				MORE_ACTIONS: 'Más acciones',
				NO_RECORDS: 'No se encontraron eventos de calidad de datos para el rango de tiempo seleccionado',
				LOADING: 'Cargando...',
				SHUTDOWN_TAG: 'Etiqueta de parada',
				TRIP: 'Disparo',
				TRIP_LIMIT: 'Límite de disparo',
				ALARM: 'Alarma',
				ALARM_LIMIT: 'Límite de alarma',
				THRESHOLD: 'Umbral',
				THRESHOLD_LIMIT: 'Límite de umbral',
				INSTRUMENT: 'Instrumento',
				INSTRUMENT_RANGE: 'Rango del instrumento',
			},
			SYSTEM_DETAILS: {
				NO_IMAGE_FOUND: 'No se encontró imagen',
				ASSET_DETAILS: 'Detalles del activo',
				CURRENT_ALERTS_EQUIPMENT: 'Alertas actuales/Equipo',
				EQUIPMENT_DISTRIBUTION: 'Distribución por equipo',
				TOP_FAILURE_MODES: 'Principales modos de fallo por equipo',
				CUSTOM_INPUTS: 'Entradas personalizadas',
				SELECT_TAG: 'Seleccionar etiqueta',
				UPDATE: 'Actualizar',
				SPECIFY_VALUE: 'Especificar valor',
				TIMESTAMP: 'Marca de tiempo',
				LAB_DATA: 'Datos de laboratorio',
				NO_DATA_FOUND: 'No se encontraron datos',
			},
			ALERT_SETTINGS: {
				TITLE: 'Configuración de alertas',
				CANCEL: 'Cancelar',
				FAILURE_MODE: 'Modo de fallo',
				AGGREGATED_ANOMALY_SCORE: 'Puntuación de anomalía agregada',
				INSTRUMENT_HEALTH: 'Salud del instrumento/Calidad de datos',
				FLATLINE: '1: Línea plana',
				MISSING_DATA: '2: Datos faltantes',
				OUT_OF_RANGE: '3: Fuera de rango',
				OUTLIERS: '4: Valores atípicos',
			},
			DIAGNOSTICS: {
				TITLE: 'Diagnósticos del sistema',
				CANCEL: 'Cancelar',
				ROOT_CAUSE_ICON_ALT: 'Icono de causa raíz',
				NOT_GENERATED_YET: 'Aún no ha generado diagnósticos del sistema.',
				RUN_TO_PROCEED: 'Ejecute los diagnósticos para continuar.',
				GENERATION_FAILED: 'La última generación de diagnósticos del sistema falló.',
				RUN_AGAIN: 'Ejecute los diagnósticos de nuevo para continuar.',
				GENERATE_NOW: 'Generar ahora',
				REGENERATE: 'Regenerar',
				FAILED_AT: 'La generación de diagnósticos del sistema falló en',
				LAST_GENERATED: 'Última generación',
				GENERATING: 'Generando diagnósticos del sistema',
				SEVERITY: 'Gravedad:',
				ISSUE: 'Problema:',
				IMPACT: 'Impacto:',
				ACTION: 'Acción:',
				PRIORITY: 'Prioridad:',
			},
			PERFORMANCE_CURVE: {
				TAG: 'Etiqueta',
				FILTER_TAG_VALUE: 'Filtrar valor de etiqueta',
				SEARCH_TAG: 'Buscar etiqueta...',
				NO_TAG_FOUND: 'No se encontró etiqueta',
				GREATER_THAN: 'Mayor que',
				LESS_THAN: 'Menor que',
				OK: 'Aceptar',
				DATE_RANGE: 'Rango de fechas',
				START_DATE: 'Fecha de inicio',
				END_DATE: 'Fecha de fin',
				SELECT: 'Seleccionar',
			},
		},
		PLATFORM_CONFIGURATION: {
			HEADER_TITLE: 'Configuración de la plataforma',
			TABS: {
				ORGANISATION_SETUP: 'Configuración de la organización',
				ASSET_REGISTRY: 'Registro de activos',
				MODULE_HIERARCHY: 'Jerarquía de módulos',
				PROPERTY_TEMPLATES: 'Plantillas de propiedades',
			},
			COMING_SOON: 'Próximamente',
		},
		CUSTOMER_SETUP: {
			TABS: {
				CLIENT_SETUP: 'Detalles de la organización',
				FACILITY_SETUP: 'Instalaciones',
				PLANT_ECONOMICS: 'Parámetros económicos',
			},
			COMMON: {
				SAVE_CHANGES: 'Guardar cambios',
				CANCEL: 'Cancelar',
				CONFIRM: 'Confirmar',
				EDIT: 'Editar',
				DELETE: 'Eliminar',
				LOADING: 'Cargando...',
				SEARCH: 'Buscar...',
				CLOSE: 'Cerrar',
				SAVED_SUCCESSFULLY: 'Guardado exitosamente',
				ERROR_SAVING: 'Error al guardar los cambios',
				TIMEZONE: 'Zona horaria',
				LATITUDE: 'Latitud',
				LONGITUDE: 'Longitud',
				SELECT_TIMEZONE: 'Seleccionar zona horaria',
			},
			CLIENT: {
				TITLE: 'Detalles de la organización',
				SUBTITLE: 'Configurar los detalles de la organización',
				LOGO: 'Logotipo',
				UPLOAD_LOGO: 'Subir logotipo',
				HQ_ADDRESS: 'Dirección de la sede central',
				ENTERPRISE_NAME: 'Nombre de la empresa',
				INDUSTRY_SECTOR: 'Sector industrial',
				STREET_ADDRESS: 'Dirección',
				CITY: 'Ciudad',
				STATE: 'Estado',
				COUNTRY: 'País',
				ZIP_CODE: 'Código postal',
				ZOOM_LEVEL: 'Nivel de zoom',
				BUSINESS: 'Negocio',
				NOTES: 'Notas',
				SELECT_INDUSTRY_SECTOR: 'Seleccionar sector industrial',
				PLACEHOLDER_BUSINESS: 'Por favor ingrese detalles del negocio',
				PLACEHOLDER_NOTES: 'Por favor ingrese notas',
			},
			FACILITY: {
				TITLE: 'Instalaciones',
				SUBTITLE: 'Definir ubicaciones y parámetros de instalaciones',
				ADD_FACILITY: 'Agregar instalación',
				GROUP_BY: 'Agrupar por',
				COL_NAME: 'Nombre',
				COL_LOCATION: 'Ubicación',
				COL_CAPACITY: 'Capacidad (MW)',
				COL_REGION: 'Región',
				COL_INDUSTRY: 'Industria',
				NO_FACILITIES_SEARCH: 'No se encontraron instalaciones.',
				TRY_ADJUSTING: 'Intente ajustar su consulta de búsqueda.',
				NO_FACILITIES_YET: 'Aún no hay instalaciones configuradas.',
				CLICK_TO_GET_STARTED: "Haga clic en 'Agregar instalación' para comenzar.",
				DELETE_TITLE: 'Eliminar instalación',
				DELETE_DESCRIPTION: '¿Está seguro de que desea eliminar permanentemente la instalación "{{name}}"?',
				DELETE_WAIT: 'Eliminando instalación...',
				DELETED_SUCCESS: 'Instalación eliminada exitosamente',
				DELETE_ERROR: 'Error al eliminar la instalación',
			},
			ADD_FACILITY_DIALOG: {
				TITLE_ADD: 'Agregar instalación',
				TITLE_EDIT: 'Editar instalación',
				UPDATED_SUCCESS: 'Instalación actualizada exitosamente',
				UPDATE_ERROR: 'Error al actualizar la instalación',
				CREATED_SUCCESS: 'Instalación creada exitosamente',
				CREATE_ERROR: 'Error al crear la instalación',
				FACILITY_NAME: 'Nombre de la instalación',
				FACILITY_CODE: 'Código de instalación',
				LOCATION: 'Ubicación',
				REGION: 'Región',
				CURRENCY: 'Moneda',
				INSTALLED_CAPACITY: 'Capacidad instalada (MW)',
				INDUSTRY: 'Industria',
				GIS_LOCATION: 'Ubicación GIS',
				PLACEHOLDER_FACILITY_NAME: 'Nombre de la planta',
				PLACEHOLDER_LOCATION: 'Ciudad, Estado',
				SELECT_REGION: 'Seleccionar región',
				SELECT_CURRENCY: 'Seleccionar moneda',
				SELECT_INDUSTRY: 'Seleccionar industria',
			},
			FACILITY_FORM: {
				TAB_FACILITY_INFO: 'Información de la instalación',
				TAB_HISTORIAN_INFO: 'Información del historiador',
				TAB_SAP_INFO: 'Información de SAP',
				ENTERPRISE: 'Empresa',
				ADDRESS: 'Dirección',
				CITY: 'Ciudad',
				STATE: 'Estado',
				COUNTRY: 'País',
				ZIP: 'Código postal',
				ZOOM_LEVEL: 'Nivel de zoom',
				APPLICATION: 'Aplicación',
				NOTES: 'Notas',
				CUSTOMER_ADVOCATE: 'Representante del cliente',
				HISTORIAN_TYPE: 'Tipo de historiador',
				ACCESS_METHOD: 'Método de acceso',
				ACCESS_URL: 'URL de acceso',
				RESOURCE_URL: 'URL de recurso',
				DATA_FETCH_SETTINGS: 'Configuración de obtención de datos',
				FORWARD_AGGREGATE: 'Reenviar agregado',
				FETCH_RATE: 'Frecuencia de obtención',
				FETCH_RATE_UNIT: 'Unidad de frecuencia de obtención',
				ENABLE_SAMPLING: 'Habilitar muestreo',
				SAMPLING_RATE: 'Frecuencia de muestreo',
				SAMPLING_RATE_UNIT: 'Unidad de frecuencia de muestreo',
				PREDICTION_SETTINGS: 'Configuración de predicción',
				PREDICTION_RATE: 'Frecuencia de predicción',
				PREDICTION_RATE_UNIT: 'Unidad de frecuencia de predicción',
				DQ_ALERTS: 'Alertas de calidad de datos',
				START_DELAY: 'Retraso de inicio (en horas)',
				END_DELAY: 'Retraso de fin (en horas)',
				FUNCTIONAL_LOC_MAPPING: 'Mapeo de ubicación funcional/ID de equipo',
				UPLOAD_FUNCTIONAL_LOC: 'Subir datos de ubicación funcional/ID de equipo',
				DOWNLOAD_FUNCTIONAL_LOC: 'Descargar mapeo de ubicación funcional/ID de equipo',
				SAP_DATA: 'Datos de SAP',
				UPLOAD_SAP_DATA: 'Subir datos de SAP',
				DOWNLOAD_SAP_FORMAT: 'Descargar formato de datos de SAP',
				UPDATE_SAP_DATA: 'Actualización de Datos de Permiso de SAP',
				UPLOAD_UPDATE_SAP_DATA: 'Cargar Actualización de Datos de Permiso de SAP',
				DOWNLOAD_UPDATE_SAP_FORMAT: 'Descargar Formato de Actualización de Datos de Permiso de SAP',
				CMMS_WRITE_INTEGRATION: 'Integración de escritura CMMS',
				CMMS_LAST_DATA_PULL: 'Última Extracción de Datos CMMS',
				IP_ADDRESS: 'Dirección IP',
				USER_NAME: 'Nombre de usuario',
				PASSWORD: 'Contraseña',
				TEST: 'Prueba',
				TEST_WRITE_INTEGRATION: 'Probar integración de escritura',
			},
			PLANT_ECONOMICS: {
				TITLE: 'Parámetros económicos',
				SUBTITLE: 'Configurar factores económicos y parámetros de costos',
				SELECT_FACILITY_MSG: 'Seleccione una instalación para gestionar sus parámetros económicos.',
				SECTION_TITLE: 'Parámetros de economía de producción',
				CHOOSE_FACILITY: 'Elija una instalación...',
				PRODUCTION_DETAILS: 'Detalles de producción',
				LABOR_SALARY: 'Parámetros de salario laboral (por hora)',
				UPDATED_SUCCESS: 'Economía de la planta actualizada exitosamente',
				UPDATE_ERROR: 'Error al actualizar la economía de la planta',
				COST_PER_UNIT: 'Costo/Unidad de producción',
				CAPACITY_HOUR: 'Capacidad/hora (p. ej. MWh)',
				REVENUE_HOUR: 'Ingresos/hora',
				MARGIN_PERCENT: 'Margen (%)',
				OTHER_COSTS: 'Otros costos fijos de inactividad',
				TECHNICIAN: 'Técnico',
				HELPER: 'Auxiliar',
				SUPERVISOR: 'Supervisor',
				MANAGER: 'Gerente',
			},
		},
		MODEL_EXPLAIN: {
			TITLE: 'Explicar tags',
			SELECTED_TAG: 'Tag seleccionado',
			CAUSAL_TAGS: 'Tags causales',
			TAG_SINGULAR: 'tag',
			TAG_PLURAL: 'tags',
			CONTRIBUTOR_SCORE: 'Puntuación',
			NO_CONTRIBUTORS: 'No se encontraron tags contribuyentes para esta marca de tiempo.',
			LOADING_CAUSAL_TAGS: 'Cargando tags causales...',
			CLOSE: 'Cerrar',
			ASSET: 'Activo',
			FULLSCREEN: 'Pantalla completa',
			EXIT_FULLSCREEN: 'Salir de pantalla completa',
			EXPAND: 'Expandir',
			COLLAPSE: 'Contraer',
			EXPLAIN: 'Explicar',
		},
		FILE_PREVIEW: {
			LOADING_REPORT: "Cargando informe…",
			REPORT_IN_PROGRESS: "El informe se está generando. Vuelva dentro de 5 minutos.",
			REPORT_FAILED: "No se pudo generar el informe. Vuelva a compartirlo.",
		},
		ALERT_V2: {
			FORECAST: {
				TTF_SHORT: 'TTF',
				TTI_SHORT: 'TTI',
				DETAILS: 'Detalles de {{kind}}',
				NO_VALUES: 'No hay valores {{kind}} válidos disponibles.',
				ON_DEMAND_NO_FORECAST: 'No hay pronóstico disponible desde el punto seleccionado. Arrastre el marcador a otro punto e inténtelo de nuevo.',
				MIN: 'Mín =',
				CURRENT_VALUE: 'Valor actual',
				VS_BASELINE: 'vs. línea base',
				ACTIVE_DURATION: 'Duración activa',
				SAMPLE_DENSITY: 'Densidad de muestreo',
				FORECAST: 'Pronóstico {{kind}} =',
				TTF: {
					ALERT: {
						TITLE: 'TTF a nivel de alerta',
						DESCRIPTION: 'TTF = mín (TTF de cada etiqueta contribuyente). La superación prevista más próxima determina el valor consolidado que se muestra a continuación.',
					},
					ALERT_LIST: {
						TITLE: 'TTF a nivel de alerta',
						DESCRIPTION: 'TTF = mín (TTF de cada modo de fallo). La superación prevista más próxima determina el valor consolidado que se muestra a continuación.',
					},
					FAILURE_MODE: {
						TITLE: 'TTF del modo de fallo',
						DESCRIPTION: 'TTF = mín (TTF de cada etiqueta contribuyente). La superación prevista más próxima determina el valor consolidado que se muestra a continuación',
					},
					TAG: {
						TITLE: 'Nivel de etiqueta TTF',
						DESCRIPTION: 'Pronóstico de días hasta que el valor proyectado de la etiqueta supere su límite operativo, según la tasa de cambio reciente extrapolada.',
					},
				},
				TTI: {
					ALERT_LIST: {
						TITLE: 'Tiempo hasta la intervención — nivel de alerta',
						DESCRIPTION: 'El pronóstico de intervención más próximo entre los modos de fallo de esta alerta.',
					},
					ALERT: {
						TITLE: 'Tiempo hasta la intervención — nivel de alerta',
						DESCRIPTION: 'El pronóstico de intervención más próximo de esta alerta entre las métricas de degradación del rendimiento monitorizadas.',
					},
					FAILURE_MODE: {
						TITLE: 'Modo de fallo — Tiempo hasta la intervención',
						DESCRIPTION: 'Intervención operativa prevista más próxima según los indicadores de rendimiento asociados a este modo de fallo.',
					},
					TAG: {
						TITLE: 'Nivel de etiqueta — Tiempo hasta la intervención',
						DESCRIPTION: 'Intervención operativa prevista más temprana para esta etiqueta.',
					},
				},
			},
			DQ_SETTINGS: {
				TITLE: "Configuración de calidad de datos",
				DETECTION_TITLE: "Detección de calidad de datos",
				ALERT_GEN_TITLE: "Generación de alertas de calidad de datos",
				ALERT_GEN_DESC: "Elija qué problemas de DQ detectados deben generar alertas. Desactivar la generación de alertas no detiene el cálculo de DQ.",
				FLATLINE_DETECTION: "Detección de línea plana",
				MISSING_DATA_DETECTION: "Detección de datos faltantes",
				OUTLIER_DETECTION: "Detección de valores atípicos",
				OUT_OF_RANGE_DETECTION: "Detección fuera de rango",
				ERRATIC_DETECTION: "Detección errática",
				FLATLINE_ALERT: "Alerta de línea plana",
				MISSING_DATA_ALERT: "Alerta de datos faltantes",
				OUTLIER_ALERT: "Alerta de valores atípicos",
				OUT_OF_RANGE_ALERT: "Alerta fuera de rango",
				ERRATIC_ALERT: "Alerta errática",
				CLOSE_TOOLTIP: "Cerrar"
			},
			DETAIL: {
				NO_DATA_URL: "No se encontraron datos para la URL proporcionada.",
				NO_DATA_URL_DESC: "Verifique la URL ingresada e intente de nuevo.",
				FAILURE_MODES: "Modos de fallo",
				SEARCH: "Buscar...",
				SORT_FAILURE_SCORE: "Ordenar por puntuación de fallo",
				SORT_CREATION_DATE: "Ordenar por fecha de creación",
				OTHER_ACTIVE_ALERTS: "Otras alertas activas",
				NEW_FAILURE: "Nuevo fallo agregado",
				ALERT_TITLE_PLACEHOLDER: "Título de alerta",
				SEARCH_OWNER: "Buscar propietario...",
				SEARCH_WATCHERS: "Buscar observadores..",
				ASSIGN_OWNER: "Asignar propietario",
				ADD_WATCHERS: "Agregar observadores",
				VERSION_HISTORY: "Historial de versiones",
				COPY_LINK: "Copiar enlace de alerta",
				BOOKMARK: "Marcar alerta",
				REMOVE_BOOKMARK: "Eliminar marcador",
				FETCHING_SYSTEM_DETAILS: "Obteniendo detalles del sistema",
				RESTORE_VERSION: "Restaurar versión",
				CANNOT_DELETE_VERSION: "No se pueden eliminar versiones mientras RCA está en progreso",
				DELETE_VERSION: "Eliminar versión",
				EDIT: "Editar",
				CLOSE: "Cerrar",
				DOWNLOAD: "Descargar",
				SHARE: "Compartir",
				ANOMALY_SCORE: "Puntuación de anomalía",
				TIMELINE: "Línea de tiempo",
				VERSIONS: "Versiones",
				NO_DATA_AVAILABLE: "No hay datos disponibles",
				EXPORT_REPORT: "Exportar Informe",
				TIME_TO_FAILURE_IN: "Tiempo hasta el fallo en {{unit}}",
				TIME_TO_INTERVENTION_IN: "Tiempo hasta la intervención en {{unit}}",
				SWITCH_TO_FM_VIEW: 'Cambiar a vista FM',
				SWITCH_TO_RCA_VIEW: 'Cambiar a vista RCA',
				CREATED_ON: 'Creado el',
				MENU_CREATED_ON: 'Creado el',
				STATE: 'Estado',
				DUE_DATE: 'Fecha de vencimiento',
				STATUS: 'Estado',
				OWNER: 'Propietario',
				WATCHERS: 'Observadores',
				WATCHER: 'Observador',
				LAST_RUN_PREFIX: 'Última ejecución:',
				MENU_LAST_RUN: 'Última ejecución',
				RUN_NOW: 'Ejecutar ahora',
				MENU_RUN_NOW: 'Ejecutar ahora',
				MORE: 'Más',
				REPORT_ISSUE: 'Reportar problema',
				NAV: {
					THRESHOLD: 'Umbral',
					DATA_QUALITY: 'Calidad de datos',
					ACTIVITY_LOGS: 'Registros de actividad',
					DISCUSSION: 'Discusión',
					ANALYSIS_VIEWS: 'Análisis y vistas',
					RETRAIN_MODEL: 'Reentrenar modelo',
					FEEDBACK: 'Comentarios',
					DISPLAY_TAGS: 'Mostrar etiquetas',
					PREFERRED_SETTINGS: 'Configuración preferida',
					DOCUMENTS: 'Documentos',
					WORK_ORDERS: 'Órdenes de trabajo',
					ROOT_CAUSE_ANALYSIS: 'Análisis de causa raíz',
				},
				TAGS_TOOLTIP: "Etiquetas",
				TIME_TO_TRIP: "Tiempo hasta la falla",
				DAYS: "días",
				CMMS_NUMBER: "Número CMMS",
				STACKED_VIEW: "Vista apilada",
				OVERLAY_VIEW: "Vista superpuesta",
				GRID_VIEW: "Vista de cuadrícula",
				NO_RECOMMENDATIONS: "No hay recomendaciones que mostrar",
				RECOMMENDATIONS: "Recomendaciones",
				RECOMMENDATION_POPUP: {
					ADD_PLACEHOLDER: "Agregar recomendación",
					ADD: "Agregar",
					CANCEL: "Cancelar",
					UPDATE: "Actualizar",
					EMPTY_TITLE: "No hay recomendaciones disponibles",
					EMPTY_HINT: "Agregue una recomendación para mostrarla aquí.",
				},
				SEARCH_CATEGORY: "Buscar categoría...",
				NO_CATEGORY: "No se encontró categoría coincidente",
				SELECT_CATEGORY: "Seleccionar categoría",
				SEARCH_COMPONENT: "Buscar componente...",
				NO_COMPONENT: "No se encontró componente coincidente",
				SELECT_COMPONENT: "Seleccionar componente",
				SEARCH_ERROR: "Buscar error...",
				NO_ERROR_FOUND: "No se encontró error coincidente",
				SELECT_ERROR: "Seleccionar error",
				ALERT_DETAILS_TITLE: "Detalles de la alerta",
				EMPTY_DATA_ALT: "Sin datos",
				NO_OPEN_FAILURE_MODES: "No hay modos de fallo abiertos.",
				RELATED_ALERTS: "Alertas relacionadas",
				TOP_CONTRIBUTING_TAGS: "Principales etiquetas que contribuyen a la puntuación de anomalía",
				NO_TAGS_TO_DISPLAY: "No hay etiquetas para mostrar.",
				NO_DATA_ALT: "Sin datos",
				SELECT_FM_OR_ADD_TAGS: "Seleccione un modo de fallo o añada etiquetas para ver los gráficos.",
				BREAKDOWN_CATEGORY_LABEL: "Categoría de avería",
				BREAKDOWN_COMPONENT_LABEL: "Componente de avería",
				BREAKDOWN_ERROR_LABEL: "Error",
				SAVE: "Guardar",
				FILTER_TAGS: "Filtrar etiquetas",
				NO_MATCHING_RESULT: "Sin resultados coincidentes",
				START_TYPING: "Comience a escribir para ver etiquetas coincidentes.",
				NO_MATCHING_RESULTS: "Sin resultados coincidentes",
				CLOSE_TOOLTIP: "Cerrar",
				EDIT_DISABLED: "Está en modo de solo lectura para este establecimiento",
				MULTI_SELECT_DISABLED: "Solo el propietario de la alerta puede seleccionar múltiples modos de fallo",
				SPLIT_MERGE_OWNER: "Solo un propietario de la alerta puede separar los modos de fallo.",
				SPLIT_MERGE_STATUS: "Solo las alertas con ciertos estados pueden separarse o fusionarse.",
				SPLIT_MERGE_APPROVED: "Solo los modos de fallo aprobados o sin acción pueden separarse en una nueva alerta o fusionarse con una existente.",
				SPLIT_MERGE_ACTION: "Mover los modos de fallo a una nueva alerta o fusionar con una existente.",
				SPLIT_MERGE_IN_PROGRESS: "Hay una separación o fusión en curso para esta alerta. Espere a que se complete.",
				SPLIT_MERGE_DISMISS: "Cerrar",
				TITLE_EMPTY: "Ingrese un título para continuar.",
				TITLE_TOO_LONG: "El título no puede exceder 60 caracteres.",
				MAINTENANCE_RECORDS_DIALOG: "Registros de mantenimiento existentes detectados.<br>¿Desea eliminarlos para continuar con el reaprendizaje?",
				FAILURE_DELETED: "Modo de fallo \"{{name}}\" eliminado exitosamente",
				FAILURE_DELETE_ERROR: "Algo salió mal al eliminar \"{{name}}\". Por favor intente de nuevo.",
				FAILURE_ADDED: "Modo de fallo \"{{name}}\" agregado exitosamente",
				USED_IN_MODEL: "Usado en modelo y etiqueta calculada",
				ONGOING: "En curso",
				FAILURE_TIMELINE: {
					TITLE: "Línea de tiempo de \"{{name}}\"",
					SORT_BY: "Ordenar por",
					SORT_TIMELINE: "Línea de tiempo",
					SORT_ASSETS: "Activos",
					LIMIT_TO_SYSTEM: "Limitar resultados a este sistema",
					ASSET: "Activo",
					REASON: "Motivo",
					RECOMMENDATIONS: "Recomendaciones",
					NOT_AVAILABLE: "NA",
					NO_DATA: "No se encontraron datos.",
					MENU_LABEL: "Línea de tiempo de fallas",
				},
			},
			RCA: {
				CREATE_WORK_ORDER: "Crear orden de trabajo",
				GENERATING: "Generando análisis de causa raíz",
				GENERATE: "Generar análisis de causa raíz",
				PERCENT_COMPLETED: "% completado",
				GO_BACK: "Volver",
				RUN_NOW: "Ejecutar ahora",
				CANCEL: "Cancelar",
				NOTIFY_ME: "Notificarme",
				ALREADY_IN_PROGRESS: "La generación de RCA ya está en progreso",
				RERUN: "Volver a ejecutar",
				VIEW_TRACES: "Ver trazas",
				TITLE: "Análisis de causa raíz",
				HYPOTHESES: "Hipótesis",
				COMMENTS: "comentarios",
				EVIDENCE_POINTS: "puntos de evidencia",
				DISCUSSION_TOOLTIP: "Para discusión interna con su equipo",
				APPROVED: "Aprobado",
				APPROVE: "Aprobar",
				EDIT: "Editar",
				RELEARNED: "Reaprendido",
				RELEARN: "Reaprender",
				SUSPECTED_CAUSE: "Causa sospechosa",
				CAUSAL_CHAIN: "Cadena causal",
				STEPS: "pasos",
				RECOMMENDATIONS: "Recomendaciones",
				CHART_TAGS: "Etiquetas del gráfico",
				EXPORT_AS_PDF: "Exportar como PDF",
				PROPOSED_EVIDENCE: "Evidencia propuesta",
				ADD_TO_EVIDENCE: "Agregar como evidencia",
				EVIDENCE_ADDED_BY: "Añadido el {{date}} a las {{time}} por {{user}}",
				EVIDENCE_ADDED: "Añadido el {{date}} a las {{time}}",
				ALREADY_ADDED: "Ya agregado como evidencia",
				DRAG_TO_REORDER: "Clic y arrastrar para reordenar",
				TABS: {
					TAGS: "Etiquetas",
					WORK_ORDERS: "Órdenes de trabajo",
					DOCUMENTS: "Documentos",
					SYSTEM_DETAILS: "Detalles del sistema",
				},
				EMPTY: {
					NO_TAGS_EVIDENCE: "No hay etiquetas añadidas como evidencia",
					NO_TAGS_EVIDENCE_DESC: "Los gráficos de etiquetas aparecerán aquí cuando se propongan como evidencia.",
					NO_WORK_ORDERS: "No hay órdenes de trabajo vinculadas",
					NO_WORK_ORDERS_DESC: "Las órdenes de trabajo aparecerán aquí cuando se asocien registros de mantenimiento.",
					NO_DOCUMENT_EVIDENCE: "Sin evidencia documental",
					NO_DOCUMENT_EVIDENCE_DESC: "Agregue un documento existente o cargue uno nuevo como evidencia.",
					UPLOAD_NEW_DOCUMENT: "Subir nuevo documento",
					NO_PROPOSED_EVIDENCE: "Aún no hay evidencia propuesta",
					NO_PROPOSED_EVIDENCE_DESC: "Agregue etiquetas, órdenes de trabajo, documentos o referencias P&ID.",
					NO_TAGS_LINKED: "No hay etiquetas vinculadas",
					NO_TAGS_LINKED_DESC: "Los gráficos de etiquetas aparecerán aquí cuando se agreguen a esta hipótesis.",
					SELECT_TAG_HEADING: "No hay etiquetas seleccionadas",
					SELECT_TAG_DESC: "Haga clic en una etiqueta de la hipótesis a la izquierda, o arrastre etiquetas aquí, para ver sus gráficos.",
					NO_DOCUMENTS: "No hay documentos disponibles",
					NO_DOCUMENTS_DESC: "Manuales técnicos, informes y PDFs aparecerán aquí cuando estén vinculados.",
					NO_SYSTEM_DETAILS: "No hay detalles del sistema disponibles",
					NO_SYSTEM_DETAILS_DESC: "P&IDs, especificaciones del sistema y detalles técnicos aparecerán aquí cuando los datos del equipo estén vinculados.",
				},
				WO: {
					WORK_ORDER: "Orden de trabajo",
					MANUALLY_ADDED: "Añadido manualmente",
					DESCRIPTION: "Descripción",
					NOTIFICATION_NO: "N.° notificación",
					TYPE: "Tipo",
					EQUIPMENT: "Equipo",
					PLANNING_GROUP: "Grupo de planificación",
					STATUS: "Estado",
					USER_STATUS: "Estado de usuario",
					CREATED_BY: "Creado por",
					COMPLETED_BY: "Completado por",
					CREATED_ON: "Creado el",
					COMPLETED_ON: "Completado el",
					CAUSE: "Causa",
					CAUSE_DESC: "Desc. causa",
					ACTIVITY_GROUP: "Grupo de actividad",
					ACTIVITY_DESC: "Desc. actividad",
					SEE_LESS: "Ver menos",
					SEE_MORE: "Ver más",
					ADDED_WITH_ROOTY: "Añadido con {{name}}",
					ADDED_MANUALLY: "Añadido manualmente",
				},
				PDF: {
					ALERT_REPORT: "Informe de alerta",
					HYPOTHESIS: "Hipótesis",
					TITLE_LABEL: "Título",
					SYSTEM: "Sistema",
					TYPE: "Tipo",
					CREATED_ON: "Creado el",
					OWNER: "Propietario",
					STATE: "Estado",
					DUE_DATE: "Fecha de vencimiento",
					STATUS: "Estado",
					WATCHERS: "Observadores",
					HYPOTHESES_PREFIX: "Hipótesis",
					PAGE: "Página",
					ZOOM: "Zoom:",
					SIZE: "Tamaño:",
				},
				FEEDBACK: {
					APPROVE_HEADER: "Aprobar hipótesis",
					RELEARN_HEADER: "Reaprender hipótesis",
					COMMENT_PLACEHOLDER: "Agregar sus comentarios o notas...",
					REVISION_INFO: "Requerido para revisión",
				},
				SNACKBAR: {
					REPORT_QUEUED: "Informe solicitado. Enviaremos un enlace de descarga a {{email}} cuando esté listo.",
					RCA_COMPLETED: "Generación de RCA completada exitosamente.",
					RCA_NOTIFY: "Se le notificará una vez que la generación de RCA se complete.",
					RCA_FAILED: "Error al generar RCA.",
					REPORT_REQUEST_FAILED: "No se pudo solicitar el informe. Inténtelo de nuevo.",
					REMOVE_WO_ERROR: "Error al eliminar la orden de trabajo de la evidencia.",
					NO_RCA_DATA_AVAILABLE: "No hay datos de RCA disponibles. Ejecute un RCA para generar información.",
				},
				POPUP: {
					APPROVE_HYPOTHESES: "Aprobar hipótesis",
					APPROVE_CAUSAL: "Aprobar paso de cadena causal",
					APPROVE_RECOMMENDATION: "Aprobar recomendación",
					RELEARN_HYPOTHESES: "Reaprender hipótesis",
					RELEARN_CAUSAL: "Reaprender paso de cadena causal",
					RELEARN_RECOMMENDATION: "Reaprender recomendación",
				},
				DIALOG: {
				ADD_TAG_EVIDENCE: "¿Agregar esta etiqueta como evidencia propuesta?",
				ADD_DOCS_EVIDENCE: "¿Agregar {{count}} documento(s) como evidencia propuesta?",
				ADD_WOS_EVIDENCE: "¿Agregar esta orden de trabajo como evidencia?",
				REMOVE_RC_EVIDENCE_DESC: "¿Eliminar esta evidencia de causa raíz? Esta acción no se puede deshacer.",
					REMOVE_EVIDENCE_TITLE: "Confirmación",
					REMOVE_EVIDENCE_DESC: "¿Eliminar esta evidencia? Esta acción no se puede deshacer.",
					ERROR_TITLE: "¡Error!",
					OK: "Aceptar",
					CONFIRM: "Confirmar",
					CANCEL: "Cancelar",
					EVIDENCE_LOCKED: "La evidencia de RCA no puede moverse a la sección de evidencia propuesta.",
				},
				EVIDENCE_CONTEXT: {
					ADD_TITLE: "Agregar contexto para esta evidencia",
					EDIT_TITLE: "Editar contexto para esta evidencia",
					CLOSE: "Cerrar",
					SUBTITLE: "Ayude a RCA a entender por qué esta evidencia es relevante y cómo debe usarse en la próxima ejecución.",
					FIELD_LABEL: "¿Por qué es relevante esta evidencia?",
					FIELD_LABEL_OPTIONAL: "¿Por qué es relevante esta evidencia? (Opcional)",
					FIELD_PLACEHOLDER: "Ej.: Esta orden de trabajo menciona una fuga en el sello antes del disparo de la bomba.",
					FIELD_ERROR: "Proporcione un contexto para continuar",
					CANCEL: "Cancelar",
					UPDATE_CONTEXT: "Actualizar Contexto",
					ADD_EVIDENCE: "Agregar Evidencia",
					ABORT_TITLE: "La evidencia no se agregará",
					ABORT_DESC: "RCA necesita una breve descripción para entender cómo debe usarse esta evidencia. Si cancela ahora, esta evidencia no se considerará en la próxima ejecución de RCA.",
					ABORT_CANCEL: "Cancelar adición de evidencia",
					ABORT_GO_BACK: "Volver",
				},
			},
			METRICS2: {
				PENDING_DEFECT: "Defecto pendiente",
			},
			METRICS: {
				HEALTH_SCORE: "Puntuación de salud",
				TOTAL_ALERTS: "Alertas totales",
				UNACKNOWLEDGED: "No reconocido",
				REVIEWING: "En revisión",
				PENDING: "Pendiente",
				UNKNOWN: "Desconocido",
			},
			OVERVIEW: {
				SYSTEM_OVERVIEW: "Resumen del sistema",
				SYSTEM_HEALTH_INDICATORS: "Indicadores de salud del sistema",
				PRIORITY_ACTIONS: "Acciones prioritarias",
				PRIORITY_TOOLTIP: "Lo que necesita su atención ahora. Alertas de anomalía no reconocidas y pendientes - Defecto notificado.",
				NO_PRIORITY_ACTIONS: "Sin acciones prioritarias",
				ALL_CAUGHT_UP: "Todo al día - nada necesita atención inmediata ",
				MONITORING_TRACKING: "Monitoreo y seguimiento",
				MONITORING_TOOLTIP: "Elementos de menor prioridad en seguimiento. Alertas de anomalía con estado En proceso y En observación.",
				IN_PROCESS: "En proceso",
				ON_WATCH: "En observación",
				RUNNING_STATE: "Estado de funcionamiento",
				AT_RISK: "En riesgo",
				REVIEW: "Revisar",
				HEALTHY: "Saludable",
				CURRENT: "Actual",
				THRESHOLD: "Umbral",
				NO_DATA_FOUND: "No se encontraron datos",
				VIEW_ALL: "Ver todo →",
				NO_ALERTS_ARE: "No hay alertas {{title}}",
				NO_DATA: "Sin datos",
			},
			TABLE: {
				HEADERS: {
					STATUS: "Estado",
					ALERT_NAME: "Nombre de alerta",
					SYSTEM_NAME: "Nombre del sistema",
					TYPE: "Tipo",
					LOSS: "Pérdida (kWh)",
					START: "Inicio",
					STOP: "Fin",
					DURATION: "Duración",
					LAST_ACTIVE: "Última actividad",
					CREATED_ON: "Creado el",
					STATE: "Estado",
					OWNER: "Propietario",
					WATCHERS: "Observadores",
					FORECAST: "Pronóstico",
					CATCH: "Captura",
					UPPER_LIMIT: "Límite superior",
					VALUE: "Valor",
					LOWER_LIMIT: "límite inferior",
					LAST_SYSTEM_UPDATE: "Última actualización del sistema",
					LAST_USER_UPDATE: "Última actualización del usuario",
					DISCUSSION: "Discusión",
					TOTAL_VALUE: "Valor total",
					RELIABILITY_SAVING: "Ahorro de confiabilidad",
					MAINTENANCE_SAVING: "Ahorro de mantenimiento",
					PERFORMANCE_SAVING: "Ahorro de rendimiento",
					ALERT_DRIVEN_MAINTENANCE: "Mantenimiento basado en alertas",
				},
				NEW_FAILURE_ADDED: "Nuevo modo de falla agregado",
				TIME_TO_TRIP_DAYS: "Tiempo hasta la falla {{n}} días",
				OPEN_IN_NEW_TAB: "Abrir en nueva pestaña",
				RCA_AVAILABLE: "Análisis de causa raíz disponible",
				ASSIGN_OWNER: "Asignar propietario",
				ADD_WATCHERS: "Agregar observadores",
				SEARCH_OWNER: "Buscar propietario...",
				SEARCH_WATCHERS: "Buscar observadores...",
				NO_APPROVED_FM: "No se encontraron modos de falla aprobados",
				EXTRA_MORE: "+ {{count}} más",
				CUSTOMIZE_COLUMNS: "Personalizar columnas",
				BOOKMARK_ALERT: "Marcar alerta",
				REMOVE_BOOKMARK: "Quitar marcador",
				VIEW_ONLY_MODE: "Está en modo de solo lectura para esta instalación",
				SYSTEM_TOOLTIP: "Sistema: {{system}}\nUnidad: {{unit}}\nInstalación: {{facility}}",
			},
			UTILS: {
				STATUS: {
					UNACK: "No reconocido",
					IN_PROCESS: "En proceso",
					ON_WATCH: "En observación",
					PENDING_DEFECT: "Pendiente - Defecto notificado",
					CLOSED_MAINT_DEFERRED: "Cerrado - Mantenimiento aplazado",
					CLOSED_NO_ACTION: "Cerrado - Sin acción planificada",
					CLOSED_RESOLVED: "Cerrado - Resuelto",
					REJECTED: "Rechazado",
				},
				STATE: {
					TENTATIVE: "Tentativo",
					ACTIVE: "Activo",
					RETURNED_TO_NORMAL: "Vuelto a la normalidad",
					CLOSED: "Cerrado",
					NOISE_DISCARDED: "Ruido/Descartado",
				},
				TYPE: {
					H_ANOMALY: "Anom. alta",
					L_ANOMALY: "Anom. baja",
					DATA_QUALITY: "Calidad de datos",
					USER_REPORTED: "Reportado por usuario",
					THRESHOLD: "Umbral",
					DIAGNOSIS: "Diagnóstico",
					DIGITAL: "Digital",
				},
				SUBTYPE: {
					OUTLIER: "Valor atípico",
					OUT_OF_RANGE: "Fuera de rango",
					FLATLINE: "Línea plana",
					MISSING: "Faltante",
					UNKNOWN: "Desconocido",
					PAINT_BRUSHING: "Paint Brushing",
				},
				THRESHOLD_ALERT: "Alerta de umbral",
				DATA_QUALITY_ALERT: "Alerta de calidad de datos",
				TITLE_TOOLTIP: "Título: {{title}}",
				TITLE_ID_TOOLTIP: "Título: {{title}}\nID de alerta: {{id}}",
				DAYS: "{{n}} días",
				HOURS: "{{n}} horas",
				DAYS_SHORT: "{{n}}d",
				HOURS_SHORT: "{{n}}h",
				POTENTIAL: "(Potencial)",
			},
			DOC_PREVIEW: {
				PREVIEW_DOCUMENT: "Vista previa del documento",
				CLOSE: "Cerrar",
				DOWNLOAD_FILE: "Descargar archivo",
			},
			LIST: {
				ALERTS_COUNT: "{{count}} alertas",
				SHOW_MORE_ALERTS: "Mostrar {{count}} alertas más",
				COLUMN_SAVED: "La vista de columnas se ha guardado",
				SOMETHING_WENT_WRONG: "Algo salió mal, inténtelo de nuevo",
				TAKES_FEW_SECONDS: "Esto puede tardar unos segundos...",
				BULK_RESULT: "{{msg}} para {{success}} de {{total}} alertas.",
				STATUS_CLOSED_NO_ACTION: "Estado establecido en Cerrado - Sin acción planificada",
				ACTION_UPDATED: "{{action}} actualizado",
				ACTION_STATUS: "Estado",
				ACTION_BOOKMARK: "Marcador",
				ACTION_SUBSCRIBERS: "Suscriptores",
			},
			DIALOG: {
				ADD_COMMENT: "Agregar comentario*",
				COMMENT_REQUIRED: "Agregue un comentario para continuar",
				ADD_A_REASON: "Agregar un motivo",
				SELECTED_FAILURE_MODES: "Modos de falla seleccionados",
				SELECT_ALL: "Seleccionar todo",
				CANCEL: "Cancelar",
				CLOSE: "Cerrar",
				ADD: "Agregar",
				OK: "Aceptar",
				MARK_AS_CATCH: "Marcar como detectado",
			},
			APPROVE: {
				TITLE: "Aprobar modo de falla",
				EDIT_TITLE: "Editar - Aprobar modo de falla",
				RECOMMENDATIONS_FOR: "Recomendaciones para {{name}}",
				ADD_RECOMMENDATION_PLACEHOLDER: "Agregar recomendación...",
				APPROVE: "Aprobar",
				UPDATE: "Actualizar",
			},
			RELEARN: {
				TITLE: "Reaprender modo de falla",
				RELEARN: "Reaprender",
			},
			BULK_UPDATE: {
				PROCESSING: "Procesando",
				COMPLETED: "¡Actualización masiva completada!",
				DOWNLOAD_REPORT: "Descargar informe",
				SELECT_DUE_DATE: "Seleccionar fecha de vencimiento",
				DUE_DATE_HINT: "La fecha de vencimiento es de 28 días a partir de hoy de forma predeterminada y puede ajustarse si es necesario.",
				DUE_DATE_TOOLTIP: "Seleccione una fecha de vencimiento para la alerta seleccionada",
				UPDATED_SUCCESSFULLY: "Actualizado correctamente",
				UPDATE_FAILED: "Error en la actualización",
				SHOWING: "Mostrando {{shown}}/{{total}}",
			},
			SPLIT_MERGE: {
				TITLE: "Dividir/Fusionar modo de falla",
				SUBTITLE: "Mueva los modos de falla aprobados o sin acción a una nueva alerta o fusiónelos con una alerta existente.",
				APPROVED: "Aprobado",
				APPROVED_ON: "Aprobado el {{date}}",
				APPROVED_FAILURE_MODES: "Modos de falla aprobados",
				FAILURE_MODES: "Modos de falla",
				TAB_CREATE: "Crear nueva alerta",
				TAB_MERGE: "Fusionar con existente",
				ALERT_TITLE: "Título de la alerta",
				SYSTEM: "Sistema",
				UNIT: "Unidad",
				SEVERITY: "Gravedad",
				SELECT_SEVERITY: "Seleccionar gravedad",
				OWNER: "Propietario",
				CREATED_ON: "Creado el",
				STATUS: "Estado",
				SELECT_TARGET_ALERT: "Seleccionar alerta de destino",
				SEARCH_PLACEHOLDER: "Buscar...",
				LOADING: "Cargando...",
				NOT_OWNER_MESSAGE: "No es el propietario de la alerta con estado 'En proceso', 'En observación', 'Sin acción planificada' o 'Defecto pendiente notificado'.",
				PROCESSING_TOOLTIP: "Procesando, por favor espere!",
				PROCESSING: "Procesando...",
				SUBMIT_CREATE: "Crear nueva alerta",
				SUBMIT_MERGE: "Fusionar con alerta",
				VIEW_CREATE: "Abrir nueva alerta",
				VIEW_MERGE: "Abrir alerta",
				GO_BACK: "Volver",
				SUCCESS_CREATE: "Nueva alerta creada correctamente.",
				SUCCESS_MERGE: "Fusionado correctamente con la alerta existente.",
				FAILED_CREATE: "La creación de la alerta no se realizó correctamente. Inténtelo de nuevo.",
				FAILED_MERGE: "Error al fusionar la alerta. Inténtelo de nuevo.",
				PENDING: "Solicitud en cola. Se procesará una vez que finalice el lote de predicción actual.",
				CONFLICT: "Ya hay una solicitud de división/fusión en curso para esta alerta.",
				CONFLICT_DESTINATION: "Ya hay una solicitud de división/fusión en curso para la alerta de destino.",
				TITLE_PLACEHOLDER_EXAMPLE: 'CESR-C-20250807-IPNK',
				SYSTEM_PLACEHOLDER_EXAMPLE: 'GAS TURBINE TRAIN D',
				UNIT_PLACEHOLDER_EXAMPLE: 'COGEN',
				OWNER_PLACEHOLDER_EXAMPLE: 'Ronald Richards',
				CREATED_ON_PLACEHOLDER_EXAMPLE: '25 ago, 2025',
			},
			FILTER: {
				FILTER_BY: "Filtrar por",
				SEARCH_BY_ALERT_NAME: "Buscar por nombre de alerta...",
				CLEAR_SEARCH: "Borrar búsqueda",
				STATE: "Estado",
				ANOMALY: "Anomalía",
				ACTIVE: "Activo",
				RETURNED_TO_NORMAL: "Vuelto a la normalidad",
				OTHER_ALERT_TYPES: "Otros tipos de alerta",
				CATCH: "Captura",
				TRUE: "Verdadero",
				FALSE: "Falso",
				AGENTS: "Agentes",
				HAS_RCA: "Con análisis de causa raíz",
				NO_RCA: "Sin análisis de causa raíz",
				BOOKMARK_AND_CASES: "Marcadores y casos",
				ONLY_TRACKED_CASES: "Solo alertas con casos rastreados",
				DIAGNOSIS_CONDITIONS: "Condiciones de diagnóstico",
				TRIP_BREAKDOWN: "Disparo/Avería",
				UNDER_PERFORMANCE: "Bajo rendimiento",
				SMB_DOWN: "SMB caído",
				SMB_UNDER_PERF: "SMB bajo rendimiento",
				CURTAILMENT: "Reducción",
				OUT_OF_ENV_SCOPE: "Fuera del alcance ambiental",
				DATA_QUALITY_TYPE: "Tipo de calidad de datos",
				OUTLIER: "Valor atípico",
				OUT_OF_RANGE: "Fuera de rango",
				FLATLINE: "Línea plana",
				MISSING: "Faltante",
				TAG_STATUS: "Estado de la etiqueta",
				TAG_STATUS_INFO: "Aplicable solo para alertas de DQ",
				USED_IN_MODEL: "Utilizado en el modelo",
				DROPPED_TAGS: "Etiquetas descartadas",
				WATCHERS: "Observadores",
				SEARCH_PLACEHOLDER: "Empiece a escribir para buscar",
				CLEAR_ALL: "Borrar todo",
			},
			COLUMNS: {
				NUMBER: "Número",
				ALERT_NAME: "Nombre de alerta",
				STATUS: "Estado",
				SYSTEM: "Sistema",
				TYPE: "Tipo",
				DATE: "Fecha",
				CREATED_ON: "Creado el",
				STATE: "Estado",
				OWNER: "Propietario",
				WATCHERS: "Observadores",
				CATCH: "Captura",
				FORECAST: "Pronóstico",
				UPPER_LIMIT: "Límite superior",
				VALUE: "Valor",
				LOWER_LIMIT: "Límite inferior",
				LAST_SYSTEM_UPDATE: "Última actualización del sistema",
				LAST_USER_UPDATE: "Última actualización del usuario",
				TOTAL_VALUE: "Valor total",
				RELIABILITY_SAVINGS: "Ahorros de confiabilidad",
				MAINTENANCE_SAVINGS: "Ahorros de mantenimiento",
				PERFORMANCE_SAVINGS: "Ahorros de rendimiento",
				ALERT_DRIVEN_MAINTENANCE: "Mantenimiento basado en alertas",
				DISCUSSION: "Discusión",
				LOSS: "Pérdida (kWh)",
				START: "Inicio",
				STOP: "Fin",
				DURATION: "Duración",
			},
			NO_ALERTS: {
				TITLE: "No se encontraron alertas",
				SUBTITLE: "Modifique los filtros o el rango de fechas para ver los resultados",
			},
			COLUMN_CONFIG: {
				SHOW_COLUMNS: "Mostrar columnas",
				SEARCH_PLACEHOLDER: "Empiece a escribir para buscar",
				SELECT_ALL: "Seleccionar todo",
				RESET_TO_DEFAULT: "Restablecer valores predeterminados",
			},
			PAGE_TITLE: "Alertas",
			OVERVIEW_TAB: "Resumen",
			SEARCH_PLACEHOLDER: "Buscar...",
			NO_MATCHING_RESULTS: "No hay resultados coincidentes",
			SEARCH_OWNER_PLACEHOLDER: "Buscar propietario...",
			SELECT_OWNERS: "Seleccionar propietarios",
			ALL_STATUSES: "Todos los estados",
			STATUS_FILTER: "Filtro de estado",
			CHOOSE_STATUSES: "Elegir estados a mostrar",
			FILTERS: "Filtros",
			GROUP_BY: "Agrupar por",
			MORE: "Más",
			SELECT_ALERTS_FOR_CASE: "Seleccione las alertas que desea etiquetar en este caso",
			SHOWING_RESULTS_FOR: 'Mostrando resultados para "{{term}}"',
			CHIP: {
				THRESHOLD: "Umbral",
				HIGH_ANOMALY_SHORT: "Anom. alta",
				LOW_ANOMALY_SHORT: "Anom. baja",
				DATA_QUALITY: "Calidad de datos",
				DIAGNOSIS: "Diagnóstico",
			},
			TYPE: {
				THRESHOLD: "Umbral",
				HIGH_ANOMALY: "Anomalía alta",
				LOW_ANOMALY: "Anomalía baja",
				DATA_QUALITY: "Calidad de datos",
				DIAGNOSIS: "Diagnóstico",
			},
			AUTO_REFRESH: {
				LABEL: "Autoactualizar",
				OFF: "Desactivado",
				LIVE: "En vivo",
				MIN_5: "5 minutos",
				MIN_15: "15 minutos",
				MIN_30: "30 minutos",
				HOUR_1: "1 hora",
			},
			MORE_MENU: {
				EXPORT_DATA: "Exportar datos",
				EXPAND_ALL_GROUPED: "Expandir todos los elementos agrupados",
				COLLAPSE_ALL_GROUPED: "Contraer todos los elementos agrupados",
				EXPAND_ALL_WITHIN_GROUP: "Expandir todos los elementos del grupo",
				COLLAPSE_ALL_WITHIN_GROUP: "Contraer todos los elementos del grupo",
				SWITCH_TO_CLASSIC: "Cambiar a vista clásica",
			},
			TOOLTIP: {
				TYPE_NEW_EVENTS: "{{type}} nuevos eventos",
				TYPE_ALERTS: "{{count}} alertas de {{type}}",
				COUNT_NEW_EVENTS: "{{count}} nuevos eventos",
				COUNT_TYPE_NEW_EVENTS: "{{count}} nuevos eventos de {{type}}",
				SYSTEM_OPEN_ALERTS: "Sistema: {{name}}\nAlertas abiertas: {{count}}",
				UNIT_OPEN_ALERTS: "Unidad: {{name}}\nAlertas abiertas: {{count}}",
				FACILITY_OPEN_ALERTS: "Instalación: {{name}}\nAlertas abiertas: {{count}}",
				EDIT_DISABLED_CLOSED: "Las acciones de edición están deshabilitadas para las alertas cerradas/rechazadas.",
			},
		},
		MODEL_WIZARD: {
		NO_CUSTOMER_TAGS_AVAILABLE: 'No hay etiquetas de cliente disponibles',
		MAP_CUSTOMER_TAGS_CONTENT: 'Agregue o importe etiquetas de cliente para asignarlas a las etiquetas de activos.',
		SYSTEM_SUMMARY: {
			TITLE: "Resumen técnico del sistema",
			GENERATE: "Generar resumen",
			PLACEHOLDER: "Proporcione un resumen técnico detallado del sistema o genere uno a partir de los documentos disponibles y los sistemas conectados.",
			HELPER: "Puede editar el resumen generado o escribir uno manualmente.",
			DRAWER_TITLE: "Generar resumen técnico del sistema",
			SOURCE_DOCS: "Documentos de origen",
			SOURCE_DOCS_DESC: "Seleccione documentos que expliquen el diseño, la operación, la lógica de control o el comportamiento del equipo del sistema.",
			DOCS_SELECTED: "Documentos seleccionados",
			SELECT_DOCUMENTS: "Seleccionar documentos",
			UPLOAD_TITLE: "Cargar documentos de apoyo",
			UPLOAD_DESC: "Cargue archivos adicionales que aún no estén disponibles en el Administrador de documentos.",
			UPLOAD_FAILED: "Error al cargar",
			VIEW_FILE: "Ver archivo",
			PROCESSING: "Procesando...",
			COMPLETED: "Completado",
			FAILED: "Fallido",
			DUPLICATE_UPLOAD: "«{{name}}» ya está agregado: se omitió la carga duplicada.",
			ALREADY_UPLOADED_USED: "«{{name}}» ya está cargado y se usó para el entrenamiento.",
			CONNECTED_SYSTEMS: "Sistemas conectados",
			CONNECTED_DESC: "Agregue sistemas aguas arriba, aguas abajo o paralelos que influyan en el comportamiento de este sistema.",
			UPSTREAM: "Sistemas aguas arriba",
			SELECT_UPSTREAM: "Seleccionar sistemas aguas arriba",
			DOWNSTREAM: "Sistemas aguas abajo",
			SELECT_DOWNSTREAM: "Seleccionar sistemas aguas abajo",
			PARALLEL: "Sistemas paralelos",
			SELECT_PARALLEL: "Seleccionar sistemas paralelos",
			SEARCH_SYSTEM: "Buscar sistema",
			SEARCH_FACILITY: "Buscar instalación",
			SEARCH_UNIT: "Buscar unidad",
			NO_SYSTEMS: "No se encontraron sistemas",
			OPTIONAL_META: "Metadatos opcionales del sistema",
			OPTIONAL_META_DESC: "Los detalles opcionales pueden mejorar la calidad del resumen técnico generado.",
			PRIMARY_COMPONENT: "Componente principal",
			FLUID_MEDIUM: "Fluido / Medio",
			CRITICAL_CONTROL_NODES: "Nodos de control críticos",
			AUXILIARY_SYSTEMS: "Sistemas auxiliares",
			DIAG_UPSTREAM: "Marcador de diagnóstico: fallo aguas arriba",
			DIAG_DOWNSTREAM: "Marcador de diagnóstico: fallo aguas abajo",
			ADDITIONAL_CONTEXT: "Agregar contexto adicional",
			OPTIONAL: "Opcional",
			DOCUMENTS_COUNT: "documentos",
			CONNECTED_COUNT: "sistemas conectados",
			VIEW_SOURCES: "Ver fuentes",
			VIEW_SOURCES_DESC: "Documentos y sistemas conectados utilizados para generar esta descripción.",
			NO_DOCS_USED: "No se utilizaron documentos para generar esta descripción.",
			NO_SYSTEMS_USED: "No se utilizaron sistemas conectados para generar esta descripción.",
			NO_SOURCES: "No hay fuentes disponibles",
			NO_SOURCES_DESC: "No se utilizaron documentos ni sistemas conectados para generar esta descripción.",
			REGENERATE: "Regenerar",
			CLICK_TO_EDIT: "Haz clic para editar",
			GENERATION_STARTED: "Generando la descripción del sistema… esto puede tardar un momento.",
			ALREADY_IN_PROGRESS: "Ya se está generando una descripción para este sistema. Espere a que finalice antes de volver a generarla.",
			GENERATION_FAILED: "Error al generar la descripción del sistema.",
			GENERATION_FAILED_TEXT: "Error en la generación del sistema.",
			LAST_UPDATED: "Última actualización",
			BY: "por",
			DOCUMENTS: "Documentos",
			SELECT_DOCS_TITLE: "Seleccionar documentos de origen",
			SELECT_DOCS_DESC: "Seleccione documentos a nivel de instalación, unidad o sistema que expliquen el diseño, la operación, la lógica de control o el comportamiento del equipo del sistema.",
			DOCUMENT_SCOPE: "Alcance del documento",
			SCOPE_FACILITY: "Instalación",
			SCOPE_UNIT: "Unidad",
			SCOPE_SYSTEM: "Sistema",
			SEARCH_SCOPE_FACILITY: "Buscar instalación",
			SEARCH_SCOPE_UNIT: "Buscar instalación, unidad",
			SEARCH_SCOPE_SYSTEM: "Buscar instalación, unidad, sistema",
			SEARCH_SCOPE: "Buscar alcance",
			NO_SCOPES: "No se encontraron alcances coincidentes. Pruebe con otra palabra clave.",
			ALL_TYPES: "Todos los tipos",
			SEARCH_DOCS: "Buscar documentos...",
			UPDATED: "Actualizado",
			NO_DOCS_TITLE: "No se encontraron documentos",
			NO_DOCS_DESC: "No hay documentos coincidentes. Intente cambiar los filtros.",
			LOADING_MORE: "Cargando más documentos...",
			SELECTED_DOCS: "Documentos seleccionados",
			ADD: "Agregar",
			DOCUMENTS_WORD: "documentos",
			ADD_DOCUMENTS: "Agregar documentos",
			CANCEL: "Cancelar",
			REGENERATE_CONFIRM_TITLE: "¿Regenerar la descripción del sistema?",
			REGENERATE_CONFIRM_MESSAGE: "Regenerar reemplazará la descripción actual del sistema por una recién generada. Esta acción no se puede deshacer.",
		},
			ESCALATION_CONFIG: {
				TITLE: "Configuración de escalamiento",
				DELAY_LABEL: "Retraso de escalamiento (en días)",
				LEVEL_LABEL: "Nivel",
				LEVEL_PLACEHOLDER: "Ingrese el nivel",
				SELECT_USERS: "Seleccionar usuarios",
				SEARCH_USERS_PLACEHOLDER: "Buscar por ID de correo electrónico",
				NO_MATCHING_EMAIL: "No se encontró ningún ID de correo coincidente",
				EMAILS_LABEL: "Agregar IDs de correo separados por comas",
				EMAILS_PLACEHOLDER: "abc@gmail.com, def@gmail.com",
				ADD_LEVEL: "+ Agregar nivel",
				ADD_LEVEL_TOOLTIP: "Agregar nivel",
				REMOVE_TOOLTIP: "Eliminar",
				CONFIG_TYPE_UNIT: "Usar configuración de la unidad",
				CONFIG_TYPE_CUSTOM: "Usar configuración personalizada",
				CONFIG_TYPE_NONE: "Sin configuración de escalamiento",
			},
			NO_ASSET_TAGS_FOUND: 'No hay etiquetas de activos disponibles',
			NO_MAPPED_TAGS_FOUND: 'No hay etiquetas mapeadas disponibles',
		ASSET_INFORMATION: "Información de activos",
		NO_ASSET_FOUND: "No se encontró ningún activo",
		EQUIPMENT: "Equipo",
		TEMPLATE: "Plantilla",
		APPLICATION: "Aplicación",
		INDUSTRY: "Industria",
		CONFIGURATION_COL: "Configuración",
		MODEL_CONFIGURATION: "Configuración del modelo",
		MODELING_TECHNIQUE: "Técnica de modelado",
		SCALER: "Escalador",
		SMOOTHING: "Suavizado",
		SELECT_SMOOTHING_FUNCTION: "Seleccionar función de suavizado",
		SMOOTHING_FUNCTION: "Función de suavizado",
		WINDOW_SIZE: "Tamaño de ventana",
		IN_HOURS: "en horas",
		IN_DAYS: "(en días)",
		SIGMA: "Sigma",
		POLYNOMIAL_ORDER: "Orden del polinomio",
		VALUE_REQUIRED: "El valor es obligatorio",
		VALUE_MIN_1: "El valor debe ser mayor o igual a 1",
		NONE: "Ninguno",
		ANOMALY_SCORE_CALC_METHOD: "Método de cálculo de puntuación de anomalías",
		ANOMALY_CALC_DEFAULT: "Predeterminado (RMS de todas las etiquetas)",
		ANOMALY_CALC_NEW: "Nuevo (suma de RMS de etiquetas del activo)",
		PREDICTION_TIME_PERIOD: "Período de predicción",
		TRAINING_TIME_PERIOD: "Período de entrenamiento",
		CALENDAR_SELECTION: "Selección por calendario",
		CHART_BASED_SELECTION: "Selección por gráfico",
		START_TIME: "Hora de inicio",
		END_TIME: "Hora de fin",
		START_TIME_REQUIRED: "La hora de inicio es obligatoria",
		END_TIME_REQUIRED: "La hora de fin es obligatoria",
		STARTUP_TRAINING_BUFFER: "Búfer de entrenamiento de arranque",
		SHUTDOWN_TRAINING_BUFFER: "Búfer de entrenamiento de parada",
		TRAINING_BUFFER_GROUP: "Búfer de entrenamiento",
		TRAINING_BUFFER_STARTUP_SHORT: "Arranque (en días)",
		TRAINING_BUFFER_SHUTDOWN_SHORT: "Parada (en días)",
		TRAINING_CONDITIONS: "Condiciones de entrenamiento",
		METHOD1_RANGE_FILTER: "Método 1: Filtro de rango",
		METHOD2_CONDITION_FILTER: "Método 2: Filtro de condición",
		LOAD_TAG: "Etiqueta de carga",
		REFERENCE_TAG: "Etiqueta de referencia",
		NUM_OF_BINS: "Número de intervalos",
		QUANTILE_CONDITION: "Condición de cuantil",
		LESS_THAN: "Menor que",
		GREATER_THAN: "Mayor que",
		EQUAL_TO: "Igual a",
		VALUE: "Valor",
		TAG: "Etiqueta",
		MIN: "Mín",
		MAX: "Máx",
		CONDITION: "Condición",
		AND: "Y",
		OR: "O",
		ADD: "Agregar",
		CLOSE: "Cerrar",
		ADD_NOTE: "Agregar nota",
		VIEW_NOTE: "Ver nota",
		VIEW_EDIT_NOTE: "Ver/editar nota",
		NOTE_FOR_DATE_RANGE: "para el rango de fechas {{range}}",
		ENTER_NOTES: "Ingrese notas aquí",
		SEARCH_TAGS: "Buscar etiquetas...",
		NO_MATCHING_TAGS: "No se encontraron etiquetas coincidentes",
		SELECT_TRAINING_REGIONS: "Seleccionar regiones de entrenamiento automáticamente",
		ADD_TRAINING_RANGE: "Agregar rango de entrenamiento",
		DELETE_TRAINING_RANGE: "Eliminar rango de entrenamiento",
		NAME: "Nombre",
		TAG_ID: "ID de etiqueta",
		UNIT_SETUP: "Configuración de unidad",
		SCHEMATIC: "Esquema",
		EQUIPMENT_LIST: "Lista de equipos",
		UNITS: 'Unidades',
		CAPACITY: 'Capacidad',
		SYSTEM_INFORMATION: 'Información del sistema',
		DESCRIPTION: 'Descripción',
		CRITICALITY: 'Criticidad',
		COMMENTS: 'Comentarios',
		SEARCH: 'Buscar',
		NO_UNIT_FOUND: 'No se encontró ninguna unidad',
		NO_SYSTEM_FOUND: 'No se encontró ningún sistema',
		CUSTOMER: 'Cliente',
		FACILITY: 'Instalación',
		UNIT: 'Unidad',
		SYSTEM: 'Sistema',
		ORIGINAL_AUTHOR: 'Autor original',
		TRAINING_DATASET: 'Conjunto de datos de entrenamiento',
		VALIDATION_LOSS: 'Pérdida de validación',
		LAST_DEPLOYED: 'Último desplegado',
		ON: 'En',
		SELECTED_VERSION: 'Versión seleccionada',
		DEPLOYED_PERIOD: 'Período de despliegue',
		STATUS: 'Estado',
		MARK_AS_IMPORTANT: 'Marcar como importante',
		DISABLE: 'Deshabilitar',
		DELETE: 'Eliminar',
		DELETE_VERSION_TOOLTIP: 'Eliminar la versión',
		TAB_FACILITY_SETUP: 'Configuración de instalación',
		TAB_TAG_MAPPING: 'Mapeo de etiquetas',
		TAB_DATA_SYNC: 'Sincronización de datos',
		TAB_DATA_IMPORT: 'Importación y procesamiento de datos',
		TAG_MAPPING_REQUIRED_TOOLTIP: 'El mapeo de etiquetas debe completarse, luego esta pestaña se habilitará.',
		TAB_MODEL_BUILDING: 'Construcción de modelos',
		RECALCULATING_TOOLTIP: 'Recálculo en progreso',
		CUSTOMER_TAG_LIST: 'Lista de etiquetas del cliente',
		TAGS_BTN: 'Etiquetas',
		MODEL_BUILDING_CONFIG_TOOLTIP: 'Configuración del paso de construcción del modelo',
		TAGS_TO_BE_MAPPED: 'Etiquetas a mapear',
		UPLOAD_SYSTEM_TAGS: 'Subir etiquetas del sistema',
		DOWNLOAD_FACILITY_TAGS: 'Descargar etiquetas de instalación',
		ASSETS_PLACEHOLDER: 'ACTIVOS',
		SEARCH_IN_ALL_FIELDS: 'Buscar en todos los campos',
		COL_NAME: 'Nombre',
		COL_DESCRIPTION: 'Descripción',
		COL_UNIT: 'Unidad',
		CUSTOMER_TAGS: 'Etiquetas del cliente',
		UPLOAD_TAGS_TOOLTIP: 'Subir etiquetas',
		DOWNLOAD_TAGS_TOOLTIP: 'Descargar etiquetas',
		TAG_MAPPING_NO_ASSET_TOOLTIP: 'Se debe crear al menos 1 activo para realizar el mapeo de etiquetas',
		MAP_SELECTED: 'Mapear seleccionados',
		IMPORT_WO_MAPPING: 'Importar mapeo WO',
		TAGS_MAPPED: 'Etiquetas mapeadas',
		SAVE_CHANGES: 'Guardar cambios',
		UNMAP_SELECTED: 'Desmapear seleccionados',
		UNMAPPED_TAGS: 'Etiquetas no mapeadas',
		COL_TAG_NAME: 'Nombre de etiqueta',
		COL_ASSET: 'Activo',
		COL_TAG_ID: 'ID de etiqueta',
		COL_THRESHOLD_HIGH: 'Umbral alto',
		COL_THRESHOLD_LOW: 'Umbral bajo',
		COL_TRIP_HIGH: 'Disparo alto',
		COL_TRIP_LOW: 'Disparo bajo',
		COL_ALARM_HIGH: 'Alarma alta',
		COL_ALARM_LOW: 'Alarma baja',
		COL_DIRECTIONALITY: 'Direccionalidad',
		COL_FLATLINE_DETECTION: 'Detección de línea plana',
		COL_MISSING_DATA_DETECTION: 'Detección de datos faltantes',
		COL_OUTLIER_DETECTION: 'Detección de valores atípicos',
		COL_RANGE_DETECTION: 'Detección de fuera de rango',
		COL_FLATLINE_ALERT_GENERATION: 'Generación de alerta de línea plana',
		COL_MISSING_DATA_ALERT_GENERATION: 'Generación de alerta de datos faltantes',
		COL_OUTLIER_ALERT_GENERATION: 'Generación de alerta de valor atípico',
		COL_RANGE_ALERT_GENERATION: 'Generación de alerta de fuera de rango',
		COL_ATTENTION: 'Atención',
		COL_THRESHOLD_NOTIFICATION: 'Notificación de umbral',
		COL_KPI: 'KPI',
		SHOW_COLUMNS_TOOLTIP: 'Mostrar columnas',
		VIEW_CHANGES_TOOLTIP: 'Ver cambios',
		EDIT_TAG_TOOLTIP: 'Editar etiqueta',
		VIEW_PIDS_TOOLTIP: 'Ver PIDs',
		IN_PROGRESS: 'En progreso',
		CORRECT_RECORDS_MSG: 'Por favor corrija los registros con errores y cargue nuevamente.',
		DOWNLOAD_ERROR_RECORDS: 'Descargar registros de error',
		RELEVANT_INFORMATION: 'Información relevante',
		PIDS_PANEL: 'P&IDs',
		IMAGES_PANEL: 'Imágenes',
		TEST_REPORTS_PANEL: 'Informes de prueba',
		PROCEDURES_PANEL: 'Procedimientos',
		TAG_DATA: 'Datos de etiqueta',
		SEARCH_TAG: 'Buscar etiqueta',
		SEARCH_ASSET: 'Buscar activo',
		EXPORT_DQ_METRICS_TOOLTIP: 'Exportar métricas DQ',
		EXPORT: 'Exportar',
		TAG_SELECTION_PLACEHOLDER: 'Selección de etiqueta',
		PREPROCESSING_STATS_PLACEHOLDER: 'Estadísticas de preprocesamiento',
		TAG_MAPPING_PLACEHOLDER: 'Mapeo de etiquetas',
		TAG_TYPE_PLACEHOLDER: 'Tipo de etiqueta',
		OPERATING_REGION_PLACEHOLDER: 'Región de operación',
		COL_PLOT: 'Gráfico',
		COL_CORR: 'Corr.',
		COL_MODEL: 'Modelo',
		COL_TAGS: 'Etiquetas',
		SHUTDOWN_TAG_TOOLTIP: 'Etiqueta de apagado',
		COL_MAX: 'Máx.',
		COL_MIN: 'Mín.',
		COL_STD_DEV: 'Desv. Est.',
		COL_AGGREGATE_TAG: 'Etiqueta agregada',
		COL_MEAN_SHIFT: 'Desplazamiento de media',
		COL_VARIANCE: 'Varianza',
		COL_MEAN: 'Media',
		COL_DEVIATION_SCORE: 'Puntuación de desviación',
		COL_OP_UPPER: 'Op. Superior',
		COL_OP_LOWER: 'Op. Inferior',
		COL_NANS: 'NaNs',
		COL_OUTLIERS: 'Valores atípicos',
		COL_FLATLINE: 'Línea plana',
		COL_OUT_OF_RANGE: 'Fuera de rango',
		COL_TOTAL_INVALID_DATA: 'Total de datos no válidos',
		NO_RECORDS_FOUND: 'No se encontraron registros',
		NO_DATA_AVAILABLE_SYSTEM: 'No hay datos disponibles para el sistema seleccionado. Extraiga nuevos datos o cargue',
		CHOOSE_MODEL_VERSION_MSG: 'Elija una versión del modelo para ver los gráficos de etiquetas',
		SELECT_PLOT_CHECKBOX_MSG: 'Seleccione la casilla de verificación Gráfico de una etiqueta para ver el gráfico',
		TAG_CORRELATION_TITLE: 'Correlación de etiquetas',
		TAG_CORRELATION_CONDITION_PLACEHOLDER: 'Condición de correlación de etiquetas',
		CORR_GREATER_THAN_OPTION: 'Mostrar etiquetas con correlaciones mayores que',
		CORR_LESS_THAN_OPTION: 'Mostrar etiquetas con correlaciones menores que',
		CORR_VALUE_PLACEHOLDER: 'Valor de correlación',
		SELECT_RANGE_LABEL: 'Seleccionar rango',
		SELECT_RANGE_TOOLTIP: 'Arrastre sobre el gráfico para elegir un rango de fechas',
		REMOVE_RANGE_LABEL: 'Eliminar rango',
		REMOVE_RANGE_TOOLTIP: 'Arrastre sobre el gráfico para excluir un rango de fechas del modelado',
		SYSTEM_DATA_FILTER_LABEL: 'Filtro de datos del sistema',
		SELECTED_DATE_RANGES_LABEL: 'Rango(s) de fechas seleccionado(s):',
		CONFIRM_SELECTION: 'Confirmar selección',
		REMOVED_DATE_RANGES_LABEL: 'Rango(s) de fechas eliminado(s):',
		EDIT_MODEL_TITLE: 'Editar modelo',
		FORM_ERROR_MSG: '¡Vaya! Cambie algunas cosas e intente enviar de nuevo.',
		OP_LOWER_PLACEHOLDER: 'Op. Inferior',
		OP_UPPER_PLACEHOLDER: 'Op. Superior',
		REQUIRED: 'Requerido',
		CANCEL_CHANGES_TOOLTIP: 'Cancelar cambios',
		CANCEL: 'Cancelar',
		SAVE_DATA_TOOLTIP: 'Guardar datos',
		SAVE: 'Guardar',
		SIMULATION: 'Simulación',
		SHOW_FAILURE_INFO: 'Mostrar info de fallo',
		OK: 'Ok',
		RESET_ASSET_SELECTION_TOOLTIP: 'Restablecer selección de activos',
		CLOSE_CROSSHAIR_TOOLTIP: 'Cerrar retícula',
		CROSSHAIR: 'Retícula',
		LOADING: 'Cargando...',
		NO_FAILURE_MODE_FOUND: 'No se encontró modo de fallo.',
		MODEL_PARAMETERS_PANEL: 'Parámetros del modelo',
		BOILER_HEALTH_PANEL: 'Salud de la caldera',
		ALERT_PARAMETERS_PANEL: 'Parámetros de alerta',
		FAILURE_PARAMETERS_PANEL: 'Parámetros de fallo',
		APPLY_SOURCE_VERSION_FEEDBACK: 'Aplicar retroalimentación de versión fuente',
		COMMENT_PLACEHOLDER: 'Comentario',
		SAVE_MODEL: 'Guardar modelo',
		SAVE_MODEL_TOOLTIP: 'Guardar modelo',
		RESAVE: 'Volver a guardar',
		RESAVE_TOOLTIP: 'Volver a guardar modelo',
		DEPLOY_MODEL_TOOLTIP: 'Implementar modelo',
		DEPLOY_TAG_UNMAPPED_TOOLTIP: 'No se permite la implementación porque el modelo {{version}} contiene etiqueta(s) que se han desvinculado del sistema',
		DEPLOY: 'Implementar',
		GO_LIVE_CSV_TOOLTIP: 'Ir en vivo con transmisión CSV/Historian',
		GO_LIVE: 'IR EN VIVO',
		GO_LIVE_OPTIONS_TITLE: 'Opciones en vivo',
		DATA_SOURCE_TYPE_PLACEHOLDER: 'Tipo de fuente de datos',
		HISTORIAN_OPTION: 'Historian',
		START_PREDICTION_FROM: 'Iniciar predicción desde',
		FROM_DATE_REQUIRED: 'La fecha de inicio es',
		GO_LIVE_BTN: 'Ir en vivo',
		GO_LIVE_TOOLTIP: 'Ir en vivo',
		THRESHOLD_PLACEHOLDER: 'Umbral',
		AUTOMATIC_OPTION: 'Automático',
		MANUAL_OPTION: 'Manual',
		RISK_PROFILE_PLACEHOLDER: 'Perfil de riesgo',
		CREATE_CONDITION: 'Crear condición',
		RETURN_CONDITION: 'Condición de retorno',
		EXCEED_FOR_PLACEHOLDER: 'Exceder por',
		OUT_OF_PLACEHOLDER: 'De',
		DOWN_FOR_PLACEHOLDER: 'Bajar por',
		ALARM_THRESHOLD_PLACEHOLDER: 'Umbral de alarma',
		ADD_TOOLTIP: 'Agregar',
		GENERATE_ALERT_TOOLTIP: 'Generar alerta',
		UPDATE: 'Actualizar',
		SELECT_DATE_PLACEHOLDER: 'Seleccionar fecha',
		DATE_REQUIRED_ERROR: 'La fecha es',
		HEALTH_PLACEHOLDER: 'Salud',
		REMOVE_TOOLTIP: 'Eliminar',
		GENERATE_BOILER_HEALTH_TOOLTIP: 'Generar salud de caldera',
		ANOMALY_WT_THRESHOLD_PLACEHOLDER: 'Umbral de anomalía ponderada',
		LOW_OPTION: 'Bajo',
		MEDIUM_OPTION: 'Medio',
		HIGH_OPTION: 'Alto',
		CUTOFF_PARTIAL_MATCH: 'Límite para coincidencia parcial',
		IN_PERCENTAGE_HINT: 'en porcentaje',
		CUTOFF_FULL_MATCH: 'Límite para coincidencia completa',
		UPDATE_FAILURE_TOOLTIP: 'Actualizar fallo',
		START_DELAY_PLACEHOLDER: 'Retraso de inicio',
		NO_OF_HOURS_HINT: '(número de horas)',
		END_DELAY_PLACEHOLDER: 'Retraso de fin',
		GROUPING: 'Agrupación',
		DOWN_CONDITION_PLACEHOLDER: 'Condición de descenso',
		ANOMALY_SCORE_THRESHOLD: 'Umbral de puntuación de anomalía',
		FILTER_FAILURE_PLACEHOLDER: 'Filtrar fallo',
		VALUE_BETWEEN_0_1: 'Ingrese un valor entre 0 y 1',
		FEEDBACKS: 'Retroalimentaciones',
		LIVE_FEEDBACKS: 'Retroalimentaciones en vivo',
		PREVIOUS_FEEDBACKS: 'Retroalimentaciones anteriores',
		BAND_LEARNING_BEHAVIOUR: 'Comportamiento de aprendizaje de bandas',
		CONSERVATIVE: 'Conservador',
		CONSERVATIVE_TOOLTIP: 'Crea bandas más estrechas alrededor de la región de entrenamiento seleccionada',
		MODERATE: 'Moderado',
		MODERATE_TOOLTIP: 'Crea bandas equilibradas alrededor de la región de entrenamiento seleccionada',
		AGGRESSIVE: 'Agresivo',
		AGGRESSIVE_TOOLTIP: 'Crea bandas más amplias alrededor de la región de entrenamiento seleccionada',
		UPDATE_FEEDBACK: 'Actualizar retroalimentación',
		UPDATE_PARAMETERS_TOOLTIP: 'Actualizar parámetros',
		DATA_IMPORT_PANEL: 'Importación de datos',
		PRE_PROCESSING_PANEL: 'Pre-procesamiento',
		CSV_OPTION: 'CSV',
		UPLOADED_CSV_OPTION: 'CSV cargado',
		SELECT_SOURCE_HINT: 'Seleccionar fuente para importar datos',
		SAMPLING_RATE_PLACEHOLDER: 'Tasa de muestreo',
		SAMPLING_RATE_REQUIRED: 'Tasa de muestreo',
		IN_MINUTES_HINT: '(en minutos)',
		SELECT_CSV_FILE_PLACEHOLDER: 'Seleccionar archivo CSV',
		CSV_FILE_REQUIRED: 'El archivo CSV es',
		SELECT_FILE_BTN: 'Seleccionar archivo',
		DATA_SYNC_MORE_DATA_TOOLTIP: 'Para obtener más datos, vaya a la pestaña Sincronización de datos y realice una solicitud de extracción de datos.',
		DATA_SET_NAME_PLACEHOLDER: 'Nombre del conjunto de datos',
		IMPORT_TOOLTIP: 'Importar',
		IMPORT_DATA: 'Importar datos',
		STATE_IDENTIFICATION_PANEL: 'Identificación de estado',
		EXCLUDE_REGION_PANEL: 'Excluir región',
		PRE_PROCESSING_CONFIG_PANEL: 'Configuración de pre-procesamiento',
		MODEL_TAG_SELECTION_PANEL: 'Selección de etiquetas del modelo',
		PROCESS_TOOLTIP: 'Procesar',
		PROCESS_DATA: 'Procesar datos',
		SHUTDOWN_TAG_PLACEHOLDER: 'Etiqueta de apagado',
		CONDITION_PLACEHOLDER: 'Condición',
		LESS_THAN_OPTION: 'Menor que',
		GREATER_THAN_OPTION: 'Mayor que',
		EQUAL_TO_OPTION: 'Igual a',
		VALUE_PLACEHOLDER: 'Valor',
		SHUTDOWN_CONDITION_PLACEHOLDER: 'Condición de apagado',
		AND_OPTION: 'Y',
		OR_OPTION: 'O',
		SHUTDOWN_SPAN_PLACEHOLDER: 'Duración de apagado',
		IN_HOURS_HINT: '(en horas)',
		SHUTDOWN_TRANSITION_PLACEHOLDER: 'Transición de apagado',
		STARTUP_TRANSITION_PLACEHOLDER: 'Transición de arranque',
		EXCLUDE_REGION_TAG_PLACEHOLDER: 'Etiqueta de región excluida',
		EXCLUDE_CONDITION_PLACEHOLDER: 'Condición de exclusión',
		OUTLIER_DETECTION_METHOD: 'Método de detección de valores atípicos',
		OUTLIER_DETECTION_THRESHOLD: 'Umbral de detección de valores atípicos',
		SIGMA_HINT: 'Sigma',
		INTERPOLATION_METHOD: 'Método de interpolación',
		INTERPOLATION_CONFIG: 'Configuración de interpolación',
		FLATLINE_THRESHOLD_TIME: 'Tiempo umbral de línea plana',
		FLATLINE_TIME_BASE: 'Base de tiempo de línea plana',
		HOURS_OPTION: 'Horas',
		MINUTES_OPTION: 'Minutos',
		SECONDS_OPTION: 'Segundos',
		CROSS_CORRELATION: 'Correlación cruzada',
		// pre-processing-configuration-form: row group titles + short field labels
		OUTLIER_DETECTION_GROUP: 'Detección de valores atípicos',
		INTERPOLATION_GROUP: 'Interpolación',
		FLATLINE_GROUP: 'Línea plana',
		LABEL_METHOD: 'Método',
		LABEL_THRESHOLD: 'Umbral',
		LABEL_CONFIGURATION: 'Configuración',
		FLATLINE_DETECTION_SHORT: 'Detección',
		FLATLINE_THRESHOLD_TIME_SHORT: 'Tiempo umbral',
		FLATLINE_TIME_BASE_SHORT: 'Base de tiempo',
		DATA_DENSITY_THRESHOLD: 'Umbral de densidad de datos para selección de etiquetas',
		DATA_DENSITY_REQUIRED: 'El umbral de densidad de datos es',
		GLOBAL_PREPROCESSING: 'Preprocesamiento global',
		RANGE_PREPROCESSING: 'Preprocesamiento de rango',
		DENSITY_HINT: 'Densidad',
		REFRESH_TABLE_DATA_TOOLTIP: 'Actualizar datos de la tabla',
		LAST_DATA_PULL_LABEL: 'Última extracción de datos:',
		UPLOAD_CSV_TOOLTIP: 'Subir CSV',
		NO_RAW_TAGS_TOOLTIP: 'No hay etiquetas brutas en este sistema, por lo que no se puede cargar el archivo',
		UPLOAD_BTN: 'Subir',
		ANOTHER_PROCESS_RUNNING_TOOLTIP: 'Otro proceso está en ejecución',
		NO_RAW_TAG_MAPPED_TOOLTIP: 'No hay etiqueta bruta mapeada con este sistema',
		NEW_DATA_PULL_REQUEST: 'Nueva solicitud de extracción de datos',
		ADD_NEW_DATA_PULL_TOOLTIP: 'Agregar nueva solicitud de extracción de datos',
		DELETE_SYSTEM_DATA_TOOLTIP: 'Eliminar datos del sistema',
		STOP_DATA_PULL_TOOLTIP: 'Detener extracción de datos',
		COL_SERIAL_NO: 'N°',
		COL_DATA_REQUESTED_FOR: 'Datos solicitados para',
		COL_REQUESTED_ON: 'Solicitado el',
		COL_ACCESS_METHOD: 'Método de acceso',
		COL_REQUEST_TYPE: 'Tipo de solicitud',
		COL_FILE_NAME: 'Nombre de archivo',
		COL_PULLED_BY: 'Extraído por',
		COL_DATA_RECEIVED: 'Datos recibidos',
		COL_ACTIONS: 'Acciones',
		DATA_REPULL_TOOLTIP: 'Reextracción de datos',
		TAG_PULL_REQUEST: 'Solicitud de extracción de etiquetas',
		COL_VALUE: 'Valor',
		COL_MISSING: 'Faltante',
		COL_OUTLIER: 'Valor atípico',
		TRIP_LIMIT_TOOLTIP: 'Límite de disparo',
		TRIP_LABEL: 'Disparo',
		ALARM_LIMIT_TOOLTIP: 'Límite de alarma',
		ALARM_LABEL: 'Alarma',
		THRESHOLD_LIMIT_TOOLTIP: 'Límite umbral',
		THRESHOLD_LABEL: 'Umbral',
		INSTRUMENT_RANGE_TOOLTIP: 'Rango de instrumento',
		INSTRUMENT_LABEL: 'Instrumento',
		HIGH_LABEL: 'Alto:',
		LOW_LABEL: 'Bajo:',
		AVG_LABEL: 'Prom.:',
		DATA_PULL_REQUEST: 'Solicitud de extracción de datos',
		SELECT_TAGS_PLACEHOLDER: 'Seleccionar etiquetas',
		FROM_DATE_PLACEHOLDER: 'Fecha desde',
		SELECT_FROM_DATE_HINT: 'Fecha desde',
		TO_DATE_PLACEHOLDER: 'Fecha hasta',
		TO_DATE_REQUIRED: 'La fecha hasta es',
		SELECT_TO_DATE_HINT: 'Fecha hasta',
		PULL_DATA_TOOLTIP: 'Extraer datos',
		PULL_DATA: 'Extraer datos',
		STATUS_PANEL: {
			SUMMARY: 'Resumen',
			TAG_SUMMARY: 'Resumen de etiquetas',
			RECORDS: 'Registros',
			TOTAL_TAGS: 'Total de etiquetas',
			TAGS_IN_MODEL: 'Etiquetas en el modelo',
			TAGS_MAPPED_TO_FM: 'Etiquetas con modo de fallo',
			TAGS_WITH_NO_FM: 'Etiquetas sin modo de fallo',
			PROCESSING_TIME: 'Tiempo de procesamiento',
			TRAINING_TIME: 'Tiempo de entrenamiento',
			TOTAL_TAGS_DROPPED: 'Total de etiquetas eliminadas',
			ALERTS_GENERATED: 'Alertas generadas',
			PRECISION_PREVIOUS: 'Precisión anterior',
			PRECISION_CURRENT: 'Precisión actual',
			PHASE_DATA_IMPORT: 'Importación de datos',
			PHASE_PREPROCESSING: 'Preprocesamiento de datos',
			PHASE_MODELING: 'Modelado',
			PHASE_ALERT_FEEDBACK: 'Comentarios de alertas',
			PHASE_READY_TO_DEPLOY: 'Listo para implementar',
			DROPPED_TAGS: 'Etiquetas eliminadas',
			CALCULATED_TAGS_DROPPED: 'Etiquetas calculadas eliminadas',
			RAW_TAGS_DROPPED: 'Etiquetas sin procesar eliminadas',
			TAGS_DROPPED_PREPROCESSING: 'Eliminadas en preprocesamiento',
			TAGS_DROPPED_MANUALLY: 'Eliminadas manualmente',
			HIGH_DEVIATION_TAGS: 'Etiquetas de alta desviación',
			EXPORT: 'Exportar',
			COL_TAG_NAME: 'Nombre de etiqueta',
			COL_TAG_ID: 'ID de etiqueta',
			COL_DESCRIPTION: 'Descripción',
			COL_UNIT: 'Unidad',
			COL_CALCULATED: 'Calculada',
			COL_DROPPED_DUE_TO: 'Eliminada por',
			COL_REASON: 'Motivo',
			YES: 'Sí',
			NO: 'No',
			DROPPED_DUE_IMPORT: 'Importación',
			DROPPED_DUE_PREPROCESSING: 'Preprocesamiento',
			DROPPED_DUE_MANUAL: 'Manual',
			DROPPED_DUE_UNKNOWN: '—',
			NO_TAGS_DROPPED: 'Aún no se han eliminado etiquetas',
			NO_HIGH_DEVIATION: 'Ejecute la creación del modelo para completar las etiquetas de alta desviación',
			NO_HIGH_DEVIATION_EMPTY: 'No se encontraron etiquetas de alta desviación',

			PHASE_DEPLOYED: 'Implementado',
			DROPPED_DUE_CALCULATED: 'Calculada',
			STEP_STATUS: 'Estado',
			STEP_STATUS_COMPLETED: 'Completado',
			STEP_PREPROCESSING_TIME: 'Tiempo de preprocesamiento',
			STEP_TRAINING_TIME: 'Tiempo de entrenamiento',
			STEP_PREDICTION_TIME: 'Tiempo de predicción',
			STEP_ALERTS_GENERATED: 'Alertas generadas',
			STEP_PRECISION_CURRENT: 'Precisión actual',
			STEP_PRECISION_PREVIOUS: 'Precisión anterior',
			REASON_UNSELECTED_FROM_MODEL: 'No seleccionado del modelo',
			REASON_INVALID_DATA: '{{percent}}% de datos no válidos',
			STEP_SECONDS_VALUE: '{{value}} s',
		},
		UPLOAD_CSV_TITLE: 'Subir CSV',
		},
		CASES: {
			WORK_ORDER: {
				CREATE_TITLE: 'Crear una notificación de orden de trabajo',
				CREATE_DESC: 'Crear una notificación de orden de trabajo para este caso',
				DESCRIPTION: 'Descripción',
				DESCRIPTION_PLACEHOLDER: 'Describa el trabajo a realizar (obligatorio)',
				DESCRIPTION_REQUIRED: 'La descripción es obligatoria',
				PRIORITY: 'Prioridad',
				DUE_DATE: 'Fecha de vencimiento',
				ASSIGNED_TO: 'Asignado a',
				ESTIMATED_HOURS: 'Horas estimadas',
				HOURS_PLACEHOLDER: 'Introduzca horas',
				CANCEL: 'Cancelar',
				CONFIRM: 'Confirmar',
				UNASSIGNED: 'Sin asignar',
				CREATED: 'Orden de trabajo {{number}} creada',
				CREATED_PLAIN: 'Orden de trabajo creada',
				FAILED: 'No se pudo crear la orden de trabajo',
				CREATE_BUTTON: 'Crear orden de trabajo',
				NONE_YET: 'Aún no hay orden de trabajo',
				VIEW_TITLE: 'Orden de trabajo {{number}}',
				VIEW_SUB: 'Orden de trabajo creada desde este caso',
				CREATED_BY: 'Creada por {{name}}',
			},
			TRIAGE: {
				FROM_TRIAGE: 'Caso del Triaje de alertas',
				FROM_TRIAGE_DESC: 'Las alertas de este caso están en Triaje de alertas; ábralas allí para ver su telemetría y evidencia',
				HIERARCHY: 'Jerarquía de triaje de alertas',
				NO_FLOC: 'Sin ubicación técnica',
				ALERTS: 'Alertas de triaje',
				ADD_ALERTS: 'Añadir alertas',
				ADD_ALERTS_TIP: 'Buscar alertas de triaje y añadirlas a este caso',
				AUTO_FIND: 'Búsqueda automática',
				AUTO_FIND_TIP: 'Alertas agrupadas con las de este caso o en la misma ubicación técnica cerca del evento',
				AUTO_FIND_DESC: 'Grupo de lote o misma ubicación técnica en la ventana alrededor de la alerta de origen',
				EVENT_START: 'Inicio del evento',
				VIA_SOURCE: 'Origen',
				VIA_MANUAL: 'Añadida',
				VIA_AUTO: 'Encontrada automáticamente',
				ALERT_MISSING: 'Ya no está en la cola de triaje',
				OPEN_TRIAGE: 'Abrir en Triaje de alertas',
				REMOVE_ALERT: 'Quitar del caso',
				SEARCH_PLACEHOLDER: 'Buscar por ID de alerta, tag, nombre o ubicación técnica…',
				SEARCHING: 'Buscando…',
				NO_MATCH: 'No hay alertas coincidentes',
				ADD: 'Añadir',
				NO_SUGGESTIONS: 'No hay otras alertas en esta ventana',
				REASON_GROUP: 'Mismo grupo de lote',
				REASON_FLOC: 'Misma ubicación técnica en ±{{hours}} h',
				SELECT_ALL: 'Seleccionar todo',
				ADD_SELECTED: 'Añadir seleccionadas ({{count}})',
				EVIDENCE: 'Evidencia',
				KIND_FACT: 'Hechos',
				KIND_TAG: 'Tags',
				KIND_MAINTENANCE: 'Mantenimiento',
				KIND_REPORT: 'Informes',
				KIND_NOTE: 'Notas',
				NO_EVIDENCE: 'Aún no hay evidencia',
				REMOVE_EVIDENCE: 'Quitar evidencia',
				ADD_EVIDENCE_PLACEHOLDER: 'Añadir a {{kind}}…',
				BY_AGENT: 'Agente de triaje',
				BY_ENGINEER: 'Ingeniero',
				ALERT_REMOVED: 'Alerta quitada del caso',
				ALERTS_ADDED: '{{count}} alerta(s) añadida(s)',
				EVIDENCE_ADDED: 'Evidencia añadida',
				EVIDENCE_REMOVED: 'Evidencia quitada',
				ACTION_FAILED: 'La acción falló',
				HIERARCHY_SOURCE: 'Jerarquía',
				SOURCE_TRIAGE: 'Triaje de alertas',
				SOURCE_PLATFORM: 'Sistemas de la plataforma',
				SELECT_FLOC: 'Ubicación técnica',
				ROOT: 'Todo',
				FLOC_SEARCH: 'Buscar código o nombre de ubicación técnica…',
				FLOC_REQUIRED: 'Seleccione una ubicación técnica',
				NO_CHILDREN: 'No hay niveles inferiores',
				RELATED_TRIAGE_ALERTS: 'Alertas de triaje (opcional)',
				SELECT_ALERTS: 'Seleccionar alerta(s)',
			},
			SELECT_STATUS: 'Seleccionar estado',
			SELECT_CATEGORY: 'Seleccionar categoría',
			UNASSIGNED: 'Sin asignar',
			UNKNOWN_CREATOR: 'Creador desconocido',
			ALL_CASES: 'Todos los casos',
			CREATE_CASE: 'Crear caso',
			CASE_MANAGEMENT: 'Gestión de casos',
			UNKNOWN: 'Desconocido',
			UNCATEGORIZED: 'Sin categorizar',
			TITLE: 'Casos',
			SEARCH_PLACEHOLDER: 'Buscar...',
			NO_MATCHING_RESULTS: 'Sin resultados coincidentes',
			SEARCH_OWNER_PLACEHOLDER: 'Buscar propietario...',
			SEARCH_WATCHERS_PLACEHOLDER: 'Buscar observadores...',
			SELECT_OWNERS: 'Seleccionar propietarios',
			FILTERS: 'Filtros',
			GROUP_BY: 'Agrupar por',
			MORE: 'más',
			CASES_COUNT: '{{count}} casos',
			NO_CASES_FOUND: 'No hay casos disponibles',
			SYSTEM_TAGS: 'Etiquetas del sistema',
			CHECK_FILTERS_DATE_RANGE: 'Modifique los filtros o el rango de fechas para ver los resultados',
			CHIP: {
				OPEN: 'Abierto',
				PENDING: 'Pendiente',
				CLOSED: 'Cerrado',
			},
			GROUP_BY_OPTION: {
				NONE: 'Ninguno',
				STATUS: 'Estado',
				CATEGORY: 'Categoría',
				SYSTEM: 'Sistema',
				OWNER: 'Propietario',
				CREATOR: 'Creador'
			},
			STATUS_OPTION: {
				1: 'Notificación al cliente',
				2: 'Notificación al sitio',
				3: 'Investigación del sitio',
				4: 'Mantenimiento pendiente',
				5: 'Mantenimiento diferido',
				6: 'Parada pendiente',
				7: 'Caso resuelto',
				8: 'No se necesita acción'
			},
			CATEGORY_OPTION: {
				1: 'Confiabilidad',
				2: 'Proceso',
				3: 'Instrumentación',
				4: 'Mecánico',
				5: 'Eléctrico',
				6: 'Arranque/Parada',
				7: 'Otro'
			},
			COLUMNS: {
				SELECT: 'Seleccionar',
				NUMBER: 'Número',
				CASE_ID: 'ID del Caso',
				CASE_NAME: 'Nombre del Caso',
				SYSTEM_NAME: 'Nombre del Sistema',
				ALERT_NAME: 'Nombre de la Alerta',
				CATEGORY: 'Categoría',
				STATUS: 'Estado',
				CATCH: 'Catch',
				SOURCE: 'Origen',
				OWNER: 'Propietario',
				WATCHERS: 'Observadores',
				CREATED_BY: 'Creado Por',
				CREATED_ON: 'Creado El',
				SYSTEM_ANALYSIS: 'Análisis e Interpretación del Sistema',
				DUE_DATE: 'Fecha de Vencimiento',
				ESTIMATED_VALUE: 'Valor Estimado',
				AGREED_VALUE: 'Valor Acordado',
				LAST_MODIFIED: 'Última Modificación',
				RCH: 'Hipótesis de Causa Raíz',
				FEEDBACK_OUTCOME: 'Comentarios y Resultado',
				WORK_ORDER: 'Orden de Trabajo',
				POTENTIAL_IMPACT: 'Impacto Potencial',
			},
			MANAGEMENT: {
				FAILURE_MODE: 'Modo de fallo',
				SELECTED_VIEW: 'Vista seleccionada',
				USER_PREFERENCE_SETTINGS: 'Configuración de preferencias del usuario',
				CASES_LAYOUT: 'Diseño de casos',
				SIMPLIFIED: 'Simplificado',
				ADVANCED_DEFAULT: 'Avanzado (predeterminado)',
				LINKED_ALERT_REMOVED: 'Alerta vinculada eliminada',
				LINKED_ALERT_REMOVED_DESC: 'La alerta vinculada de este caso ya no está disponible',
				LINK_NEW_ALERT: 'Vincular nueva alerta',
				DRAG_TO_REORDER: 'Click and drag to reorder',
				NO_TAGS_AVAILABLE_FOR_FM: 'No hay etiquetas disponibles para este modo de fallo.',
				NO_TAGS_AVAILABLE_FOR_ALERT: 'No hay etiquetas disponibles para esta alerta.',
				NO_TAGS_ADDED: 'No hay etiquetas añadidas',
				ADD_TAGS_FROM_DISPLAY_TAGS: 'Usa el panel Mostrar etiquetas de la derecha para añadir etiquetas a este caso',
				VIEW_SETTINGS: 'Ajustes de visualización',
				DISPLAY_TAGS: 'Mostrar etiquetas',
				ASSET: 'Activo',
				SELECT_STATUS: 'Seleccionar estado',
				SELECT_CATEGORY: 'Seleccionar categoría',
				SEARCH_OWNER: 'Buscar propietario...',
				SEARCH_WATCHERS: 'Buscar observadores...',
			},
			TOOLTIP: {
				OPEN_IN_NEW_TAB: 'Abrir en una nueva pestaña',
				CUSTOMIZE_COLUMNS: 'Personalizar columnas',
				ONLY_OWNER_CATCH_TOOLTIP: 'Solo el propietario del caso puede marcar esto como un catch',
				ONLY_OWNER_EDIT_TOOLTIP: 'Solo el propietario o creador del caso puede modificar esto',
				MARKED_AS_CATCH_TOOLTIP: 'Marcado como Catch. Abra los detalles del caso para actualizar.',
				NOT_MARKED_AS_CATCH_TOOLTIP: 'No marcado como Catch. Abra los detalles del caso para cambiar esto.',
				OPEN_CASE: '{{count}} caso abierto',
				OPEN_CASES: '{{count}} casos abiertos',
				PENDING_CASE: '{{count}} caso pendiente',
				PENDING_CASES: '{{count}} casos pendientes',
				OPEN_TOOLTIP: 'Casos abiertos (incluye):\nNotificación al cliente\nNotificación al sitio\nInvestigación del sitio',
				PENDING_TOOLTIP: 'Acción pendiente (incluye):\nMantenimiento pendiente\nMantenimiento diferido\nParada pendiente',
				CLOSED_TOOLTIP: 'Casos cerrados (incluye):\nCaso resuelto\nNo se necesita acción'
			},
			COMMON_DIALOG: {
				SELECT_ALL: 'Seleccionar todo',
				REPORT_PDF_FILE_NAME: 'Nombre del archivo PDF del informe',
				INCLUDE_EVIDENCE_ATTACHMENTS: 'Incluir archivos adjuntos de evidencia',
				GENERATING_REPORT_FOR: 'Está generando un informe para {{count}} casos registrados',
				SELECT_FMS_TIMELINE: 'Seleccione los modos de fallo de la línea de tiempo para agregarlos al caso.',
				SELECT_FMS_FOR_RECOMMENDATIONS: 'Seleccionar modos de fallo para recomendaciones',
				RECOMMENDATIONS_FOR: 'Recomendaciones para {{name}}',
				NO_RECS_FOR_FM: 'No hay recomendaciones para este modo de fallo.',
				NO_OPEN_FMS: 'No hay modos de fallo abiertos.',
				NO_FMS_SELECTED: 'No se seleccionaron modos de fallo. Seleccione uno o más para continuar.',
				FMS_SELECTED: '{{count}} modo(s) de fallo seleccionado(s)',
				SELECT_FMS_TO_CONTINUE: 'Seleccione al menos un modo de fallo para continuar',
				SELECT_RECS_TO_CONTINUE: 'Seleccione al menos una recomendación para continuar',
				SELECT_ANALYSIS_TO_CONTINUE: 'Seleccione al menos un análisis para continuar',
				SELECT_VIEW_TO_CONTINUE: 'Seleccione al menos una vista para continuar',
				SELECT_ITEM_TO_CONTINUE: 'Seleccione al menos un elemento para continuar',
				ADD_SELECTED_RECOMMENDATIONS: 'Agregar recomendaciones seleccionadas',
				ADD_SELECTED_ANALYSIS: 'Agregar análisis seleccionado',
				ADD_SELECTED_VIEWS: 'Agregar vistas seleccionadas',
				ADD_SELECTED_FAILURE_MODES: 'Agregar modos de fallo seleccionados',
			},
			FILTER: {
				FILTER_BY: 'Filtrar por',
				SEARCH_PLACEHOLDER: 'Buscar por nombre o ID...',
				STATUS: 'Estado',
				CATEGORY: 'Categoría',
				CATCH: 'Catch',
				CREATED_BY: 'Creado por',
				WATCHERS: 'Observadores',
				CLEAR_ALL: 'Borrar todo'
			},
			DETAILS: {
				CASE_NARRATIVE: 'Descripción del caso',
				SYSTEM_ANALYSIS: 'Análisis e interpretación del sistema',
				RCH: 'Hipótesis de causa raíz',
				POTENTIAL_IMPACT: 'Impacto potencial',
				PROPOSED_ACTIONS: 'Acciones propuestas',
				FEEDBACK_OUTCOME: 'Comentarios y resultado',
				WORK_ORDER: 'Orden de Trabajo',
				MARK_AS_CATCH: 'Marcar como catch',
				SYSTEM_ANALYSIS_PLACEHOLDER: 'Resuma lo que se observó, cuándo comenzó y la condición operativa actual…',
				RCH_PLACEHOLDER: 'Describa la causa raíz sospechada o confirmada. Vincule a FM o eventos si es relevante...',
				TAG_RELATED_FAILURE_MODES: 'Modos de fallo relacionados con la etiqueta',
				ADD_FAILURE_MODES_TOOLTIP: 'Agregar modos de fallo',
				ADD_FMS: 'Agregar FM',
				RECOMMENDED_ACTIONS: 'Acción(es) recomendada(s)',
				ADD_SELECTED: 'Agregar seleccionado',
				ADD_SELECTED_RECOMMENDATIONS_TOOLTIP: 'Agregar recomendaciones seleccionadas',
				ADD_RECOMMENDATIONS_TOOLTIP: 'Agregar recomendaciones',
				ADD_MORE: 'Agregar más',
				ADD_MORE_RECOMMENDATIONS_TOOLTIP: 'Agregar más recomendaciones',
				PROPOSED_ACTIONS_PLACEHOLDER: 'Acciones propuestas, plazos, riesgo si no se ejecutan...',
				POTENTIAL_IMPACT_PLACEHOLDER: 'Describa el impacto comercial/operativo potencial (por ejemplo, riesgo de inactividad, pérdida de calidad, seguridad, costo)...',
				FEEDBACK_OUTCOME_PLACEHOLDER: 'Notas del sitio, acciones implementadas, lecciones aprendidas…',
				WORK_ORDER_PLACEHOLDER: 'p. ej. WO-2026-001248 (Introduzca el número o referencia de la orden de trabajo de su sistema de mantenimiento.)',
				CANCEL: 'Cancelar',
				SAVE: 'Guardar',
				EVIDENCE_ATTACHMENTS: 'Evidencias y adjuntos',
				SAVED_ANALYSIS: 'Análisis guardados',
				NO_SAVED_ANALYSIS_AVAILABLE: 'No hay análisis guardados disponibles',
				ADD_SAVED_ANALYSIS: 'Agregar análisis guardado',
				ADD_ANALYSIS: 'Agregar análisis',
				LINK_ALERT_TO_ADD_ANALYSIS: 'Etiqueta una alerta relacionada con análisis guardado para añadirla aquí',
				SAVED_VIEWS: 'Vistas guardadas',
				ONLY_OWNERS_SAVE_TAG_VIEWS: 'Solo el propietario de la alerta o del caso puede guardar o modificar las vistas de etiquetas.',
				SAVE_CURRENT_TAG_VIEW: 'Guardar vista de etiqueta actual',
				SAVE_CURRENT_VIEW: 'Guardar vista actual',
				NO_SAVED_VIEWS_AVAILABLE: 'No hay vistas guardadas disponibles',
				ADD_SAVED_VIEWS: 'Agregar vistas guardadas',
				ADD_VIEW: 'Agregar vista',
				LINK_ALERT_TO_ADD_VIEWS: 'Etiqueta una alerta relacionada con vistas guardadas para añadirlas aquí',
				TAG_RELATED_ALERTS: 'Alertas relacionadas con la etiqueta',
				ADD_ALERTS: 'Agregar alertas',
				UPLOAD_EVIDENCES: 'Subir evidencias',
				UPLOAD_PLACEHOLDER: 'Adjuntar, arrastrar y soltar o pegar evidencia…',
				VALUE_IMPACT: 'Impacto de Valor',
				VALUE_CALCULATION_INPUTS: 'Datos de Cálculo de Valor',
				LIKELIHOOD: 'Probabilidad (%)',
				IMPACT: 'Impacto',
				LIKELIHOOD_IMPACT_MATRIX: 'Matriz de Probabilidad e Impacto',
				SAVINGS: 'Ahorros',
				CONTRIBUTION_FACTOR: 'Factor de Contribución',
				ESTIMATED_VALUE: 'Valor Estimado (USD)',
				AGREED_VALUE: 'Valor Acordado (USD)',
				TOTAL_PRODUCTION_LOST: 'Producción Total Perdida (KBOE)',
				TOTAL_FLARING_AVOIDED: 'Quema Evitada Total (MT CO2)',
				PRODUCTIVITY: 'Productividad (Horas)',
				EMISSIONS: 'Emisiones (Toneladas)',
				SELECT_VALUE: 'Seleccionar Valor',
				ENTER_VALUE: 'Ingresar Valor',
				EXPORT_AS_PDF: 'Exportar como PDF',
				SAVE_CASE_FIRST: 'Guarde el caso primero',
				GENERATE_PDF: 'Generar PDF',
				SEND_VIA_EMAIL: 'Enviar por correo',
				SHARE_VIA_EMAIL: 'Compartir por correo',
				CLEAR_ALL: 'Borrar todo',
				CLEAR_ALL_TOOLTIP: 'Borrar toda la información',
				SAVE_TOOLTIP: 'Guardar información',
				OPTIONAL_FIELD_SAVE_ERROR: 'Error al guardar los cambios de los campos opcionales'
			},
			EMAIL: {
				SEND_VIA_MAIL: 'Enviar por correo',
				RECEIVER_EMAIL_IDS: 'IDs de correo electrónico del destinatario',
				SEARCH_USER: 'Buscar usuario',
				SELECT_ENTER_EMAIL_IDS: 'Seleccionar/Ingresar IDs de correo electrónico',
				DONE: 'Listo',
				SELECT: 'Seleccionar',
				PLEASE_SELECT_RECIPIENTS: 'Por favor seleccione los destinatarios',
				SUBJECT: 'Asunto',
				DEFAULT_SUBJECT: 'Uptime AI: Caso creado',
				ASSET: 'Activo',
				OWNER: 'Propietario',
				CREATED_BY: 'Creado por',
				CREATED_ON: 'Creado el',
				CASE_STATUS: 'Estado del caso',
				CATEGORY: 'Categoría',
				MODIFIED_ON: 'Modificado el',
				CASE_NAME: 'Nombre del caso',
				USERS: 'Usuarios',
				CANCEL: 'Cancelar',
				SEND_EMAIL: 'Enviar correo',
				PLEASE_SELECT_RECIPIENTS_TOOLTIP: 'Por favor seleccione destinatarios',
			},
			NOTIFICATION: {
				FMS_ADDED_SUCCESS: 'Modos de fallo agregados correctamente',
				ANALYSIS_ADDED_SUCCESS: 'Análisis seleccionados agregados correctamente',
				VIEWS_ADDED_SUCCESS: 'Vistas seleccionadas agregadas correctamente',
				FMS_ADDED_SUCCESS_ALT: 'Modos de fallo seleccionados agregados correctamente',
				ALL_RECOMMENDATIONS_ADDED: 'Se agregaron todas las recomendaciones de los modos de fallo aprobados',
				RECOMMENDATIONS_ADDED_SUCCESS: 'Recomendaciones seleccionadas agregadas correctamente',
				GENERATING_PDF: 'Generando su PDF... Se lo enviaremos por correo cuando esté listo.',
				NO_VALID_FILES: 'No se seleccionaron archivos válidos. Solo se permiten archivos con las extensiones {{extensions}}',
				UPLOAD_SIZE_LIMIT: '{{name}} no se pudo cargar debido al límite de tamaño de archivo.',
				UPLOAD_FAILED: '{{name}} no se pudo cargar.',
				FAILED_TO_GENERATE_PDF: 'Error al generar el PDF',
				BULK_REPORT_TITLE: 'Generando informe de casos agregados',
				PREPARING_DOWNLOAD: 'Preparando su descarga. Esto puede tardar un momento.',
				CSV_DOWNLOAD_SUCCESS: 'CSV descargado correctamente',
				CSV_DOWNLOAD_FAILED: 'Error al exportar CSV',
				SELECT_STATUS_TO_SAVE: 'Por favor, seleccione el estado del caso para guardarlo',
				SELECT_CATEGORY_TO_SAVE: 'Por favor, seleccione la categoría del caso para guardarlo',
				CASE_ADDED_SUCCESS: 'Caso agregado exitosamente',
				CASE_UPDATED_SUCCESS: 'Caso actualizado exitosamente',
				ENTER_TITLE_TO_PROCEED: 'Por favor, ingrese un título para continuar'
			}
		},
		IOW: {
			FACILITY: 'Instalación',
			SELECT_FACILITY: 'Seleccionar instalación',
			SEARCH_FACILITY: 'Buscar instalación...',
			NO_FACILITY_FOUND: 'No se encontró ninguna instalación coincidente',
			UNIT: 'Unidad',
			SELECT_UNIT: 'Seleccionar unidad',
			SEARCH_UNIT: 'Buscar unidad...',
			NO_UNIT_FOUND: 'No se encontró ninguna unidad coincidente',
			SYSTEM: 'Sistema',
			SELECT_SYSTEM: 'Seleccionar sistema',
			SEARCH_SYSTEM: 'Buscar sistema...',
			NO_SYSTEM_FOUND: 'No se encontró ningún sistema coincidente',
			TAGS: 'Etiquetas',
			SELECT_TAGS: 'Seleccionar etiquetas',
			SEARCH_TAG: 'Buscar etiqueta...',
			NO_TAG_FOUND: 'No se encontró ninguna etiqueta coincidente',
			CASE_STATUS: 'Estado del caso',
			EXCEEDANCE_TYPE: 'Tipo de excedencia',
			SELECT_EXCEEDANCE_TYPE: 'Seleccionar tipo de excedencia',
			SELECT_ALL: 'Seleccionar todo',
			ANALYSE_TOP_TRENDS: 'Analizar las 20 principales tendencias',
			SAVE: 'Guardar',
			COPY: 'Copiar',
			ADD_NEW: 'Agregar nuevo',
			EDIT: 'Editar',
			DELETE: 'Eliminar',
			DOWNLOAD: 'Descargar',
			ACTIVE_EXCEEDANCES: 'Excedencias activas',
			DATE_RANGE_DISABLED_TOOLTIP: 'La selección de rango de fechas no es aplicable cuando se selecciona el filtro de excedencia activa.',
			SELECT_DATE_RANGE: 'Seleccionar rango de fechas',
			ENTER_DATE_RANGE: 'Ingresar un rango de fechas',
			START_DATE: 'Fecha de inicio',
			END_DATE: 'Fecha de fin',
			APPLY_TIME_CHANGE: 'Aplicar cambio de período',
			SUMMARY: 'Resumen',
			SELECT_SYSTEM_MESSAGE: 'Por favor seleccione un sistema para ver las excedencias.',
			LOADING: 'Cargando...',
			NO_EXCEEDANCE_FOUND: 'No se encontró ninguna excedencia.',
			NO_ACTIVE_EXCEEDANCE_FOUND: 'No se encontró ninguna excedencia activa.',
			NO_DATA_AVAILABLE: 'No hay datos disponibles para el rango de tiempo seleccionado',
			TRY_SELECTING_DIFFERENT_RANGE: 'Intente seleccionar un rango de fechas diferente',
			CRUNCHING_DATA: 'Procesando datos, ¡espere un momento!',
			TOTAL_EXCEEDANCES: 'Número total de excedencias del sistema',
			GROUP_TRENDS: 'Agrupar tendencias',
			TRENDS_PER_CHART: 'Tendencias / gráfico (hasta 8)',
			CANCEL: 'Cancelar',
			PROCEED: 'Continuar',
			SELECT: 'Seleccionar',
			SELECT_DATE_RANGE_LABEL: 'Seleccionar rango de fechas',
			DATE_RANGE: 'Rango de fechas',
			DATE_RANGE_REQUIRED: 'El rango de fechas es obligatorio.',
			REGROUP_EXCEEDENCES: 'Reagrupar excedencias',
			DURATION_MINUTES: 'Duración (en min.)',
			DURATION_REQUIRED: 'La duración es obligatoria.',
			ENTER_VALID_NUMBER: 'Por favor ingrese un número válido.',
			DOWNLOAD_TITLE: 'Descargar informe IOW',
			GROUP_BY_SYSTEM: 'Agrupar por sistema',
			GROUP_BY_UOM: 'Agrupar por unidad de medida',
			GROUP_COUNT_REQUIRED: 'El número de grupos es obligatorio.',
			MIN_VALUE_2: 'El valor mínimo es 2.',
			MAX_VALUE_8: 'El valor máximo es 8.',
			GROUP_COUNT_INVALID: 'El número de grupos no es válido.',
			WATCHERS: 'Observadores',
			CLOSE: 'Cerrar',
		},
		CAPACITY_OPTIMIZATION: {
			COMMON: {
				SAVE: 'Guardar',
				CANCEL: 'Cancelar',
				DELETE: 'Eliminar',
				EDIT: 'Editar',
				CLOSE: 'Cerrar',
				LOADING: 'Cargando...',
				SEARCH: 'Buscar...',
				ACTIONS: 'Acciones',
				NAME: 'Nombre',
				DESCRIPTION: 'Descripción',
				STATUS: 'Estado',
				TYPE: 'Tipo',
				CREATED: 'Creado',
				LAST_UPDATED: 'Última actualización',
				DOWNLOAD: 'Descargar',
				UPLOAD: 'Subir',
				IMPORT: 'Importar',
				EXPORT: 'Exportar',
				RUN: 'Ejecutar',
				STOP: 'Detener',
				YES: 'Sí',
				NO: 'No',
				APPLY: 'Aplicar',
				RESET: 'Restablecer',
				CONFIRM: 'Confirmar',
				BACK: 'Atrás',
				NEXT: 'Siguiente',
			},
			NAV: {
				SCENARIOS: 'Escenarios',
				DASHBOARD: 'Panel',
				COMPARISON: 'Comparación',
				SETTINGS: 'Configuración',
				MODELS: 'Modelos',
				SIMULATION: 'Simulación',
				REALTIME: 'Tiempo real',
				TOPOLOGY: 'Topología',
				STRATEGIC: 'Estratégico',
			},
			LANDING: {
				TITLE: 'Optimización de capacidad',
				SUBTITLE: 'Optimice la generación de energía y agua en toda su flota',
			},
			SCENARIO: {
				TITLE: 'Biblioteca de escenarios',
				NEW_SCENARIO: 'Nuevo escenario',
				SEARCH_SCENARIO: 'Buscar escenario',
				DUPLICATE: 'Duplicar',
				RUN_OPTIMIZATION: 'Ejecutar optimización',
				FORCE_STOP: 'Forzar detención',
				VIEW_RESULTS: 'Ver resultados',
				SCENARIO_NAME: 'Nombre del escenario',
				CLASSIFICATION: 'Clasificación',
				SOLVER: 'Solucionador',
				RUN_MODE: 'Modo de ejecución',
				STATUS_READY: 'Listo',
				STATUS_RUNNING: 'En ejecución',
				STATUS_COMPLETED: 'Completado',
				STATUS_FAILED: 'Fallido',
				PROMOTE: 'Promover',
				ALTERNATIVE_SOLVER: 'Solucionador alternativo',
			},
			CONFIG: {
				TITLE: 'Configuración del escenario',
				TABS: {
					AVAILABILITY: 'Disponibilidad de activos',
					DEMAND: 'Pronóstico de demanda',
					CONSTRAINTS: 'Restricciones',
					SOLVER: 'Solucionador y ejecución',
					TESTING: 'Perfiles de prueba',
					GROWTH_FACTOR: 'Factor de crecimiento',
					SWRO_AVAILABILITY: 'Disponibilidad SWRO',
				},
				HORIZON: 'Horizonte (h)',
				STEP: 'Paso (min)',
				START_HOUR: 'Hora de inicio',
				TARGET_DATE: 'Fecha objetivo',
				LATITUDE: 'Latitud',
				LONGITUDE: 'Longitud',
				PERF_CURVE: 'Fuente de curva de rendimiento',
				OEM_CURVES: 'Curvas de diseño OEM',
				HISTORICAL_ML: 'Datos históricos (ML)',
				PLANNING_OFFLINE: 'Planificación (sin conexión)',
				LIVE_REALTIME: 'En vivo (tiempo real)',
				UPLOAD_CSV: 'Subir CSV',
				DOWNLOAD_CSV: 'Descargar CSV',
				POWER_MW: 'Potencia (MW)',
				WATER_MIGD: 'Agua (MIGD)',
				POWER_IMPORT: 'Importación de energía',
				POWER_EXPORT: 'Exportación de energía',
				WATER_IMPORT: 'Importación de agua',
				WATER_EXPORT: 'Exportación de agua',
				INITIAL_STATUS: 'Estado inicial',
				DURATION_IN_STATE: 'Duración en estado (horas)',
				ON: 'ENCENDIDO',
				OFF: 'APAGADO',
			},
			CONSTRAINTS: {
				TITLE: 'Configuración de restricciones',
				ANCILLARY_SERVICES: 'Servicios auxiliares',
				MIN_UP_DOWN_TIME: 'Tiempo mínimo de encendido/apagado',
				RAMP_LIMITS: 'Límites de rampa',
				FIXED_LOADS: 'Cargas fijas',
				AGC_DISPATCH: 'Despacho AGC',
				ALLOW_LOAD_SHEDDING: 'Permitir descarga de carga',
				ALLOW_WATER_SHORTAGE: 'Permitir escasez de agua',
				ENFORCE_FUEL_LIMITS: 'Aplicar límites de combustible',
				SPINNING_RESERVE: 'Reserva giratoria (MW)',
				OPERATING_RESERVE: 'Reserva operativa (MW)',
				WATER_RESERVE: 'Reserva de agua (MIGD)',
			},
			GROWTH_FACTOR: {
				TITLE: 'Configuración del factor de crecimiento',
				ADJUSTMENT_TYPE: 'Tipo de ajuste',
				VALUE: 'Valor del factor de crecimiento',
				TARGET_METRIC: 'Métrica objetivo',
				START_TIME: 'Hora de inicio',
				END_TIME: 'Hora de fin',
			},
			SWRO: {
				TITLE: 'Configuración de disponibilidad SWRO',
				SELECT_PLANTS: 'Seleccionar plantas SWRO',
				FLAT_VALUE: 'Valor de disponibilidad fijo',
			},
			DASHBOARD: {
				TITLE: 'Resultados de optimización',
				STATION_FILTER: 'Filtro de estación',
				ALL_STATIONS: 'Todas las estaciones',
				TOTAL_COST: 'Costo total',
				POWER_GENERATION: 'Generación de energía',
				WATER_PRODUCTION: 'Producción de agua',
				FUEL_CONSUMPTION: 'Consumo de combustible',
			},
			COMPARISON: {
				TITLE: 'Comparación de escenarios',
				SEARCH_SCENARIO: 'Buscar escenario',
				BASELINE: 'Línea base',
				SELECT_BASELINE: 'Seleccionar línea base',
			},
			SETTINGS: {
				TITLE: 'Configuración',
				PLATFORM: 'Configuración de plataforma',
				DATA_MGMT: 'Gestión de datos',
				MODULE_CONFIG: 'Configuración del módulo',
				TAGS: 'Etiquetas',
				TEMPLATES: 'Plantillas',
				TOPOLOGY: 'Topología',
				TRAINING: 'Entrenamiento',
				USERS: 'Usuarios',
			},
			PLATFORM_SETUP: {
				TITLE: 'Configuración de plataforma e instalación',
				ENTERPRISE_NAME: 'Nombre de la empresa',
				STREET_ADDRESS: 'Dirección',
				CITY: 'Ciudad',
				STATE: 'Estado/Provincia',
				COUNTRY: 'País',
				ZIP_CODE: 'Código postal',
				LATITUDE: 'Latitud',
				LONGITUDE: 'Longitud',
				INDUSTRY: 'Industria',
				TIMEZONE: 'Zona horaria',
				BUSINESS: 'Negocio',
				NOTES: 'Notas',
				COST_PER_UNIT: 'Costo por unidad ($)',
				CAPACITY_PER_HOUR: 'Capacidad por hora',
				REVENUE_PER_HOUR: 'Ingresos por hora ($)',
				OPERATIONAL_MARGIN: 'Margen operativo (%)',
				TECHNICIAN_SALARY: 'Salario técnico ($/h)',
				HELPER_SALARY: 'Salario ayudante ($/h)',
			},
			USER_MGMT: {
				TITLE: 'Gestión de usuarios',
				ADD_USER: 'Agregar usuario',
				USERNAME: 'Nombre de usuario',
				DISPLAY_NAME: 'Nombre para mostrar',
				PASSWORD: 'Contraseña',
				ROLE: 'Rol',
				ADMIN: 'Administrador',
				SUPER_USER: 'Superusuario',
				USER: 'Usuario',
				NO_PERMISSION: 'No tiene permiso para acceder a esta sección.',
			},
			SIMULATION: {
				TITLE: 'Simulación de sensibilidad',
				TARGET_EQUIPMENT: 'Equipo objetivo',
				SWEEP_PARAMETER: 'Parámetro de barrido',
				START_VALUE: 'Valor inicial',
				END_VALUE: 'Valor final',
				STEPS: 'Pasos',
				RUN_SWEEP: 'Ejecutar barrido',
			},
			REALTIME: {
				TITLE: 'Panel en tiempo real',
				CONFIRMED_TARGET: 'Objetivo confirmado',
				SELECT_DATE: 'Seleccionar fecha',
				SCENARIO_NAME: 'Nombre del escenario',
				HORIZON_HOURS: 'Horizonte (horas)',
				SOLVER: 'Solucionador',
				PERF_CURVE: 'Curva de rendimiento',
				START_MODE: 'Modo de inicio',
				RAMP_LIMITS: 'Límites de rampa',
				MIN_UP_DOWN: 'Tiempo mínimo encendido/apagado',
				ANCILLARY: 'Servicios auxiliares',
				IMPORT_SCENARIO: 'Importar desde escenario',
			},
			TOPOLOGY: {
				TITLE: 'Topología SCADA',
				POWER_VIEW: 'Energía',
				WATER_VIEW: 'Agua',
				AUTO_CORRECT: 'Corrección automática',
				FLEET_OVERVIEW: 'Vista general de la flota',
			},
			DEMAND: {
				HORIZON: 'Horizonte (h)',
				STEP: 'Paso (min)',
				START_HOUR: 'Hora de inicio',
				UPDATE_PLAN: 'Actualizar plan de demanda',
				UPDATE_PLAN_TOOLTIP: 'Volver a muestrear todas las tablas de programación en la nueva rejilla temporal, interpolando los valores ya introducidos.',
				UPDATE_PLAN_HINT: 'Los parámetros de programación cambiaron: pulse Actualizar plan de demanda para volver a muestrear las tablas.',
				SOLAR_INPUT: 'Entrada solar',
				SOLAR_PHASES_ACTIVE: 'fases activas',
			},
			TAG_EXPLORER: {
				TITLE: 'Explorador de tags',
				SUBTITLE: 'Represente valores históricos de cualquier tag mapeado. Los puntos se agregan en el servidor para que un rango amplio siga siendo fluido.',
				TAGS: 'Tags',
				TAGS_PLACEHOLDER: 'Seleccione hasta 10 tags',
				TAGS_SEARCH_PLACEHOLDER: 'Buscar por parámetro o nombre de tag...',
				START_DATE: 'Fecha de inicio',
				END_DATE: 'Fecha de fin',
				PLOT: 'Graficar',
				LOADING_TAGS: 'Cargando lista de tags...',
				QUERYING: 'Consultando datos históricos...',
				NO_DATA_FOR: 'Sin datos en este rango para:',
				UNITS_DROPPED: 'El gráfico muestra dos unidades a la vez; las series en {{units}} no se representaron.',
				BUCKET_HINT: 'Agregado en intervalos de {{bucket}}.',
				COL_PARAMETER: 'Parámetro',
				COL_TAG: 'Tag',
				COL_UNIT: 'Unidad',
				COL_POINTS: 'Puntos',
				COL_MIN: 'Mín.',
				COL_MAX: 'Máx.',
				COL_AVERAGE: 'Promedio',
				GROUP_SYSTEM_DEMAND: 'Demanda del sistema',
				GRID_POWER_DEMAND: 'Demanda eléctrica de la red',
				GRID_WATER_DEMAND: 'Demanda de agua de la red',
				AXIS_TIME: 'Tiempo',
				AXIS_VALUE: 'Valor',
				REQUEST_FAILED: 'Error en la solicitud ({{status}})',
				SERVER_UNREACHABLE: 'No se pudo conectar con el servidor.',
			},
		},
		DISPLAY_TAGS: {
			HEADER: 'Mostrar otras etiquetas',
			CLOSE: 'Cerrar',
			SEARCH_PLACEHOLDER: 'Buscar...',
			FILTER_TOOLTIP: 'Filtrar etiquetas',
			SELECT_SYSTEM: 'Seleccionar sistema',
			ALL_SYSTEMS: 'Todos los sistemas',
			FILTER_BY: 'Filtrar por',
			ALL_TAGS: 'Todas las etiquetas',
			MODELED_TAGS: 'Etiquetas modeladas',
			SHOW_CALCULATED_TAGS: 'Mostrar etiquetas calculadas',
			NO_MATCHING_RESULTS: 'No hay resultados coincidentes',
			START_TYPING: 'Empiece a escribir para ver etiquetas coincidentes.',
		},
		PROCESS: {
      LIST_TABLE: {
				NO_CURRENT_BATCHES_TITLE: 'No hay lotes actuales',
				NO_CURRENT_BATCHES_CONTENT: 'Los lotes activos o en ejecución aparecerán aquí una vez que comience un proceso.',
				NO_PAST_BATCHES_TITLE: 'No hay lotes anteriores',
				NO_PAST_BATCHES_CONTENT: 'Los lotes completados, detenidos o fallidos aparecerán aquí una vez que finalice una ejecución.'
			},
			LIST: {
				PAGE_TITLE: 'Proceso',
				SEARCH_PLACEHOLDER: 'Buscar por ID de lote',
				CURRENT_BATCHES_TAB: 'Lotes actuales',
				PAST_BATCHES_TAB: 'Lotes anteriores',
				FILTER: {
					SYSTEM: 'Sistema',
					SEARCH_SYSTEM: 'Buscar sistema',
					CREATED_BETWEEN: 'Creado entre',
					STARTED_ON: 'Iniciado el',
					CLEAR_DATE: 'Borrar fecha',
					OWNER: 'Responsable',
					SEARCH_OWNER: 'Buscar responsable',
				},
			},
			TABLE: {
				COL_BATCH_NAME_ID: 'Nombre / ID de lote',
				COL_START_DATE_TIME: 'Fecha / hora de inicio',
				COL_END_DATE_TIME: 'Fecha / hora de fin',
				COL_LAST_UPDATED: 'Última actualización',
				COL_DURATION: 'Duración',
				COL_RUN_TIME: 'Tiempo de ejecución',
				COL_STATUS: 'Estado',
				COL_OWNER: 'Responsable',
				COL_WATCHERS: 'Observadores',
				COL_PERCENT_COMPLETE: 'Porcentaje completado',
				COL_PROJECTED_PRODUCT: 'Producto proyectado',
				COL_FINAL_PRODUCT: 'Producto final',
				SELECT_COLUMNS: 'Seleccionar columnas',
				SAVE_VIEW: 'Guardar vista',
				APPLY: 'Aplicar',
				LOADING: 'Cargando...',
				NO_RECORDS: 'No se encontraron registros',
			},
			DETAILS: {
				TITLE_PREFIX: 'Detalles del proceso',
				BATCH_NAME: 'Nombre del lote',
				FACILITY: 'Instalación',
				UNIT: 'Unidad',
				SYSTEM: 'Sistema',
				STATUS: 'Estado',
				START_DATE_TIME: 'Fecha / hora de inicio',
				LAST_UPDATED: 'Última actualización',
				OVERLAY: 'Superpuesto',
				STACKED: 'Apilado',
				GRID: 'Cuadrícula',
				SELECT_OWNER: 'Seleccionar responsable',
				WATCHERS_TOOLTIP: 'Observadores',
				FILTER: {
					LAB_PARAMETERS: 'Parámetros de laboratorio',
					BATCH: 'Lote',
					OTHERS: 'Otros',
					SEARCH_BATCH: 'Buscar lote',
				},
				GOLDEN_BATCH_BAND: 'Banda de lote dorado',
				PREDICTION: 'Predicción',
			},
		},
		DYNAMIC_DASHBOARD: {
			DASHBOARD_WIZARD: 'Asistente de panel',
			ADD_NEW_DASHBOARD: 'Agregar nuevo panel',
			CREATE_DASHBOARD: 'Crear panel',
			SEARCH: 'Buscar',
			EDIT_MODE: 'Modo edición',
			SAVE_DASHBOARD: 'Guardar panel',
			PUBLIC: 'Público',
			PRIVATE: 'Privado',
			SENSOR_DATA: 'Datos de sensor',
			NON_SENSOR_DATA: 'Datos no sensor',
			ENTER_DATE_RANGE: 'Ingresar rango de fechas',
			START_DATE: 'Fecha de inicio',
			END_DATE: 'Fecha de fin',
			APPLY_TIME_CHANGE: 'Aplicar cambio de tiempo',
			MORE: 'Más',
			NOTHING_CREATED: 'Aún no ha creado nada',
			LOADING: 'Cargando...',
			NO_DATA: 'No hay datos disponibles para los atributos seleccionados',
			CONFIGURE_ATTRIBUTES: 'Configurar atributos para renderizar',
			SELECT_CHART_TYPE: 'Seleccionar tipo de gráfico',
			CONFIG_ONLY_WIDGET: 'Este es un widget de solo configuración. No se mostrarán gráficos.',
			TYPE_OF_CONFIG: 'Tipo de configuración:',
			GROUP_KEY: 'Clave de grupo:',
			SPECIFICATION_LIMIT: 'Límite de especificación',
			PLEASE_ADD_STATS: 'Por favor agregue una tarjeta de estadísticas',
			ADD_ATTRIBUTES: 'Agregar atributos para mostrar',
			PROCESSING_DATA: 'Procesando datos, por favor espere...',
			EDIT: 'Editar',
			DUPLICATE: 'Duplicar',
			REMOVE: 'Eliminar',
			CANCEL: 'Cancelar',
			SAVE: 'Guardar',
			BACK: 'Volver',
			PERFORMANCE_CURVE_OF: 'Curva de rendimiento de',
			NO_WIDGETS_AVAILABLE: 'No hay widgets disponibles. Agrega un widget para comenzar',
			TAB_EMPTY_STATES: {
				ALL: {
					HEADING: 'Aún no hay paneles',
					CONTENT: 'Cree su primer panel para monitorear métricas clave, tendencias e información en un solo lugar.',
				},
				MY_DASHBOARD: {
					HEADING: 'No hay paneles creados por usted',
					CONTENT: 'Los paneles que cree aparecerán aquí.',
				},
				SHARED: {
					HEADING: 'Aún no hay paneles compartidos',
					CONTENT: 'Los paneles que otros compartan con usted aparecerán aquí.',
				},
				PRIVATE: {
					HEADING: 'Aún no hay paneles privados',
					CONTENT: 'Los paneles que cree y mantenga privados aparecerán aquí.',
				},
				SEARCH: {
					HEADING: 'No se encontraron paneles',
					CONTENT: 'Pruebe con una palabra clave diferente o borre la búsqueda.',
				},
			},
			SLICER_POPUP: {
				SELECT_ALL: 'Select All',
				PREVIEW: 'Preview',
				APPLY_AND_CLOSE: 'Apply & Close',
				APPLYING: 'Applying...',
      		},
			COLLABORATOR: {
				TITLE_SUFFIX: 'Colaboradores',
				SEARCH_PLACEHOLDER: 'Buscar por nombre o correo',
				COLLABORATED_WITH: 'Colaborado con',
				USERS: 'usuarios',
				ALL_USERS: 'Todos los usuarios',
				OWNER: 'Propietario',
				CANCEL: 'Cancelar',
				SAVE: 'Guardar',
				CANCEL_CHANGES: 'Cancelar cambios',
				SAVE_CHANGES: 'Guardar cambios',
				ROLE: {
					FULL: 'Completo',
					FULL_DESC: 'Acceso completo',
					EDIT: 'Editar',
					EDIT_DESC: 'Acceso de visualización y edición',
					VIEW: 'Ver',
					VIEW_DESC: 'Solo visualización',
				},
			},
			EDIT_PANEL: {
				CREATE_PANEL: 'Crear panel',
				EDIT_PANEL: 'Editar panel',
				CANCEL: 'Cancelar',
				SAVE: 'Guardar',
				SELECT_CHART_TYPE: 'Tipo de gráfico',
				ADD_TITLE: 'Título',
				PANEL_NAME: 'Nombre del panel',
				ADDITIONAL_GRAPH_OPTIONS: 'Opciones adicionales de gráfico',
				SETTINGS: 'Configuración',
			},
			DASHBOARD_POPUP: {
				TITLE: 'Panel',
				SELECT_TYPE: 'Seleccionar tipo de panel',
				TYPE_DASHBOARD: 'Panel',
				TYPE_CONFIG: 'Configuración',
				TYPE_PERFORMANCE_CURVES: 'Curvas de rendimiento',
				NAME: 'Nombre',
				NAME_TAKEN: 'El nombre ya está en uso',
				NAME_REQUIRED: 'El nombre es obligatorio',
				LEVEL: 'Nivel',
				SELECT_LEVEL: 'Seleccionar nivel',
				FACILITY: 'Instalación',
				SELECT_FACILITY: 'Seleccionar instalación',
				FACILITY_REQUIRED: 'La instalación es obligatoria',
				UNIT: 'Unidad',
				SELECT_UNIT: 'Seleccionar unidad',
				UNIT_REQUIRED: 'La unidad es obligatoria',
				CANCEL: 'Cancelar',
				SAVE: 'Guardar',
			},
			TAG_PANEL: {
				ENABLE_QUICK_PLOT: 'Activar gráfico rápido',
				SELECT_UNITS: 'Seleccionar unidades',
				SEARCH_UNIT: 'Buscar unidad...',
				NO_UNIT_FOUND: 'No se encontró ninguna unidad',
				SELECT_SYSTEMS: 'Seleccionar sistemas',
				SEARCH_SYSTEM: 'Buscar sistema...',
				NO_SYSTEM_FOUND: 'No se encontró ningún sistema',
				ADD: 'Agregar',
				PREVIEW: 'Vista previa',
				PREVIEW_CHART: 'Vista previa del gráfico',
				DRAG_AND_DROP: 'Arrastrar y soltar',
				COPY: 'Copiar',
				DELETE: 'Eliminar',
				EDIT: 'Editar',
				LABEL: 'Etiqueta',
				TAG: 'Etiqueta',
				X_TAG: 'Etiqueta X',
				Y_TAG: 'Etiqueta Y',
				Z_TAG: 'Etiqueta Z',
				SEARCH_TAG: 'Buscar etiqueta...',
				NO_TAG_FOUND: 'No se encontró ninguna etiqueta',
				DESIGN_VALUE_TAG: 'Etiqueta de valor de diseño',
				CALC_TYPE: 'Tipo de cálculo',
				CALC_ORIGINAL: 'Original',
				CALC_AVERAGE: 'Promedio',
				CALC_MOVING_AVG: 'Promedio móvil',
				CALC_MAX: 'Máximo',
				CALC_MIN: 'Mínimo',
				CALC_SUM: 'Suma',
				CALC_MEDIAN: 'Mediana',
				CALC_MOVING_DELTA: 'Delta móvil',
				CALC_COUNT_EVENT: 'Contar evento',
				AGGREGATE: 'Agregar',
				AGGREGATE_WINDOW: 'Ventana de agregación',
				COUNT_WINDOW: 'Ventana de conteo',
				AGGREGATE_WINDOW_UNIT: 'Unidad de ventana de agregación',
				COUNT_WINDOW_UNIT: 'Unidad de ventana de conteo',
				WINDOW_SIZE: 'Tamaño de ventana',
				MINUTES: 'Minuto(s)',
				HOURS: 'Hora(s)',
				DAYS: 'Día(s)',
				WEEKS: 'Semana(s)',
				GREATER_THAN: 'Mayor que',
				LESS_THAN: 'Menor que',
				EQUAL_TO: 'Igual a',
				RESET_FILTER: 'Restablecer filtro',
				SELECT_AXIS: 'Seleccionar eje',
				X_AXIS: 'Eje X',
				Y_AXIS: 'Eje Y',
				SPEC_LABEL: 'Etiqueta (máx. 6 caracteres)',
				DESCRIPTION: 'Descripción',
				VALUE: 'Valor',
				ENABLE_TREND_CHART: 'Activar gráfico de tendencia',
				ADD_TITLE: 'Agregar título',
				ADD_SUBTITLE: 'Agregar subtítulo',
				UNIT: 'Unidad',
				SELECT_ICON: 'Seleccionar ícono',
				SEARCH_ICONS: 'Buscar íconos...',
				FORMULA: 'Fórmula',
				FORMULA_PLACEHOLDER: 'Escriba la fórmula, p.ej. (A+B)*C',
				ERROR_INVALID_VARS: 'Se usaron variable(s) inválidas',
				ERROR_INVALID_SYNTAX: 'Expresión matemática inválida',
				ERROR_FORMULA_REQUIRED: 'La fórmula es obligatoria',
				ERROR_LESS_THAN_THRESHOLD: "Este valor debe ser menor que el umbral 'Menor que'.",
				ERROR_GREATER_THAN_THRESHOLD: "Este valor debe ser mayor que el umbral 'Mayor que'.",
				SELECT_CHILDREN: 'Seleccionar elementos secundarios',
				AT_LEAST_ONE: 'Se debe seleccionar al menos 1 opción',
				TITLE_REQUIRED: 'El título es obligatorio',
				TITLE_DUPLICATE: 'Este título ya se usa en otra fórmula',
				ADD_A_TITLE: 'Agregar título',
				DELETE_BUTTON: 'Eliminar',
			},
			SENSOR_TABLE_CONFIG: {
				ADD_ROW: 'Agregar fila',
				ADD_COLUMN: 'Agregar columna',
				COLUMN_NAME: 'Nombre de columna',
				DELETE_COLUMN: 'Eliminar columna',
				DATE_FILTER: 'Filtro de fecha',
				ROWS: 'Filas',
				NUMBER_OF_ROWS: 'Número de filas',
				SELECT_TAG: 'Seleccionar etiqueta',
				CONFIGURE_TAG: 'Configurar etiqueta',
				DELETE_ROW: 'Eliminar fila',
				APPLY_DATE_FILTERS: 'Aplicar filtros de fecha a las columnas',
				NONE: 'Ninguno',
				SELECT_FY_START: 'Seleccionar primer día del año fiscal',
				CANCEL: 'Cancelar',
				APPLY: 'Aplicar',
				SEARCH_TAG: 'Buscar etiqueta...',
				NO_TAG_FOUND: 'No se encontró ninguna etiqueta',
				GREATER_THAN: 'Mayor que',
				LESS_THAN: 'Menor que',
				EQUAL_TO: 'Igual a',
				LESS_GREATER_ERROR: "El valor 'Menor que' debe ser mayor que el valor 'Mayor que'.",
				IGNORE_NULLS: 'Ignorar nulos',
				AGGREGATION: 'Agregación',
				DEFINE_COLOR: 'Definir valor de etiqueta para establecer color de texto',
				LESSER_THAN: 'Menor que',
				PICK_COLOR: 'Elegir color',
				COLOR: 'Color',
				LESSER_THAN_ERROR: 'El valor debe ser menor que el valor mayor definido.',
				GREATER_THAN_ERROR: 'El valor debe ser mayor que el valor menor definido.',
				BETWEEN: 'Entre',
				AND: 'Y',
				BETWEEN_RANGE_ERROR: 'Ingrese un rango válido: el valor inferior debe ser menor que el superior.',
			},
			RECENT: 'Reciente',
			FAVOURITES: 'Favoritos',
			CREATED_BY_ME: 'Creado por mí',
			TAB_ALL: 'Todos',
			TAB_MY_DASHBOARD: 'Mi panel',
			TAB_SHARED: 'Compartido',
			TAB_PRIVATE: 'Privado',
			ALL_DASHBOARDS: 'Todos los paneles',
			MY_DASHBOARDS: 'Mis paneles',
			SHARED_DASHBOARDS: 'Paneles compartidos',
			PRIVATE_DASHBOARDS: 'Paneles privados',
			COL_NAME: 'Nombre',
			COL_CREATED_ON: 'Creado el',
			COL_UPDATED_ON: 'Actualizado el',
			COL_OWNED_BY: 'Propietario',
			COL_SHARED: 'Compartido',
			COPY_LINK: 'Copiar enlace',
			RENAME: 'Renombrar',
			OPEN_IN_NEW_TAB: 'Abrir en nueva pestaña',
			SELECT: 'Seleccionar',
			SELECT_PERFORMANCE_CURVE: 'Seleccionar curva de rendimiento',
			MENU_EDIT_DASHBOARD: 'Editar panel',
			MENU_COPY_DASHBOARD: 'Copiar panel',
			MENU_PUBLISH: 'Publicar',
			MENU_UNPUBLISH: 'Despublicar',
			MENU_DELETE_DASHBOARD: 'Eliminar panel',
			MONGO: {
				SELECT_GRAPH_FIRST: '*Seleccione primero el tipo de gráfico',
				LABEL_USED: 'Etiqueta ya utilizada',
				REQUIRED: '*Obligatorio',
				DEFINE_RELATION: 'Definir relación',
				INVALID_VARIABLE: 'Variable inválida en la fórmula.',
				INVALID_RELATION: 'Relación inválida con la fuente.',
				INVALID_FORMULA_SYNTAX: 'Sintaxis de fórmula inválida.',
				SOURCE: 'Fuente',
				ATTRIBUTE: 'Atributo',
				DISPLAY_ATTRIBUTE: 'Mostrar atributo',
				GROUP_BY_ATTR: 'Agrupar por',
				AGGREGATION: 'Agregación',
				OPEN_FILTERS: 'Abrir filtros',
				REMOVE_COLUMN: 'Eliminar columna',
				ADD_ATTRIBUTE: 'Agregar atributo',
				RAW_ATTRIBUTE: 'Atributo sin procesar',
				CALC_ATTRIBUTE: 'Atributo calculado',
				ADD_RAW_ATTRIBUTE_COL: 'Agregar columna de atributo sin procesar',
				ADD_CALC_ATTRIBUTE_COL: 'Agregar columna de atributo calculado',
				GROUP_BY: 'Agrupar por',
				GROUP_DISPLAY_TYPE: 'Tipo de visualización de grupo',
				SORT_BY: 'Ordenar por',
				SORT_ASC: 'A → Z',
				SORT_DESC: 'Z → A',
				SIDE_BY: 'Lado a lado',
				NA: 'N/A',
				STACK_BY: 'Apilar por',
				NO_OF_BINS: 'Número de bins',
				SLICERS: 'Filtros (seleccionar hasta {{limit}})',
				SELECT_UP_TO: 'Seleccionar hasta',
				DRILL_DOWN: 'Desglose',
				DRILL_DOWN_ATTRS: 'Atributos para desglose (seleccionar hasta {{limit}})',
				SELECT_ATTRS: 'Seleccionar atributos',
			},
			TAG_AGG: {
				SELECT_TAG: 'Seleccionar etiqueta',
				SELECT_AGGREGATE_TYPE: 'Seleccionar tipo de agregación',
				ENABLE_AGGREGATE: 'Habilitar agregación',
			},
			SIDE_PANEL: {
				SETTINGS: 'Configuración',
				SAVE: 'Guardar',
				CLOSE: 'Cerrar',
				PANEL: 'Panel',
				AXIS: 'Eje',
				GRAPH_OPTIONS: 'Opciones de gráfico',
				SELECT_CONFIG_TYPE: 'Seleccionar tipo de configuración',
				EXCEL_CONFIG: 'Configuración Excel',
				TAG_GROUP: 'Grupo de etiquetas',
				PANEL_DESCRIPTION: 'Descripción del panel',
				X_AXIS_MIN: 'Mín. eje X',
				X_AXIS_MAX: 'Máx. eje X',
				X_AXIS_UNIT: 'Unidad eje X',
				Y_AXIS_UNIT: 'Unidad eje Y',
				SHOW_LEGEND: 'Mostrar leyenda',
				OVERLAP_LEGENDS: 'Superponer leyendas',
				TABLE_MODE: 'Modo tabla',
				TITLE_COLOR: 'Color del título',
				BORDER_COLOR: 'Color del borde',
				TREND_CHART_COLOR: 'Color del gráfico de tendencia',
				UPLOAD: 'Cargar',
				DOWNLOAD: 'Descargar',
				UPLOAD_BASE_CURVE: 'Cargar curva base',
				BASE_CURVE_FORMAT: 'Formato de curva base',
				DELETE_CURVE_GRAPH: 'Eliminar gráfico de curva',
			},
			SINGLE_STATS: {
				ADD_STAT: 'Agregar estadística',
				COLOR_PICKER: 'Selector de color',
				COLOR_TITLE: 'Título',
				COLOR_BORDER: 'Borde',
				COLOR_ICON: 'Icono',
				COLOR_ICON_OUTLINE: 'Contorno de icono',
				NO_ICON_FOUND: 'No se encontró ningún icono coincidente',
			},
		},
		SCHEDULER: {
			LIST: {
				TITLE: 'Lista de programaciones',
				HEADER_TITLE: 'Programador de informes',
				NEW_SCHEDULER_TOOLTIP: 'Crear nueva programación',
				NEW_SCHEDULER: 'Nueva programación',
				COL_TITLE: 'Título',
				COL_MEDIUM: 'Medio',
				COL_SUBJECT: 'Asunto',
				COL_RUNS: 'Ejecuciones',
				COL_MODIFIED_ON: 'Modificado el',
				COL_CREATED_ON: 'Creado el',
				COL_ACTIONS: 'Acciones',
				EDIT_TOOLTIP: 'Editar programación',
				DELETE_TOOLTIP: 'Eliminar programación',
				MEDIUM_EMAIL: 'Correo electrónico',
				MEDIUM_SMS: 'SMS',
				MEDIUM_CALL: 'Llamada',
				SCHEDULER_DELETED: 'Programación eliminada',
				DELETE_FAILED: 'Error al eliminar',
				OKAY: 'Aceptar',
				NO_REPORT: 'No se encontraron informes'
			},
			DETAILS: {
				TITLE: 'Programación',
				CREATE_TITLE: 'Crear programación',
				EDIT_DETAILS_TITLE: 'Editar detalles',
				SCHEDULE_DETAILS_TITLE: 'Detalles de la programación',
				CANCEL: 'Cancelar',
				SAVE: 'Guardar',
				SELECT_FACILITY: 'Seleccionar instalación',
				LOADING: 'Cargando...',
				SCHEDULE_RECURRING_REPORTS: 'Programar informes recurrentes',
				MONTHS: 'Meses',
				ALL: 'Todos',
				DAY: 'Día',
				EVERY: 'Cada',
				TH_DAY: 'º día',
				WEEKDAYS: 'Días de la semana',
				TIME: 'Hora',
				SELECT_TIME: 'Seleccionar hora',
				HOUR: 'Hora',
				MINUTE: 'Minuto',
				FILE_NAME_LABEL: 'Nombre del archivo',
				REPORT_NAME_LABEL: 'Nombre del informe',
				ENTER_NAME: 'Ingresar nombre',
				REPORT_TITLE: 'Título del informe (máx. 20 caracteres)',
				ENTER_TITLE: 'Ingresar título',
				REPORTING_INTERVAL: 'Intervalo de informes',
				MEDIUM: 'Medio',
				TEMPLATE_NAME: 'Nombre de la plantilla',
				SUBJECT: 'Asunto',
				ENTER_SUBJECT: 'Ingresar asunto',
				SELECT_USERS: 'Seleccionar usuarios',
				SEARCH_BY_EMAIL: 'Buscar por direcciones de correo',
				NO_MATCHING_EMAIL: 'No se encontró ninguna dirección de correo coincidente',
				ADD_EMAILS_LABEL: 'Agregar direcciones de correo separadas por comas',
				OKAY: 'Aceptar',
				SELECT_AT_LEAST_ONE_UNIT: 'Seleccione al menos una unidad',
				SELECT_AT_LEAST_ONE_SYSTEM: 'Seleccione al menos un sistema',
				SELECT_USER_OR_EMAIL: 'Seleccione al menos un usuario o agregue direcciones de correo',
				INVALID_EMAILS: 'Se ingresaron direcciones de correo no válidas',
			},
			TEMPLATES: {
				DAILY_REPORT: 'Informe diario',
				BIWEEKLY_REPORT: 'Informe quincenal',
				KPI_REPORT_THERMAL: 'Informe de KPI - Térmico',
				ALERT_STATUS_UPDATE_REPORT: 'Informe de actualización de estado de alertas',
				DATA_QUALITY_REPORT: 'Informe de calidad de datos',
				DATA_LAG_REPORT: 'Informe de retraso de datos',
				IOW_REPORT: 'Informe IOW',
				SERVER_EXCEPTION_REPORT: 'Informe de excepciones del servidor',
			},
			REPORTING_INTERVALS: {
				LAST_8_HOURS: 'Últimas 8 horas',
				LAST_12_HOURS: 'Últimas 12 horas',
				LAST_24_HOURS: 'Últimas 24 horas',
				TODAY: 'Hoy',
				YESTERDAY: 'Ayer',
				LAST_7_DAYS: 'Últimos 7 días',
				THIS_WEEK: 'Esta semana',
				PREVIOUS_WEEK: 'Semana anterior',
				LAST_15_DAYS: 'Últimos 15 días',
				LAST_30_DAYS: 'Últimos 30 días',
				THIS_MONTH: 'Este mes',
				PREVIOUS_MONTH: 'Mes anterior',
				THIS_QUARTER: 'Este trimestre',
				PREVIOUS_QUARTER: 'Trimestre anterior',
				LAST_3_MONTHS: 'Últimos 3 meses',
				LAST_6_MONTHS: 'Últimos 6 meses',
				LAST_12_MONTHS: 'Últimos 12 meses',
				THIS_YEAR: 'Este año',
				PREVIOUS_YEAR: 'Año anterior',
			},
		},
		ANALYSIS_VIEWS: {
			UNABLE_TO_CREATE_ANALYSIS_TEMPLATE: 'No se puede crear una plantilla de análisis a partir de múltiples instalaciones',
			TITLE: 'Análisis y vistas',
			CLOSE: 'Cerrar',
			EXPORT_TO_EXTERNAL: 'Exportar etiquetas seleccionadas a sistema externo',
			SAVED_ANALYSIS: 'Análisis guardado',
			CREATE_NEW: 'Crear nuevo',
			SAVED_VIEWS: 'Vistas guardadas',
			SAVE_CURRENT_VIEW: 'Guardar vista actual',
			SAVE_DISABLED_TOOLTIP: 'Solo el propietario de la alerta puede guardar o modificar vistas de etiquetas.',
			TEMPLATE_TAG: '[Plantilla]',
			SNAPSHOT_TAG: '[Instantánea]',
			EDIT: 'Editar',
			DELETE: 'Eliminar',
			SAVED_DASHBOARDS: 'Paneles guardados',
			NO_DASHBOARDS: 'No hay paneles guardados disponibles',
		},
		THRESHOLD_PANEL: {
			TITLE: 'Umbral',
			CLOSE: 'Cerrar',
			ONGOING: 'En curso',
			SHOW_LESS: 'Mostrar menos',
			SEE_MORE: 'Ver más',
		},
		ACTIVITY_LOGS: {
			TITLE: 'Registros de actividad',
			ACTIONS: 'Acciones ({{count}})',
			CLOSE: 'Cerrar',
			SEARCH_PLACEHOLDER: 'Buscar...',
		},
		FEEDBACK_RIGHT_NAV: {
			TITLE: 'Comentarios',
			CLOSE: 'Cerrar',
			APPROVED: 'Aprobado',
			RELEARNED: 'Reaprendido',
			QUOTE_APPROVED_HYPOTHESIS: 'Hipótesis aprobada',
			QUOTE_RELEARNED_HYPOTHESIS: 'Hipótesis reaprendida',
			QUOTE_APPROVED_CAUSAL: 'Paso de cadena causal aprobado',
			QUOTE_RELEARNED_CAUSAL: 'Paso de cadena causal reaprendido',
			QUOTE_APPROVED_RECOMMENDATION: 'Recomendación aprobada',
			QUOTE_RELEARNED_RECOMMENDATION: 'Recomendación reaprendida',
			QUOTE_OTHER: 'Otro',
			FILE_ALT: 'Archivo',
			EMPTY_HEADING: 'No hay comentarios disponibles',
			EMPTY_CONTENT: 'Apruebe o reaprenda para agregar un comentario.',
		},
		DISCUSSION: {
			TITLE: 'Discusión',
			COMMENTS_COUNT: 'Comentarios ({{count}})',
			CLOSE: 'Cerrar',
			CREATE_CASE_TITLE: 'Cree un caso para gestionar el seguimiento',
			CREATE_CASE: 'Crear caso',
			BACK: 'Atrás',
			THREAD_BY: 'Hilo por',
			SEARCH_PLACEHOLDER: 'Buscar...',
			NO_COMMENTS_HEADING: 'No hay comentarios aquí',
			NO_COMMENTS_BODY: 'Deje su primer comentario para iniciar la discusión sobre este tema.',
			EDITED: 'Editado',
			RCA_VERSION_DELETED: 'Versión de RCA eliminada',
			COMMENT_DELETED: 'Este comentario fue eliminado.',
			COMMENT_DELETED_ALT: 'Este comentario ha sido eliminado.',
			REPLY_SINGULAR: 'respuesta',
			REPLY_PLURAL: 'respuestas',
			LAST_REPLY: 'Última respuesta',
			REPLY_PROMPT: 'Responder...',
			COMMENT_PLACEHOLDER: 'Agregue un comentario, use @ para etiquetar miembros del equipo',
			REPLY_TO_COMMENT_PLACEHOLDER: 'Responder al comentario...',
		},
		RETRAIN_MODEL: {
			TITLE: 'Reentrenar Modelo',
			CLOSE: 'Cerrar',
			CURRENT_MODEL_DETAILS: 'Detalles del modelo actual',
			DEPLOYED_VERSION_LABEL: 'Versión desplegada - Fecha / Hora',
			LAST_PREDICTION_LABEL: 'Última predicción - Fecha / Hora',
			FORM_ERROR: '¡Vaya! Cambie algunas cosas y vuelva a intentarlo.',
			TRAINING_PERIOD: 'Período de entrenamiento',
			DATE_RANGE_SELECTION_METHOD: 'Método de selección de rango de fechas',
			SELECT_TRAINING_MODE_ARIA: 'Seleccionar modo de selección de entrenamiento',
			CALENDAR_SELECTION: 'Selección de calendario',
			CHART_BASED_SELECTION: 'Selección basada en gráfico',
			VIEW_EDIT_NOTE: 'Ver / Editar Nota',
			ADD_NOTE: 'Agregar Nota',
			ADD_TRAINING_RANGE: 'Agregar rango de entrenamiento',
			DELETE_TRAINING_RANGE: 'Eliminar rango de entrenamiento',
			ADVANCED_SETTINGS: 'Configuración avanzada',
			BAND_LEARNING_BEHAVIOUR: 'Comportamiento de aprendizaje de banda',
			SELECT_BAND_LEARNING_ARIA: 'Seleccionar comportamiento de aprendizaje de banda',
			CONSERVATIVE_TOOLTIP: 'Crea bandas más estrechas alrededor de la región de entrenamiento seleccionada',
			CONSERVATIVE: 'Conservador',
			MODERATE_TOOLTIP: 'Crea bandas equilibradas alrededor de la región de entrenamiento seleccionada',
			MODERATE: 'Moderado',
			AGGRESSIVE_TOOLTIP: 'Crea bandas más amplias alrededor de la región de entrenamiento seleccionada',
			AGGRESSIVE: 'Agresivo',
			PREDICTION_SMOOTHING_SETTINGS: 'Configuración de suavizado de predicción',
			SMOOTHING: 'Suavizado',
			WINDOW_SIZE: 'Tamaño de ventana',
			WINDOW_SIZE_PLACEHOLDER: 'Tamaño de ventana (en horas)',
			VALUE_IS: 'El valor es',
			REQUIRED: 'obligatorio',
			VALUE_MIN: 'El valor debe ser mayor o igual a',
			POLYNOMIAL_ORDER: 'Orden polinómico',
			SIGMA: 'Sigma',
			SELECT_ATTENTION_TAGS: 'Seleccionar etiquetas de atención',
			SEARCH_PLACEHOLDER: 'Buscar...',
			NO_MATCHING_TAGS: 'No se encontraron etiquetas coincidentes',
			SHOW_ALL_TAGS: 'Mostrar todas las etiquetas',
			SHOW_ATTENTION_TAGS_ONLY: 'Mostrar solo etiquetas de atención',
			MODELING_TECHNIQUE: 'Técnica de modelado',
			AUTO_ENCODER: 'Auto Encoder',
			ATTENTION_AUTO_ENCODER: 'Attention Auto Encoder',
			CANCEL_TOOLTIP: 'Cancelar cambios',
			CANCEL: 'Cancelar',
			RETRAIN_DEPLOY_TOOLTIP: 'Reentrenar e implementar',
		},
		ROOT_CAUSE_RECOMMENDATION: {
			CLOSE: 'Cerrar',
			ICON_ALT: 'Icono de causa raíz',
			NOT_GENERATED_MESSAGE: 'Aún no ha generado el análisis de causa raíz. Genérelo para continuar.',
			FAILED_MESSAGE: 'Su último análisis de causa raíz falló.<br> Genérelo nuevamente para continuar.',
			GENERATE_NOW: 'Generar ahora',
			REFRESH: 'Actualizar',
			LAST_GENERATED: 'Generado por última vez',
			GENERATING: 'Generando análisis de causa raíz',
			LOADER_ALT: 'cargando',
			LIKE_ALT: 'Me gusta',
			DISLIKE_ALT: 'Icono de no me gusta',
			MONETARY_VALUE: 'Valor monetario',
			FAILURE_HISTORY: 'Historial de fallas',
			INFO_CARD_ARIA: 'Tarjeta de información',
			PREVIOUS_FAILURE_MODES: 'Modos de falla anteriores',
			HYPOTHESIS_PREFIX: 'Hipótesis',
			MOST_LIKELY: '(Más probable)',
			CASCADES_AS_FOLLOWS: '.Esta causa raíz probablemente se propaga de la siguiente manera:',
			AGREE: 'De acuerdo',
			PARTIALLY_AGREE: 'Parcialmente de acuerdo',
			DISAGREE: 'En desacuerdo',
			TELL_US_MORE: 'Cuéntenos más:',
			FEEDBACK_PLACEHOLDER: 'Siéntase libre de agregar detalles específicos',
			CANCEL: 'Cancelar',
			SUBMIT: 'Enviar',
		},
		RIGHT_PANEL_DOCUMENTS: {
			TITLE: 'Documentos',
			CLOSE: 'Cerrar',
			SEARCH_PLACEHOLDER: 'Buscar...',
			FILTER_TAGS: 'Filtrar etiquetas',
			EMPTY_HEADING: 'No hay documentos disponibles',
		},
		MONETORY_VALUE_DIALOG: {
			TITLE: 'Valores Monetarios',
			CURRENCY_HINT: 'Los valores monetarios se ingresan en {{currency}}',
			RELIABILITY: 'Confiabilidad',
			MAINTENANCE: 'Mantenimiento',
			PERFORMANCE: 'Rendimiento',
			POTENTIAL_SUFFIX: ' (Potencial)',
			ENTER_VALUE: 'Ingrese el valor',
			COMMENT_REQUIRED_ERROR: 'El comentario no puede estar vacío.',
			AMOUNT_REQUIRED_ERROR: 'Debe ingresar al menos un valor.',
			COMMENT: 'Comentario',
			COMMENT_PLACEHOLDER: 'Agregue su comentario',
			CANCEL: 'Cancelar',
			SAVE: 'Guardar',
		},
		FAILURE_MODE_DETAILS: {
			TITLE: 'Detalles del modo de falla',
			OPEN_ALERT: 'Abrir alerta',
			TTF_ALT: 'TTF',
			ADD_MONETARY_VALUE: 'Agregar valor monetario',
			CMMS_NUMBER_TOOLTIP: 'Número CMMS',
			MORE_SUFFIX: 'más',
			ADD_CMMS_NUMBER: 'Agregar número CMMS',
			BREAKDOWN_CATEGORY: 'Categoría de desglose',
			BREAKDOWN_COMPONENT: 'Componente de desglose',
			ERROR_LABEL: 'Error',
			TAG_CHARTS_SUFFIX: 'gráficos de etiquetas',
		},
		DATA_QUALITY_PANEL: {
			TITLE: 'Calidad de Datos',
			CLOSE: 'Cerrar',
			SEE_LESS: 'Ver menos',
			SEE_MORE: 'Ver más',
		},
		FAILURE_TIMELINE_PANEL: {
			SORT_BY: 'Ordenar por:',
			ASSET: 'Activo:',
			REASON: 'Motivo:',
			RECOMMENDATIONS: 'Recomendaciones:',
			NA: 'NA',
		},
		REPORT_ISSUE_SIDEPANEL: {
			TITLE: 'Reportar un problema',
			SUBTITLE: 'Cuéntenos qué salió mal con el agente de RCA.',
			CLOSE: 'Cerrar',
			WARNING_BANNER: 'Esto no actualizará ni volverá a ejecutar el RCA actual. Para mejorar una hipótesis, cadena causal o recomendación, use las opciones de comentarios dentro del RCA.',
			SECTION_TITLE: '¿Qué salió mal?',
			SECTION_HINT: 'Seleccione todo lo que corresponda.',
			ISSUES_ERROR: 'Seleccione al menos una opción.',
			DETAILS_ERROR: 'Agregue detalles sobre el problema que experimentó.',
			DETAILS_LABEL_REQUIRED: 'Detalles adicionales (Requerido)',
			DETAILS_LABEL_OPTIONAL: 'Detalles adicionales (Opcional)',
			DETAILS_PLACEHOLDER: 'Por ejemplo, el RCA identificó la tendencia de presión correcta pero concluyó que la bomba causó el evento, aunque el historial de mantenimiento indicaba una falla de válvula.',
			DISCLAIMER: 'Al enviar este informe, los datos relevantes del RCA y los registros de actividad se compartirán con el equipo autorizado de UptimeAI para su investigación.',
			CANCEL: 'Cancelar',
			SUBMIT_REPORT: 'Enviar Informe',
			RUN_RCA_FIRST: 'Ejecute un RCA antes de reportar un problema con el agente.',
			SUBMITTED_SUCCESS: 'Problema reportado con éxito',
			SUBMIT_FAILED: 'Error al reportar el problema. Inténtelo de nuevo.',
			OPT_PLATFORM_DATA_LABEL: 'No se consideraron datos relevantes de la plataforma',
			OPT_PLATFORM_DATA_HINT: 'El RCA no utilizó todas las alertas, etiquetas, tendencias, eventos u otros datos relevantes disponibles en la plataforma.',
			OPT_EVIDENCE_LABEL: 'Los documentos o evidencias no se consideraron correctamente',
			OPT_EVIDENCE_HINT: 'Los documentos cargados, la evidencia propuesta u otra información de respaldo fueron ignorados o interpretados incorrectamente.',
			OPT_USER_INPUT_LABEL: 'Mi aporte no se consideró adecuadamente',
			OPT_USER_INPUT_HINT: 'El RCA no consideró adecuadamente el contexto, las instrucciones, notas o comentarios que proporcioné durante esta investigación o en ejecuciones anteriores.',
			OPT_CAUSAL_LABEL: 'El razonamiento causal fue incorrecto',
			OPT_CAUSAL_HINT: 'El RCA consideró información relevante pero llegó a una conclusión incorrecta.',
			OPT_WEIGHTED_LABEL: 'La evidencia se ponderó incorrectamente',
			OPT_WEIGHTED_HINT: 'El RCA se centró demasiado en un dato y no consideró suficientemente otra evidencia importante.',
			OPT_UNSUPPORTED_LABEL: 'Una conclusión no estuvo respaldada por evidencia',
			OPT_UNSUPPORTED_HINT: 'El RCA generó una afirmación o conclusión sin datos o evidencia de respaldo suficientes.',
			OPT_RECOMMENDATION_LABEL: 'La recomendación no fue viable',
			OPT_RECOMMENDATION_HINT: 'La recomendación fue demasiado general, poco práctica o no útil operativamente.',
			OPT_UNCLEAR_LABEL: 'La explicación no fue clara',
			OPT_UNCLEAR_HINT: 'El razonamiento fue difícil de entender o no proporcionó suficiente justificación.',
			OPT_OTHER_LABEL: 'Otro',
			OPT_OTHER_HINT: 'Reporte un problema que no esté listado arriba.',
		},
		LIBRARY: {
			TITLE: 'Biblioteca',
			SUBTITLE: 'Planos P&ID y documentos de ingeniería (manuales, hojas de datos, listas de alarmas / disparos) en un solo lugar.',
			SEARCH: 'Buscar planos, documentos, equipos o un tag (p. ej. PT-0940)…',
			TAB_PIDS: 'P&ID',
			TAB_DOCS: 'Manuales y datos',
			PIDS: {
				LOADING: 'Cargando planos…',
				FAILED: 'No se pudieron cargar los planos.',
				LOCATED: 'Planos que muestran {{tag}}',
				NOT_LOCATED: '{{tag}} no aparece en ningún plano indexado.',
				NO_MATCH: 'Ningún plano coincide con la búsqueda.',
				TAGS: '{{count}} tags',
				PICK: 'Elija un plano a la izquierda o busque un tag para encontrar los planos que lo muestran.',
				VIEW_DRAWING: 'Plano',
				VIEW_PDF: 'PDF completo',
				PDF_LOADING: 'Cargando el PDF…',
				PDF_FAILED: 'El PDF de este plano no está disponible.',
				OTHER: 'Otros planos',
				REFERENCE: 'Leyendas e índices de planos',
			},
			DOCS: {
				LOADING: 'Cargando documentos…',
				FAILED: 'No se pudieron cargar los documentos.',
				EMPTY: 'No hay documentos.',
				NO_MATCH: 'Ningún documento coincide con la búsqueda.',
				PICK: 'Elija un documento para leerlo aquí.',
				GROUP_ITEM: 'En esta ubicación',
				GROUP_ABOVE: 'De {{floc}}',
				GROUP_BELOW: 'Debajo de esta ubicación',
				GROUP_TYPE: '{{type}}',
			},
		},
		ASSET_EXPLORER: {
			FLOC: {
				TITLE: 'Árbol de activos de {{facility}} (ubicaciones técnicas SAP)',
				SEARCH_PLACEHOLDER: 'Buscar UT, equipo o tag del historiador…',
				SEARCH_HINT: 'Los activos coincidentes aparecen abajo; elija una sugerencia de tag para mostrarlo en el P&ID.',
				HIDE_EMPTY: 'Ocultar ubicaciones sin tags',
				HIDE_EMPTY_HINT: 'Oculta las ubicaciones técnicas sin tags del historiador en su subárbol. Los paquetes y los grupos sin asignar se muestran siempre.',
				NODE_HITS: 'Activos coincidentes ({{count}})',
				CLOSE_HITS: 'Cerrar resultados',
				NODE_SEARCH_FAILED: 'La búsqueda de activos falló. Inténtelo de nuevo.',
				NO_NODE_HITS: 'Ningún activo coincide con «{{query}}».',
				REVEAL_FAILED: 'No se pudo abrir este activo en el árbol.',
				TREE_EMPTY: 'El árbol de activos está vacío.',
				TREE_HIDDEN: '{{count}} ubicaciones sin tags ocultas',
				CHILDREN_FAILED: 'No se pudieron cargar los hijos de este nodo.',
				CHILDREN_HIDDEN: 'Hay {{count}} ubicaciones hijas sin tags del historiador ocultas.',
				COUNT_TIP: '{{count}} tags del historiador en este subárbol',
				PATH: 'Ruta del activo',
				UNASSIGNED_NAME: 'Tags sin asignar',
				UNASSIGNED_TIP: 'Tags del historiador sin UT ni paquete, agrupados por el código de sistema del nombre del tag',
				UNASSIGNED_NOTE: 'Estos tags del historiador no tienen ubicación técnica SAP ni paquete de equipos. Se agrupan aquí solo por el código de sistema del nombre del tag (o a nivel de sitio si no lo hay); su equipo es desconocido.',
				PACKAGE_NOTE: 'Paquete de equipos rotativos: sus tags están asignados al paquete en conjunto, no a una sola ubicación técnica SAP.',
				LEVEL_SITE: 'Sitio',
				LEVEL_SYSTEM: 'Sistema',
				LEVEL_SUBSYSTEM: 'Subsistema',
				LEVEL_EQUIPMENT: 'Equipo',
				LEVEL_PACKAGE: 'Paquete',
				LEVEL_UNASSIGNED: 'Sin asignar',
				KIND_FLOC: 'Ubicación técnica SAP',
				KIND_PACKAGE: 'Paquete de equipos',
				KIND_UNASSIGNED: 'Grupo de tags sin asignar',
				SUBTREE_TAGS: '{{count}} tags en el subárbol',
				LOOP_TAGS_BADGE: '{{count}} tags de paquete del mismo lazo',
				PIDS_SHOWING: 'En {{count}} P&ID',
				PROP_FLOC: 'Código UT',
				PROP_CODE: 'Código de paquete',
				PROP_LEVEL: 'Nivel',
				PROP_KIND: 'Tipo',
				PROP_LOOP: 'Número de lazo',
				PROP_OWN_TAGS: 'Tags en este nodo',
				PROP_SUBTREE_TAGS: 'Tags en el subárbol',
				WITH_DATA: '{{count}} con datos',
				N_TAGS: '{{count}} tags',
				INCLUDE_SUBTREE: 'Incluir subárbol',
				TAGS_OWN_NOTE: 'Tags ubicados directamente en este nodo.',
				TAGS_SUBTREE_NOTE: 'Tags ubicados en este nodo y en todos los nodos inferiores.',
				DETAIL_FAILED: 'No se pudo cargar este nodo. Inténtelo de nuevo.',
				NO_OWN_TAGS: 'No hay tags del historiador ubicados en este nodo.',
				NO_OWN_TAGS_LOOP: 'No hay tags del historiador en la propia ubicación técnica; abajo se listan los tags de paquete que comparten su número de lazo.',
				TRUNCATED: 'Se muestran los primeros {{shown}} de {{total}} tags.',
				FILTER_TAGS: 'Filtrar tags…',
				NO_FILTER_MATCH: 'Ningún tag coincide con el filtro.',
				COL_RULE: 'Regla de ubicación',
				COL_DATA: 'Datos',
				PLACED_AT: 'En',
				LOOP_TITLE: 'Tags de paquete con este número de lazo ({{count}})',
				LOOP_EXPLAIN: 'Estos tags pertenecen a paquetes de equipos rotativos, no a esta ubicación técnica. Se muestran porque su nombre lleva el número de lazo {{loop}}, el mismo que este equipo. No se cuentan en los totales de tags de este nodo.',
				LOOP_GROUP: 'Lazo {{loop}} · paquete {{package}} ({{count}})',
				OPEN_PACKAGE: 'Abrir paquete',
				PID_GROUP_NODE: 'Muestra {{name}}',
				PID_NODE_FOUND: '{{name}} (su símbolo de equipo o sus tags) aparece en {{count}} plano(s).',
				PID_NODE_NONE: 'Ningún P&ID digitalizado muestra {{name}} ni sus primeros tags.',
				CHIPS_MORE: 'Se muestran {{shown}} de {{total}} tags del nodo; añada otros desde la tabla de Resumen o la búsqueda.',
				RULE_FLOC_CURATED: 'UT (curada)',
				RULE_FLOC_CURATED_HINT: 'UT de la hoja curada de asignación tag–equipo.',
				RULE_FLOC_BACKFILLED: 'UT (completada)',
				RULE_FLOC_BACKFILLED_HINT: 'UT de la asignación tag–activo del historiador, usada cuando la hoja curada no tiene ninguna.',
				RULE_FLOC_WELL: 'UT por pozo submarino',
				RULE_FLOC_WELL_HINT: 'Tag submarino ubicado en la UT del árbol de producción de su pozo (o la UT del pozo) según el número de pozo del nombre.',
				RULE_FLOC_LOOP: 'UT por número de lazo',
				RULE_FLOC_LOOP_HINT: 'Ubicado en la única UT de equipo cuyo código termina en el número de lazo del tag.',
				RULE_PACKAGE_PREFIX: 'Paquete por prefijo',
				RULE_PACKAGE_PREFIX_HINT: 'Asignado a un paquete de equipos; ubicado bajo el subsistema codificado en el nombre del tag.',
				RULE_PACKAGE_SITE: 'Paquete (sitio)',
				RULE_PACKAGE_SITE_HINT: 'Asignado a un paquete de equipos; el nombre no codifica subsistema, así que queda a nivel de sitio.',
				RULE_UNASSIGNED: 'Sin asignar (prefijo)',
				RULE_UNASSIGNED_HINT: 'Sin UT ni paquete; agrupado bajo el subsistema codificado en el nombre del tag.',
				RULE_SITE: 'Sitio',
				RULE_SITE_HINT: 'Sin UT, paquete ni código de subsistema; se mantiene a nivel de sitio.',
			},
			TITLE: 'Jerarquía de activos de {{facility}}',
			BREADCRUMB: 'Explorador de activos',
			RELOAD: 'Recargar',
			LOADING_TREE: 'Cargando jerarquía de activos…',
			LOAD_FAILED: 'No se pudo cargar la jerarquía de activos. Inténtelo de nuevo.',
			SEARCH_PLACEHOLDER: 'Buscar equipo o tag del historiador…',
			SEARCH_HINT: 'Escribir filtra el árbol; elija un tag para verlo en el P&ID.',
			TREE_EMPTY: 'Ningún activo coincide con la búsqueda.',
			EXPAND: 'Expandir',
			COLLAPSE: 'Contraer',
			LEVEL_KICKER: 'Nivel {{level}}',
			NODE_ID: 'ID',
			TAGS_MAPPED: '{{count}} tags del historiador',
			PIDS_LINKED: '{{count}} P&ID vinculados',
			TAB_OVERVIEW: 'Resumen',
			TAB_PID: 'P&ID',
			TAB_TELEMETRY: 'Series temporales',
			TAB_DOCS: 'Documentos',
			DOCS: {
				VIEW: 'Documentos ({{count}})',
				HINT: 'Manuales, hojas de datos y listas de alarmas / disparos de {{name}} y de las ubicaciones superiores.',
				ALSO_PIDS: 'También en {{count}} hojas P&ID',
				OPEN_LIBRARY: 'Abrir la biblioteca',
				EMPTY: 'No hay documentos vinculados a esta ubicación ni a las superiores.',
			},
			OPEN_KG: 'Abrir en el grafo de conocimiento',
			VIEW_ALERTS: 'Ver alertas',
			VIEW_PID: 'Ver P&ID',
			VIEW_TELEMETRY: 'Ver series temporales',
			DESCRIPTION: 'Descripción',
			NO_DESCRIPTION: 'No hay descripción registrada para este activo.',
			CHILDREN: 'Activos hijos ({{count}})',
			PROPERTIES: 'Propiedades',
			TAGS_TITLE: 'Tags del historiador ({{count}})',
			NO_TAGS: 'No hay tags del historiador asignados a este activo.',
			COL_TAG: 'Tag',
			COL_COMPONENT: 'Componente',
			COL_RANGE: 'Rango operativo',
			COL_UNIT: 'Unidad',
			COL_ACTIONS: 'Acciones',
			LOCATE_ON_PID: 'Mostrar en el P&ID',
			PLOT: 'Graficar',
			NO_SELECTION: 'Seleccione un activo en la jerarquía o busque un tag.',
			LEVEL: {
				FACILITY: 'Instalación',
				SYSTEM: 'Sistema',
				SUBSYSTEM: 'Subsistema',
				EQUIPMENT: 'Equipo',
				COMPONENT: 'Componente',
				INSTRUMENT: 'Instrumento',
			},
			PID: {
				SHEET: 'Plano',
				SEARCH_SHEETS: 'Buscar planos…',
				SEARCH_ON_DRAWING: 'Buscar un tag en este plano…',
				NO_MATCHES: 'Ningún tag de este plano coincide.',
				FILTER_ALL: 'Todos',
				FILTER_INSTRUMENTS: 'Instrumentos',
				FILTER_EQUIPMENT: 'Equipos',
				FILTER_NONE: 'Ninguno',
				GROUP_LOCATED: 'Planos que muestran {{tag}}',
				GROUP_NODE: 'Vinculados a {{name}}',
				GROUP_ALL: 'Todos los planos ({{count}})',
				SOURCE_DIGITISED: 'digitalizado',
				SOURCE_TEXT: 'indexado por texto',
				SOURCE_NEEDS_OCR: 'requiere OCR',
				SOURCE_CATALOGUED: 'catalogado',
				SOURCE_BLANK: 'sin texto',
				DETECTIONS: '{{count}} elementos',
				LOCATING: 'Buscando {{tag}} en los P&ID…',
				LOCATE_FAILED: 'No se pudo buscar {{tag}} en los P&ID.',
				NOT_ON_PID: '{{tag}} no aparece en ningún P&ID digitalizado.',
				FOUND_ON: '{{tag}} aparece en {{count}} plano(s)',
				CLEAR_LOCATE: 'Borrar',
				TYPE_INSTRUMENT: 'Instrumento',
				TYPE_EQUIPMENT: 'Equipo',
				CONFIDENCE: '{{pct}} % de confianza',
				CANONICAL: 'Tag canónico',
				HISTORIAN_TAG: 'Tag del historiador',
				NOT_LINKED: 'No vinculado a un tag del historiador',
				PLOT: 'Graficar en series temporales',
			},
			PID_VIEWER: {
				ZOOM_IN: 'Acercar',
				ZOOM_OUT: 'Alejar',
				FIT: 'Ajustar a la vista',
				FOCUS_HIGHLIGHT: 'Ir al tag resaltado',
				FULLSCREEN: 'Pantalla completa',
				EXIT_FULLSCREEN: 'Salir de pantalla completa',
				LOADING: 'Cargando plano…',
				NO_DRAWING: 'No hay ningún plano seleccionado.',
				LOAD_FAILED: 'No se pudo cargar este plano.',
				NO_IMAGE: 'No hay imagen para este plano',
				NO_IMAGE_HINT: 'El plano está digitalizado ({{count}} elementos, {{highlighted}} resaltados) pero su imagen no está disponible.',
				PAN_HINT: 'Arrastre para desplazar · desplace para ampliar',
				ASPECT_WARNING: 'Los tamaños de imagen y plano difieren; los recuadros pueden estar desplazados.',
				HISTORIAN_TAG: 'Tag del historiador',
				NOT_LINKED: 'No vinculado',
				CLICK_HINT: 'Haga clic para seleccionar',
				UNTAGGED: 'Elemento sin tag',
			},
			TAG_SEARCH: {
				SEARCHING: 'Buscando…',
				FAILED: 'La búsqueda de tags falló. Inténtelo de nuevo.',
				NO_RESULTS: 'Ningún tag del historiador coincide con «{{query}}».',
				HAS_DATA: 'Con datos',
				NO_DATA: 'Sin datos',
				ALREADY_ADDED: 'Ya seleccionado',
			},
			TELEMETRY: {
				ACTIVE_TAGS: 'Tags en el gráfico ({{count}} / {{max}})',
				SEARCH_PLACEHOLDER: 'Buscar tags del historiador para añadir…',
				DROPPED: 'Máximo {{max}} tags: se quitó {{tag}} para hacer espacio.',
				REMOVE: 'Quitar del gráfico',
				WINDOW: 'Ventana de tiempo',
				WINDOW_7D: '7 d',
				WINDOW_30D: '30 d',
				WINDOW_90D: '90 d',
				WINDOW_1Y: '1 a',
				CHART_TITLE: 'Series temporales del historiador',
				POINTS: '{{count}} puntos',
				LOADING: 'Cargando series temporales…',
				NO_DATA: 'No hay lecturas para los tags seleccionados en esta ventana.',
				NO_TAGS: 'Busque un tag o elija uno arriba para graficarlo.',
				SUMMARY: 'Resumen',
				LATEST: 'Último',
				MIN: 'Mín',
				MAX: 'Máx',
				MEAN: 'Media',
			},
		},
		TRIAGE: {
			RULE_SIGNALS: {
				TITLE: 'What this rule measures',
				MEASURED: 'Measured',
				CONTEXT: 'Context',
				HAS_READINGS: 'Readings before the alert',
				NO_READINGS: 'No readings in the 24 h before the alert',
				SOURCE: 'Mapping from {{source}}',
				GUESSED: 'Shell\'s configuration does not list this rule\'s inputs; the charted signals were chosen by the agent from the well\'s sensors.',
			},
			BASIS: {
				NO_RESULT: 'No decision yet: run the agent on this alert.',
				RECOMMENDATIONS: 'Recommendations',
				NO_RECOMMENDATIONS: 'The agent made no recommendations for this alert.',
				FINAL_HYPOTHESES: 'Final hypotheses (adjudicator)',
				NO_FACT_SPAN: 'This run did not record which evidence it read.',
				LINK_RCA: 'Deep RCA · {{count}} verified facts',
				LINK_EVIDENCE: 'Evidence used',
			},
			PFLOW: {
				ALERT_DRAWINGS: 'Drawings the alert equipment is on (open with the alert context)',
				TAB: 'Process flow',
				TITLE: 'Block flow (process units)',
				CHECKED_LEGEND: 'Checked by the agent ({{n}})',
				OPEN_MAP: 'Open process map',
				OPEN_ON_MAP: 'Show on process map',
				ALERT_UNIT: 'Alert\'s unit',
				STATE_MOVED: 'Moved',
				STATE_HELD: 'Steady',
				STATE_NODATA: 'No data',
				TIMING_BEFORE: 'before the alert',
				TIMING_TOGETHER: 'with the alert',
				TIMING_AFTER: 'after the alert',
				TIMING_EARLIER: '> 48 h earlier',
				KEY_SENSORS: 'Key sensors (click to chart)',
				CHART_IT: 'chart it on the right',
				ON_DRAWING: 'Equipment on the alert\'s drawing',
			},
			STEP_PANEL: {
				DQ: 'Data quality of the readings before the alert',
				NO_DQ: 'No data-quality assessment was recorded for this alert.',
				STATE: 'Alert tag with the machine\'s run indicator',
				LIMITS: 'Limits of this tag and when they applied',
				RULE: 'The detector and the tags it watches',
				EQUIPMENT: 'Sensors on this equipment — click one to chart it on the right',
				PROCESS: 'Live P&ID — click a tag to chart it on the right',
				NO_ANOMALY: 'The run has no anomaly-model analysis for this alert.',
			},
			DOCPAGE: {
				MAXIMIZE: 'Maximize',
				RESTORE: 'Restore',
				MARKING: 'Finding the cited passage on this page…',
				MARKING_TERMS: 'Finding the search words on this page…',
				MARK_FAILED: 'The page is shown, but the passage could not be located on it.',
				PAGE_OF: 'page {{page}} of {{pages}}',
				PREV: 'Previous page',
				NEXT: 'Next page',
				CITED_FOUND: 'The red box marks the passage the triage relied on.',
				OCR: 'This page is a scan, read by OCR, so the box position is approximate.',
				CITED_MISSING: 'The cited words could not be found on this page image (the scan reads differently); the passage is the one quoted in the triage.',
				CITED_ON: 'The cited passage is on page {{page}}.',
				LOADING: 'Loading the page…',
				CLOSE: 'Close',
			},
			DOCS: {
				REFERRED: 'Referred documents',
				ALL: 'All documents',
				SEARCH_PLACEHOLDER: 'Filter by name — press Enter to search inside the documents',
				SEARCH_INSIDE: 'Search inside',
				WHOLE_SITE: 'Whole site',
				RESULTS: 'Pages matching “{{q}}”',
				NO_RESULTS: 'No page matches these words.',
				PAGE: 'p.{{n}}',
				USED: 'Passages the triage used',
				USED_HINT: 'Click a passage to open its page with the passage in a red box',
				CITED: 'cited',
				VIEW_PAGE: 'View page',
			},
			SEE: {
				RULE: 'Rule, delay and replay: see Source Alert',
				SENSORS: 'Sensors on this machine: see System Details',
				TAGS: 'Plot them: see Tags',
				CONNECTED: 'Upstream and downstream units: see System details › Process flow',
				PID: 'P&ID drawings: see System details',
				WORK_ORDERS: 'Open work: see Work Orders',
				ALERTS: 'Earlier alerts: see Alerts',
				REPORTS: 'Shift reports: see Reports',
				REASONING: 'How the agent reasoned: see Reasoning',
			},
			PANE_SPLIT_HINT: 'Drag to resize; double-click to reset',
			RELATED: {
				TITLE: 'Related alerts',
				HELP: 'Found by the known-issue check: earlier alerts on this equipment known before this alert\'s cut-off, and later alerts that linked to this one. Each alert keeps its own label.',
				NONE: 'No related alert found.',
				ISSUE_SIZE: 'Issue of {{n}} alerts',
				REL_COVERED_BY: 'Service already raised',
				REL_SAME_CONDITION: 'Same condition',
				REL_SAME_EVENT: 'Same event',
				DIR_EARLIER: 'earlier alert',
				DIR_LATER: 'later alert',
				SCORE: 'score {{s}}',
				STATUS_PROPOSED: 'Proposed',
				STATUS_CONFIRMED: 'Confirmed',
				STATUS_REJECTED: 'Rejected',
				CONFIRM: 'Confirm',
				REJECT: 'Reject',
				CHIP: 'Same issue as {{n}} other alert(s)',
				CHIP_TIP: 'The known-issue check found {{n}} other alert(s) on the same condition. Open the alert to see them under Related alerts, and confirm or reject the link.',
				CHIP_PROPOSED: 'Some links still await review.',
			},
			QUEUE_RUN: {
				BUTTON: 'Triage selected',
				HINT: 'Run the Triage Agent on each selected alert, one alert at a time per run (never grouped); a few run at once.',
				STARTED: 'Triaging {{n}} alerts individually',
				PROGRESS: 'Triage: {{done}} of {{total}} done, {{running}} running',
				DONE: 'Triage finished for {{n}} alerts ({{failed}} failed)',
			},
			LABEL_SETTINGS: {
				PROPOSALS_TITLE: 'Proposed mapping changes ({{n}})',
				PROPOSALS_HELP: 'Reviewers agreed with the agent\'s finding but expected another customer label. Apply moves the finding in the editor below; it is accepted when you save the new version.',
				N_ALERTS: '{{n}} alerts',
				APPLY: 'Apply to mapping',
				APPLIED: 'Applied — save to accept',
				REJECT: 'Reject',
				TAB_SETTINGS: 'Settings',
				TAB_LABELS: 'Labels',
				INTRO: 'The agent decides an internal finding; the mapping turns it into the label the customer sees. A change saves a new version (v{{v}} is in force) and relabels every alert at once, without re-running triage.',
				EXTERNAL_TITLE: 'External labels',
				EXTERNAL_HELP: 'The labels shown in the queue and reported to the customer. The outcome drives the approve button: close, act (raise the action type) or hold for review. Saved labels cannot be deleted, only retired; their keys are permanent.',
				COL_NAME: 'Name / key',
				COL_CUSTOMER: 'Customer value',
				COL_OUTCOME: 'Outcome',
				COL_ACTION: 'Action type',
				COL_COLOR: 'Colour',
				COL_SCORED: 'Scored as',
				COL_ACTIVE: 'Active',
				UP: 'Move up',
				DOWN: 'Move down',
				REMOVE: 'Remove (never saved)',
				FALLBACK: 'fallback',
				CUSTOMER_NONE: 'Not exported',
				ACTION_PH: 'e.g. service_notification',
				OUTCOME_CLOSE: 'Close',
				OUTCOME_ACTION: 'Action',
				OUTCOME_HOLD: 'Hold for review',
				NOT_SCORED: 'Not scored',
				NEW_KEY: 'New key, e.g. valid_monitor',
				NEW_NAME: 'Name shown to users',
				ADD: 'Add label',
				KEY_RULE: 'Key: 3–41 lower-case letters, digits or underscores, starting with a letter.',
				KEY_TAKEN: 'That key is already used (keys are never reused, even after retiring).',
				NAME_REQUIRED: 'Give the label a name.',
				FALLBACK_LABEL: 'Fallback label',
				FALLBACK_HELP: 'Used when a finding has no mapping. Must be active and hold for review.',
				MAPPING_TITLE: 'Mapping: external label ← internal findings',
				MAPPING_HELP: 'Each external label (left) owns the agent findings on the right. Every finding belongs to exactly one label. Click a finding to move it. Amber findings differ from the default mapping.',
				UNMAPPED: '{{n}} findings are not mapped; they would show as the fallback label.',
				N_FINDINGS: '{{n}} findings',
				NONE: 'No findings mapped',
				RETIRED_NONE: 'Retired: owns no findings',
				DEFAULT_WAS: 'default: {{x}}',
				CHECK_N: 'Check {{n}}',
				MOVE_TO: 'Move “{{x}}” to',
				BY_CHECK: 'View by triage check',
				NO_CHANGES: 'No changes.',
				PREVIEWING: 'Checking the change…',
				MOVING: '{{n}} triaged alerts would change label.',
				DISCARD: 'Discard',
				SAVE: 'Save new version',
				SAVED: 'Label mapping v{{v}} saved',
				HISTORY: 'Versions',
				IN_FORCE: 'in force',
				RESTORE: 'Load into editor',
				RESTORE_REASON: 'Restore the mapping of v{{v}}',
			},
			LABELS: {
				FINDING_TIP: 'Shown to Shell as “{{label}}” (label mapping v{{v}}, Settings → Labels).',
				FINDING: 'Finding',
				SOURCE_AGENT: 'Agent',
				SOURCE_POLICY: 'Policy',
				SOURCE_HUMAN: 'Reviewer',
				SOURCE_DERIVED: 'Derived',
				MAPPING: 'Mapping v{{v}} → {{label}}',
				MAPPING_TIP: 'The finding is turned into the customer label by the label mapping in Settings › Labels. Changing the mapping relabels alerts without re-running triage.',
				ALSO_FOUND: 'Also found',
				CHECK: 'check {{n}}',
				SECONDARY_ACTION: 'Also found: {{names}}. That finding leads to an action, but the main finding closes the alert. Review before closing.',
				INTERNAL_COLUMN: 'Finding',
			},
			ACT: {
				APPROVED_CLOSED: 'Approved and closed',
				CLOSED: 'Closed – False alert',
				CLOSED_FLAGGED: 'Closed – False alert · rule flagged for tuning',
				CLOSE_ALERT: 'Close alert',
				CLOSE_CONFIRM: 'Close alert',
				CLOSE_TITLE: 'Close as False – No Action',
				CREATE_INSTRUMENT_WO: 'Create instrument WO',
				CREATE_SERVICE: 'Create Service',
				DUE_DATE: 'Due date',
				EQUIPMENT: 'Equipment',
				EVIDENCE_ATTACHED: 'Evidence attached (click to leave one out)',
				FEED_CONFIRM: 'Report issue',
				FEED_LEAD: 'The alert was raised on values that are not measurements. The issue goes to {{owner}}; no work order is raised because no transmitter is broken.',
				FEED_REPORTED: 'Data-feed issue reported to {{owner}}',
				FEED_TITLE: 'Report data-feed issue',
				FEWER_FIELDS: 'Show fewer fields',
				FLAG_RULE: 'Flag rule for tuning',
				FROM_AGENT: 'from the agent',
				FROM_DQ_POLICY: 'from DQ policy',
				LINKED: 'Linked to {{id}} and closed',
				LINKED_ALERT: 'Linked alert',
				LINK_CLOSE: 'Link & close',
				LINK_CONFIRM: 'Link & close',
				LINK_LEAD: 'This condition is already covered by an open record. The alert is linked to it and closed as Valid – No Action.',
				LINK_TITLE: 'Link to the known issue',
				LOADING: 'Preparing the form…',
				MORE_FIELDS: 'Show more fields',
				NOTE: 'Note (optional)',
				NOTE_PLACEHOLDER: 'Add context for the SME team…',
				NO_EVIDENCE: 'Nothing cited to attach',
				NO_REPLAY: 'The detector\'s rule could not be replayed on the raw data, so no fix is suggested.',
				OPEN_CASE: 'Open case',
				OWNER: 'Owner',
				OWNER_ME: 'Me',
				PREFILLED: 'prefilled',
				PRIORITY: 'Priority',
				PROBLEM: 'Problem',
				RECOMMENDATION: 'Recommendation',
				REPORT_FEED: 'Report data-feed issue',
				ROUTE_TO: 'Route to',
				SENT_TO: 'Sent to {{owner}}.',
				SERVICE_CONFIRM: 'Create Service',
				SERVICE_CREATED: 'Service case #{{id}} created',
				SERVICE_NAME: 'Title',
				SERVICE_TITLE: 'Create Service',
				TAG: 'Tag',
				UNDO: 'Undo',
				UNDONE: 'Action undone',
				WO_CONFIRM: 'Create work order',
				WO_CREATED: 'Work order {{id}} created · {{route}}',
				WO_TITLE: 'Create instrument work order',
			},
			CHIPS: {
				UNACK_HINT: '{{n}} not yet acknowledged',
			},
			RULE: {
				FLAGGED_SHORT: 'Rule flagged',
				FLAGGED_TIP: 'The detector rule was flagged for tuning',
			},
			SETTINGS: {
				DEFAULT: 'Default',
				FROM_DEFAULT: 'default',
				FROM_FACILITY: 'facility',
				FROM_EQUIPMENT: 'this equipment',
				HISTORY: 'Change history',
				LOADING: 'Loading settings…',
				NO_HISTORY: 'No change yet: every value is the code default.',
				N_CHANGED: '{{n}} changed',
				OPEN: 'Triage settings',
				OPEN_HINT: 'Flatline, delays, HIL in memory, routing',
				READ_ONLY: 'Only an administrator can change these settings.',
				REASON: 'Reason for the change (required)',
				RESET: 'Reset',
				RE_EVAL: 'changes results',
				RE_EVAL_CHANGED: 'Run the golden set before relying on this change',
				RE_EVAL_HINT: 'Changing this changes triage results: run the golden set before relying on it',
				RE_EVAL_NOTE: 'Each change is a new version; every triage run records the version it used. Settings marked "changes results" need a golden-set run before you rely on them.',
				SAVE: 'Save',
				SAVED: 'Settings saved as version {{v}}',
				SAVE_FAILED: 'The settings could not be saved',
				SCOPE: 'Applies to',
				SCOPE_FACILITY: 'The whole facility',
				SUBTITLE: 'Version {{v}}',
				TITLE: 'Alert Triage settings',
			},
			TREE: {
				ALL_OPEN: 'All open alerts',
				CLEAR_FILTER: 'Show all nodes',
				NO_ACTION_TOTAL: 'No action',
				SHOWING_ONLY: 'Showing: {{cls}} only',
				SHOW_NODES_WITH: 'Show nodes with',
			},
			KG: {
				CLICK_TO_COLLAPSE: 'Clic para contraer',
				NO_EXACT: 'Ningún nodo se llama «{{tag}}»',
				PICK_MATCH: 'Estos coinciden en parte, uno por cada parte de la planta; elija uno para explorar:',
				BREADCRUMB_OPS: 'Operaciones costa afuera',
				BREADCRUMB_TWINS: 'Gemelos topológicos',
				BREADCRUMB_GRAPH: 'Grafo de conocimiento Shell Vito',
				TITLE: 'Grafo de conocimiento interactivo de la planta',
				NODES: '{{n}} nodos',
				RELATIONSHIPS: '{{n}} relaciones',
				LIVE: 'Neo4j en vivo',
				CENTER_PLACEHOLDER: 'Tag central (p. ej. PT-1502, MTR-0900)…',
				EXPLORE: 'Explorar',
				HOPS: 'Profundidad',
				HOPS_1: '1 salto: vecinos directos',
				HOPS_2: '2 saltos: equipos vecinos',
				HOPS_3: '3 saltos: topología amplia',
				SHOW_TYPE: 'Mostrar este tipo',
				HIDE_TYPE: 'Ocultar este tipo',
				ZOOM_IN: 'Acercar',
				ZOOM_OUT: 'Alejar',
				FIT: 'Ajustar a la pantalla',
				SHOWING: 'Mostrando {{shown}} de {{total}} nodos',
				SHOW_MORE: 'Mostrar {{n}} más',
				EXPAND_ALL: 'Expandir todos los grupos',
				COLLAPSE_ALL: 'Contraer grupos',
				HINT: 'Pase el cursor para ver nombres · clic en un grupo para expandirlo · clic en un nodo para inspeccionarlo · arrastre para mover, desplace para hacer zoom',
				LOADING: 'Leyendo el grafo de conocimiento…',
				LOAD_FAILED: 'No se pudo cargar el grafo de conocimiento',
				CLICK_TO_EXPAND: 'Clic para listar y expandir',
				GROUP: 'NODOS AGRUPADOS',
				COLLAPSE_GROUP: 'Contraer grupo',
				CENTER_ON_NODE: 'Centrar el grafo en este nodo',
				PROPERTIES: 'Propiedades del nodo',
				LOADING_RELATIONS: 'Cargando relaciones…',
				OUTGOING: 'Relaciones salientes ({{n}})',
				INCOMING: 'Relaciones entrantes ({{n}})',
				TYPE: {
					Equipment: 'Equipo',
					ControlValve: 'Válvula de control',
					Instrument: 'Instrumento',
					Event: 'Alerta',
					Event_PostJune2026: 'Alerta (después de junio 2026)',
					Alert: 'Alerta',
					TripEvent: 'Evento de disparo',
					RootCause: 'Causa raíz',
					PhaScenario: 'Escenario PHA',
					Detector: 'Detector',
					Measurement: 'Medición',
					Document: 'Documento',
					PIDDrawing: 'Plano P&ID',
					FLOC: 'FLOC',
					ProcessLine: 'Línea de proceso',
					System: 'Sistema',
				},
			},
			LIBRARY: {
				TITLE: 'Especialista de biblioteca',
				EXCERPTS_N: '{{n}} extractos · {{docs}} documentos',
				NONE: 'Sin manual en el alcance',
				LIMITS_N: '{{n}} límites indicados',
				SCOPE: 'Buscado para',
				HINT: 'Manuales del fabricante, hojas de datos y listas de alarmas y disparos de este equipo (por FLOC), buscados por significado y palabras. El agente los cita como LIB-n.',
				QUESTIONS: 'Preguntas realizadas',
				NONE_HINT: 'No hay manual ni hoja de datos para este equipo ni sus FLOC superiores.',
				STATED_LIMITS: 'Límites indicados para este instrumento',
				EXCERPTS: 'Extractos',
			},
			LIMITS: {
				ROW_FOUND: 'The red box marks the row this limit was read from.',
				OPEN_PAGE: 'Open the source page',
				OPEN_ROW: 'Open the source row',
				HIDE_SOURCE: 'Hide the source',
				SHEET_TITLE: 'Source row in the Shell workbook',
				SHEET_UNAVAILABLE: 'The workbook could not be read.',
				SHEET_ROWS: '{{n}} row(s) name this tag, of {{total}}',
				SHEET_NO_ROW: 'No row in this sheet names the tag.',
				SHEET_ROW: 'Row {{n}}',
				AT_ALERT: 'In force at the alert ({{t}}) marked',
				IN_FORCE: 'in force',
				NOT_IN_FORCE: 'not in force then',
				FROM: 'from {{from}}',
				QUOTED_FROM: 'quoted {{from}} – {{to}}',
				MAPPING_REVIEW: 'instrument ↔ tag mapping under review',
				DCS: 'DCS limit tags (historian)',
				AT_ALERT_VALUE: 'at the alert: {{v}}',
				TITLE: 'Límites',
				CLOSEST: '{{kind}} {{value}} · {{headroom}}% de margen',
				NONE: 'Ningún límite conocido',
				RULE_BREACHED: 'Regla de variación TMP cumplida',
				HINT: 'Todos los límites de ingeniería conocidos del tag (punto de ajuste PSV / DCS / PTM del TMP de Shell, SimpleLimits, valores del manual en la misma unidad) frente a la última lectura y el máximo o mínimo de 24 h antes de la alerta.',
				NONE_HINT: 'No se conoce límite TMP, SimpleLimits, de detector ni de manual para este tag.',
				SOURCE: 'Fuente',
				LIMIT: 'Límite',
				VALUE: 'Valor',
				EXTREME_24H: 'Máx. / mín. 24 h',
				HEADROOM: 'Margen',
				STATUS: 'Estado',
				RATE_RULES: 'Reglas de variación TMP',
				LARGEST_CHANGE: 'mayor cambio {{value}}',
				BREACHED: 'Superada',
				NOT_BREACHED: 'No superada',
				DETECTOR: 'Configuración del detector',
				CONFLICT: 'Valores TMP contradictorios:',
				REACHED: 'Alcanzado',
				NEAR: 'Cerca',
				CLEAR: 'Holgado',
				NO_READING: 'Sin lectura',
			},
			PREFS: {
				TITLE: 'Preferencias',
				HEIGHT: 'Altura preferida de los gráficos',
				CONDENSED: 'Compacta',
				NORMAL: 'Normal',
				EXPANDED: 'Ampliada',
				LIMITS_AND_VALUES: 'Límites y valores de etiquetas',
				SHOW: 'Mostrar',
				HIDE: 'Ocultar',
				OTHER: 'Líneas de límite dibujadas por defecto',
				TRIP_LINE: 'Línea de disparo',
				ALARM_LINE: 'Línea de alarma',
				THRESHOLD_LINE: 'Línea de umbral',
				INSTRUMENT_LINE: 'Línea de rango del instrumento',
				NOTE: 'Se aplica a todos los gráficos de triaje. La banda sombreada es el episodio del modo de falla (inicio de la señal hasta la vuelta a la normalidad). Los límites provienen solo de datos de Shell cargados (TMP, SimpleLimits).',
				RESET: 'Restablecer valores predeterminados',
			},
			PLAYBOOK: {
				TITLE: 'Comprobaciones del manual del sitio',
				META: '{{count}} reglas evaluadas',
				META_HINT: 'Reglas extraídas de las notas de revisión del sitio para este detector, vigentes en el momento de la alerta, comprobadas con la evidencia anterior al corte',
				LEGEND: '✓ se cumple · ✗ no se cumple · ? no evaluable. Una comprobación SALVO QUE que se cumple bloquea la regla; las partes no comprobables las juzga el agente.',
				OPEN_RULE: 'Abrir la regla en Aprendizajes',
				DISPOSITION_HINT: 'Lo que hace la práctica del sitio cuando se aplica esta regla',
				UNLESS_HINT: 'Excepciones: si se cumple alguna, la regla no se aplica',
				JUDGED_BY_AGENT: 'Lo juzga el agente',
				JUDGED_HINT: 'Esta parte no se puede comprobar automáticamente; el agente la valora con la evidencia',
				VALUE_YES: 'se cumple',
				VALUE_NO: 'no se cumple',
				VALUE_UNKNOWN: 'no evaluable',
				ST_MATCHED: 'Coincide',
				ST_MATCHED_HINT: 'Se cumplieron todas las comprobaciones CUANDO y ninguna excepción',
				ST_PARTLY: 'Coincide en parte',
				ST_PARTLY_HINT: 'Las comprobaciones automáticas se cumplieron; las partes que juzga el agente deciden si se aplica del todo',
				ST_EXCEPTED: 'Exceptuada',
				ST_EXCEPTED_HINT: 'Se aplicaría, pero se cumplió una excepción (SALVO QUE)',
				ST_UNDETERMINED: 'Indeterminada',
				ST_UNDETERMINED_HINT: 'Una comprobación no pudo evaluarse con la evidencia anterior al corte',
				ST_NOT_MATCHED: 'No coincide',
				ST_NOT_MATCHED_HINT: 'Una comprobación CUANDO no se cumplió',
			},
			LEARNING_CHECK: {
				OR: 'o',
				HOURS: '{{n}} h',
				DAYS: '{{n}} días',
				ON_ITEM: 'en este equipo',
				V_STOPPED: 'se detuvo',
				V_STARTED: 'arrancó',
				V_RESTARTED: 'rearrancó',
				V_SHUTDOWN_OR_STARTUP: 'se paró o arrancó',
				V_NO_SIGNIFICANT_CHANGE: 'ningún cambio significativo',
				V_PROCESS_OR_OPERATING_CHANGE: 'un cambio de proceso u operación',
				V_SINGLE_TAG_DEPARTURE: 'una sola etiqueta que se desvía',
				V_MIXED: 'patrones mixtos',
				V_CONSISTENT: 'coherente con lo normal',
				V_MOVED_TOGETHER: 'se movieron con ella',
				MACHINE_EVENT: 'la máquina {{events}} en un plazo de {{window}}',
				MACHINE_EVENT_NO_WINDOW: 'la máquina {{events}}',
				MACHINE_EVENT_ANY: 'una parada o arranque de la máquina en {{window}}',
				SINCE_RESTART: 'la máquina rearrancó como mucho {{window}} antes de la alerta',
				RUNNING: 'la máquina en marcha en el momento de la alerta',
				NOT_RUNNING: 'la máquina parada en el momento de la alerta',
				WITHIN_BASELINE: 'la etiqueta de la alerta dentro de su banda normal en el momento de la alerta',
				OUTSIDE_BASELINE: 'la etiqueta de la alerta fuera de su banda normal en el momento de la alerta',
				SUSTAINED: 'una desviación sostenida de lo normal',
				NOT_SUSTAINED: 'ninguna desviación sostenida de lo normal',
				CHART_PATTERN: 'los gráficos muestran {{patterns}}',
				CHART_PATTERN_ANY: 'se lee un patrón en los gráficos',
				MULTIVARIATE: 'el modelo multivariante indica {{values}}',
				MULTIVARIATE_ANY: 'el modelo multivariante tiene un veredicto',
				CONNECTED: 'sistemas conectados: {{values}}',
				CONNECTED_ANY: 'se leyeron los sistemas conectados',
				MOVED_TOGETHER: 'las etiquetas relacionadas se movieron juntas',
				NOT_MOVED_TOGETHER: 'las etiquetas relacionadas no se movieron juntas',
				OPEN_WORK: 'aviso u orden de trabajo abiertos en este equipo',
				NO_OPEN_WORK: 'ningún aviso ni orden de trabajo abiertos en este equipo',
				COHORT: 'muchas alertas en el mismo sistema a la vez (causa común)',
				NO_COHORT: 'sin ráfaga de alertas en el mismo sistema',
				SENSOR_FAULT: 'el sensor está averiado o sus datos no sirven',
				SENSOR_OK: 'los datos del sensor son utilizables',
				RETURNED: 'la señal volvió a lo normal antes de la alerta',
				NOT_RETURNED: 'la señal no había vuelto a lo normal en el momento de la alerta',
				SHIFT_LOG: 'un parte de turno reciente (plazo de {{window}}) menciona «{{query}}»',
				NO_SHIFT_LOG: 'ningún parte de turno reciente (plazo de {{window}}) menciona «{{query}}»',
				RECENT_WORK: 'trabajo de mantenimiento reciente (plazo de {{window}}) que coincide con «{{query}}»',
				NO_RECENT_WORK: 'ningún trabajo de mantenimiento reciente (plazo de {{window}}) que coincida con «{{query}}»',
				OTHER_ALERTS: 'al menos {{n}} alertas más del mismo detector en {{window}}',
				PRIOR_ALERTS: 'al menos {{n}} alertas anteriores en esta etiqueta (plazo de {{window}})',
				PRIOR_ALERTS_EVER: 'al menos {{n}} alertas anteriores en esta etiqueta',
			},
			LEARNING_EDIT: {
				TITLE: 'Editar aprendizaje',
				ASOF_WARNING: 'Al guardar se escribe la versión v{{next}}, vigente desde ahora. El triaje de alertas anteriores mantiene la versión vigente en su momento (as-of).',
				F_TITLE: 'Título',
				RECOMPILE: 'Las comprobaciones automáticas se recompilarán a partir de la nueva condición.',
				ACTIVE_HINT: 'el agente lo consulta',
				RETIRED_HINT: 'retirado desde ahora',
				REASON: 'Motivo del cambio',
				REASON_HINT: 'Se guarda con la nueva versión y se muestra en su historial.',
				NO_CHANGES: 'Aún no hay cambios.',
				SAVE: 'Guardar nueva versión',
				SAVED: 'Guardado como v{{version}}, vigente desde ahora; los triajes anteriores mantienen la versión previa.',
			},
			LEARNING_DETAIL: {
				TITLE: 'Aprendizaje',
				EDIT: 'Editar',
				CLOSE: 'Cerrar',
				EFFECTIVE: 'vigente desde {{date}}',
				SUPPORT: 'Respaldo: {{support}}',
				CONSISTENCY: 'consistencia {{pct}}',
				MANUAL_FIELDS: 'fijado a mano: {{fields}}',
				CONDITION: 'Condición',
				EXCEPTIONS: 'Excepciones',
				CHECKS: 'Comprobaciones automáticas',
				CHECKS_HINT: 'La condición traducida a hechos que el agente puede comprobar con la evidencia en el momento de la alerta; el resto lo juzga el agente.',
				CHECKS_STALE: 'La condición se editó: sus comprobaciones automáticas se están recompilando y no se usan hasta entonces.',
				WHEN: 'Cuando',
				UNLESS: 'Salvo que',
				MANUAL: 'Lo juzga el agente',
				NO_CHECKS: 'Ninguna condición comprobable automáticamente',
				GROUPS: 'Grupos de sensores a los que se refieren sus alertas',
				TYPICAL_TAGS: 'Etiquetas típicas',
				QUOTES: 'De las notas de revisión',
				GRAPH: 'Entorno en el grafo de conocimiento',
				GRAPH_MISSING: 'Aún no está en el grafo de conocimiento.',
				REL_DETECTOR: 'Para el detector',
				REL_FLOC: 'En ubicación técnica',
				REL_SUPERSEDES: 'Sustituye a',
				NO_LINKS: 'Sin vínculos con detector, ubicación ni versiones anteriores.',
				SIMILAR: 'Aprendizajes similares',
				NO_SIMILAR: 'Ningún aprendizaje activo de significado cercano.',
				OPEN_SIMILAR: 'Abrir este aprendizaje',
				ASOF_NOTE: 'Las versiones nunca se modifican: un triaje en el momento t usa la versión vigente en t.',
				NOW: 'ahora',
				CHANGED: 'Cambios:',
				SHOW_DIFF: 'Ver diferencias de la regla',
				HIDE_DIFF: 'Ocultar diferencias',
				F_TITLE: 'título',
				F_RULE: 'regla',
				F_DISPOSITION: 'disposición',
				F_STATUS: 'estado',
				F_CONDITION: 'condición',
				F_EXCEPTIONS: 'excepciones',
				F_SUPPORT: 'respaldo',
				SHOW_ALL_SOURCES: 'Ver las {{count}}',
			},
			PID: {
				CLICK_TO_PLOT: 'Clic para graficar',
				NO_HISTORIAN_DATA: 'Sin datos del historiador',
				MORE_TAGS: '+{{count}} tags más en este elemento',
				NO_DATA_AT_ALERT: 'Sin lecturas en las 72 h previas a la alerta',
				CLICKABLE_COUNT: '{{clickable}} de {{total}} tags tienen datos',
				TAGS_FAILED: 'No se pudieron cargar los tags de este plano',
				HIDE_LEGEND: 'Ocultar leyenda',
				SHOW_LEGEND: 'Mostrar leyenda',
				LEGEND_DATA: 'Con datos del historiador (clic)',
				LEGEND_NO_DATA: 'Sin datos del historiador',
				LEGEND_ALERT: 'Tag de la alerta',
				LEGEND_RELATED: 'Mismo equipo / lazo que la alerta',
				LEGEND_SUGGESTED: 'Sugerido para revisar',
				ONLY_WITH_DATA: 'Solo tags con datos',
				SHEET_N: 'hoja {{sheet}}',
				BACK: 'Atrás',
				BACK_TIP: 'Volver a la hoja anterior ({{count}} en el historial)',
				SHOW_PANEL: 'Mostrar panel',
				HIDE_PANEL: 'Ocultar panel',
				FROM_UPSTREAM: 'Desde aguas arriba',
				TO_DOWNSTREAM: 'Hacia aguas abajo',
				RESIZE: 'Arrastre para cambiar el ancho del panel',
				ON_DRAWING: 'En el plano',
				LOCATE_ITEM: 'Mostrar en el plano',
				FROM_OTHER_SHEET: 'Seleccionado en otra hoja',
				ITEM_TAGS: 'Tags de este elemento ({{count}})',
				SWITCH_TIP: 'clic para graficar este tag en su lugar',
				ADD_TO_CHART: 'Añadir al gráfico',
				REMOVE_FROM_CHART: 'Quitar del gráfico',
				ON_CHART: '{{count}} / {{max}} en el gráfico',
				ALERT_WINDOW: 'Alerta a las {{asOf}} · 3 días antes a 1 día después',
				LAST_DAYS: 'Últimos {{days}} días de datos disponibles',
				CHART_FULL: 'Se pueden graficar juntos como máximo {{max}} tags',
				TIME_SERIES: 'Serie temporal',
				LOOK_NEXT: 'Mirar a continuación',
				CONTEXT_FAILED: 'No se pudieron cargar los tags relacionados',
				CONTEXT_UNKNOWN: 'Este tag no está en el catálogo de sensores',
				LOOP_N: 'Lazo {{loop}}',
				SAME_LOOP: 'Mismo lazo',
				SAME_EQUIPMENT: 'Mismo equipo',
				UPSTREAM: 'Unidades aguas arriba',
				DOWNSTREAM: 'Unidades aguas abajo',
				SERVICE: 'Servicios auxiliares',
				NONE_WITH_DATA: 'Ninguno con datos del historiador',
				SHOW_MORE: 'Mostrar {{count}} más',
				NO_UNITS: 'Sin unidades conectadas',
				HOPS: '{{count}} salto(s)',
				OPEN_DRAWING: 'Abrir plano',
				MORE_SENSORS: '+{{count}} sensores más',
				TWIN: 'Tren gemelo: {{unit}}',
				TWIN_ON_CHART: 'El tag gemelo está en el gráfico',
				COMPARE_TWIN: 'Comparar con el gemelo',
				TWIN_NO_TAG: 'No se conoce un tag en la misma posición en {{unit}}',
				TWIN_SAME_MEASURE: 'Misma magnitud en {{unit}}',
				LOCATE_ON_SHEET: 'Mostrar en esta hoja',
				OTHER_CONNECTORS: 'Servicios y alivio ({{count}})',
				OTHER_CONNECTORS_TIP: 'Conectores de control, servicios y alivio de esta hoja',
				SIDE_BY_SIDE: 'Lado a lado',
				SIDE_BY_SIDE_TIP: 'Pantalla completa: plano y panel lado a lado',
				REL: {
					ALERT: 'Tag de la alerta',
					LOOP: 'Mismo lazo',
					EQUIPMENT: 'Mismo equipo',
				},
			},
			BATCH: {
				TOGGLE: 'Lote',
				TOGGLE_HINT: 'Modo lote: lista grupos de alertas del mismo FLOC dentro de una ventana de tiempo y evalúa cada grupo en conjunto',
				TOGGLE_OFF_HINT: 'Volver a la lista de alertas individuales',
				WINDOW_LABEL: 'Ventana de {{hours}} h',
				WINDOW_HINT: 'Ventana del lote: las alertas de un FLOC dentro de estas horas desde la primera forman un grupo',
				WINDOW_TITLE: 'Ventana del lote',
				WINDOW_OPTION: '{{hours}} h',
				HELP: 'Las alertas se agrupan por FLOC. La ventana se ancla en la primera alerta del grupo; el corte es el miembro más reciente, así que cada miembro se evalúa con lo que se sabía en ese momento. Una sola investigación cubre el grupo y da a cada miembro su propia disposición. Los grupos usan los filtros de fecha, búsqueda, FLOC, objetivo y estado.',
				GROUPS_TITLE: 'Lotes · ventana de {{hours}} h',
				GROUPS_COUNT: '({{groups}} grupos · {{alerts}} de {{considered}} alertas)',
				NEWEST_FIRST: 'Más recientes primero',
				EMPTY: 'Sin lotes',
				EMPTY_HINT: 'Con los filtros actuales ningún FLOC tiene dos o más alertas dentro de la ventana.',
				COL_SIZE: 'Tamaño',
				COL_SPAN: 'Intervalo',
				COL_DETECTORS: 'Detectores',
				COL_CLASSES: 'Clases actuales',
				COL_TAG: 'Tag',
				COL_AS_OF: 'A fecha de',
				TOGGLE_MEMBERS: 'Mostrar u ocultar las alertas de este grupo',
				N_ALERTS: '{{count}} alertas',
				SPAN: '{{count}} alertas en {{span}}',
				MINUTES: '{{count}} min',
				HOURS_MINUTES: '{{hours}} h {{minutes}} min',
				CUTOFF: 'corte',
				N_UNTRIAGED: '{{count}} sin evaluar',
				ALL_TRIAGED: 'Todas evaluadas',
				RUNNING: 'Ejecución del lote en curso',
				TRIAGE_BATCH: 'Evaluar lote ({{count}})',
				TRIAGE_SELECTED: 'Evaluar {{count}} seleccionadas',
				TRIAGE_HINT: 'Una investigación conjunta de estas alertas a fecha del miembro más reciente; cada alerta recibe su propia disposición',
				SELECT_MIN: 'Seleccione al menos {{count}} alertas de este grupo',
				SELECT_MAX: 'Un lote admite como máximo {{count}} alertas: seleccione hasta {{count}}',
				PAGE_HINT: 'La paginación cuenta grupos',
				RANGE: '{{start}}–{{end}} de {{total}} grupos',
				DONE: 'Lote de {{count}} alertas evaluado',
				GATED: 'Lote no analizado: el control de calidad de datos bloqueó la ejecución (ver el canvas)',
				FAILED: 'La ejecución del lote no terminó',
				ROW_CHIP: 'lote de {{count}}',
				ROW_CHIP_TIP: 'La última ejecución evaluó esta alerta junto con {{count}} alertas de su FLOC (una investigación, una disposición por alerta)',
				CARD_TITLE: 'Evaluación en grupo',
				CARD_META: 'Lote de {{count}} · ventana de {{hours}} h · corte {{time}}',
				EPISODE_CLASS: 'Episodio',
				EPISODE_HINT: 'Clasificación del grupo en conjunto',
				THIS_MEMBER: 'Esta alerta',
				MEMBERS: 'Alertas del lote',
				THIS_ALERT: 'esta alerta',
				NOW_IN_GROUP: 'Esta alerta está ahora en un grupo de {{count}} en su FLOC (ventana de {{hours}} h, {{span}} min, {{untriaged}} sin evaluar).',
				MORE_DETECTORS: '+{{count}} más',
				TRIAGE_WITH: 'Evaluar con {{count}} alertas de este FLOC',
			},
			UEV: {
				TITLE: 'Evidencias y comentarios',
				HINT: 'Las observaciones de campo, avisos SAP, tags del historiador y archivos que añada aquí se entregan al agente al volver a ejecutarlo, marcados como aportados por el usuario y ponderados aparte del registro a la fecha.',
				BADGE_N: '{{count}} elemento(s)',
				BADGE_CHANGED: 'cambió la respuesta',
				EMPTY: 'Aún no se ha añadido evidencia.',
				LOAD_ERROR: 'No se pudo cargar la evidencia',
				ADD: 'Añadir evidencia',
				ADDED: 'Evidencia añadida',
				UPDATED: 'Evidencia actualizada',
				REMOVED_NOTICE: 'Evidencia eliminada',
				TYPE_OBSERVATION: 'Comentario / observación',
				TYPE_SAP: 'Aviso SAP',
				TYPE_TAG: 'Tag del historiador',
				TYPE_FILE: 'Archivo',
				TEXT_LABEL: 'Qué se observó o midió',
				TEXT_PLACEHOLDER: 'p. ej. el manómetro local marca 30 scfm; válvula de drenaje con pase',
				CONTEXT_LABEL: 'Por qué importa para esta alerta',
				CONTEXT_PLACEHOLDER: 'Nota de contexto para el agente (opcional)',
				NOTIF_LABEL: 'Número de aviso',
				LOOKUP: 'Buscar',
				NOTIF_NOT_FOUND: 'Aviso no encontrado',
				NOTIF_AFTER: 'Creado {{hours}} h después de la alerta',
				NOTIF_BEFORE: 'Creado antes de la alerta',
				NOTIF_NAMES_TAG: 'Menciona el tag de la alerta {{tag}}',
				FLOC_EQUIPMENT: 'Mismo equipo',
				FLOC_UNIT: 'Misma unidad',
				FLOC_FACILITY: 'Otro equipo',
				RAISED: 'Creado {{time}}',
				COMPLETED: 'Cerrado {{time}}',
				TAG_LABEL: 'Tag del historiador',
				TAG_PLACEHOLDER: 'Buscar tags (p. ej. LIC0920)',
				TAG_HINT: 'El agente lee este tag a la hora de la alerta, como cualquier otro tag.',
				FILE_CHOOSE: 'Elegir archivo',
				FILE_HINT: 'PDF, imagen, texto, CSV, Word o Excel, hasta 10 MB',
				FILE_TYPE_ERROR: 'Tipo de archivo no admitido: suba un PDF, PNG, JPG, texto, CSV, Word o Excel',
				FILE_SIZE_ERROR: 'El archivo supera los 10 MB',
				FILE_META: '{{pages}} página(s), {{size}} KB',
				FILE_NO_TEXT: 'sin texto extraído ({{note}})',
				OPEN_FILE: 'Abrir archivo',
				SAVE: 'Añadir',
				CANCEL: 'Cancelar',
				EDIT: 'Editar',
				REMOVE: 'Eliminar',
				REMOVE_CONFIRM: '¿Eliminar este elemento? Las versiones anteriores se conservan y las ejecuciones que las usaron las siguen citando.',
				REASON: 'Motivo (opcional)',
				SAVE_EDIT: 'Guardar como nueva versión',
				VERSIONS: 'Historial',
				REMOVED: 'Eliminado',
				SHOW_REMOVED: 'Mostrar eliminados',
				HIDE_REMOVED: 'Ocultar eliminados',
				BY: 'Añadido por {{name}} · {{time}}',
				EDITED_BY: 'v{{n}} por {{name}} · {{time}}',
				AFTER_CUTOFF: 'después del corte',
				RERUN: 'Volver a ejecutar con evidencia',
				RERUN_HINT: 'Ejecuta de nuevo el Agente de Triaje con los {{count}} elemento(s) activos; sígalo en vivo en el lienzo',
				RERUN_BATCH: 'Volver a ejecutar el lote ({{count}} alertas)',
				RERUN_BATCH_HINT: 'Ejecuta de nuevo el lote con la evidencia activa de todos sus miembros',
				LAST_RUN: 'La última ejecución usó {{refs}}',
				OUTCOME_CHANGED: 'Cambió la respuesta: {{from}} → {{to}}',
				OUTCOME_UNCHANGED: 'Respuesta sin cambios',
				OUTCOME_NOT_ATTRIBUTED: 'Respuesta cambiada ({{from}} → {{to}}), no atribuida a la evidencia',
				OUTCOME_NO_BASELINE: 'El agente indica que la evidencia decidió la respuesta',
				AGENT_LINE: 'Respuesta de una ejecución con evidencia del usuario {{refs}}',
				NODE: 'Evidencia del usuario',
				CANVAS_BADGE: 'Evidencia del usuario · {{count}}',
				CANVAS_HINT: 'Ejecución con evidencia aportada por el usuario: {{refs}}',
				PICKER: 'evidencia del usuario',
				INSPECTOR_ITEMS: 'Elementos usados ({{count}})',
				INSPECTOR_BASELINE: 'Respuesta sin esta evidencia: {{cls}}',
				INSPECTOR_NO_BASELINE: 'No hay ejecución anterior sin evidencia del usuario',
				INSPECTOR_AUDIT: 'Los elementos aportados por el usuario quedan fuera de la vista a la fecha; la comprobación de fugas cubre solo los datos del arnés.',
				ATTRIBUTION_USER_EVIDENCE: 'Cambiada por la evidencia: {{from}} → {{to}}',
				ATTRIBUTION_USER_EVIDENCE_NO_BASELINE: 'Decidida por la evidencia (sin ejecución anterior)',
				ATTRIBUTION_NOT_ATTRIBUTED: 'Cambiada, no atribuida: {{from}} → {{to}}',
				ATTRIBUTION_UNCHANGED: 'Sin cambios',
				EFFECT_CHANGED_ANSWER: 'cambió la respuesta',
				EFFECT_SUPPORTED_ANSWER: 'apoya la respuesta',
				EFFECT_CONTRADICTED: 'contradice, no adoptada',
				EFFECT_NO_BEARING: 'sin relación',
				EFFECT_NOT_ADDRESSED: 'no tratada',
			},
			WATCH: {
				STATUS_WATCHING: 'En vigilancia',
				ACTION: 'Vigilar',
				ACTION_HINT: 'Volver a revisar esta alerta más tarde, con los datos registrados después de esta evaluación',
				UNWATCH: 'Dejar de vigilar',
				DIALOG_TITLE: 'Vigilar alerta',
				DIALOG_LEAD: 'La alerta queda en vigilancia hasta la fecha límite; después puede reevaluarse con todo lo registrado desde esta evaluación.',
				ASSESSED_AS_OF: 'Evaluación actual a fecha de',
				ASSESSED_HINT: 'El corte de la evaluación que está viendo. Las opciones cuentan desde este momento, no desde hoy.',
				LOOK_AGAIN: 'Revisar de nuevo',
				PRESET_HOURS: '+{{count}} h',
				PRESET_DAYS: '+{{count}} d',
				PRESET_CUSTOM: 'Fecha y hora',
				DUE_AT: 'Vence el',
				DUE_LINE: 'Vence {{time}}',
				DUE_BEFORE_ASSESSMENT: 'debe ser posterior a la evaluación',
				SUGGESTED: 'Sugerido por el agente',
				USE_SUGGESTION: 'Usar como motivo',
				REASON: 'Motivo',
				REASON_HINT: 'Qué revisar al vencer (obligatorio)',
				CONFIRM: 'Vigilar',
				SET_NOTICE: 'Alerta puesta en vigilancia',
				BANNER_DUE: 'Vigilancia vencida',
				BANNER_WAITING: 'En vigilancia',
				CHIP_DUE: 'Vencida · {{time}}',
				CHIP_WAITING: 'En vigilancia · vence {{time}}',
				TIP_DUE: 'En vigilancia, vencida desde {{time}}: reevaluar con los datos nuevos',
				TIP_WAITING: 'En vigilancia hasta {{time}}',
				SET_BY: 'Establecida por {{name}} el {{date}}',
				BASELINE: 'Se vigila la evaluación a fecha de {{time}}',
				CHECKING: 'Comprobando lo registrado desde entonces…',
				NOTHING_NEW: 'Aún no se ha registrado nada nuevo desde la evaluación.',
				LATER_ALERTS: 'Alertas posteriores',
				BEYOND: '+{{count}} después',
				OPEN_LATER: 'Abrir esta alerta',
				SAP_RECORDS: 'Registros SAP',
				SUPERVISOR_REPORTS: 'Informes del supervisor',
				HISTORIAN: 'Historian',
				HOURS: '{{count}} h',
				ON_TAGS: 'en {{count}} tags',
				WINDOW: 'Datos nuevos de {{from}} a {{to}}',
				REASSESS: 'Reevaluar con datos nuevos',
				REASSESS_HINT: 'Volver a evaluar con el corte movido a la fecha límite (nunca después de ahora); el canvas sigue la ejecución',
				REASSESS_WAIT: 'Disponible cuando venza la vigilancia',
				NEW_DATA: 'datos nuevos',
				NEW_DATA_DOT: 'Vencida, con datos registrados desde la evaluación',
				FILTER_LABEL: 'Vigilancia',
				FILTER_DUE: 'Vencida',
				FILTER_WAITING: 'En vigilancia (no vencida)',
				REASSESSED_HEADER: 'Reevaluada a fecha de {{time}} (primera evaluación a fecha de {{previous}}: {{cls}})',
			},
			SHELL: {
				TOGGLE: 'Mostrar etiquetas HIL',
				TOGGLE_HINT: 'Añade la etiqueta de revisión HIL (humano en el bucle) y su comentario como columnas para comparar. Solo datos de validación: nunca una entrada del agente de triaje.',
				VALIDATION_ONLY: 'Las etiquetas HIL (humano en el bucle) son datos de validación. Nunca son una entrada del agente de triaje.',
				COLUMN: 'Etiqueta HIL',
				NOT_VETTED: 'Sin revisar',
				NOT_VETTED_TIP: 'Sin etiqueta HIL para esta alerta',
				STATE: 'Estado HIL',
				COMMENT: 'Comentario',
				ACTION_TAKEN: 'Acción tomada',
				RELIABILITY: 'Fiabilidad',
				INHERITED: 'Heredada del episodio padre',
				AGREES: 'Coincide con HIL',
				DIFFERS: 'Difiere de HIL',
				AGREES_TIP: 'Nuestra clasificación coincide con la etiqueta HIL',
				DIFFERS_TIP: 'Nuestra: {{ours}} · HIL: {{shell}}',
				AGREEMENT: 'Coincide con HIL en {{agree}} de {{compared}} triajadas',
				AGREEMENT_TIP: 'Alertas filtradas triajadas (no pendientes) con etiqueta HIL, y cuántas tienen la misma clase.\nLas etiquetas HIL son datos de validación, nunca una entrada del agente.',
				CARD_TITLE: 'Revisión HIL',
				FILTER_LABEL: 'Etiqueta HIL',
				FILTER_NONE: 'Sin revisar',
				COLUMN_COMMENT: 'Comentario HIL',
			},
			FACTS: {
				TITLE: 'Evidencia leída — más antigua → más reciente (toda antes del corte)',
				HINT: 'Intervalo de los hechos que la ejecución leyó de cada fuente. Cada consulta se detiene en el corte.',
				CUTOFF: 'Corte {{time}}',
				COL_SOURCE: 'Fuente',
				COL_OLDEST: 'Más antigua',
				COL_NEWEST: 'Más reciente',
				COL_GAP: 'Antes del corte',
				SOURCE_HISTORIAN: 'Historian',
				SOURCE_SAP_NOTIFICATION: 'Avisos SAP',
				SOURCE_SAP_WORKORDER: 'Órdenes de trabajo SAP',
				SOURCE_SUPERVISOR_REPORT: 'Informes del supervisor',
				SOURCE_ALERTS: 'Alertas',
				SOURCE_MEMORY: 'Memoria',
				NOT_READ: 'No se leyeron hechos',
				POST_ALERT: 'Registros posteriores a la alerta',
				POST_ALERT_NONE: 'ninguno obtenido: cada consulta se detiene en el corte',
				AFTER_CUTOFF: 'después del corte',
				GAP_SECONDS: '{{count}} s',
				GAP_MINUTES: '{{count}} min',
				GAP_HOURS: '{{count}} h',
				GAP_DAYS: '{{count}} d',
			},
			SENSOR: {
				MEASURE: {
					temperature: 'Temperatura',
					pressure: 'Presión',
					differential_pressure: 'Presión diferencial',
					level: 'Nivel',
					flow: 'Caudal',
					vibration: 'Vibración',
					axial_position: 'Posición axial',
					speed: 'Velocidad',
					current: 'Corriente',
					power: 'Potencia',
					voltage: 'Tensión',
					valve_position: 'Posición de válvula',
					status: 'Estado',
					composition: 'Composición',
				},
				GROUP: {
					vibration: 'Vibración',
					bearing_temperature: 'Temperatura de cojinetes',
					axial_position: 'Posición axial',
					speed_run: 'Velocidad y marcha',
					lube_oil: 'Aceite lubricante',
					seal_gas: 'Gas de sello',
					suction: 'Aspiración',
					discharge: 'Descarga',
					cooling: 'Refrigeración',
					anti_surge: 'Antibombeo',
					scrubber_level: 'Nivel del depurador',
					control_valve: 'Válvula de control',
					motor_electrical: 'Motor eléctrico',
					turbine: 'Turbina',
				},
				ROLE: {
					process_value: 'Valor de proceso',
					setpoint: 'Consigna',
					controller_output: 'Salida del controlador',
					limit: 'Límite',
					mode: 'Modo',
					totaliser: 'Totalizador',
				},
				GROUP_NONE: 'Otros',
				COL_SENSOR: 'Sensor',
				CONVENTION_ONLY: 'solo convención del tag',
				TIP_MEASURES: 'Mide: {{value}}',
				TIP_WHY: 'Por qué se monitoriza (Plan técnico de monitorización)',
				TIP_NO_REASON: 'No hay un motivo de monitorización registrado para este sensor.',
				TIP_CONVENTION: 'Descrito solo por la convención de tags de los P&ID; el plan de monitorización no lo cubre.',
				TIP_ACTION: 'Acción recomendada',
				TIP_UNIT: 'Unidad: {{unit}}',
				TIP_LIMITS: 'Límites: {{value}}',
				TIP_SOURCES: 'Fuentes: {{value}}',
				TIP_LOW: 'Solo el nombre del tag describe este sensor, por lo que su significado es menos seguro.',
				LIMIT_LOW: 'bajo',
				LIMIT_HIGH: 'alto',
			},
			CONNECTED: {
				USUALLY_LEADS: 'suele adelantarse {{t}} (r {{r}})',
				USUALLY_LAGS: 'suele retrasarse {{t}} (r {{r}})',
				USUALLY_WITH: 'suele moverse a la vez (r {{r}})',
				NOT_COUPLED: 'normalmente no acoplado (r {{r}})',
				USUAL_DELAY: 'se movió con su retraso habitual',
				NOT_USUAL_DELAY: 'no con su retraso habitual',
				COUPLING_HINT: 'Cómo se relaciona normalmente este sensor con la etiqueta de la alerta en la línea base en marcha: el retraso de mejor correlación y su r. «Retraso habitual» compara con él el momento de esta vez.',
				TITLE: 'Sistemas conectados',
				VERDICT: {
					upstream_led: 'Aguas arriba se movió primero',
					service_related: 'Un servicio auxiliar se movió con ello',
					downstream_followed: 'Aguas abajo siguió: el cambio empieza aquí',
					moved_together: 'Las unidades conectadas se movieron juntas',
					isolated: 'Los sistemas conectados se mantuvieron: local a este equipo',
					background_drift: 'Unidades conectadas fuera de la línea base desde hace días (fondo)',
					moved_unordered: 'Las unidades conectadas se movieron, orden poco claro',
					insufficient: 'Muy pocos sensores para juzgar',
				},
				UPSTREAM: 'Aguas arriba',
				DOWNSTREAM: 'Aguas abajo',
				SERVICE: 'Servicios auxiliares',
				REL_UPSTREAM: 'aguas arriba',
				REL_DOWNSTREAM: 'aguas abajo',
				REL_SERVICE: 'servicio auxiliar',
				AS_OF: 'Leído a la hora de la alerta: no se usa nada registrado después',
				OF_SENSORS: 'de {{total}} sensores con datos',
				RATIO_HINT: 'Sensores de interfaz de las unidades vecinas con lecturas utilizables antes de la alerta',
				ANCHOR_ONSET: 'Inicio del tag de la alerta',
				PLOT: 'Tag de la alerta y sensores de interfaz',
				PLOT_TITLE: 'Gráfico de sistemas conectados',
				PLOT_CAPTION: 'Negro = tag de la alerta · sombreado gris = máquina parada · línea discontinua = inicio del tag de la alerta · banda gris = dentro de ±3 sd de la línea base en marcha. Clic para ampliar.',
				NEIGHBOURS: 'Unidades conectadas',
				NEIGHBOURS_META: '{{total}} unidades conectadas leídas, {{moved}} se movieron',
				EXPAND_ALL: 'Expandir todo',
				COLLAPSE_ALL: 'Contraer estables',
				NO_NEIGHBOURS: 'No se leyó ninguna unidad conectada.',
				OPEN_UNIT: 'Abrir esta unidad en la vista de proceso',
				LINK_HIGH: 'enlace: alto',
				LINK_MEDIUM: 'enlace: medio',
				LINK_LOW: 'enlace: bajo',
				LINK_HINT: 'Qué tan seguros son los planos de que estas dos unidades están conectadas',
				STATE_MOVED: 'se movió',
				STATE_HELD: 'estable',
				STATE_NO_DATA: 'sin datos',
				SENSORS_N: '{{count}} sensores',
				COL_SENSOR: 'Sensor de interfaz',
				COL_STATE: 'Estado',
				COL_Z_LAST: 'z último',
				COL_Z_LAST_HINT: 'Distancia de la última lectura antes de la alerta respecto a la línea base en marcha, en desviaciones estándar',
				COL_Z_DAY: 'z 24 h',
				COL_Z_DAY_HINT: 'Distancia mediana respecto a la línea base en marcha en las 24 h previas a la alerta, en desviaciones estándar',
				COL_ONSET: 'La desviación empezó',
				NO_READINGS: 'Sin lecturas utilizables antes de la alerta',
				RELIEF: 'Colectores de alivio',
				MORE: 'Mostrar más',
				LESS: 'Mostrar menos',
				DUR_MIN: '{{n}} min',
				DUR_H: '{{n}} h',
				DUR_D: '{{n}} días',
				TIMING_BEFORE: 'se movió {{t}} antes del tag de la alerta',
				TIMING_BEFORE_SHORT: '{{t}} antes',
				TIMING_AFTER: 'se movió {{t}} después del tag de la alerta',
				TIMING_AFTER_SHORT: '{{t}} después',
				TIMING_TOGETHER: 'se movió junto con el tag de la alerta',
				TIMING_TOGETHER_SHORT: 'juntos',
				TIMING_EARLIER: 'empezó {{t}} antes del tag de la alerta — fondo',
				TIMING_EARLIER_SHORT: '{{t}} antes · fondo',
				TIMING_EARLIER_NO_DUR: 'empezó mucho antes del tag de la alerta — fondo',
				TIMING_EARLIER_NO_DUR_SHORT: 'mucho antes · fondo',
				TIMING_HELD: 'se mantuvo cerca de su línea base',
				TIMING_NO_DATA: 'sin lecturas utilizables antes de la alerta',
				TIMING_UNCLEAR: 'se movió, momento poco claro',
			},
			GAPS: {
				TITLE: 'Sensores esperados sin tag ({{count}})',
				LINK: 'Sensores esperados sin tag ({{count}})',
				LINK_HINT: 'Sensores que espera la plantilla de la máquina y que no tienen tag en el historian',
				EXPLAIN: 'Son sensores que la plantilla de activo C3 espera para esta máquina, pero que no pudieron asociarse a un tag del historian, por lo que no se pueden leer datos de ellos. La lista es informativa y no se puede editar aquí.',
				NONE: 'No hay sensores sin asociar.',
				COL_MACHINE: 'Máquina',
				COL_SENSOR: 'Sensor esperado',
				COL_FAILURE_GROUP: 'Grupo de fallo',
				COL_UNIT_TYPE: 'Tipo de unidad',
			},
			FLOC: {
				LEVEL_1: 'Activo',
				LEVEL_2: 'Instalación',
				LEVEL_3: 'Sistema',
				LEVEL_4: 'Subsistema',
				LEVEL_5: 'Equipo',
				PATH: 'Ruta FLOC',
				LEGEND_TITLE: 'Niveles FLOC',
				LEGEND_HINT: 'Cada ubicación se identifica con su código de ubicación funcional SAP (FLOC). Los niveles van del activo al equipo.',
				TREE_FILTER_PLACEHOLDER: 'Buscar un sistema o equipo (nombre o FLOC)…',
				SCOPE_N: '{{count}} FLOC',
				SCOPE_TIP: 'La cola está filtrada por este FLOC y todo lo que hay debajo',
				SCOPE_CLEAR: 'Quitar el filtro de ubicación',
				UNPLACED_TIP: 'Alertas sin ubicación funcional',
				ALERTS_TOTAL: '{{count}} alertas',
				SOURCE_ASSET_CODE: 'Ubicado por el código del nombre del activo',
				SOURCE_WELL: 'Ubicado por el número del pozo submarino',
				SOURCE_TRAIN: 'Ubicado por el código de tren o paquete',
				SOURCE_TAG_MAPPING: 'Ubicado por la asignación de tags del historian',
				EXTRACT_HAD: 'la extracción de la alerta tenía {{floc}}',
			},
			PMAP: {
				KEY_SENSORS: 'Sensores clave ({{count}})',
				KEY_SENSORS_HINT: 'Los sensores que mejor describen el estado de esta unidad',
				TITLE: 'Vista de proceso',
				BUTTON: 'Vista de proceso',
				OPEN: 'Abrir la vista de proceso',
				OPEN_HINT: 'Áreas de planta y unidades de proceso, conectadas como en los P&ID',
				BACK: 'Volver a la cola',
				UNITS_META: '{{units}} unidades de proceso en {{areas}} áreas',
				LAYERS: 'Capas de conexión',
				SECONDARY: 'Mostrar enlaces secundarios ({{count}})',
				RELIEF: 'Alivio / antorcha ({{count}})',
				UTILITY: 'Servicios auxiliares ({{count}})',
				CONTROL: 'Señales de control ({{count}})',
				TARGET_ONLY: 'Solo objetivo',
				LEGEND_BACKBONE: 'Enlace de proceso',
				LEGEND_LINK: 'Enlace secundario',
				LEGEND_RELIEF: 'Alivio / antorcha',
				LEGEND_UTILITY: 'Servicio auxiliar',
				LEGEND_CONTROL: 'Señal de control',
				LEGEND_UP: 'Aguas arriba',
				LEGEND_DOWN: 'Aguas abajo',
				LEGEND_TARGET: 'Contiene FLOC objetivo',
				LEGEND_LOAD: 'Carga de alertas',
				LANE_META: 'Unidades: {{units}} · Alertas: {{alerts}}',
				LANE_TIP: '{{units}} unidades, {{alerts}} alertas, {{targets}} unidades con FLOC objetivo',
				EXPAND_LANE: 'Expandir {{name}}',
				COLLAPSE_LANE: 'Contraer {{name}}',
				LINKS: 'Conexiones entre unidades de proceso',
				EDGE_ARIA: 'Conexión de {{from}} a {{to}}, {{medium}}',
				UNIT_ALERTS: '{{total}} alertas ({{scope}} en alcance)',
				IN_SCOPE_N: '{{count}} en alcance',
				TARGETS_N: '{{count}} FLOC objetivo',
				SHEET_N: 'hoja {{sheet}}',
				CHIP: 'Proceso: {{name}}',
				CHIP_HINT: 'Abrir la vista de proceso en esta unidad',
				UNITS_LABEL: 'Unidades de proceso',
				N_MORE: '+{{count}} más',
				FROM_TO: '{{from}} → {{to}}',
				MEDIUM: 'Medio',
				CONFIDENCE: 'Confianza',
				CONF_HIGH: 'Alta',
				CONF_MEDIUM: 'Media',
				CONF_LOW: 'Baja',
				WEAK: 'enlace débil',
				ONE_END: 'visto solo en un plano',
				TYPE: 'Tipo',
				LAYER_BACKBONE: 'Enlace de proceso',
				LAYER_LINK: 'Enlace secundario',
				LAYER_RELIEF: 'Alivio / antorcha',
				LAYER_UTILITY: 'Servicio auxiliar',
				LAYER_CONTROL: 'Señal de control',
				CONNECTORS_N: '{{count}} conectores en los planos',
				EVIDENCE_LOADING: 'Leyendo la evidencia de los planos…',
				PANEL_ARIA: 'Detalles de la unidad de proceso',
				LOADING: 'Cargando…',
				SHOW_ALERTS: 'Mostrar alertas de esta unidad',
				OPEN_EXPLORER: 'Abrir en el explorador de activos',
				ALERTS: 'Alertas',
				NO_ALERTS: 'Sin alertas',
				DRAWINGS: 'Planos ({{count}})',
				NO_DRAWINGS: 'No hay ningún plano vinculado a esta unidad',
				OPEN_DRAWING: 'Abrir el P&ID',
				FLOCS: 'FLOC ({{count}})',
				NO_FLOCS: 'No hay FLOC asignados a esta unidad',
				OPEN_NODE: 'Abrir en el explorador de activos',
				SHOW_FLOC_ALERTS: 'Mostrar alertas de este FLOC',
				SHARED_FLOCS: 'Compartidos con otras unidades ({{count}})',
				INBOUND: 'Entrantes ({{count}})',
				OUTBOUND: 'Salientes ({{count}})',
				NO_CONNECTIONS: 'No se encontraron conexiones en los planos',
				SHOW_ALL: 'Mostrar las {{count}}',
				SHOW_FEWER: 'Mostrar menos',
			},
			SEARCH_ALERTS_PLACEHOLDER: 'Buscar alerta, ID, ID de definición, tag, FLOC…',
			CANVAS: {
				CAUSAL: {
					QUERIES: 'Preguntas ({{n}})',
					COL_HYPOTHESIS: 'Hipótesis',
					COL_FACET: 'Faceta',
					COL_QUERY: 'Pregunta',
					COL_ADMITTED: 'Admitidos',
					NOTHING: 'nada admitido',
					ADMITTED: 'Extractos admitidos ({{n}})',
					EXCERPTS_FROM_TRACE: 'Extractos tomados de la traza del paso (los seis primeros); los resultados rechazados aparecen cuando se carga el documento de la ejecución.',
					REJECTED: 'Resultados rechazados ({{n}})',
					NONE_REJECTED: 'No se rechazó ningún resultado.',
					FACET_DESIGN_BASIS: 'Bases de diseño / envolvente',
					FACET_ORIGINATING_CHANGE: 'Cambio de origen',
					FACET_MECHANISM_SENSITIVITY: 'Sensibilidad del mecanismo',
					FACET_PROTECTION_DETECTION: 'Protección / detección',
					FACET_SYMPTOM_DIAGNOSTIC: 'Síntoma / diagnóstico',
					FACET_CORRECTIVE_ACTION: 'Acción correctiva',
				},
				TIER: {
					STAGE_QUICK: 'Etapa 1 · Triaje rápido (mini-agente)',
					STAGE_DEEP: 'Etapa 2 · Investigación profunda',
					QUICK_ANSWER: 'Respuesta rápida',
					FINAL_ANSWER: 'Respuesta final',
					OUTCOME: 'Resultado',
					ACCEPTED: 'Aceptada',
					ESCALATED: 'Escalada',
					ROUTE_ACCEPTED: 'Aceptada → Resultado',
					ROUTE_ESCALATED: 'Escalada → Etapa 2',
					NO_GATE: 'Sin puerta (solo triaje rápido)',
					DECIDING: 'Comprobando la respuesta rápida…',
					WAITING: 'Espera la respuesta rápida',
					NOT_NEEDED: 'No necesaria — la respuesta rápida pasó la puerta; se ahorraron el tiempo y los tokens de la investigación profunda.',
					NOT_RUN: 'No ejecutada — esta ejecución fue solo de triaje rápido.',
					WOULD_HAVE_RUN: 'Se habría ejecutado',
					DEEP_SPECIALISTS: 'Especialistas lentos',
					SKIP_VERDICTS: 'Nueva comprobación de veredictos',
					SKIP_ADJUDICATION: 'Comprobación de completitud y segunda adjudicación',
					CHECK_NO_ACTION: 'Respuesta sin acción',
					CHECK_CONFIDENCE: 'Confianza',
					CHECK_NOT_CAPPED: 'Sin tope',
					CHECK_MODEL: 'El modelo respondió',
					CHECK_NO_REAL_EVENT: 'Ningún veredicto de evento real',
					CEILING: 'tope {{pct}}',
					RULE_FALLBACK: 'respaldo por reglas',
					QUICK_NODE_NOTE: 'Etapa 1 · triaje rápido: es la pasada del mini-agente, antes de la puerta.',
					ESCALATED_NOTE: 'Escalada: al menos una comprobación falló, así que se ejecutó la investigación profunda.',
					ACCEPTED_NOTE: 'Aceptada: todas las comprobaciones pasaron; la respuesta rápida es el resultado.',
					CHECKS: 'Comprobaciones de la puerta',
					COL_CHECK: 'Comprobación',
					COL_VALUE: 'Valor',
					COL_THRESHOLD: 'Umbral',
					COL_RESULT: 'Resultado',
					PASSED: 'Superada',
					FAILED: 'Fallida',
					REASONS: 'Por qué se escaló',
					QUICK_VS_FINAL: 'Respuesta rápida frente a final',
				},
				TITLE: 'Lienzo de ejecución',
				OPEN: 'Abrir lienzo',
				OPEN_HINT: 'Seguir la ejecución paso a paso: cada agente, llamada al modelo y consulta',
				BACK: 'Volver a la alerta',
				RUN_PICKER: 'Ejecución',
				RUN_PICKER_EMPTY: 'Aún no hay ejecuciones',
				LIVE: 'En vivo',
				LIVE_HINT: 'Siguiendo la ejecución en tiempo real (se actualiza cada 1,5 s)',
				ELAPSED: 'Transcurrido',
				DURATION: 'Duración',
				TOKENS: '{{input}} entrada / {{output}} salida tokens',
				EVALUATION: 'Evaluación',
				EVENTS_N: '{{count}} eventos',
				EVENTS_HINT: '{{llm}} llamadas al modelo · {{lookups}} consultas',
				ZOOM_FIT: 'Ajustar al ancho',
				ZOOM_100: 'Tamaño real',
				POLL_ERROR: 'No se pudieron obtener nuevos eventos: {{error}} — reintentando',
				LOADING: 'Cargando la ejecución…',
				NO_RUNS: 'Esta alerta aún no tiene ejecuciones',
				NO_EVENTS: 'No se registraron eventos para esta ejecución (es anterior al lienzo)',
				PICK_NODE: 'Seleccione un nodo para ver lo que recibió y produjo',
				IN_PROGRESS: 'El agente de triaje está en ejecución. Continúa aunque salga de esta página.',
				STALLED_NOTICE: 'Se perdió el contacto con la ejecución; el resultado aparecerá al actualizar la página.',
				RECONSTRUCTED: 'Reconstruido a partir de la traza guardada: esta ejecución es anterior al flujo de eventos, por lo que no hay entradas, salidas, llamadas al modelo ni consultas.',
				PASS_N: 'Pasada {{n}}',
				ROUND_N: 'Ronda {{n}}',
				STATUS: {
					RUNNING: 'En ejecución',
					COMPLETED: 'Completada',
					FAILED: 'Fallida',
					GATED: 'No analizada',
					PENDING: 'Pendiente',
					NO_DATA: 'Sin datos',
					SKIPPED: 'Omitido',
					STALLED: 'Conexión perdida',
				},
				COL: {
					PRE_RUN: 'Preparación',
					RESOLVE: 'Resolución y señal',
					SPECIALISTS: 'Especialistas',
					VERDICTS: 'Veredictos',
					LOOP: 'Bucle de razonamiento',
					DECISION: 'Decisión',
				},
				NODE: {
					LIBRARY_CAUSAL: 'Biblioteca · fundamento causal',
					ESCALATION: 'Puerta de escalado',
					LIBRARY: 'Especialista de biblioteca',
					CONNECTED: 'Sistemas conectados',
					GATE: 'Puerta DQ',
					TOPOLOGY: 'Topología',
					EVIDENCE: 'Evidencia',
					VIEW: 'Vista a fecha',
					FINAL: 'Resultado',
					RESOLVER: 'Resolutor',
					SIGNAL: 'Señal',
					COHORT: 'Cohorte',
					MAINTENANCE: 'Mantenimiento',
					MANUAL_PRECEDENT: 'Precedente de alerta',
					LEARNINGS: 'Aprendizajes',
					PROFILE: 'Perfil',
					MULTIVARIATE: 'Multivariante',
					TMP: 'TMP',
					SHIFT_DPR: 'Turno y DPR',
					VISUAL: 'Analista visual',
					VERDICTS: 'Veredictos',
					HYPOTHESIZE: 'Hipótesis',
					INVESTIGATE: 'Investigación',
					COMPLETENESS: 'Completitud',
					ADJUDICATOR: 'Adjudicador',
					SUPERVISOR: 'Supervisor',
				},
				BADGE: {
					CAUSAL_N: '{{admitted}} extractos · {{queries}} preguntas',
					HEADROOM: '{{kind}} {{value}} · {{pct}}%',
					LIBRARY_N: '{{n}} extractos · {{docs}} docs',
					LIBRARY_LIMITS: '{{n}} extractos · {{limits}} límites',
					GATE_PASS: 'Aprobada',
					GATE_FAIL: 'Rechazada',
					TAGS_N: '{{count}} tags',
					RECORDS_N: '{{count}} registros',
					WITHHELD_N: '{{count}} retenidos',
					RESOLVED: 'Resuelto',
					NOT_RESOLVED: 'No resuelto',
					ALERTS_N: '{{count}} alertas',
					FACTS_N: '{{count}} hechos',
					PRIOR_N: '{{count}} previas',
					LEARNINGS_N: '{{count}} aprendizajes',
					LOADED: 'Cargado',
					NONE: 'Ninguno',
					MOVED_N: '{{moved}} de {{of}} se movieron',
					VERDICTS_N: '{{count}} veredictos',
					LOOKUPS_N: '{{count}} consultas',
					CHECKS_N: '{{ran}} de {{of}} comprobaciones',
					SPECIALISTS_N: '{{n}} de {{of}} especialistas',
				},
				BATCH_BADGE: 'Lote de {{count}} alertas en {{floc}}',
				BATCH_HINT: 'Evaluadas juntas como un episodio: {{ids}}',
				REASSESS_BADGE: 'Reevaluación a fecha {{t}}',
				REASSESS_HINT: 'Evaluación anterior: {{cls}}',
				ZONE: {
					EVIDENCE: 'Recopilación de evidencia',
					PARALLEL: 'en paralelo',
					LOOP: 'Bucle de razonamiento',
					DECISION: 'Decisión',
				},
				LOOP: {
					CAUSAL_HINT: 'Tras la primera pasada del tablero, la Biblioteca plantea preguntas de ingeniería por hipótesis (bases de diseño, cambio, sensibilidad, protección, diagnóstico, acción correctiva) y solo admite extractos sobre este instrumento o equipo como evidencia LIB-n',
					BOARD: 'Tablero de hipótesis',
					INVESTIGATOR: 'Investigador',
					ROUND_OF: 'Ronda {{n}} de máx. {{max}}',
					HINT: 'el tablero propone y pide, el Investigador consulta, el tablero vuelve a ponderar',
					ROUNDS_USED: '{{n}} de máx. {{max}} rondas',
					REQUESTS_N: '{{count}} solicitudes',
					REWEIGH: 'resultados → reponderar',
					LEAD_HINT: 'Hipótesis principal, su peso y el cambio desde la pasada anterior',
					WEIGHING: 'Ponderando hipótesis…',
					NEXT_PASS: 'Siguiente pasada: reponderación',
					CALL_NO_HINT: 'Llamada {{n}} de {{tool}} en esta ejecución',
					CITED_HINT: 'Citada por la siguiente pasada: {{hyps}}',
					REPEAT_OF: 'igual que la ronda {{n}}',
					CALLING: 'Ejecutando consultas…',
					MOVED: 'Pasada {{n}}:',
					MOVED_HINT: 'Cómo se movió el tablero tras leer los resultados de esta ronda',
					SETTLED_FIRST: 'Resuelto en la pasada {{n}}: no hicieron falta consultas',
					SETTLED_AT: 'Resuelto en la pasada {{n}}: no hacen falta más consultas',
					BUDGET_SPENT: 'Presupuesto de rondas agotado ({{max}} de {{max}})',
					SHELF: 'Estante de herramientas',
					SHELF_HINT: 'el Investigador puede llamar a cualquier herramienta, tantas veces como necesite, con distintos argumentos',
					UNUSED: 'no usada en esta ejecución',
				},
				TOOL: {
					SEARCH_LIBRARY: 'Buscar en biblioteca',
					SEARCH_LEARNINGS: 'Buscar aprendizajes',
					CONNECTED_EQUIPMENT: 'Equipos conectados',
					UNIT_SENSORS: 'Sensores de la unidad',
					FIND_SENSORS: 'Buscar sensores',
					PARALLEL_SYSTEMS: 'Sistemas paralelos',
					SISTER_TRAIN: 'Tren gemelo',
					UNIT_ALERTS: 'Alertas de la unidad',
					TAG_WINDOW: 'Ventana del tag',
					TAG_HISTORY: 'Historial del tag',
					SEARCH_RECORDS: 'Buscar registros',
					SEARCH_REPORTS: 'Buscar informes',
				},
				TOOL_HINT: {
					SEARCH_LEARNINGS: 'Aprendizajes y reglas del manual del sitio vigentes en el momento de la alerta, ordenados por significado frente a una pregunta.',
					CONNECTED_EQUIPMENT: 'Unidades de proceso aguas arriba, aguas abajo o hermanas (de los conectores del diagrama de flujo), sus sensores de interfaz y si se movieron antes, con o después del tag de la alerta.',
					UNIT_SENSORS: 'Cómo se comportó una unidad de proceso concreta, sensor por sensor, para las magnitudes pedidas.',
					FIND_SENSORS: 'Qué sensores existen para una pregunta y qué mide cada uno.',
					PARALLEL_SYSTEMS: 'El tren gemelo (FGC A ↔ B, GLC A ↔ B …): sus sensores y alertas en las mismas horas — ¿causa común o local?',
					SISTER_TRAIN: 'El otro tren o la sonda redundante del mismo lazo: ¿causa común o local?',
					UNIT_ALERTS: 'Alertas de vigilancia en una unidad (aguas arriba, aguas abajo, gemela) en las horas previas a la alerta.',
					TAG_WINDOW: 'Estadísticas de cualquier tag en las últimas N horas antes de la alerta.',
					TAG_HISTORY: 'Con qué frecuencia un tag salió de su banda en hasta 180 días y si siguieron trabajos.',
					SEARCH_RECORDS: 'Búsqueda por palabras clave en avisos y órdenes SAP (1 año) e informes de turno (6 meses).',
					SEARCH_REPORTS: 'Informes de supervisión y producción hasta un año atrás; todas las palabras deben coincidir, se devuelven pasajes.',
				},
				CALL: {
					NTH: 'Llamada #{{n}} de {{tool}} en esta ejecución',
					ARGS: 'Argumentos',
					NO_ARGS: 'Sin argumentos',
					REPEAT_NOTE: 'Idéntica a la solicitud de la ronda {{n}}: no se volvió a ejecutar, se reutilizó el resultado anterior.',
					CITED: 'Citada por la pasada {{n}}',
					CALLS_N: '{{count}} llamadas',
					ROUNDS_LIST: 'rondas {{rounds}}',
					NOT_USED: 'El Investigador no usó esta herramienta en esta ejecución.',
					GROUPED: '{{count}} consultas · herramientas usadas: {{tools}}',
					CARRIED: '{{count}} observaciones de rondas anteriores arrastradas',
				},
				EVO: {
					TITLE: 'Cómo la evidencia movió la creencia: peso de cada hipótesis por pasada',
					HYPOTHESIS: 'Hipótesis',
					AFTER_N: 'tras la ronda {{n}} · {{count}} consultas',
					NOT_ON_BOARD: 'No estaba en el tablero en esta pasada',
					AFTER_ROUND: 'tras la ronda {{n}} ({{count}} consultas)',
					CITES: 'la nueva evidencia cita {{calls}}',
					MOVE_AFTER: 'Tras la ronda {{n}}:',
					PRECEDED_BY: 'consultas previas:',
				},
				INSPECTOR: {
					TAB_INPUT: 'Entrada',
					TAB_OUTPUT: 'Salida',
					TAB_MODEL_CALLS: 'Llamadas al modelo',
					TAB_LOOKUPS: 'Consultas',
					TAB_TRACE: 'Traza',
					EMPTY: 'vacío',
					NOT_STARTED: 'Este paso aún no ha comenzado',
					NO_INPUT: 'No se registró entrada para este paso',
					STILL_RUNNING: 'Aún en ejecución — la salida aparecerá cuando el paso termine',
					NO_OUTPUT: 'No se registró salida',
					HYPOTHESES_N: '{{count}} hipótesis',
					REQUESTS: 'Consultas solicitadas',
					WINDOWS: 'Lecturas por ventana',
					LEAK_CHECK: 'Comprobación de fugas: {{value}}',
					MACHINE_STATE: 'Estado de la máquina',
					PACKAGE_TEXT: 'Paquete de señal tal como lo lee el modelo',
					ANOMALY_TEXT: 'Texto del modelo de anomalías',
					NO_LOOKUPS: 'Sin consultas en este paso',
					RAW: 'Toda la salida como datos',
					NO_MODEL_CALLS: 'Sin llamadas al modelo en este paso',
					ATTEMPT_N: 'Intento {{n}}',
					PROMPT: 'Prompt',
					PROMPT_SIZE: '{{chars}} caracteres, {{images}} imágenes',
					IMAGE_PART: 'imagen ({{kb}} KB)',
					RESPONSE: 'Respuesta',
					NO_TRACE: 'Sin línea de traza para este nodo',
				},
			},
			VALIDATION: {
				COLUMN: 'Validación',
				FILTER: 'Validación',
				HUMAN: 'Humana',
				AGENT: 'Agente',
				NONE: 'Sin triaje',
				HUMAN_VALIDATED: 'Validada por humano',
				HUMAN_CORRECTED: 'Corregida por humano',
				AGENT_VALIDATED: 'Validada por el agente',
				TIP_AGENT: 'Triada por el agente; ninguna persona la ha revisado aún',
				TIP_HUMAN_UNKNOWN: 'Validada por una persona',
				TIP_REPLAY: 'Etiqueta HIL reproducida por {{reviewer}} el {{date}}',
				TIP_UI: 'Revisada en UptimeAI por {{reviewer}} el {{date}}',
				TIP_CORRECTED: 'Un humano corrigió al agente: {{agent}} → {{human}}',
				TIP_ABSTAINED: 'El agente lo dejó para revisión humana; el humano la clasificó como {{human}}',
				TIP_AGREED: 'El humano coincidió con el agente: {{human}}',
				CSV: {
					VALIDATED_BY: 'Validada por',
					REVIEWER: 'Revisor',
					REVIEW_SOURCE: 'Origen de la revisión',
				},
			},
			REVIEW: {
				TITLE: 'Revisión SME',
				SOURCE_REPLAY: 'Etiqueta HIL (reproducida)',
				SOURCE_UI: 'Revisada en UptimeAI',
				BY: '{{reviewer}} · {{date}}',
				N_REVIEWS: '{{count}} revisiones',
				LABEL: 'Etiqueta',
				RELIABILITY: 'Fiabilidad: {{value}}',
				RELIABILITY_HIGH: 'alta',
				RELIABILITY_MEDIUM: 'media',
				RELIABILITY_LOW: 'baja',
				RELIABILITY_HINT: 'Hasta qué punto la etiqueta es fiable como verdad de referencia: las etiquetas humanas pueden fallar',
				ACTION_TAKEN: 'Acción tomada',
				NO_LABEL: 'Sin etiqueta registrada',
				AGENT_VS_HUMAN: 'Agente vs. humano',
				AGREEMENT_AGREE: 'Coinciden',
				AGREEMENT_DISAGREE: 'Discrepan',
				AGREEMENT_ABSTAINED: 'Abstención',
				AGENT_CONFIDENCE: 'Confianza del agente {{value}}',
				OUTCOMES: 'Avisos SAP en los 30 días siguientes (a posteriori)',
				REASONS: 'Motivos',
				AGENT_SAW_CHART: 'Juicio del agente sobre el gráfico',
				AGENT_SAW_STATE: 'Estado de la máquina en ese momento',
				LEARNINGS_CHANGED: 'Aprendizajes modificados por esta revisión ({{count}})',
				EARLIER: 'Revisiones anteriores',
				VERDICT: {
					CONFIRMED: 'Confirmada',
					CONFIRMED_HINT: 'El agente y el humano eligieron la misma clase.',
					AGENT_WRONG: 'Agente equivocado',
					AGENT_WRONG_HINT: 'Prevalece la clase del revisor sobre la del agente; el agente fue corregido.',
					AGENT_ABSTAINED: 'Agente se abstuvo',
					AGENT_ABSTAINED_HINT: 'El agente lo dejó para revisión humana; la etiqueta humana fija la clase.',
					HUMAN_LIKELY_WRONG: 'Humano probablemente equivocado',
					HUMAN_LIKELY_WRONG_HINT: 'Etiquetada sin acción, pero hubo avisos SAP en este equipo en los 30 días siguientes; se excluye de la memoria.',
					CONTESTED: 'En disputa',
					CONTESTED_HINT: 'El agente y el humano discrepan y la evidencia posterior no lo resuelve.',
					HUMAN_OVERRIDE: 'Anulación humana',
					HUMAN_OVERRIDE_HINT: 'Una persona en UptimeAI eligió una clase distinta a la del agente; prevalece su decisión.',
				},
			},
			MEMORY: {
				SIMILAR: 'similar {{sim}}',
				SIMILAR_HINT: 'No pertenece al ámbito propio de esta alerta: se añadió porque su significado es cercano a la alerta (similitud 0–1)',
				PROFILE: 'Perfil del detector',
				TITLE: 'Memoria operativa utilizada',
				CHIP: 'Memoria: {{learnings}} aprendizajes, {{precedents}} precedentes revisados',
				CHIP_HINT: 'Aprendizajes y precedentes revisados por humanos, conocidos antes de esta alerta, que consultó el agente',
				NO_LEARNINGS: 'Ningún aprendizaje aplicado',
				PRECEDENTS: '{{count}} precedentes revisados',
				SHOW_TRACE: 'Ver en la traza',
			},
			LEARNINGS: {
				STATUS_RETIRED: 'Retirado',
				SCOPE_PLAYBOOK: 'Manual del sitio',
				SCOPE_PROFILE: 'Perfil del detector',
				ALL_SCOPES: 'Todos los tipos de ámbito',
				MEANING_PLACEHOLDER: 'Buscar por significado, p. ej. temperatura de cojinete tras reinicio',
				MEANING_SEARCH: 'Buscar',
				MEANING_HINT: 'Ordena los aprendizajes actuales según lo cerca que está su significado de sus palabras (embeddings), no por palabras exactas. Pulse Intro para buscar; vacíe el cuadro para ver todos.',
				RANKED_BY: 'Ordenado por significado: «{{q}}»',
				COL_SIMILARITY: 'Similitud',
				SIMILARITY_HINT: 'Similitud coseno del significado (0–1); por encima de 0,8 aprox. es una coincidencia cercana',
				COL_LEARNING: 'Aprendizaje',
				COL_EDITED: 'Editado por',
				EDITED_BY: 'Editado por {{name}}',
				EDIT_REASON: 'Motivo: {{reason}}',
				NO_DISPOSITION: 'ninguna (contexto)',
				N_ALERTS: '{{count}} alertas',
				NO_MATCH: 'Nada con un significado cercano',
				NO_MATCH_HINT: 'Pruebe otras palabras o vacíe la búsqueda para ver todos los aprendizajes.',
				BUTTON: 'Aprendizajes',
				BUTTON_HINT: 'Aprendizajes y memoria operativa de revisiones humanas',
				TITLE: 'Aprendizajes y memoria operativa',
				SUBTITLE: 'Reglas extraídas de revisiones humanas de alertas comparables; el agente solo consulta las conocidas antes de cada alerta',
				REFRESH: 'Actualizar',
				STAT_REVIEWS: 'Revisiones humanas',
				STAT_REPLAYED: '{{count}} etiquetas HIL reproducidas',
				STAT_IN_APP: '{{count}} en UptimeAI',
				STAT_AGREEMENT: 'Agente vs. humano',
				STAT_RECONCILIATION: 'Conciliación',
				STAT_LEARNINGS: 'Aprendizajes',
				STATUS_ACTIVE: 'Activo',
				STATUS_CANDIDATE: 'Candidato',
				STATUS_CONTESTED: 'En disputa',
				SCOPE_SIGNAL: 'Señal',
				SCOPE_EQUIPMENT: 'Equipo + detector',
				SCOPE_DETECTOR: 'Detector',
				SEARCH: 'Buscar ámbito, detector o regla',
				N_SHOWN: '{{shown}} de {{total}}',
				EMPTY: 'Aún no hay aprendizajes',
				EMPTY_HINT: 'Los aprendizajes aparecen cuando las personas revisan alertas triadas.',
				COL_SCOPE: 'Ámbito',
				COL_SCOPE_TYPE: 'Tipo de ámbito',
				COL_DISPOSITION: 'Disposición',
				COL_SUPPORT: 'Soporte',
				COL_SUPPORT_HINT: 'Revisiones que coinciden con la disposición / revisiones en el ámbito · consistencia',
				COL_STATUS: 'Estado',
				COL_EFFECTIVE: 'Vigente desde',
				COL_CORRECTED: 'Agente corregido',
				COL_CORRECTED_HINT: 'Revisiones en las que la persona corrigió al agente',
				COL_VERSION: 'Versión',
				RULE: 'Regla operativa',
				AUTHOR: 'Autor: {{author}}',
				CLASS_COUNTS: 'Clases humanas',
				REASONS: 'Motivos',
				CHART_PATTERNS: 'Patrones del gráfico',
				MACHINE_STATES: 'Estados de la máquina',
				SOURCE_ALERTS: 'Alertas de origen ({{count}})',
				OPEN_ALERT: 'Abrir alerta',
				VERSIONS: 'Historial de versiones',
				SUPERSEDED: 'Reemplazada',
				CURRENT: 'Actual',
			},
			PROCESS: {
				TITLE: 'Topología del proceso y jerarquía',
				FLOW_SUMMARY: '{{up}} aguas arriba · {{down}} aguas abajo',
				FLOW_SUMMARY_UNITS: '{{up}} aguas arriba · {{down}} aguas abajo (unidades de proceso)',
				PROCESS_UNITS: 'Unidades de proceso (PEFS)',
				NO_PID_LINE: 'Ninguna línea trazada en los P&ID digitalizados; enlaces de los conectores del esquema de flujo',
				IN_UNIT: 'Unidad de proceso: {{name}}',
				SERVING: 'Servicios auxiliares',
				RELIEF: 'Alivio',
				UNIT_TIP: '{{hops}} salto(s) · {{media}} · confianza {{confidence}}',
				SOURCE_PID: 'Flujo de equipos de los P&ID digitalizados (líneas trazadas en un plano).',
				SOURCE_BOTH: 'Flujo de equipos de los P&ID digitalizados (un plano a la vez); unidades de proceso de los conectores entre hojas del PEFS, la misma vista que usa el análisis de sistemas conectados.',
				HIERARCHY: 'Jerarquía de activos',
				LEVEL_SITE: 'Sitio',
				LEVEL_SYSTEM: 'Sistema',
				LEVEL_SUBSYSTEM: 'Subsistema',
				LEVEL_EQUIPMENT: 'Equipo',
				LEVEL_PACKAGE: 'Paquete',
				LEVEL_OTHER: 'Nivel',
				NOT_IN_TREE: 'No está en el árbol de activos',
				NOT_IN_TREE_HINT: 'El equipo de la alerta no tiene ubicación técnica en el árbol de activos de SAP.',
				PARTIAL_TREE: 'Solo parte de la ruta pudo ubicarse en el árbol de activos.',
				SIBLINGS: '{{count}} equipos más en {{parent}}',
				SHOW_ALL: 'Mostrar los {{count}}',
				SHOW_FEWER: 'Mostrar menos',
				N_TAGS: '{{count}} tags',
				NO_TREE_TAGS: 'No hay tags del historiador en este nodo',
				FLOW: 'Flujo del proceso',
				UPSTREAM: 'Aguas arriba',
				DOWNSTREAM: 'Aguas abajo',
				ALERT_EQUIPMENT: 'Equipo de la alerta',
				MEASURED_BY: 'Instrumento de la alerta',
				HOPS: 'A {{count}} salto(s)',
				NONE_UPSTREAM: 'Nada aguas arriba',
				NONE_DOWNSTREAM: 'Nada aguas abajo',
				NO_FLOW: 'No hay enlaces de flujo de proceso para este equipo en los P&ID digitalizados',
				NOT_IN_PIDS: 'Equipo no encontrado en los P&ID digitalizados',
				NOT_IN_PIDS_HINT: 'Sin una coincidencia en los P&ID para el equipo de la alerta no se pueden mostrar los elementos aguas arriba ni aguas abajo.',
				CONNECTED: 'Elementos conectados',
				NO_CONNECTED: 'Ningún otro elemento está conectado a este equipo en los P&ID digitalizados.',
				EDGE_SERVES: 'Abastece',
				EDGE_SENSES: 'Detecta',
				EDGE_CONTROLS: 'Controla',
				EDGE_PROTECTS: 'Protege',
				EDGE_SAME_LINE: 'Misma línea de proceso',
				EDGE_MEASURES: 'Mide',
				EDGE_FLOWS_TO: 'Fluye hacia',
				EDGE_OTHER: 'Otros enlaces',
				CHART_TAGS: 'Graficar los tags de este elemento en la pestaña Tags',
				NO_TAGS_FOR_ITEM: 'No hay tags del historiador vinculados a este elemento',
				NO_DATA_TAGS: 'El árbol de activos no asigna tags a este elemento',
				TAGS_FAILED: 'No se pudieron cargar los tags de este elemento',
				FROM_TREE: 'Número de tags según el árbol de activos',
				CLICK_HINT: 'Haga clic en un elemento para graficar sus tags del historiador (hasta 8, primero los que tienen datos).',
			},
			ANALYSIS: {
				FOUND_BY_MEANING: 'encontrado por significado',
				FOUND_BY_MEANING_SIM: 'encontrado por significado · {{sim}}',
				FOUND_BY_MEANING_HINT: 'Búsqueda híbrida: los registros se encuentran por sus palabras y por su significado (embeddings). Este lo añadió la búsqueda por significado desde el mismo subsistema; el número es su similitud con la alerta (0–1).',
				LEVEL_SHIFTS: 'Cambios de nivel',
				LEVEL_SHIFTS_HINT: 'Momentos antes del corte en que una etiqueta modelada pasó a un nuevo nivel y se mantuvo (tamaño en desviaciones estándar de la línea base, media antes → después).',
				MODEL_CACHED: 'modelo reutilizado (entrenado una vez por máquina y día)',
				MODEL_CACHED_HINT: 'La misma máquina ya tenía un modelo entrenado para este día, con datos que terminan antes de este corte; se reutilizó en lugar de reentrenarlo.',
				REGIMES: 'Ajustado por régimen de operación de {{tag}}: {{parts}} (separados {{sep}} sd)',
				REGIMES_HINT: 'La etiqueta de marcha mostró dos niveles de operación distintos (porcentaje del tiempo @ nivel), así que lo normal se aprendió por separado para cada uno.',
				TRAINED_ON: 'Entrenado con {{from}} – {{to}}',
				WINDOW_3M: '3 meses',
				WINDOW_1W: '1 semana',
				WINDOW_1D: '1 día',
				REASONING: 'Razonamiento',
				SETTLED: 'Resuelto',
				UNSETTLED: 'Sin resolver',
				SETTLED_HINT: 'El tablero de hipótesis se detuvo porque ninguna consulta adicional podía cambiar la hipótesis principal',
				UNSETTLED_HINT: 'El tablero se detuvo en su límite de pasadas con consultas aún pendientes',
				BOARD_META: '{{passes}} pasadas · {{lookups}} consultas',
				HYPOTHESES: 'Hipótesis',
				WEIGHT_HINT: 'Peso de esta hipótesis en el tablero (todas las hipótesis suman 100 %)',
				IMPLIES_HINT: 'Clasificación que implica esta hipótesis si se confirma',
				STATUS_VALIDATED: 'Validada',
				STATUS_REFINED: 'Refinada',
				STATUS_DEBUNKED: 'Descartada',
				STATUS_OPEN: 'Abierta',
				FOR: 'A favor',
				AGAINST: 'En contra',
				NONE: 'Ninguno',
				CONFLICTS: 'Contradicciones',
				LOOKUPS: 'Consultas del investigador',
				ROUND_N: 'Ronda {{n}}',
				ROUND_OTHER: 'Otras consultas',
				WHY_ASKED: 'Por qué se consultó:',
				RESULT: 'Resultado',
				SIGNAL_TITLE: 'Señal y máquina',
				N_TAGS: '{{n}} tags',
				RUNNING_AT_CUTOFF: 'En marcha al corte',
				STOPPED_AT_CUTOFF: 'Parada al corte',
				SINCE_RESTART: 'Desde el rearranque',
				SINCE_STOP: 'Desde la parada',
				HOURS: '{{n}} h',
				LAST_SHUTDOWN: 'Última parada',
				ONGOING: 'en curso',
				RUN_SOURCE: 'Estado de marcha: {{source}} ({{tag}})',
				RUNNING_PCT_HINT: 'Parte de la ventana en que la máquina estuvo en marcha (verde) o parada (rojo)',
				RUNNING: 'en marcha',
				SHUTDOWNS: 'paradas',
				DOWN: 'parada',
				MACHINE_UNKNOWN: 'Estado de marcha desconocido: no hay tag de estado de marcha para este equipo.',
				CHARTS_READ: 'Gráficos leídos por el modelo',
				ANOMALY_SCORE: 'Puntuación de anomalía',
				ENLARGE: 'Haga clic para ampliar',
				READ_ALERT_TAG: 'Tag de alerta',
				READ_RELATED: 'Tags relacionados',
				READ_MACHINE: 'Máquina',
				READ_ANOMALY: 'Lectura del modelo',
				CONSISTENT_WITH_HISTORY: 'Coherente con el histórico',
				NOT_CONSISTENT_WITH_HISTORY: 'No coherente con el histórico',
				STATS_TITLE: 'Estadísticas frente a la referencia',
				STATS_HINT: '— pase el cursor por una celda para ver p5–p95, pendiente y primera excursión de 3 sd',
				COL_TAG: 'Tag',
				COL_MEDIAN: 'Mediana',
				COL_LAST: 'Último',
				COL_Z: 'z (med.)',
				COL_Z_HINT: 'Mediana de la ventana en desviaciones estándar de referencia',
				COL_OUT: '% fuera',
				COL_OUT_HINT: 'Proporción de lecturas fuera de la banda de referencia p5–p95',
				ALERT_TAG: 'alerta',
				RUN_TAG: 'marcha',
				TIP_BASELINE: 'Referencia: mediana {{median}} ± {{sd}} sd, p5–p95 {{p5}}–{{p95}} {{unit}}',
				TIP_SPIKES: 'Picos eliminados: {{value}}',
				TIP_MASKED: 'Lecturas con fallo enmascaradas: {{n}}',
				TIP_RANGE: 'p5–p95: {{p5}} – {{p95}} {{unit}}',
				TIP_SLOPE: 'Pendiente: {{value}} {{unit}}/día',
				TIP_Z_LAST: 'z (último): {{value}} · |z| máx.: {{max}}',
				TIP_FIRST_3SD: 'Primera vez más allá de 3 sd: {{value}} UTC',
				TIP_NEVER_3SD: 'Nunca más allá de 3 sd en esta ventana',
				FOOT_SPIKES: 'Picos aislados eliminados antes de las estadísticas: {{value}}.',
				FOOT_MASKED: '{{n}} lecturas con fallo (mala calidad / fuera de rango) enmascaradas.',
				ANOMALY_TITLE: 'Modelo de anomalías',
				NOT_AVAILABLE: 'No disponible',
				VERDICT_CONSISTENT: 'Coherente',
				VERDICT_CHANGED: 'Cambiado',
				VERDICT_STARTUP: 'Transitorio de arranque',
				VERDICT_INSUFFICIENT: 'Datos insuficientes',
				MODEL_META: 'PCA {{k}} comp. · {{pct}} de varianza · {{rows}} filas de entrenamiento',
				ONSET: 'Inicio sostenido',
				NO_ONSET: 'ninguno',
				FIRST_TO_DEVIATE: 'Primer tag en desviarse',
				ABOVE_LIMIT_24H: 'Últimas 24 h por encima del límite',
				T2_SPE_HINT: 'Las puntuaciones son relativas al percentil 99,5 del entrenamiento (1,0 = límite). T² alto = los tags se movieron juntos a un punto de operación inusual; SPE alto = un tag ya no concuerda con los demás (fallo local o de instrumento); AE = error de reconstrucción del autoencoder.',
				AT_CUTOFF: 'Al corte',
				AT_PEAK: 'Pico de las últimas 24 h',
				IN_TRANSIENT: 'Dentro del transitorio de arranque',
				SCORE: 'Puntuación',
				KIND_NORMAL: 'Dentro de lo normal',
				KIND_SPE: 'Relación rota (SPE): un tag ya no concuerda con los demás',
				KIND_T2: 'Punto de operación desplazado (T²): los tags se movieron juntos, relaciones mantenidas',
				KIND_BOTH: 'Punto de operación inusual y relaciones rotas',
				ACTUAL_VS_EXPECTED: 'Real frente a esperado según los demás tags',
				NOT_MODELLED: 'No modelados (poco historial de marcha): {{tags}}',
				RECORDS_TITLE: 'Registros leídos',
				OPEN_KNOWN_ISSUE: 'Problema conocido abierto',
				NO_OPEN_KNOWN_ISSUE: 'Sin problema conocido abierto',
				OPEN_KNOWN_ISSUE_HINT: 'Si un aviso u orden de trabajo abierto ya cubre esta condición en el momento de la alerta',
				RECORDS_COUNT: '{{read}} de {{total}} registros leídos · {{cited}} citados',
				RECORDS_COUNT_HINT: 'Registros existentes antes de la alerta: {{work}} de mantenimiento, {{reports}} informes de turno, {{deferments}} pérdidas de producción; se leyeron los mejor clasificados',
				OPERATING_EVENTS: 'Eventos operativos antes de la alerta',
				FACTS: 'Hechos citados',
				NO_FACTS: 'Ningún registro afecta a esta alerta.',
				RELEVANCE_DIRECT: 'Directo',
				RELEVANCE_RELATED: 'Relacionado',
				RELEVANCE_BACKGROUND: 'Contexto',
				IMPL_KNOWN_ISSUE: 'Problema conocido abierto',
				IMPL_RECENT_WORK: 'Trabajo reciente lo explica',
				IMPL_OPERATING_EVENT: 'Evento operativo',
				IMPL_INSTRUMENT: 'Problema de instrumento',
				IMPL_DEGRADATION: 'Señal de degradación',
				DIR_NO_ACTION: 'A favor de no actuar',
				DIR_SERVICE: 'A favor de servicio',
				DIR_NEUTRAL: 'Neutral',
				OPEN_IN_MAINTENANCE: 'Mostrar en la pestaña Mantenimiento',
				OPEN_IN_REPORTS: 'Mostrar en la pestaña Informes',
				DROPPED: '{{n}} leídos pero no relevantes: {{ids}}',
			},
			VISUAL: {
				TITLE: 'Revisión de gráficos',
				PATTERN_TOGETHER: 'Los tags se movieron juntos',
				PATTERN_DEPARTED: 'Un tag se desvió solo',
				PATTERN_SHUTDOWN: 'Parada / arranque',
				PATTERN_NO_CHANGE: 'Sin cambio significativo',
				PATTERN_SPLIT: 'Tags relacionados divididos',
				PATTERN_INSUFFICIENT: 'Datos insuficientes para juzgar',
				PATTERN_UNKNOWN: 'Sin clasificar',
				CONFIDENCE: 'Confianza {{value}}',
				CONFIDENCE_HINT: 'Confianza del juicio final',
				MOVED_TOGETHER_YES: 'Se movieron juntos',
				MOVED_TOGETHER_NO: 'No se movieron juntos',
				DISAGREE: 'Las estadísticas y los gráficos no coinciden: revise los gráficos antes de confiar en este juicio.',
				AGREE: 'Los gráficos coinciden con las estadísticas',
				STATISTICS_SAY: 'Según las estadísticas',
				CHARTS_SAY: 'Según los gráficos',
				LED_BY: 'Liderado por',
				LED_BY_HINT: 'El tag que se movió primero',
				DEPARTED_ALONE: 'Se desvió solo',
				DEPARTED_ALONE_HINT: 'El tag que se movió mientras sus tags relacionados se mantenían',
				REASONING: 'Razonamiento',
				CHARTS: 'Gráficos leídos por el modelo ({{count}})',
				NO_CHARTS: 'No se guardaron imágenes de gráficos para esta ejecución.',
				OPEN_CHART: 'Abrir gráfico {{n}}',
				CHART_ALT: 'Gráfico {{n}} hasta la hora de la alerta',
				CHART_FAILED: 'No se pudo cargar la imagen del gráfico',
				CHART_N_OF: 'Gráfico {{n}} de {{total}}',
				CHART_DIALOG_HINT: 'Los gráficos terminan justo antes de la alerta. Use ← / → para navegar.',
				PREV_CHART: 'Gráfico anterior',
				NEXT_CHART: 'Gráfico siguiente',
				REVIEWS: 'Revisiones por tag ({{count}})',
				LEVEL: 'Nivel: {{value}}',
				FLUCTUATION: 'Fluctuación: {{value}}',
				MODEL: 'Revisado por {{model}}',
			},
			CONTEXT: {
				MODE_PID: 'P&ID',
				MODE_GRAPH: 'Grafo de contexto',
				CHOOSE_DRAWING: 'Elegir plano',
				ITEMS_COUNT: '{{count}} resaltados',
				HAS_INSTRUMENT: 'instrumento de la alerta',
				HAS_EQUIPMENT: 'equipo de la alerta',
				TITLE_INSTRUMENT: 'Ubicación resaltada del instrumento {{tag}}',
				TITLE_EQUIPMENT: 'Ubicación resaltada del equipo {{tag}}',
				LOADING: 'Cargando contexto del proceso…',
				LOAD_FAILED: 'No se pudo cargar el contexto del proceso de esta alerta.',
				UNRESOLVED: 'El equipo y el instrumento de la alerta no están en el grafo de conocimiento',
				UNRESOLVED_HINT: 'No se puede mostrar la ubicación en el P&ID ni los activos conectados.',
				NO_DRAWING: 'Ningún P&ID digitalizado muestra este equipo',
				NO_DRAWING_HINT: 'Use el grafo de contexto para ver los activos conectados.',
				SAME_LINE: 'En la misma línea',
				SAME_LINE_EMPTY: 'No hay elementos en la misma línea de proceso.',
				CONNECTED_ON_DRAWING: 'Conectados en el plano',
				CONNECTED_EMPTY: 'No hay elementos conectados en este plano.',
				CONNECTED_ELSEWHERE: 'Conectados, fuera de este plano',
				LOCATE: 'Mostrar en el plano',
				ADD_TO_CHART: 'Añadir {{tag}} a los gráficos',
				NOT_LINKED: 'no vinculado',
				GRAPH_EMPTY: 'No se encontraron activos conectados para esta alerta.',
				GRAPH_HINT: 'Tamaño = número de tags · haga clic en un nodo con tag del historiador para graficarlo',
				ROLE: {
					ALERT_EQUIPMENT: 'Equipo de la alerta',
					ALERT_INSTRUMENT: 'Instrumento de la alerta',
					CONNECTED: 'Conectado',
					SAME_LINE: 'Misma línea de proceso',
					OTHER: 'Otro',
				},
				EDGE: {
					FLOWS_TO: 'Fluye a',
					SERVES: 'Sirve a',
					SENSES: 'Mide',
					CONTROLS: 'Controla',
					PROTECTS: 'Protege',
					SAME_LINE: 'Misma línea',
					MEASURES: 'Mide',
					RELATED: 'Relacionado',
				},
				NODE_TYPE: {
					EQUIPMENT: 'Equipo',
					INSTRUMENT: 'Instrumento',
					CONTROLVALVE: 'Válvula de control',
					PROCESSLINE: 'Línea de proceso',
				},
				TOOLTIP: {
					TAG: 'Tag',
					HISTORIAN_TAG: 'Tag del historiador',
					TYPE: 'Tipo',
					ROLE: 'Rol',
					TAG_COUNT: 'Tags del historiador',
					LINE: 'Línea',
					DRAWING: 'Plano',
				},
			},
			PAGE_TITLE: 'Alertas',
			ENTERPRISE: 'Shell',
			SEARCH_PLACEHOLDER: 'Buscar...',
			SEARCH_OWNER: 'Buscar responsable...',
			OWNER_FILTER: 'Filtrar por responsable',
			CHOOSE_STATUSES: 'Elija los estados a mostrar',
			ALL_STATUSES: 'Todos los estados',
			FILTERS: 'Filtros',
			MORE: 'Más',
			WATCHERS: 'Observadores',
			COLLAPSE_PANEL: 'Contraer panel',
			EXPAND_PANEL: 'Expandir panel',
			RETRY: 'Reintentar',
			CLOSE: 'Cerrar',
			PREVIOUS: 'Alerta anterior',
			NEXT: 'Alerta siguiente',
			SCORE: 'Puntuación',
			SEE_MORE: 'Ver más',
			SEE_LESS: 'Ver menos',
			CLASS: {
				FALSE_NO_ACTION: 'Falsa – Sin acción',
				FALSE_DQ: 'Falsa – Calidad de datos (DQ)',
				VALID_NO_ACTION: 'Válida – Sin acción',
				CREATE_SERVICE: 'Válida – Crear servicio',
				HUMAN_REVIEW: 'Revisión SME',
				PENDING: 'Pendiente',
			},
			CLASS_OPTION: {
				FALSE_DQ: 'False – DQ (raised on bad data: instrument or data feed)',
				HUMAN_REVIEW: 'Revisión SME (se requiere evaluación manual)',
				CREATE_SERVICE: 'Crear caso (iniciar investigación y acción)',
				VALID_NO_ACTION: 'Válida – sin acción (cerrar evento – sin servicio)',
				FALSE_NO_ACTION: 'Falsa – sin acción (cerrar evento – sin servicio)',
			},
			STATUS: {
				ACKNOWLEDGED: 'Acknowledged',
				UNACKNOWLEDGED: 'Unacknowledged',
				DEFECT_RAISED: 'Pending – Defect Raised',
				UNACTIONED: 'Sin acción',
				APPROVED: 'Aprobada',
				RELEARNED: 'Reaprendida',
			},
			STATE: {
				ACTIVE: 'Activa',
				RETURNED_TO_NORMAL: 'Vuelta a la normalidad',
			},
			TELEMETRY: {
				TITLE: 'Serie temporal',
				AVAILABLE: 'Disponible',
				MISSING: 'Faltante',
				TIP_AVAILABLE: 'Lecturas del historiador para {{tag}} en las 24 h previas a la alerta',
				TIP_NO_DATA: 'Sin lecturas del historiador para {{tag}} en las 24 h previas a la alerta',
				TIP_NOT_IN_HISTORIAN: '{{tag}} no está en el historiador',
				TIP_NO_TAG: 'La alerta no indica ninguna etiqueta del historiador',
				UNUSABLE: 'No utilizable',
				TIP_UNKNOWN: 'No se pudo comprobar la disponibilidad',
			},
			TAGX: {
				THIS_EQUIPMENT: 'Este equipo',
				ALL_EQUIPMENT: 'Todos los equipos relacionados ({{count}})',
				FILTER: 'Filtrar',
				HISTORIAN_RESULTS: 'Búsqueda en el historian',
				MODE_FUNCTION: 'Por función',
				MODE_RELATION: 'Por relación',
				FILTER_MEASURE: 'Filtrar por magnitud medida',
				FILTER_GROUP: 'Filtrar por grupo funcional',
				CLEAR_FILTERS: 'Quitar filtros',
				SHOW_ALL: 'Mostrar todo ({{count}} más)',
				NO_MATCHES_FILTERED: 'Sin coincidencias para los filtros seleccionados',
				TITLE: 'Mostrar otros tags',
				SEARCH_PLACEHOLDER: 'Buscar tags por nombre o descripción',
				MIN_CHARS: 'Escriba al menos 2 caracteres',
				SEARCHING: 'Buscando…',
				NO_MATCHES: 'No hay tags coincidentes',
				HAS_DATA: 'Datos de historiador disponibles',
				NO_DATA: 'Sin datos de historiador',
				SELECTED: '{{count}} / {{max}} seleccionados',
				MAX_REACHED: 'Se pueden seleccionar como máximo {{max}} tags',
				CLEAR: 'Borrar selección',
				CHART_TOGETHER: 'Graficar juntos',
				HIDE_CHART: 'Ocultar gráfico',
				IN_LIST: 'En la lista',
				VIA: 'vía {{via}}',
				GROUP_ALERT: 'Tag de la alerta',
				GROUP_COMPONENT: 'Mismo componente',
				GROUP_EQUIPMENT: 'Mismo paquete / equipo',
				GROUP_CONNECTED: 'Equipos conectados',
				GROUP_PID: 'Instrumentos de P&ID',
				GROUP_OTHER: 'Otros relacionados',
				GROUP_SEARCH: 'Añadidos desde la búsqueda',
				NO_TAGS: 'No se encontraron tags relacionados',
				LOADING: 'Cargando tags relacionados…',
				FILTER_EMPTY: 'Ningún tag relacionado coincide con «{{q}}»',
			},
			QUEUE: {
				DATE_FIELD: 'Filtrar por campo de fecha',
				DATE_FIELD_EVENT: 'Hora del evento',
				DATE_FIELD_RAISED: 'Generada',
				SORT_OLDEST: 'Más antiguas primero (clic para invertir)',
				SORT_NEWEST: 'Más recientes primero (clic para invertir)',
				PAGE_SIZE: 'Filas por página',
				RANGE: '{{start}}–{{end}} de {{total}}',
				FIRST_PAGE: 'Primera página',
				PREV_PAGE: 'Página anterior',
				NEXT_PAGE: 'Página siguiente',
				LAST_PAGE: 'Última página',
				GROUPED_PAGE_HINT: 'Los grupos se forman con las alertas de esta página',
				ON_THIS_PAGE: 'en esta página',
				SIGNAL_START: 'Inicio del evento',
				RAISED: 'Creada el',
				RETURNED_TO_NORMAL_AT: 'Última actividad (volvió a la normalidad)',
				BASELINE_REF: 'Referencia de línea base',
				BASELINE_REF_TIP: 'Referencia de línea base del detector ({{time}}): la hora "last recorded on …" citada en la descripción de la alerta. No es la hora del evento.',
				NOT_ANALYSED: 'No analizada: {{reason}}',
				NOT_ON_PAGE: 'La repetición no está en esta página. Ábrala para ver los detalles.',
				COLUMNS: 'Columnas',
				RESET_COLUMNS: 'Mostrar todas las columnas',
				SET_STATUS: 'Establecer el estado de las alertas seleccionadas',
				CSV: {
					PROCESS_UNIT: 'UNIDAD_PROCESO',
					FLOC: 'FLOC',
					POINTS: 'TAGS',
					DEFINITION_ID: 'ID_DEFINICION',
					NUMBER: '#',
					ALERT_ID: 'ID de alerta',
					SYSTEM_NAME: 'Nombre del sistema',
					SYSTEM: 'Sistema',
					STATUS: 'Estado',
					CLASSIFICATION: 'Clasificación',
					CONFIDENCE: 'Confianza',
					ALERT_NAME: 'Nombre de la alerta',
					SOURCE: 'Fuente',
					EVENT_TIME: 'Inicio del evento (inicio de la señal)',
					RAISED: 'Creada el',
					RETURNED_TO_NORMAL: 'Última actividad (vuelta a la normalidad)',
					BASELINE_REF: 'Referencia de línea base',
					STATE: 'Situación',
					TIME_SERIES: 'Serie temporal',
					ANCHOR_TAG: 'Tag de anclaje',
					NOT_ANALYSED: 'No analizada (control DQ)',
					OWNER: 'Responsable',
				},
				COLUMN_NUMBER: 'Número',
				SORT_BY_COLUMN: 'Ordenar por esta columna',
				DATE_ON_EVENT: 'El rango de fechas se aplica al inicio del evento',
				DATE_ON_CREATED: 'El rango de fechas se aplica a Creada el (columna ordenada)',
				SHOW_COLUMNS: 'Mostrar columnas',
				SEARCH_COLUMNS: 'Buscar...',
				SELECT_ALL_COLUMNS: 'Seleccionar todo',
				RESET_DEFAULT_COLUMNS: 'Restablecer',
				RESIZE_COLUMN: 'Arrastre para cambiar el ancho',
				STILL_ACTIVE: 'Aún activa',
			},
			GROUP_BY: {
				TITLE: 'Agrupar por',
				EQUIPMENT: 'Equipment',
				NONE: 'Ninguno',
				SYSTEM: 'Sistema',
				FACILITY: 'Instalación',
				SOURCE: 'Origen',
				CLASSIFICATION: 'Clasificación',
				ALERT_STATUS: 'Estado de alerta',
			},
			MENU: {
				EXPORT: 'Exportar datos',
				COLLAPSE_GROUPS: 'Contraer todos los grupos',
				EXPAND_WITHIN_GROUP: 'Expandir todos los elementos del grupo',
				AUTO_REFRESH: 'Actualización automática',
			},
			AUTO_REFRESH: {
				OFF: 'Desactivada',
				LIVE: 'En vivo',
				MIN_5: '5 minutos',
				MIN_15: '15 minutos',
				MIN_30: '30 minutos',
				HOUR_1: '1 hora',
			},
			FILTER: {
				TITLE: 'Filtrar por',
				SEARCH_ALERT_NAME: 'Buscar por nombre de alerta...',
				START_TYPING: 'Escriba para buscar',
				APPLY: 'Aplicar',
				CLEAR_ALL: 'Borrar todo',
				TARGET_ONLY: 'Solo FLOC objetivo',
				TARGET_TIP: 'Solo alertas en los FLOC objetivo indicados en Jerarquías de activos → Jerarquía FLOC',
				TARGET_COUNT: '{{count}} alertas en la vista actual',
			},
			TABLE: {
				STEP: 'Step',
				STEP_HINT: 'The triage-path step that decided the alert (amber: held for SME review)',
				TYPE: 'Type',
				PLUS_TAGS: '+{{count}} tags',
				DEFINITION_ID: 'ID de definición',
				ALERTS: 'Alertas',
				N_ALERTS: '{{count}} alertas',
				SYSTEM_NAME: 'Nombre del sistema',
				STATUS: 'Estado',
				CLASSIFICATION: 'Clasificación',
				CONFIDENCE: 'Conf.',
				ALERT_NAME: 'Nombre de la alerta',
				SOURCE: 'Origen',
				EVENT_TIME: 'Inicio del evento',
				STATE: 'Estado',
				OWNER: 'Responsable',
				EMPTY: 'Ninguna alerta coincide con los filtros actuales',
				RECURRING: 'Recurrente: {{count}} apariciones en este episodio',
				TOGGLE_RECURRING: 'Mostrar alertas recurrentes',
				CREATED_ON: 'Creada el',
				LAST_ACTIVE: 'Última actividad',
			},
			BULK: {
				ITEMS: 'elementos',
				ASSIGN_OWNER: 'Asignar responsable a las alertas seleccionadas',
				CHANGE_CLASSIFICATION: 'Cambiar clasificación',
				DONE: '{{count}} alertas actualizadas',
				PARTIAL: '{{ok}} alertas actualizadas, {{failed}} no se pudieron actualizar',
			},
			ACTIONS: {
				APPROVE: 'Aprobar',
				APPROVED: 'Aprobada',
				RELEARN: 'Reaprender',
				RELEARNED: 'Reaprendida',
				CLASSIFY: 'Clasificar',
			},
			DETECTOR: {
				POINTS_FROM_SIGNAL_TEXT: 'Tags leídos de SignalMeasurementText',
				POINTS_FROM_DESCRIPTION: 'Tags leídos de la descripción de la alerta',
				PRIMARY: 'principal',
				TAGS_TIP: 'Tags a los que se refiere esta alerta ({{count}}):',
				TAGS_N: 'Tags ({{count}})',
				LABEL: 'Detector',
				MECHANISM: 'Mecanismo de detección',
				MONITORED_TAG: 'Etiqueta monitorizada',
				CLUSTER_SIZE: 'Tamaño del grupo',
				FREQUENCY: 'Frecuencia',
				WINDOW_SPAN: 'Duración de la ventana',
				N_ALERTS: '{{count}} alertas',
				PER_HOUR: '{{value}} alertas/h',
				HOURS: '{{value}} horas',
			},
			DQ: {
				STATUS_UNUSABLE: 'Unusable',
				PENDING_DEFECT: 'Defect raised',
				PENDING_DEFECT_TIP: 'Instrument work order {{wo}}: pending',
				TITLE: 'Evaluación de calidad de datos (DQ)',
				FROZEN: 'Línea plana',
				IMPOSSIBLE_ROC: 'Tasa de cambio',
				DOMAIN_RANGE: 'Fuera de rango',
				JITTER: 'Errático',
				PASS_FROZEN: 'Superado (dinámico)',
				PASS_IMPOSSIBLE_ROC: 'Superado',
				PASS_DOMAIN_RANGE: 'Dentro de los límites',
				PASS_JITTER: 'Señal normal',
				FAIL_FROZEN: 'Congelado',
				FAIL_IMPOSSIBLE_ROC: 'No superado',
				FAIL_DOMAIN_RANGE: 'Fuera de rango',
				FAIL_JITTER: 'Señal errática',
				NOT_ASSESSED: 'No evaluado',
				STATUS_PASS: 'Aprobado',
				STATUS_WARN: 'Advertencia',
				STATUS_FAIL: 'Fallido',
				STATUS_NO_DATA: 'Sin datos',
				STATUS_UNKNOWN: 'No evaluado',
				NOT_ANALYSED: 'No analizado',
				READINGS: '{{n}} lecturas · {{bad}} enmascaradas',
				CHECK_INFO: 'Informativo',
				NO_GATE: 'La calidad de datos no se ha evaluado para esta alerta',
				SCORE: 'Puntuación DQ: {{status}}',
			},
			AGENT: {
				NO_RUN: 'Not triaged yet',
				TIER_ACCEPTED: 'Triaje rápido · aceptado al {{pct}} ({{time}} · {{tokens}} tokens) — investigación profunda no necesaria',
				TIER_QUICK_ONLY: 'Solo triaje rápido · {{pct}} ({{time}} · {{tokens}} tokens)',
				TIER_ESCALATED: 'Escalado a investigación profunda:',
				TIER_QUICK_WAS: 'Respuesta rápida: {{cls}} {{pct}} ({{time}} · {{tokens}} tokens)',
				TIER_FINAL_IS: 'final: {{cls}} {{pct}}',
				MANUAL_CHIP: 'Manual · {{label}}',
				TITLE: 'Agente de triaje',
				RECOMMENDATION: 'Recomendación',
				NOT_RUN: 'El agente de triaje aún no se ha ejecutado para esta alerta. Pulse «Ejecutar agente de triaje» para clasificarla automáticamente.',
				NO_RECOMMENDATION: 'No hay recomendación registrada.',
				RUN: 'Ejecutar agente de triaje',
				RUNNING: 'En ejecución…',
				RERUN: 'Volver a ejecutar el agente de triaje',
				CREATES_CASE: 'Crea un caso',
				CONFIDENCE: '{{value}} de confianza',
				CAPPED: 'limitada',
				CAPPED_HINT: 'Confianza limitada a {{value}} porque algunas comprobaciones no pudieron ejecutarse',
				VERIFIED_FACTS: 'Hechos verificados y telemetría',
				N_VERIFIED: '{{count}} verificados',
				HYPOTHESIS: 'Hipótesis de trabajo y mecanismo físico (por qué)',
				SUPPORTING_TAGS: 'Etiquetas de apoyo',
				FMEA: 'FMEA dinámico',
				FAILURE_MODE: 'Modo de falla',
				MECHANISM: 'Mecanismo físico',
				IMPACT: 'Impacto sistémico',
				REMEDIATION: 'Remediación',
				DISCIPLINE: 'Disciplina',
				ACTIONABLE: 'Recomendaciones de ingeniería aplicables',
				WHAT_WOULD_CHANGE: 'Qué cambiaría esto',
				DECIDED_BY: 'Adjudicado por {{model}}',
				HARNESS_VERSION: 'harness {{v}}',
				STALE_RUN: "Obsoleto: ejecución anterior a la actualización del {{date}}; vuelva a ejecutar para ver el agente actual",
				DEGRADED: 'Regla de respaldo',
				DEGRADED_HINT: 'El LLM adjudicador no estaba disponible; esta disposición proviene de reglas deterministas. Revísela antes de aprobar.',
			},
			DIALOG: {
				APPROVE_TITLE: 'Approve classification',
				APPROVING: 'You agree with the agent: {{x}}',
				FEEDBACK_OPTIONAL: 'Optional: anything the agent should learn from this case',
				CORRECT_FINDING: 'Correct finding',
				SELECT_FINDING: 'Select the finding…',
				MAPS_TO: 'Shown to the customer as: {{x}} (mapping in force)',
				PROPOSE_TOGGLE: 'The finding “{{x}}” is right; the customer label should be different',
				PROPOSE_HELP: 'The alert keeps its finding. An administrator sees the proposal in Settings › Labels; a mapping change relabels every alert with this finding.',
				WANTED_LABEL: 'Label the customer expects',
				PROPOSED: 'Mapping change proposed to the administrators',
				RELEARN_TITLE: 'Reaprender clasificación',
				CLASSIFY_TITLE: 'Clasificar',
				CORRECT_CLASSIFICATION: 'Clasificación correcta',
				SELECT_CLASS: 'Seleccione una nueva categoría...',
				FEEDBACK: 'Comentarios',
				FEEDBACK_REQUIRED: 'Obligatorio para la revisión',
				CANCEL: 'Cancelar',
				CONFIRM: 'Confirmar',
			},
			EVIDENCE: {
				GROUP: {
					SERIES: 'Time series',
					RECORDS: 'Plant records',
				},
				ALL_TAGS: 'All tags',
				ON_DRAWING: 'Picked on the drawing:',
				CONTEXT_GRAPH: 'Context graph',
				SEARCH_REPORTS: 'Search the reports (any word in any section)',
				SEARCH_MATCHES: '{{n}} report(s) match',
				CITED_HERE: 'cited',
				AXES_UNIT: 'Axis per unit',
				AXES_TAG: 'Axis per tag',
				AXES_HINT: 'Overlay y-axes: share one axis per unit, or give every tag its own',
				SOURCE_ALERT: 'Source Alert',
				SOURCE_ALERT_FROM: 'Source alert · {{source}}',
				SYSTEM_DETAILS: 'System Details',
				REASONING_NOT_IN_RUN: 'No registrado en esta ejecución (ejecuciones anteriores a esta sección).',
				DROP_TAGS_HINT: 'Arrastre etiquetas desde el panel Mostrar etiquetas para añadir gráficos',
				TAGS: 'Etiquetas',
				MAINTENANCE: 'Mantenimiento',
				REPORTS: 'Informes',
				ALERTS: 'Alertas',
				DOCUMENTS: 'Documentos',
				REASONING: 'Razonamiento',
				REASONING_SECTION: {
					DECISION: 'Decision',
					BOARD: 'Hypothesis board',
					EVIDENCE: 'Evidence used',
					MEMORY: 'Learnings used',
					LIBRARY: 'Biblioteca',
					LIMITS: 'Límites',
					REASONING: 'Razonamiento',
					PLAYBOOK: 'Comprobaciones del playbook',
					SIGNAL: 'Señal y máquina',
					CONNECTED: 'Sistemas conectados',
					ANOMALY: 'Modelo de anomalías',
					RECORDS: 'Registros leídos',
				},
				NO_TELEMETRY: 'No hay datos históricos para estas etiquetas',
				NO_TELEMETRY_HINT: 'El historiador no cubre la ventana de la alerta para estas etiquetas.',
				NO_DATA_FOR: 'Sin datos históricos para',
				NOTIFICATIONS: 'Avisos',
				NOTIFICATION: 'Aviso',
				WORK_ORDERS: 'Órdenes de trabajo',
				WORK_ORDER: 'Orden de trabajo',
				NONE: 'Sin registros',
				ON_THIS_ITEM: 'En este equipo',
				DESCRIPTION: 'Descripción',
				NOTIFICATION_NO: 'N.º de aviso',
				TYPE: 'Tipo',
				PRIORITY: 'Prioridad',
				RAISED_ON: 'Creado el',
				COMPLETED_ON: 'Completado el',
				FLOC: 'Ubicación técnica',
				HIERARCHY_TIER: 'Nivel jerárquico',
				SUPERVISOR_REPORTS: 'Informes del supervisor',
				SHIFT_LOGS: 'Registros de turno',
				RECENT_ALERTS: 'Alertas recientes',
				RELATED_ALERTS: 'Alertas relacionadas',
				FIRED_AT: 'Disparada el',
				CONTEXT: 'Contexto',
				SHOW_AFTER_ALERT: 'Mostrar registros posteriores a la alerta',
				HINDSIGHT_HINT: 'Desactivado: solo lo registrado cuando se generó la alerta, como lo vio el agente. Activado: también los registros creados después.',
				HINDSIGHT_ON: 'Retrospectiva activada: se muestran los registros creados después de la alerta, marcados como «Después de la alerta». El agente no los vio.',
				AFTER_ALERT: 'Después de la alerta',
				HIDDEN_AFTER_ALERT: '{{n}} registrados después de la alerta ocultos',
				NONE_AT_ALERT: 'Ninguno registrado en el momento de la alerta',
				NOT_ANALYSED: 'No analizado',
				NO_TIME_SERIES: 'Sin serie temporal: {{reason}}',
				TELEMETRY_NO_DATA: 'el historiador no tiene lecturas del tag de la alerta en las 24 h previas',
				TELEMETRY_NOT_IN_HISTORIAN: 'el tag de la alerta no está en el historiador',
				TELEMETRY_NO_TAG: 'la alerta no tiene tag monitorizado',
				TELEMETRY_UNKNOWN: 'disponibilidad en el historiador desconocida',
				ADD_TAGS: 'Añadir tags',
				HIDE_TAG_LIST: 'Ocultar lista de tags',
				INCLUDE_BASELINE: 'Incluir referencia de línea base',
				ALERT_WINDOW: 'Ventana de la alerta',
				BASELINE_REF_AT: 'Referencia de línea base del detector: {{at}}',
				CHARTED_TOGETHER: 'Tags graficados juntos',
				NO_TAGS_CHARTED: 'No hay tags graficados',
				NO_TAGS_CHARTED_HINT: 'Busque o seleccione tags relacionados en la lista para graficarlos.',
				TAG_LOAD_FAILED: 'No se pudo cargar este tag',
				OVERLAY: 'Superposición – valores reales, un eje Y por unidad',
				OVERLAY_NORMALISED: 'Todos los tags en un eje (z-score, unidades distintas)',
				STATUS_AT_ALERT: 'Estado en la alerta',
				STATUS_NOW: 'ahora',
				OPEN_AT_ALERT: 'Abierto en la alerta',
				CLOSED_AT_ALERT: 'Cerrado en la alerta',
				NOT_RAISED_AT_ALERT: 'No creado en la alerta',
				SCOPE_ITEM: 'Este elemento',
				SCOPE_PARENT: 'Superior',
				BREAKDOWN: 'Avería',
				NUMBER: 'Número',
				EQUIPMENT: 'Equipo',
				REPORTED_BY: 'Reportado por',
				PLANNING_GROUP: 'Grupo de planificación',
				WORK_CENTER: 'Centro de trabajo',
				SYMPTOM: 'Síntoma',
				CREATED_ON: 'Creado el',
				SCHEDULED_START: 'Inicio programado',
				SCHEDULED_FINISH: 'Fin programado',
				ESTIMATED_DURATION: 'Duración estimada',
				HOURS_N: '{{n}} h',
				COST_ESTIMATE: 'Costo estimado',
				KNOWN_AT: 'Registrado desde',
				LONG_TEXT: 'Detalles',
				STATUS_HISTORY: 'Historial de estados',
				PRODUCTION_REPORTS: 'Informes de producción',
				DEFERMENT_REPORTS: 'Informes de diferimiento',
				SUPERVISOR_REPORT: 'Informe del supervisor',
				PRODUCTION_REPORT: 'Informe diario de producción',
				DEFERMENT_REPORT: 'Informe de diferimiento',
				FULL_SCREEN: 'Pantalla completa',
				EXIT_FULL_SCREEN: 'Salir de pantalla completa',
				BACK_TO_DOCUMENTS: 'Volver a documentos',
				DOWNLOAD: 'Descargar',
				HSSE: 'HSSE',
				PRODUCTION: 'Producción',
				HSSE_GRADE: 'Calificación HSSE',
				PRODUCTION_GRADE: 'Calificación de producción',
				REPORT_DATE: 'Fecha del informe',
				SOURCE_FILE: 'Archivo de origen',
				SUMMARY: 'Resumen',
				PRODUCTION_COMMENT: 'Comentario de producción',
				SUPERVISOR_COMMENTS: 'Comentarios del supervisor',
				ACTIVITIES: 'Actividades',
				FORECAST: 'Pronóstico / próximas tareas',
				ALARMS: 'Alarmas',
				DEFERMENT: 'Diferimiento',
				OOS: 'Equipos fuera de servicio',
				IOW: 'Excedencias DOW / IOW',
				MOCS: 'MOC temporales',
				NO_REPORT_TEXT: 'Sin texto de informe',
				CATEGORY: 'Categoría',
				MAIN_CAUSE: 'Causa principal',
				SUB_CAUSE: 'Subcausa',
				EQUIPMENT_SYSTEM: 'Sistema del equipo',
				EQUIPMENT_TYPE: 'Tipo de equipo',
				EVENT_START: 'Inicio del evento',
				EVENT_END: 'Fin del evento',
				ENDED_BEFORE_ALERT: 'Terminó antes de la alerta',
				ONGOING_AT_ALERT: 'En curso en la alerta',
				RECENT_ALERTS_HINT: 'en este tag / ubicación técnica',
				RELATED_ALERTS_HINT: 'en ±60 min, primero el mismo sistema',
				SUB_ALERTS: 'Subalertas del episodio',
				SUB_ALERTS_HINT: 'agrupadas en este episodio',
				SAME_SYSTEM: 'Mismo sistema',
				OPEN_ALERT: 'Abrir esta alerta',
				NO_DOCUMENTS: 'No hay documentos vinculados a este equipo',
				PID: 'P&ID',
				PAGES_N: '{{n}} páginas',
				UPDATED: 'Actualizado',
				SOURCE: 'Origen',
				REVISION: 'Revisión',
				DOCUMENT_TYPE: 'Tipo de documento',
				DOCUMENT_PREVIEW: 'Vista previa del documento',
				FILE_NAME: 'Nombre de archivo',
				PREVIEW_UNAVAILABLE: 'Vista previa no disponible',
				PREVIEW_UNAVAILABLE_HINT: 'El archivo de este documento no está en el repositorio de documentos.',
				SHOWING_ALL_WO: 'Showing all {{shown}} of {{total}} work orders & notifications',
				SHOWING_EVIDENCE_WO: 'Showing {{shown}} condition-evidence records (of {{total}} total)',
				SHOW_ALL_EQUIPMENT_WO: 'Show all work orders for {{equipment}}',
				CITED_IN_PATH: 'Cited',
				LINKED_WO: 'Linked WO',
				ROOT_CAUSE: 'Root Cause',
				AGENT_READ_SUMMARY: 'En su última ejecución el agente leyó {{read}} informes de supervisor y citó {{cited}}: lea primero los citados.',
				ONLY_AGENT_READ: 'Solo informes leídos por el agente',
				AGENT_CITED: 'Citado por el agente · {{relevance}}',
				AGENT_READ: 'Leído por el agente · no citado',
			},
			CHART: {
				JUDGED_AT: 'Judged at (raised later)',
				NO_DATA: 'No data in the historian',
				SEPARATE: 'Separate',
				OVERLAY: 'Overlay',
				SEPARATE_HINT: 'One panel per tag, sharing the time axis',
				OVERLAY_HINT: 'All tags on one panel, one y-axis per unit',
				ALL_READINGS: '*All good readings in the window',
				INSTRUMENT_RANGE: 'Instrument range',
				MEDIAN: 'Median',
				STEADY_ONLY: '*Steady running only (shutdown and start-up excluded)',
				THRESHOLD_LIMIT: 'Threshold limit',
				TRIP_LIMIT: 'Trip limit',
				LIMIT_TRIP: 'Disparo',
				LIMIT_ALARM: 'Alarma',
				LIMIT_THRESHOLD: 'Umbral',
				LIMIT_INSTRUMENT: 'Instrumento',
				LIMIT: 'límite',
				LIMIT_NONE: 'No hay valor cargado para esta etiqueta',
				TAG_LEGEND: 'Leyenda de etiquetas',
				MASKED_HIDDEN: '{{count}} lecturas enmascaradas (calidad de datos) excluidas del gráfico',
				NO_UNIT: 'Sin unidad',
				HIGH: 'High',
				LOW: 'Low',
				AVERAGE: 'Average',
				ACTUAL: 'Real',
				BASELINE: 'Línea base',
				SIGNAL_START: 'Inicio de señal',
				RAISED: 'Generada',
				RTN: 'Última actividad',
				BASELINE_REF: 'Ref. de línea base',
				NORMAL_MIN: 'Mín. normal',
				NORMAL_MAX: 'Máx. normal',
				MASKED: 'Lecturas enmascaradas (DQ)',
				MASKED_HOVER: 'Lectura enmascarada',
				ARTEFACT: 'Valor sustituido / artefacto de datos',
				ARTEFACT_HOVER: 'Artefacto de datos (no es una lectura de proceso)',
				TIME_AXIS: 'Hora ({{zone}})',
				OFF_SCALE: 'fuera de escala',
				MIN: 'mín.',
				MAX: 'máx.',
				RANGE_BAND: 'Mín.–máx.',
				LOADING: 'Cargando datos…',
				LOAD_ERROR: 'No se pudieron cargar datos para este rango',
				NO_DATA_IN_WINDOW: 'Sin lecturas en esta ventana',
				HISTORIAN_SPAN: 'El historiador tiene datos del {{first}} al {{last}}',
				CLOSE: 'Cerrar gráfico',
				ZOOM_HINT: 'Arrastre para ampliar o desplazar: se cargan más datos automáticamente. Doble clic para restablecer.',
				LAYOUT_STACKED: 'Apilado',
				LAYOUT_OVERLAY: 'Superpuesto',
				NORM_NONE: 'Valores brutos',
				NORM_ZSCORE: 'Puntuación z',
				NORM_RANGE: '% del rango',
				NORMALISED_Z: 'Puntuación z (σ)',
				NORMALISED_PCT: '% del rango',
				REMOVE_TAG: 'Quitar tag',
				NO_TAGS: 'Seleccione tags para graficarlos juntos',
				TOGETHER_TITLE: 'Tags graficados juntos',
			},
			DETAIL: {
				CHANGE_STATUS: 'Change status',
				ACK_HINT: 'Approve the current classification',
				REOPEN_HINT: 'Undo the last decision',
				REOPENED: 'Alert reopened',
				TARGET_FLOC: 'FLOC objetivo',
				OPEN_ALERT: 'Abrir alerta',
				BACK_TO_QUEUE: 'Volver a las alertas',
				ALERT_ANALYSIS: 'Análisis de la alerta',
				EVIDENCE: 'Evidencia',
				EVENT_TIME: 'Hora del evento',
				EVENT_TIME_HINT: 'Cuándo empezó la señal (inicio de la desviación)',
				RAISED: 'Generada',
				RAISED_HINT: 'Cuándo el sistema de vigilancia creó la alerta. El agente solo usa lo que se conocía en ese momento.',
				RTN: 'Vuelta a la normalidad',
				BASELINE_REF: 'Ref. de línea base',
				BASELINE_REF_HINT: 'Hora de referencia del detector (último registro de su línea base), no la hora del evento',
				CLASSIFICATION_HINT: 'Clasificación actual. Elija otra clase para clasificar o reaprender esta alerta.',
				CHANGE_CLASS: 'Cambiar clasificación',
				CURRENT_CLASS: 'Clasificación actual: {{value}}',
				PREVIOUSLY_APPROVED: 'Aprobada anteriormente',
				PREVIOUSLY_RELEARNED: 'Reaprendida anteriormente',
				HUMAN_REVIEW_REQUIRED: 'Revisión SME — se requiere evaluación manual',
				NOT_CLASSIFIED: 'Aún sin clasificar',
				AGENT_PROPOSED: 'Propuesta por el Agente de Triaje',
				NOT_ANALYSED_HINT: 'El Agente de Triaje no analiza esta alerta: sus datos no superaron las comprobaciones previas a la alerta. Clasifíquela manualmente si es necesario.',
				NOT_ANALYSED_REASON: 'No analizada: {{reason}}',
				RUN_BLOCKED: 'No analizable',
				RUN_BLOCKED_WHY: 'No se analizará: {{reason}}',
				RUN_GATED: 'No analizada',
				EVENT_START: 'Inicio del evento',
				CREATED_ON: 'Creado el',
				LAST_ACTIVE: 'Última actividad',
				LAST_ACTIVE_HINT: 'Cuándo volvió la alerta a la normalidad (última actividad); "Activa" mientras siga activa',
			},
			CASE: {
				CHIP: 'Caso #{{id}}',
				CREATE: 'Crear caso',
				MANAGE_HINT: 'Cree un caso para gestionar el seguimiento',
				CREATED: 'Caso #{{id}} creado',
				EXISTS: 'El caso #{{id}} ya está vinculado a esta alerta',
				CREATE_FAILED: 'No se pudo crear el caso',
				BULK_CREATED: '{{count}} caso(s) creado(s).',
			},
			RAIL: {
				LIMITS: 'Limits',
				ACTIVITY: 'Registro de actividad',
				DISCUSSION: 'Discusión',
				TRACES: 'Trazas',
				PREFERENCES: 'Preferencias',
				ANALYSIS: 'Análisis y vistas',
				OTHER_TAGS: 'Mostrar etiquetas',
				OTHER_TAGS_HINT: 'Haga clic en una etiqueta o arrástrela a los gráficos para añadirla a la pestaña Etiquetas.',
				DOCUMENTS: 'Documentos',
				NO_DOCUMENTS: 'No hay documentos vinculados a esta alerta',
				NO_DOCUMENTS_HINT: 'Ningún manual, P&ID o informe hace referencia a este equipo.',
				OPEN_IN_DOCUMENTS: 'Mostrar en la pestaña Documentos',
				REVISION: 'Rev. {{value}}',
				PID: 'P&ID',
				EXPORT_TAGS: 'Exportar etiquetas seleccionadas a un sistema externo',
				SAVED_ANALYSIS: 'Análisis guardados',
				SAVED_VIEWS: 'Vistas guardadas',
				SAVED_DASHBOARDS: 'Paneles guardados',
				NOT_AVAILABLE: 'Aún no disponible para alertas de triaje',
				PREFERENCES_NOTE: 'El sombreado de regiones de parada y las líneas de disparo / alarma / umbral aún no están disponibles para los gráficos de triaje.',
			},
			ACTIVITY: {
				N_ACTIONS: 'Acciones ({{count}})',
				EMPTY: 'Aún no hay actividad',
			},
			DISCUSSION: {
				N_COMMENTS: 'Comentarios ({{count}})',
				EMPTY: 'Aún no hay comentarios',
				PLACEHOLDER: 'Escriba un comentario...',
				REPLY: 'Responder',
				REPLY_PLACEHOLDER: 'Escriba una respuesta...',
				SEND: 'Enviar',
			},
			TRACE: {
				SEARCH: 'Search the trace (agent, finding, record id…)',
				SEARCH_MATCHES: '{{n}} agent(s) match',
				TMP_NOT_APPLIED: 'Fila del TMP registrada bajo {{component}}, no aplicada',
				TITLE: 'Traza del pipeline de agentes',
				EXPAND_ALL: 'Expandir todo',
				COLLAPSE_ALL: 'Contraer todo',
				COMPLETED: 'Completado',
				FAILED: 'Fallido',
				N_AGENTS: '{{count}} agentes',
				NO_RUN: 'Aún no hay ejecuciones del pipeline',
				NO_RUN_HINT: 'Ejecute el agente de triaje para ver la traza paso a paso de los 14 agentes.',
				STATUS_COMPLETED: 'Completado',
				STATUS_NO_DATA: 'Sin datos disponibles',
				STATUS_FAILED: 'Fallido',
				STATUS_SKIPPED: 'Omitido',
				TOKENS: 'Tokens LLM: {{input}} entrada / {{output}} salida',
			},
			ERRORS: {
				LOAD: 'No se pudieron cargar los datos de triaje',
				ACTION: 'No se pudo completar la acción',
				RUN_FAILED: 'La ejecución del agente de triaje falló',
			},
			TIMELINE: {
				TITLE: 'Línea de tiempo de eventos',
				N_EVENTS: '{{n}} eventos',
				RELATED_ALERTS: 'Alertas recientes y relacionadas',
				RANGE_ALL: 'Todo',
				RANGE_90D: '90 d',
				RANGE_30D: '30 d',
				RANGE_7D: '7 d',
				RANGE_1D: '24 h',
				RESET_ZOOM: 'Restablecer zoom',
				ZOOM_IN: 'Acercar',
				N_MORE: '+{{n}} más',
				EMPTY: 'No hay órdenes de trabajo, avisos, informes ni diferimientos registrados para esta alerta.',
				CLICK_TO_OPEN: 'Haga clic para abrirlo abajo',
				MINUTES: '{{n}} min',
				HOURS: '{{n}} h',
				DAYS: '{{n}} días',
				N_ALERTS_IN: '{{n}} alertas en {{span}}',
				N_EVENTS_IN: '{{n}} eventos en {{span}}',
				KIND_SELF: 'Esta alerta',
				KIND_ALERT: 'Alerta',
				KIND_WORK_ORDER: 'Orden de trabajo',
				KIND_NOTIFICATION: 'Aviso',
				KIND_SUPERVISOR: 'Informe de supervisor',
				KIND_PRODUCTION: 'Informe de producción',
				KIND_DEFERMENT: 'Diferimiento',
			},
			CANCEL: 'Cancel',
			SAVE: 'Save',
			PATH: {
				CITE_HINT: 'Open this record on the right',
				LAST_RECORDED: 'Detector: last recorded',
				LAST_RECORDED_TIP: 'The time the detector states in its text ("last recorded on …"); its meaning depends on the detector.',
				PLAIN_PENDING: 'A plain-language explanation is being written; reopen in a moment.',
				WHY: 'Why',
				STEP: 'Decided at',
				SHOW_DATA: 'Show data',
				HIDE_DATA: 'Hide data',
				DATA: 'Data',
				DETECTOR_CROSSED: 'crossed: why the alert fired',
				DETECTOR_OWN: 'the detector\'s rule',
				DETECTOR_OWN_TIP: 'The detector\'s own threshold. Crossing it is what raised the alert, so it is not evidence for a service; only an independent engineering limit is.',
				AGENT_DECIDED: 'agent decided',
				AGENT_DECISION: 'Agent decision',
				BASELINE: 'Baseline',
				CHECK: {
					FROZEN: 'Frozen',
					IMPOSSIBLE_ROC: 'Spikes',
					DOMAIN_RANGE: 'Out of range / codes',
					JITTER: 'Jitter',
					NODE_SUBSTITUTION: 'Feed substitution',
					TRIGGER_READINGS: 'Trigger readings',
				},
				CLEAR: 'clear',
				CONF_HIGH: 'High',
				CONF_LOW: 'Low',
				CONF_MEDIUM: 'Medium',
				DECIDED_AT: 'Decided at step {{n}} · {{title}}',
				DELAY: 'Delay',
				DISAGREE: 'The first check that matched (step {{n}}) points to {{outcome}}; the agent chose {{agent}}.',
				DISAGREE_SHORT: 'differs from path',
				DISAGREE_SHORT_TIP: 'The first matching check (step {{n}}) gives another class than the agent chose',
				DQ_ROUTE_FEED: 'Route: data-feed issue for the PI / historian owner (no work order)',
				DQ_ROUTE_INSTRUMENT: 'Route: instrument work order (I&E)',
				EXPORT_PDF: 'Export as PDF',
				FIRST_MATCH_AT: 'First match at step {{n}} · {{title}}',
				HELD_AT: 'Held at step {{n}} · {{title}}',
				JUSTIFICATION_STEP: 'Agent justification · step {{n}}',
				LIMIT: 'Limit',
				LINK_CLOSE: 'Valid – No Action (link)',
				MACHINE_SENSORS: 'Sensors on the machine',
				MATCHED: 'matched',
				NEAR: 'near',
				NONE: 'none',
				NOT_RUNNING: 'Not running steadily:',
				NO_FINDING: 'No finding recorded for this check',
				NO_LIMITS: 'No engineering limit is known for this tag',
				PEAK_24H: '24 h peak',
				PILL_ABNORMAL: 'Abnormal → continue',
				PILL_DECIDED: 'Decided',
				PILL_HELD: 'Held: not enough evidence',
				PILL_MATCHED: 'Matched',
				PILL_NOT_REACHED: 'Not reached',
				PILL_NO_MATCH: 'No match → continue',
				PROCESS_TOPOLOGY: 'Process topology',
				REACHED: 'reached',
				RECOMMENDATIONS: 'Recommendations ({{n}})',
				REPLAY_NO: 'Rule did not reproduce on raw data',
				REPLAY_YES: 'Rule reproduced on raw data',
				RULE: 'Rule',
				RUN_AT: 'Run {{at}}',
				RUN_INDICATOR: 'Run indicator',
				SELECT_SENSOR: 'select a sensor to chart it',
				SME_INTERNAL: 'SME / HIL label (internal, validation only; never an agent input)',
				STEP_AGREE: 'This check is right',
				STEP_DISAGREE: 'This check is wrong',
				STEP_EVIDENCE: '{{tags}} tags, {{records}} records, {{docs}} docs',
				SUBTITLE: '{{n}} checks · select a step',
				TITLE: 'Triage path',
				TRUST: 'Status',
				UNTRUSTED: 'not trusted',
				VALUE: 'Value',
				DECISION_TITLE: 'Decision',
				RCA_TITLE: 'Decision & Triage Path',
				RCA_PANE_TITLE: 'Decision & Triage Path',
				PROPOSED_EVIDENCE_TITLE: 'Proposed Evidence',
				MINI_TITLE: '8-Step Triage Path',
				JUSTIFICATION: 'Justification',
				ORDERED_TITLE: 'Ordered 8-Step Triage Path',
				ORDERED_SUBTITLE: '7 checks in order — the first check that matches decides the outcome',
				STEP_PASSED: 'Passed',
				STEP_NOT_REACHED: 'Not Reached',
				RULE_FLAGGED: 'Rule Flagged for Tuning',
				RULE_FLAGGED_NOTICE: 'Alert approved & detector rule flagged for tuning',
				FLAG_RULE_CTA: 'Close & Flag Rule for Tuning',
				CREATE_INSTRUMENT_WO: 'Create Instrument Work Order',
				INSTRUMENT_WO_TITLE: 'Create Instrument Work Order (Data Quality Policy)',
				INSTRUMENT_WO_POLICY: 'Routed to I&E Discipline',
				INSTRUMENT_TAG: 'Instrument Tag',
				DEFECT_DESCRIPTION: 'Defect Description',
				SUBMIT_INSTRUMENT_WO: 'Create Instrument Work Order',
				INSTRUMENT_WO_CREATED: 'Instrument Work Order {{id}} raised — Status moved to Pending – Defect Raised',
				ROOTY: 'Rooty',
				ROOTY_HINT: 'Ask Rooty or open discussion on this alert',
				ASK_ROOTY_STEP: 'Ask Rooty about this step',
				STEP_COMMENT: 'Comment on this step',
				STEP_COMMENT_PLACEHOLDER: 'Add a note on this triage step…',
				PLOT_TAG_HINT: 'Plot this tag in Proposed Evidence',
				PLOT_ALL_STEP_TAGS: 'Plot all {{count}} step tags',
				OPEN_WO_HINT: 'Open this Work Order in the Work Orders tab',
				OPEN_ALERT_EVIDENCE_HINT: 'Open this alert in the Alerts tab',
				STEP3_VISUAL_TITLE: 'Machine Diagram & Operating State',
				STEP3_VISUAL_HINT: 'Click any sensor to plot it on the right',
				STEP4_VISUAL_TITLE: 'P&ID Process Flow & Event Timeline',
				STEP4_VISUAL_HINT: 'Driver and response tags are plotted on the right',
				STEP5_VISUAL_TITLE: 'Event Timeline — Cited Work Orders & Open Alerts',
				STEP5_VISUAL_HINT: 'Click a marker or chip to inspect the Work Order or Alert on the right',
				DEEP_DETAILS: 'Deep RCA Details (Verified Facts, Hypotheses & FMEA)',
			},
		},
	}
};
